{
  "activities": {
    "addTask": "Pendenz",
    "allPersons": "Alle Personen",
    "empty": "Keine Aktivitäten vorhanden",
    "filterByPerson": "Nach Person filtern",
    "hideCompleted": "Erledigte ausblenden",
    "open": "offen",
    "showCompleted": "{{count}} erledigte anzeigen",
    "title": "Aktivitäten",
    "viaContact": "über {{name}}"
  },
  "addresses": {
    "tabCompanies": "Organisationen",
    "tabContacts": "Kontakte",
    "title": "Adressen"
  },
  "agb": {
    "footer": {
      "address": "Uniplacement GmbH · c/o S&K Partners AG · Samstagernstrasse 55 · 8832 Wollerau · Schweiz",
      "registration": "UID CHE-265.053.706 · Handelsregister Kanton Schwyz"
    },
    "notice": "Rechtlich massgebend ist die deutsche Fassung. Für Honorar und Konditionen gilt Ihr Einzelvertrag.",
    "sections": {
      "account": "§ 3 Konto und Zugang",
      "availability": "§ 10 Verfügbarkeit und Änderungen",
      "circumvention": "§ 12 Umgehungsverbot (Plattformebene)",
      "dataProtection": "§ 8 Datenschutz und KI-Verarbeitung",
      "finalProvisions": "§ 14 Schlussbestimmungen",
      "identification": "§ 7 Identifikation und Sorgfaltspflichten",
      "liability": "§ 11 Haftung",
      "offers": "§ 5 Angebote und Verkaufsverfahren",
      "scope": "§ 1 Geltungsbereich",
      "services": "§ 2 Leistungen der Plattform",
      "signature": "§ 6 Elektronische Signatur",
      "teaserNda": "§ 4 Teaser, NDA und Dossiers",
      "terms": "§ 13 Laufzeit, Sperrung, Änderungen der AGB",
      "usageRights": "§ 9 Nutzungsrechte und Daten"
    },
    "serviceItems": {
      "communication": "Kommunikation zwischen den Beteiligten",
      "contracts": "Generierung und elektronische Signatur von Verträgen",
      "dataRoom": "Datenraum, Dossiers und Dokumentenverwaltung",
      "objectInfo": "Aufbereitung und Bereitstellung von Objektinformationen",
      "offers": "Abgabe und Verwaltung von Angeboten"
    },
    "subtitle": "Plattform-Nutzungsbedingungen der Uniplacement GmbH (Betreiberin der Plattform «Immotron») · Gültig ab 1. Oktober 2026",
    "title": "Allgemeine Geschäftsbedingungen (AGB)",
    "version": "Version 1.1 · Gültig ab 1. Oktober 2026"
  },
  "ai": {
    "aiAccuracy": "KI Ø",
    "cliUnavailable": "CLI nicht verfügbar",
    "confirmed": "Bestätigt",
    "disabled": "Deaktiviert",
    "enabled": "Aktiv",
    "error": "Ein Fehler ist aufgetreten",
    "fieldsBetter": "Felder besser",
    "images": {
      "loadFailed": "Bild konnte nicht geladen werden",
      "notAvailable": "Bild nicht verfügbar",
      "primaryImage": "Hauptbild",
      "removeImage": "Bild entfernen",
      "selectAll": "Alle",
      "selectLabel": "Auswählen",
      "selectNone": "Keine",
      "selectRelevant": "Relevante",
      "selectedLabel": "Ausgewählt",
      "setAsPrimary": "Als Hauptbild setzen",
      "title": "Bilder"
    },
    "jobs": {
      "active": "Aktiv",
      "addWarning": "Hinweis hinzufügen",
      "archive": "Archivieren",
      "cancelFailed": "Abbrechen fehlgeschlagen",
      "cancelStarted": "Job wird abgebrochen",
      "core": "Pflicht",
      "cost": "Kosten",
      "coverage": "Abdeckung",
      "createProperty": "Objekt erstellen",
      "createPropertyFailed": "Objekt konnte nicht erstellt werden",
      "createPropertyRecovered": "Objekt #{{id}} wurde erstellt (Verbindung war kurz unterbrochen)",
      "creating": "Erstellen...",
      "deleteConfirm": "Job endgültig löschen? Dies kann nicht rückgängig gemacht werden.",
      "deleteFailed": "Löschen fehlgeschlagen",
      "dismissFailed": "Konnte nicht abgeschlossen werden",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumentenzuordnung",
      "documents": "Dokumente",
      "done": "Fertig",
      "duration": "Dauer",
      "error": "Fehler",
      "feedbackResetFailed": "Feedback konnte nicht zurückgesetzt werden",
      "feedbackSendFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "files": "Dateien",
      "goToProperty": "Zum Objekt",
      "helpful": "hilfreich",
      "listRefreshed": "Liste aktualisiert",
      "model": "Modell",
      "noJobsFound": "Keine Jobs gefunden",
      "optional": "Optional",
      "pipeline": {
        "jumpToLatest": "Zum neuesten",
        "live": "Live",
        "loadFailed": "Events konnten nicht geladen werden",
        "loading": "Lade Events...",
        "logTitle": "Verarbeitungs-Log",
        "noEvents": "Noch keine Events vorhanden",
        "stages": {
          "classification": "Klassifizierung",
          "extraction": "Extraktion",
          "persistence": "Persistierung",
          "upload": "Upload",
          "validation": "Validierung"
        },
        "title": "KI-Pipeline"
      },
      "processing": "Verarbeitung...",
      "quality": {
        "charsExtracted": "{{formatted}} Zeichen extrahiert",
        "docType": "Typ",
        "encryptedPdf": "Verschlüsselt",
        "encryptedShort": "verschlüsselt",
        "encryptedWarning": "Verschlüsseltes PDF — keine Extraktion möglich. Bitte ungeschützte Version hochladen.",
        "pages": "{{formatted}} Seiten",
        "scanPdf": "Scan-PDF",
        "scanShort": "Scans",
        "scanWarning": "Scan-Dokument — Extraktion kann unvollständig sein.",
        "summary": "Zusammenfassung",
        "textPdf": "Text-PDF",
        "title": "PDF-Qualität"
      },
      "reactivate": "Reaktivieren",
      "reactivateFailed": "Reaktivierung fehlgeschlagen",
      "recommended": "Empfohlen",
      "refreshFailed": "Aktualisierung fehlgeschlagen",
      "reset": "Zurücksetzen",
      "resetConfirm": "Job zurücksetzen? Das Ergebnis wird gelöscht.",
      "resetFailed": "Zurücksetzen fehlgeschlagen",
      "resetShort": "Reset",
      "retry": "Wiederholen",
      "retryFailed": "Retry fehlgeschlagen — Originaldateien evtl. nicht mehr vorhanden",
      "retryStarted": "Job wird wiederholt",
      "saveFailed": "Speichern fehlgeschlagen",
      "showAll": "Alle Jobs anzeigen",
      "showCompleted": "Auch abgeschlossene anzeigen",
      "startNewUpload": "Neuen Upload starten",
      "statistics": "Statistik",
      "status": {
        "cancelled": "Abgebrochen",
        "pending": "Wartend"
      },
      "timeAgo": {
        "justNow": "gerade eben"
      },
      "title": "KI-Extraktions-Jobs",
      "titleShort": "KI-Jobs",
      "tokens": "Tokens",
      "unhelpful": "nicht hilfreich",
      "warnings": "Hinweise",
      "warningsSaved": "Hinweise gespeichert"
    },
    "learningDescription": "Vergleich: KI-Extraktion vs. statische Quellen (GeoAdmin)",
    "learningHint": "Das System lernt automatisch mit jeder bestätigten Extraktion.",
    "learningMode": "KI Lern-Modus",
    "model": "Modell",
    "noComparisonData": "Noch keine Vergleichsdaten",
    "noComparisonDataHint": "Daten werden automatisch nach jeder KI-Extraktion + Bestätigung gesammelt.",
    "prompt": "Prompt",
    "promptPlaceholder": "Stellen Sie eine Frage...",
    "response": "Antwort",
    "send": "Senden",
    "sending": "Wird gesendet...",
    "staticAccuracy": "Statisch Ø",
    "status": "Status",
    "subtitle": "Claude AI Testumgebung",
    "title": "KI-Assistent",
    "totalExtractions": "Extraktionen",
    "upload": {
      "addMoreDocs": "Weitere Dokumente ergänzen",
      "addMoreDocsHint": "Fehlende Dokumente hochladen — bestehende Daten werden ergänzt, nicht überschrieben.",
      "addMoreHint": "Weitere Dateien/Ordner oben hinzufügen, dann Analyse starten",
      "backOtherDocs": "Zurück / Andere Dokumente",
      "backToProperties": "Zurück zu Objekte",
      "batchFailed": "fehlgeschlagen",
      "batchObjectsProcessed": "Objekten verarbeitet",
      "batchOf": "von",
      "batchProcessing": "Portfolio-Verarbeitung",
      "batchResult": "Portfolio-Ergebnis",
      "batchSuccessful": "erfolgreich",
      "catCore": "Kern-Dokumente",
      "catOptional": "Optional",
      "catRecommended": "Empfohlen",
      "chooseDirectory": "Verzeichnis wählen",
      "clickToEdit": "Klicken zum Bearbeiten",
      "collapseAll": "Alle zuklappen",
      "confidence": "Confidence",
      "confidenceExplain": "Confidence-Score erklären",
      "confirmCreate": "Erstellen",
      "confirmTitle": "Objekt erstellen?",
      "coreComplete": "Kern komplett",
      "createProperty": "Objekt erstellen",
      "createdSuccess": "Objekt erfolgreich erstellt!",
      "detectedDocTypes": "Erkannte Dokumenttypen",
      "docTypesDetected": "Dokumenttypen erkannt",
      "documentCoverage": "Dokumenten-Abdeckung",
      "documentMapping": "Dokumenten-Zuordnung",
      "documentPlural": "Dokumente",
      "documentSingular": "Dokument",
      "dropzoneHint": "PDF, Bilder, Excel oder Word hierher ziehen oder Verzeichnis/Dateien auswählen",
      "dropzoneTitle": "Objekt-Unterlagen hochladen",
      "editProperty": "Objekt bearbeiten",
      "expandAll": "Alle aufklappen",
      "feedbackFailed": "Feedback konnte nicht gesendet werden",
      "feedbackSent": "Feedback gesendet",
      "filePlural": "Dateien",
      "fileSingular": "Datei",
      "filterAll": "Alle",
      "filterOpen": "Offen",
      "filterRated": "Bewertet",
      "groupingFiles": "Dateien werden gruppiert und hochgeladen",
      "headerAncillary": "NK",
      "headerAreaFrom": "Fläche von",
      "headerAreaSqm": "Fläche m²",
      "headerAreaTo": "Fläche bis",
      "headerFloor": "Etage",
      "headerNetRent": "Nettomiete",
      "headerRented": "Vermietet",
      "headerRooms": "Zimmer",
      "headerRooms2": "Zimmer",
      "headerStatus": "Status",
      "headerTotal": "Total",
      "helpful": "Hilfreich",
      "hints": "Hinweise",
      "individualFiles": "Einzelne Dateien",
      "locationAnalysis": "Standort-Analyse",
      "lowConfidenceWarning": "Niedrige Confidence — manuelle Prüfung der Daten wird empfohlen.",
      "metaCost": "Kosten",
      "metaDuration": "Dauer",
      "metaModel": "Modell",
      "metaTokens": "Tokens",
      "newUpload": "Neuer Upload",
      "noData": "Keine Daten",
      "noPdfInDirectory": "Keine PDF-Dateien im Verzeichnis gefunden",
      "noSupportedInDirectory": "Keine unterstützten Dateien im Verzeichnis gefunden (PDF, Bilder, Excel oder Word)",
      "noValidFiles": "Keine gültigen Dateien ausgewählt",
      "unsupportedFormat": "Dateityp nicht unterstützt — erlaubt sind PDF, E-Mail (.eml), Bilder (JPEG/PNG/WebP/GIF), Excel (.xlsx/.xls) und Word (.docx/.doc)",
      "notHelpful": "Nicht hilfreich",
      "objectCreatedEmail": "Objekt erstellt — E-Mail mit offenen Fragen wurde gesendet",
      "objectUpdatedEmail": "Objekt aktualisiert — E-Mail mit offenen Fragen wurde gesendet",
      "ofDocTypes": "von",
      "openHints": "Offene Hinweise",
      "preparing": "KI-Analyse wird vorbereitet...",
      "processingDirectory": "Verzeichnis wird verarbeitet...",
      "qualityGood": "Gute Datenqualität — bereit zur Bestätigung",
      "qualityLow": "Wenige Daten extrahiert — manuelle Eingabe empfohlen",
      "qualityPartial": "Teilweise Daten extrahiert — bitte prüfen",
      "ready": "bereit",
      "redirecting": "Sie werden zur Bearbeitungsseite weitergeleitet...",
      "removeAll": "Alle entfernen",
      "rentRollStats": "Mieterspiegel-Statistik",
      "retry": "Wiederholen",
      "retryAction": "Erneut versuchen",
      "retryFailed": "Wiederholung konnte nicht gestartet werden",
      "retryNotPossible": "Wiederholung nicht möglich",
      "retryStarted": "Wiederholung gestartet",
      "saveFailed": "Speichern fehlgeschlagen",
      "saving": "Objekt wird gespeichert...",
      "scoreCurrent": "Aktuell",
      "scoreHigh": "Alle wichtigen Felder extrahiert, Daten plausibel.",
      "scoreLow": "Wenige Daten — prüfen oder manuell ergänzen.",
      "scoreMedium": "Einige Felder fehlen oder Unstimmigkeiten.",
      "scoreTitle": "Was bedeutet der Score?",
      "sectionAnalysis": "Immobilienanalyse",
      "sectionFinance": "Finanzen",
      "sectionGeoAdmin": "Behörden-Daten (swisstopo)",
      "sectionImages": "Bilder",
      "sectionInsurance": "Versicherung",
      "sectionParking": "Parkierung",
      "sectionProperty": "Objekt",
      "sectionRentRoll": "Mieterspiegel",
      "sectionUnitMix": "Wohnungsmix",
      "startAnalysis": "KI-Analyse starten",
      "submitting": "Dokumente werden übermittelt...",
      "subtitle": "Laden Sie die relevanten Dateien hoch: Mieterspiegel, Baubeschrieb, Grundbuchauszug, Gebäudeversicherungsnachweis, Marktwertschätzungen — die KI extrahiert automatisch alle Objektdaten.",
      "supplement": "Ergänzen",
      "supplementDocs": "Dokumente ergänzen",
      "title": "KI-Objekterfassung",
      "uploadFailed": "Upload fehlgeschlagen",
      "uploadedFiles": "Hochgeladene Dateien",
      "uploading": "Hochladen...",
      "waitProcessing": "Bitte warten — Upload/Verarbeitung läuft noch.",
      "whatIsWrong": "Was stimmt nicht? (optional)",
      "whyHelpful": "Warum hilfreich? (optional)"
    }
  },
  "aiClauses": {
    "cancel": "Abbrechen",
    "confirmDelete": "Löschen?",
    "confirmYes": "Bestätigen",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "editClause": "Klausel bearbeiten",
    "generate": "Generieren",
    "generateFailed": "Klausel konnte nicht generiert werden",
    "generateSuccess": "Klausel erfolgreich generiert",
    "generating": "Wird generiert...",
    "hint": "Der KI-Klausel-Generator erstellt massgeschneiderte Klauseln und ordnet sie dem gewählten Vertragsabschnitt zu. Sie können den generierten Text anschliessend bearbeiten und die Reihenfolge anpassen.",
    "moveDown": "Nach unten",
    "moveUp": "Nach oben",
    "noClauses": "Noch keine Klauseln generiert",
    "prompt": "Klausel beschreiben",
    "promptPlaceholder": "Beschreiben Sie die gewünschte Klausel, z.B. 'Rücktrittsrecht bei Finanzierungsvorbehalt'",
    "save": "Speichern",
    "section": "Abschnitt",
    "sections": {
      "BROKER_CONDITIONS": "Makler-Sonderbedingungen",
      "BUYER_CONDITIONS": "Käufer-Sonderbedingungen",
      "GENERAL_CONDITIONS": "Allgemeine Bedingungen",
      "PAYMENT_TERMS": "Zahlungsbedingungen",
      "SELLER_CONDITIONS": "Verkäufer-Sonderbedingungen",
      "TERMINATION": "Kündigungsbedingungen"
    },
    "templates": "Vorlagen",
    "title": "KI-Klausel-Generator"
  },
  "app": {
    "name": "Immotron",
    "tagline": "Real Estate Investment Platform"
  },
  "pwa": {
    "newVersionAvailable": "Neue Version verfügbar",
    "update": "Aktualisieren"
  },
  "auth": {
    "errors": {
      "accountInactive": "Ihr Konto ist noch nicht aktiviert",
      "accountInactiveDescription": "Bitte unterzeichnen Sie zuerst den Vertrag, den wir Ihnen per E-Mail zugesandt haben. Nach der Unterzeichnung erhalten Sie einen Link zur Passwort-Einrichtung.",
      "accountInactiveTitle": "Konto noch nicht aktiviert",
      "invalidCredentials": "Ungültige E-Mail oder Passwort",
      "networkError": "Netzwerkfehler. Bitte versuchen Sie es erneut.",
      "sessionExpired": "Ihre Sitzung ist abgelaufen"
    },
    "forgotPassword": {
      "backToLogin": "Zurück zur Anmeldung",
      "email": "E-Mail-Adresse",
      "networkError": "Verbindungsfehler. Bitte versuchen Sie es erneut.",
      "submit": "Link senden",
      "subtitle": "Geben Sie Ihre E-Mail-Adresse ein",
      "success": "Falls ein Konto existiert, erhalten Sie eine E-Mail.",
      "title": "Passwort vergessen"
    },
    "login": {
      "email": "E-Mail-Adresse",
      "emailPlaceholder": "ihre@email.ch",
      "forgotPassword": "Passwort vergessen?",
      "noAccount": "Noch kein Konto?",
      "password": "Passwort",
      "passwordError": "E-Mail-Adresse oder Passwort ist falsch.",
      "passwordPlaceholder": "Ihr Passwort",
      "register": "Registrieren",
      "rememberMe": "Angemeldet bleiben",
      "selectCompany": "Firma auswählen",
      "selectCompanySubtitle": "Wählen Sie die Firma, für die Sie sich anmelden möchten",
      "submit": "Anmelden",
      "subtitle": "Willkommen zurück",
      "title": "Anmelden",
      "withPassword": "Mit Passwort anmelden"
    },
    "logout": "Abmelden",
    "magicLink": {
      "continueToApp": "Weiter zur Plattform",
      "emailFallbackHint": "Bitte geben Sie Ihre E-Mail-Adresse an, damit wir Ihnen einen neuen Link schicken können.",
      "expiredMessage": "Aus Sicherheitsgründen ist dieser Link nur begrenzt gültig.",
      "expiredTitle": "Anmelde-Link abgelaufen",
      "networkError": "Verbindungsfehler. Bitte versuchen Sie es erneut.",
      "newLinkSent": "Wir haben Ihnen einen neuen Anmelde-Link an Ihre hinterlegte E-Mail-Adresse geschickt. Bitte prüfen Sie Ihr Postfach.",
      "resend": "Erneut senden",
      "sendNewLink": "Neuen Link senden",
      "sentHint": "Kein Link erhalten? Prüfen Sie Ihren Spam-Ordner.",
      "sentMessage": "Wir haben einen Anmelde-Link an {{email}} gesendet.",
      "sentTitle": "Link unterwegs!",
      "stillSignedIn": "Sie sind bereits angemeldet.",
      "submit": "Anmelde-Link anfordern",
      "subtitle": "Wir schicken Ihnen einen Anmelde-Link an Ihre E-Mail-Adresse.",
      "switchedUser": "Zuvor angemeldet als {{from}} — jetzt angemeldet als {{to}}",
      "title": "Anmelden",
      "verifyingSubtitle": "Bitte warten Sie einen Moment.",
      "verifyingTitle": "Anmeldung wird verarbeitet…",
      "wrongAddress": "Falsche Adresse? Zurück zur Eingabe"
    },
    "passkey": {
      "cancelled": "Passkey-Anmeldung abgebrochen.",
      "divider": "oder",
      "error": "Passkey-Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "login": "Mit Passkey anmelden",
      "registerSuccess": "Passkey erfolgreich eingerichtet!",
      "setupAction": "Jetzt einrichten",
      "setupDialog": {
        "cancelled": "Passkey-Einrichtung abgebrochen.",
        "created": "Passkey wurde erstellt. Geben Sie optional einen Gerätenamen ein.",
        "description": "Mit einem Passkey können Sie sich schnell und sicher per Fingerabdruck, Gesichtserkennung oder Gerätesperre anmelden.",
        "deviceNameHint": "Ein Name hilft Ihnen, diesen Passkey später zu erkennen.",
        "deviceNameLabel": "Gerätename (optional)",
        "deviceNamePlaceholder": "z.B. iPhone von Max",
        "error": "Passkey konnte nicht eingerichtet werden. Bitte versuchen Sie es erneut.",
        "notSupported": "Ihr Browser unterstützt keine Passkeys. Bitte verwenden Sie einen aktuellen Browser.",
        "register": "Passkey einrichten",
        "saveError": "Der Passkey wurde lokal erstellt, konnte aber nicht gespeichert werden. Bitte versuchen Sie es erneut.",
        "skipName": "Überspringen",
        "success": "Passkey erfolgreich eingerichtet!",
        "title": "Passkey einrichten"
      },
      "setupDismiss": "Später",
      "setupMessage": "Richten Sie einen Passkey ein für schnelleren und sichereren Login.",
      "setupTitle": "Passkey einrichten"
    },
    "passwordSetup": {
      "backToLogin": "Zurück zum Login",
      "confirmPassword": "Passwort bestätigen",
      "emailPlaceholder": "E-Mail-Adresse eingeben",
      "error": "Passwort konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
      "expiredMessage": "Dieser Link ist leider abgelaufen. Bitte kontaktieren Sie uns für einen neuen Link.",
      "expiredMessageNew": "Dieser Link ist abgelaufen. Bitte fordern Sie einen neuen an.",
      "expiredTitle": "Link abgelaufen",
      "invalidMessage": "Dieser Link ist ungültig oder wurde bereits verwendet.",
      "invalidTitle": "Link ungültig",
      "magicLinkError": "Der Magic Link konnte nicht gesendet werden.",
      "magicLinkSentHint": "Überprüfen Sie Ihren Posteingang und klicken Sie auf den Link.",
      "magicLinkSentMessage": "Ein Login-Link wurde an Ihre E-Mail-Adresse gesendet.",
      "magicLinkSentTitle": "Link gesendet",
      "newPassword": "Neues Passwort",
      "reqDigit": "Eine Ziffer",
      "reqLowercase": "Ein Kleinbuchstabe",
      "reqMinLength": "Mindestens 8 Zeichen",
      "reqUppercase": "Ein Grossbuchstabe",
      "requestNewLink": "Neuen Link anfordern",
      "requirementsNotMet": "Das Passwort erfüllt nicht alle Anforderungen",
      "settingUpFor": "Passwort einrichten für",
      "submit": "Passwort speichern",
      "subtitle": "Erstellen Sie Ihr Passwort für den Zugang zur Plattform",
      "successMessage": "Ihr Passwort wurde gespeichert. Sie werden zur Anmeldung weitergeleitet.",
      "successTitle": "Passwort erfolgreich eingerichtet",
      "title": "Passwort einrichten",
      "weakPassword": "Das Passwort erfüllt nicht die Anforderungen."
    },
    "profile": "Profil",
    "resetPassword": {
      "confirmPassword": "Passwort bestätigen",
      "error": "Link ungültig oder abgelaufen",
      "newPassword": "Neues Passwort",
      "submit": "Passwort setzen",
      "subtitle": "Geben Sie Ihr neues Passwort ein",
      "success": "Passwort erfolgreich geändert. Sie werden zur Anmeldung weitergeleitet.",
      "title": "Neues Passwort setzen"
    },
    "settings": "Einstellungen",
    "twoFactor": {
      "backToLogin": "Zurück zur Anmeldung",
      "codeLabel": "Bestätigungscode",
      "codeSent": "Neuer Code wurde gesendet",
      "expiredCode": "Der Code ist abgelaufen. Bitte fordern Sie einen neuen an.",
      "invalidCode": "Ungültiger Code",
      "maxAttempts": "Zu viele Versuche. Bitte melden Sie sich erneut an.",
      "resend": "Code erneut senden",
      "resendCooldown": "Erneut senden in {{seconds}}s",
      "resendSuccess": "Neuer Code wurde gesendet.",
      "submit": "Bestätigen",
      "subtitle": "Wir haben einen Bestätigungscode an {{email}} gesendet",
      "title": "Verifizierungscode eingeben",
      "verify": "Bestätigen",
      "wrongCode": "Der eingegebene Code ist ungültig."
    }
  },
  "buyerProfile": {
    "title": "Investorprofil (KI)",
    "relevance": "Relevanz",
    "notProfiled": "Noch nicht profiliert",
    "notProfiledHint": "Für diese Organisation wurde noch kein Investorprofil erstellt.",
    "badgeTooltip": "Immobilien-Relevanz: {{score}}/100",
    "scoreOutOf": "{{score}} von 100",
    "profiledAtValue": "Profiliert am {{date}}",
    "openSearchProfile": "Suchprofil öffnen",
    "run": "Profil erstellen",
    "rerun": "Profil neu erstellen",
    "runSuccess": "Investorprofil aktualisiert",
    "runError": "Investorprofil konnte nicht erstellt werden",
    "groupRun": "Investorprofile für Gruppe erstellen",
    "batchSummary": "{{profiled}} profiliert · {{skipped}} übersprungen · {{errors}} Fehler",
    "batchStarted": "{{count}} Organisationen werden im Hintergrund profiliert — Seite später aktualisieren",
    "filterLabel": "Investor-Relevanz filtern",
    "filterAll": "Relevanz: alle",
    "filterProfiled": "Nur profilierte",
    "filterMin": "Score ≥ {{min}}"
  },
  "campaigns": {
    "blocks": {
      "add": "Block hinzufügen",
      "fields": {
        "addItem": "Item hinzufügen",
        "addRow": "Zeile hinzufügen",
        "alt": "Alternativtext",
        "body": "Text",
        "buttonColor": "Button-Farbe",
        "buttonText": "Button-Text",
        "buttonUrl": "Button-URL",
        "caption": "Bildunterschrift",
        "cardColor": "Kartenfarbe",
        "cardText": "Karten-Text",
        "cardTitle": "Karten-Titel",
        "heading": "Überschrift",
        "imageHeight": "Bildhöhe",
        "imageOpacity": "Bild-Deckkraft",
        "imageUrl": "Bild-URL",
        "itemText": "Item-Text",
        "itemTitle": "Item-Titel",
        "label": "Bezeichnung",
        "leftImage": "Linkes Bild",
        "leftText": "Linker Text",
        "list": "Liste",
        "overlayOpacity": "Abdunklung",
        "rightImage": "Rechtes Bild",
        "rightText": "Rechter Text",
        "subtitle": "Untertitel",
        "textAlign": "Ausrichtung",
        "textOffsetY": "Text-Position (vertikal)",
        "title": "Titel",
        "value": "Wert"
      },
      "moveDown": "Nach unten",
      "moveUp": "Nach oben",
      "remove": "Block entfernen",
      "title": "Inhaltsblöcke",
      "types": {
        "contract_details": "Vertragsdetails",
        "cta": "Call-to-Action",
        "divider": "Trennlinie",
        "expiry_notice": "Ablaufhinweis",
        "feature": "Feature-Sektion",
        "hero": "Hero-Bild",
        "image": "Bild",
        "key_value": "Datentabelle",
        "text": "Text",
        "two_column": "Zwei Spalten"
      }
    },
    "company": "Firma",
    "confirmDelete": "Möchten Sie diese Kampagne wirklich löschen?",
    "confirmDeleteDescription": "Sind Sie sicher, dass Sie diese Kampagne löschen möchten?",
    "createSuccess": "Kampagne erfolgreich erstellt",
    "deleteCampaign": "Kampagne löschen",
    "deleteFailed": "Kampagne konnte nicht gelöscht werden.",
    "deleteSuccess": "Kampagne erfolgreich gelöscht",
    "editCampaign": "Kampagne bearbeiten",
    "errors": {
      "createFailed": "Kampagne konnte nicht erstellt werden",
      "deleteFailed": "Kampagne konnte nicht gelöscht werden",
      "loadFailed": "Kampagnen konnten nicht geladen werden",
      "noRecipients": "Keine Empfänger hinzugefügt",
      "previewFailed": "Vorschau konnte nicht geladen werden",
      "sendFailed": "Kampagne konnte nicht versendet werden",
      "updateFailed": "Kampagne konnte nicht aktualisiert werden"
    },
    "footer": {
      "address": "Adresse",
      "companyName": "Firmenname",
      "email": "E-Mail",
      "phone": "Telefon",
      "title": "Footer",
      "website": "Website"
    },
    "fromEmail": "Absender-E-Mail",
    "fromName": "Absender-Name",
    "header": {
      "backgroundColor": "Hintergrundfarbe",
      "headerSubtitle": "Slogan / Untertitel",
      "headerTitle": "Header-Titel",
      "logoUrl": "Logo-URL",
      "textColor": "Textfarbe",
      "title": "Header"
    },
    "imagePicker": {
      "confirmDelete": "Möchten Sie dieses Bild wirklich löschen?",
      "delete": "Bild löschen",
      "deleteFailed": "Bild konnte nicht gelöscht werden.",
      "deleteSuccess": "Bild gelöscht",
      "empty": "Noch keine Bilder hochgeladen",
      "title": "Bild auswählen",
      "upload": "Bild hochladen",
      "uploading": "Wird hochgeladen..."
    },
    "list": {
      "empty": {
        "description": "Erstellen Sie Ihre erste E-Mail-Kampagne",
        "title": "Keine Kampagnen vorhanden"
      }
    },
    "name": "Name",
    "newCampaign": "Neue Kampagne",
    "noTemplate": "Ohne Vorlage",
    "pause": {
      "button": "Pausieren",
      "confirm": "Kampagnenversand pausieren? Der aktuelle Empfänger wird noch fertig versendet.",
      "failed": "Kampagne konnte nicht pausiert werden.",
      "success": "Kampagne wurde pausiert.",
      "title": "Kampagne pausieren"
    },
    "preview": {
      "refresh": "Vorschau aktualisieren",
      "title": "Vorschau"
    },
    "recipients": {
      "actions": "Aktionen",
      "add": "Empfänger hinzufügen",
      "added": "{{count}} Empfänger hinzugefügt",
      "clear": "Alle entfernen",
      "company": "Firma",
      "confirmClear": "Möchten Sie alle Empfänger entfernen?",
      "confirmDelete": "Diesen Empfänger wirklich entfernen?",
      "delete": "Entfernen",
      "deleteFailed": "Empfänger konnte nicht entfernt werden.",
      "deleteSuccess": "Empfänger entfernt",
      "existingCount": "{{count}} Empfänger bereits hinzugefügt",
      "filterAll": "Alle",
      "filterType": "Typ filtern",
      "limitReached": "Versandlimit erreicht ({{sent}}/{{limit}})",
      "mode": "Modus",
      "modeAll": "Alle Kontakte",
      "modeByCompany": "Nach Firma",
      "modeManual": "Manuell auswählen",
      "modeUpload": "Excel/CSV hochladen",
      "noRecipients": "Keine Empfänger hinzugefügt",
      "onlyWithEmail": "Nur mit E-Mail",
      "previewTitle": "Empfänger-Vorschau",
      "reset": "Zurücksetzen",
      "resetConfirm": "Status von {{email}} zurücksetzen?",
      "resetFailed": "Empfänger konnten nicht zurückgesetzt werden.",
      "resetStatus": "Zurücksetzen",
      "resetSuccess": "Status zurückgesetzt",
      "search": "Empfänger suchen...",
      "searchCompanies": "Firma suchen...",
      "selectCompanies": "Firmen auswählen",
      "selectContacts": "Kontakte auswählen",
      "selected": "{{count}} ausgewählt",
      "send": "Senden",
      "sendConfirm": "E-Mail jetzt an {{email}} senden?",
      "sendFailed": "Kampagne konnte nicht gesendet werden.",
      "sendLimit": "Versandlimit",
      "sendLimitHint": "Max. Empfänger pro Versand (leer = alle)",
      "sendSingle": "Senden",
      "sendSuccess": "E-Mail gesendet",
      "statusTitle": "Empfänger-Status",
      "syncStatus": "Status aktualisieren",
      "title": "Empfänger",
      "total": "{{count}} Empfänger total",
      "uploadBtn": "Datei hochladen",
      "uploadErrors": "Fehler",
      "uploadHint": "Excel (.xlsx) oder CSV-Datei mit E-Mail-Adressen hochladen",
      "uploadResult": "{{added}} hinzugefügt, {{skipped}} übersprungen ({{total}} total)",
      "viewAll": "Alle {{count}} Empfänger anzeigen"
    },
    "replyTo": "Antwort-Adresse",
    "resume": {
      "button": "Fortsetzen",
      "confirm": "Versand an {{count}} verbleibende Empfänger fortsetzen?",
      "failed": "Kampagne konnte nicht fortgesetzt werden.",
      "success": "Kampagne wurde fortgesetzt.",
      "title": "Kampagne fortsetzen"
    },
    "selectTemplate": "Vorlage auswählen",
    "send": {
      "confirmSend": "Kampagne jetzt an {{count}} Empfänger senden?",
      "paused": "Pausiert",
      "progress": "Fortschritt: {{sent}} von {{total}}",
      "rateHint": "5-120 E-Mails pro Minute (Standard: 30)",
      "rateLabel": "Versandgeschwindigkeit",
      "send": "Kampagne senden",
      "sendNow": "Jetzt senden",
      "sending": "Wird versendet...",
      "testEmail": "Test-E-Mail-Adresse",
      "testSend": "Test-Mail senden",
      "title": "Versenden"
    },
    "sendLimit": {
      "saveFailed": "Sendelimit konnte nicht gespeichert werden.",
      "saved": "Sendelimit gespeichert."
    },
    "sendLimitSaved": "Sendelimit gespeichert.",
    "sendSuccess": "Kampagne wird versendet",
    "stats": {
      "bounced": "Bounced",
      "clicked": "Geklickt",
      "delivered": "Zugestellt",
      "failed": "Fehlgeschlagen",
      "opened": "Geöffnet",
      "recipients": "Empfänger",
      "sent": "Gesendet"
    },
    "statuses": {
      "CANCELLED": "Abgebrochen",
      "DRAFT": "Entwurf",
      "PARTIALLY_SENT": "Teilweise versendet",
      "PAUSED": "Pausiert",
      "SENDING": "Wird versendet",
      "SENT": "Versendet"
    },
    "subject": "Betreff",
    "subtitle": "E-Mail-Kampagnen verwalten und versenden",
    "syncStatus": "Status aktualisieren",
    "template": "Vorlage",
    "testSendSuccess": "Test-E-Mail gesendet an {{email}}",
    "title": "Kampagnen",
    "updateSuccess": "Kampagne erfolgreich aktualisiert"
  },
  "ceoAgent": {
    "batch": {
      "description": "Verarbeite mehrere offene Pendenzen mit KI auf einmal.",
      "run": "5 Tasks verarbeiten",
      "title": "Batch-Verarbeitung"
    },
    "results": {
      "title": "Ergebnisse"
    },
    "status": {
      "available": "KI verfügbar",
      "openTasks": "Offene Pendenzen",
      "pendingAI": "Wartend auf KI",
      "processedToday": "Heute verarbeitet"
    },
    "subtitle": "Autonomer KI-Assistent für Pendenzen",
    "suggestions": {
      "empty": "Keine Vorschläge — alles erledigt!",
      "process": "Verarbeiten",
      "title": "Vorschläge"
    },
    "title": "Pendenzen-Assistent"
  },
  "ceoComposer": {
    "refine": {
      "label": "Was soll ich anpassen?",
      "placeholder": "z.B. Termin-/Telefon-Vorschläge entfernen, um schriftliche Antwort bitten",
      "apply": "Anpassen",
      "regenerate": "Erneuern",
      "regenerateHint": "Mail frisch generieren — übernimmt gepinnte Notizen",
      "hint": "Der Basistext bleibt erhalten — nur das Gewünschte wird geändert. Die vorherige Version bleibt im Verlauf."
    },
    "emptyState": {
      "contextAnchor": "Ich kenne diese Pendenz:",
      "loading": "Vorschläge werden geladen …",
      "quickStartHeading": "Gezielt loslegen",
      "linkCardTitle": "Kontakt, Firma oder Objekt verknüpfen",
      "linkCardDesc": "Verknüpfe eine Entität, damit der Assistent gezielte, ausführbare Vorschläge machen kann.",
      "linkContact": "Kontakt verknüpfen",
      "linkCompany": "Firma verknüpfen",
      "linkProperty": "Objekt verknüpfen",
      "inlineEmpty": "Aktuell keine konkreten Vorschläge verfügbar."
    },
    "suggestions": {
      "button": "Vorschläge"
    },
    "selection": {
      "asPostit": "📌 Als Post-it",
      "created": "Als Post-it gespeichert",
      "error": "Post-it konnte nicht gespeichert werden"
    },
    "investorMatch": {
      "manualButton": "KI-Käufer ermitteln",
      "title": "KI-Käufer-Ermittlung",
      "hint": "Findet passende Käufer aus dem CRM — strukturierter Vorfilter plus KI-Bewertung.",
      "run": "KI-Käufer ermitteln",
      "rerun": "Neu ermitteln",
      "confirmAction": "Bestätigen & ausführen",
      "linkProperty": "Objekt verknüpfen",
      "loading": "Käufer werden ermittelt …",
      "loadFailed": "Ermittlung fehlgeschlagen.",
      "retry": "Erneut versuchen",
      "empty": "Keine passenden Käufer gefunden.",
      "close": "Schliessen",
      "selectPropertyHint": "Diese Pendenz ist mit keinem Objekt verknüpft. Wähle ein Objekt für die Käufer-Ermittlung.",
      "searchPlaceholder": "Immobilie suchen…",
      "change": "Ändern",
      "candidateCount": "{{count}} Kandidaten",
      "aiUsed": "KI-bewertet",
      "aiNotUsed": "Nur Vorfilter",
      "fitScore": "Fit-Score: {{score}}%",
      "showReasoning": "Begründung anzeigen",
      "hideReasoning": "Begründung verbergen",
      "prefilterOnly": "Vorfilter-Score (ohne KI-Bewertung)",
      "rankedHint": "Bester Treffer zuerst — Fit-Score wie im Quality Gate.",
      "entityCompany": "Firma",
      "entityContact": "Person",
      "recommendation": {
        "strong": "Starker Treffer",
        "possible": "Möglicher Treffer",
        "weak": "Schwacher Treffer",
        "none": "Kein Treffer"
      },
      "rankLabel": "Rang {{rank}}"
    },
    "trace": {
      "title": "Was der Assistent gemacht hat",
      "sectionLink": "Verknüpfung",
      "sectionSearch": "Semantische Suche",
      "sectionSources": "Genutzte Quellen",
      "sectionPortfolio": "Portfolio-Kontext",
      "linkContact": "Kontakt",
      "linkCompany": "Firma",
      "linkProperty": "Immobilie",
      "noLink": "keine Verknüpfung",
      "searchHits": "Suche {{count}} Treffer",
      "searchUsed": "{{count}} genutzt",
      "searchNotRun": "Suche nicht ausgeführt",
      "query": "Query",
      "relevance": "Relevanz {{pct}}%",
      "sourcesUsed": "{{count}} Quelle(n) genutzt",
      "noCrmContext": "kein CRM-Kontext",
      "portfolioIncluded": "Portfolio-Daten beigelegt",
      "portfolioRequested": "Portfolio angefragt, aber nicht beigelegt",
      "showWeakHits_one": "{{count}} weiterer Treffer anzeigen",
      "showWeakHits_other": "{{count}} weitere Treffer anzeigen",
      "hideWeakHits": "Weitere Treffer ausblenden"
    },
    "aiUnavailable": "AI ist nicht konfiguriert. Bitte den API-Key unter Admin > System hinterlegen.",
    "assignedTo": "Zuständig",
    "attachments": {
      "add": "Anhang hinzufügen",
      "contextCount": "{{count}}/{{total}} im Kontext",
      "deleted": "Anhang gelöscht",
      "excludedFromContext": "Nicht im Kontext",
      "fileTooLarge": "Datei zu gross: {{name}}",
      "inContext": "Im Kontext",
      "uploadError": "Anhang konnte nicht hochgeladen werden",
      "uploaded": "Anhang hochgeladen"
    },
    "backToTasks": "Zurück zu Pendenzen",
    "bccPlaceholder": "bcc@example.com",
    "ccPlaceholder": "cc1@example.com, cc2@example.com",
    "chatReset": "Chatverlauf zurückgesetzt",
    "chatResetError": "Chatverlauf konnte nicht zurückgesetzt werden",
    "chips": {
      "email": "E-Mail verfassen",
      "followup": "Follow-up",
      "noContact": "Kein Kontakt verknüpft. Bitte zuerst einen Kontakt zuweisen.",
      "noEmail": "Der Kontakt hat keine E-Mail-Adresse hinterlegt.",
      "research": "Kontakt recherchieren",
      "summary": "Zusammenfassung",
      "companyResearch": "Firma recherchieren"
    },
    "chunks": {
      "title": "Notizen",
      "save": "Als Notiz speichern",
      "alreadySaved": "Bereits als Notiz gespeichert",
      "saved": "Notiz gespeichert",
      "saveError": "Notiz konnte nicht gespeichert werden",
      "delete": "Notiz löschen",
      "deleted": "Notiz gelöscht",
      "deleteError": "Notiz konnte nicht gelöscht werden",
      "deleteConfirm": "Diese Notiz wirklich löschen?",
      "empty": "Keine Notizen — pinne Chat-Antworten um Wissen zu speichern",
      "sourceCompany": "Firma",
      "sourcePerson": "Person",
      "sourceManual": "Manuell",
      "sourceUserNote": "Notiz",
      "sourceEmailContext": "E-Mail",
      "sourceAi": "KI",
      "sourceChat": "Chat",
      "emailNoSubject": "(Kein Betreff)",
      "emailFrom": "Von:",
      "emailTo": "An:",
      "emailCc": "CC:",
      "emailExpand": "E-Mail aufklappen",
      "emailCollapse": "E-Mail zuklappen",
      "addNote": "Notiz hinzufügen",
      "edit": "Notiz bearbeiten",
      "expand": "Mehr anzeigen",
      "collapse": "Weniger anzeigen",
      "detach": "Verknüpfung entfernen",
      "notePlaceholder": "Notiz für KI-Kontext (z.B. «kein Videocall», «formal schreiben») — Enter zum Speichern, Shift+Enter für Zeilenumbruch",
      "noteHint": "Wird automatisch im KI-Kontext berücksichtigt",
      "noteAdded": "Notiz gespeichert",
      "noteAddError": "Notiz konnte nicht gespeichert werden",
      "pinFromChat": "Als Notiz speichern",
      "pinnedFromChat": "Als Notiz gespeichert",
      "pinnedFromChatBadge": "Bereits als Notiz gespeichert",
      "pinFromChatError": "Notiz konnte nicht gespeichert werden",
      "researchSaved": "{{count}} Recherche-Notizen erstellt",
      "researchSavedRaw": "Recherche als Notiz gespeichert",
      "researchSaveError": "Recherche-Notizen konnten nicht gespeichert werden",
      "sourceAiResponse": "Chat-Antwort",
      "sourceStrategyCards": "Strategie",
      "sourceChatCard": "Chat-Karte",
      "sourceContract": "Vertrag",
      "sourceAppKnowledge": "App-Wissen",
      "sourceCrmProfile": "CRM-Profil",
      "sourceDocument": "Dokument",
      "sourceResearchQuestion": "Recherche-Frage",
      "sourceEmailSent": "Gesendete E-Mail",
      "sourceOfficialData": "Amtsdaten",
      "noteUpdated": "Notiz aktualisiert",
      "noteUpdateError": "Notiz konnte nicht aktualisiert werden",
      "emptyWithNotes": "Noch keine Notizen — Notiz oben tippen oder Chat-Antworten pinnen",
      "scopeLocal": "Lokal (nur diese Pendenz)",
      "scopeLocalBadge": "Nur hier",
      "scopeAtProperty": "An Immobilie #{{id}}",
      "scopeAtPropertyLabel": "An Immobilie: {{label}}",
      "scopeAtContact": "An Kontakt: {{name}}",
      "scopeAtContactId": "An Kontakt #{{id}}",
      "scopeAtCompany": "An Organisation: {{name}}",
      "scopeAtCompanyId": "An Organisation #{{id}}",
      "pin": "Als relevant pinnen",
      "unpin": "Pin entfernen",
      "pinned": "Notiz gepinnt",
      "unpinned": "Pin entfernt",
      "pinError": "Pin konnte nicht gesetzt werden",
      "pinnedSection": "Gepinnt ({{count}})",
      "historyShow": "Verlauf anzeigen ({{count}})",
      "historyHide": "Verlauf ausblenden",
      "historyBadge": "Verlauf",
      "historyBadgeHint": "Automatisch aus dem Chat gespeichert — nicht als Notiz angeheftet",
      "pinToCompany": "An Firma heften",
      "pinToCompanyNamed": "An Firma «{{name}}» heften",
      "pinToCompanyShort": "An Firma",
      "pinToContact": "An Kontakt heften",
      "pinToContactNamed": "An Kontakt «{{name}}» heften",
      "pinToContactShort": "An Kontakt",
      "pinToProperty": "An Immobilie heften",
      "pinToPropertyNamed": "An Immobilie «{{label}}» heften",
      "pinToPropertyShort": "An Immobilie",
      "createContact": "Kontakt im CRM erstellen",
      "createContactShort": "Kontakt",
      "createCompany": "Organisation im CRM erstellen",
      "createCompanyShort": "Organisation",
      "createSubtask": "Sub-Pendenz erstellen",
      "attachToExisting": "An bestehenden Eintrag anhängen",
      "attachShort": "Anhängen",
      "dragHandle": "Notiz verschieben",
      "dragHint": "Notizen per Drag & Drop in den Ziel-Bereich ziehen — die Reihenfolge bestimmt den E-Mail-Aufbau",
      "pinnedEmptyDropHint": "Notizen hierhin ziehen, um die E-Mail-Reihenfolge festzulegen",
      "reorderSaved": "Reihenfolge gespeichert",
      "reorderError": "Reihenfolge konnte nicht gespeichert werden",
      "a11yDragStart": "Notiz {{id}} wird gezogen",
      "a11yDragOverPinned": "Notiz {{id}} über dem Ziel-Bereich",
      "a11yDragOverUnpinned": "Notiz {{id}} über Recherche-Bereich",
      "a11yDragEndPinned": "Notiz {{id}} im Ziel-Bereich abgelegt",
      "a11yDragEndUnpinned": "Notiz {{id}} aus Ziel-Bereich entfernt",
      "a11yDragCancel": "Verschieben abgebrochen",
      "pinnedToMain": "An Hauptpendenz gepinnt",
      "convertedToSubtask": "→ Sub-Pendenz #{{id}}",
      "convertedToSubtaskHint": "Zur Sub-Pendenz springen"
    },
    "clearContext": "Kontext-Auswahl leeren",
    "company": "Firma",
    "contact": "Kontakt",
    "property": "Immobilie",
    "contextIncluded": "Pendenzen als Kontext",
    "contextView": {
      "agentPreview": "Was der CEO-Agent sieht",
      "ancestors": "Pfad im Baum",
      "inherited": "Vererbter Kontext",
      "own": "Eigener Kontext",
      "placeholder": "Kontext für diese Pendenz definieren...\\n\\nz.B. Warum existiert diese Aufgabe? Welche Informationen soll der CEO-Agent berücksichtigen?",
      "treeSelector": "Kontext-Auswahl im Baum"
    },
    "createdBy": "Erstellt von",
    "creating": "Erstelle...",
    "edit": "Bearbeiten",
    "emailPreview": "E-Mail-Vorschau",
    "emailSettings": {
      "title": "E-Mail-Einstellungen",
      "options": "Optionen",
      "tone": "Ton",
      "length": "Länge",
      "purpose": "Zweck",
      "language": "Sprache",
      "contextHint": "Kontext: {{docs}} Dokument(e), {{nodes}} Pendenz(en) ausgewählt. Über die Anhänge- und Kontext-Auswahl steuerbar.",
      "brief": "Auftrag",
      "briefPlaceholder": "Was soll die E-Mail bewirken? (leer lassen für rein kontextbasiert)",
      "recipient": "Empfänger",
      "noRecipient": "Kein Kontakt verknüpft",
      "emailsInHistory": "{{count}} E-Mail(s) im Verlauf",
      "autoContext": {
        "pinnedKnowledge": "{{count}} gepinnte Notizen"
      },
      "create": "E-Mail erstellen",
      "fromContext": "E-Mail aus Ziel und Kontext erstellen",
      "tones": {
        "visionary": "Visionär",
        "pragmatic": "Pragmatisch",
        "formal": "Formell"
      },
      "lengths": {
        "short": "Kurz",
        "medium": "Mittel",
        "detailed": "Ausführlich"
      },
      "purposes": {
        "first_contact": "Erstkontakt",
        "follow_up": "Follow-Up",
        "offer": "Angebot",
        "forward": "Weiterleitung"
      },
      "languages": {
        "de": "Deutsch",
        "en": "Englisch",
        "fr": "Französisch",
        "it": "Italienisch"
      }
    },
    "error": "Fehler bei der Verarbeitung. Bitte erneut versuchen.",
    "errorInvalidInput": "Ungueltige Eingabe — bitte erneut versuchen.",
    "findings": "Erkenntnisse",
    "from": "Von",
    "fromCompany": "Firma",
    "fromDefault": "Standard",
    "fromPrivate": "Privat",
    "hierarchy": "Hierarchie",
    "hint": "Schreibe frei — der Agent hilft bei E-Mails, Recherche, Follow-ups und mehr.",
    "noContactLinked": "Kein Kontakt oder Firma verknüpft.",
    "noEmail": "Noch keine E-Mail generiert. Frage den Agenten, eine E-Mail zu verfassen.",
    "noResearch": "Keine Recherche-Ergebnisse. Frage den Agenten, einen Kontakt oder eine Firma zu recherchieren.",
    "panel": {
      "actionPreview": "Aktions-Vorschau",
      "companyResearch": "KI Recherche",
      "contactOrg": "Kontakt/Firma",
      "contextView": "Kontext",
      "details": "Details",
      "email": "E-Mail-Vorschau",
      "findings": "Erkenntnisse",
      "overview": "Übersicht",
      "research": "Recherche",
      "subtasks": "Sub-Pendenzen",
      "treeDetail": "Baum-Navigation",
      "workflow": "Workflow"
    },
    "panels": {
      "companyResearch": "KI Recherche",
      "details": "Details",
      "email": "E-Mail",
      "overview": "Übersicht",
      "research": "Recherche"
    },
    "participantHint": "Teilnehmer als Vorschläge verfügbar — im CC-Feld tippen",
    "pinError": "Pin konnte nicht gesetzt werden",
    "pinRemoved": "Pin entfernt",
    "pinSaved": "Erkenntnis gespeichert",
    "placeholder": "Nachricht eingeben...",
    "preview": "Vorschau",
    "removePin": "Pin entfernen",
    "researchPanel": {
      "keyPersons": "Schlüsselpersonen (aus Recherche)"
    },
    "richMarkdown": {
      "miniCardsLabel": "Strukturierte Daten",
      "nextStepsTitle": "Nächste Schritte"
    },
    "saveInsight": "Als Erkenntnis speichern",
    "send": "Senden",
    "sendError": "E-Mail konnte nicht gesendet werden.",
    "sendNow": "Jetzt senden",
    "sending": "Wird gesendet...",
    "sent": "Gesendet",
    "skills": {
      "actionError": "Aktion konnte nicht ausgeführt werden",
      "addNote": "Notiz erstellen",
      "companyUpdated": "Firmendaten aktualisiert",
      "contactUpdated": "Kontaktdaten aktualisiert",
      "createSubtask": "Sub-Pendenz erstellen",
      "enrichCompany": "Firma anreichern",
      "enrichContact": "Kontakt anreichern",
      "noteSaved": "Notiz gespeichert",
      "subtaskCreated": "Sub-Pendenz erstellt"
    },
    "skillChips": {
      "ariaLabel": "Skill für die nächste Nachricht",
      "modeHint": "Modus: {{mode}}",
      "research": "Recherche",
      "email": "E-Mail",
      "companyResearch": "Firma recherchieren",
      "personResearch": "Person recherchieren",
      "textGenerate": "Text generieren",
      "contextResearch": "Kontext recherchieren",
      "emailDraft": "E-Mail entwerfen",
      "noteCreate": "Notiz erstellen",
      "subtask": "Sub-Pendenz",
      "summarize": "Zusammenfassen",
      "matchInvestors": "KI-Käufer"
    },
    "researchType": {
      "label": "Recherche-Typ",
      "auto": "automatisch erkannt",
      "autoReset": "Automatisch erkennen",
      "menuAria": "Recherche-Typ wählen",
      "deepRunning": "Tiefe Recherche läuft …",
      "types": {
        "firmen_profil": "Firma",
        "person": "Person",
        "produkt_api": "Produkt/API",
        "preise": "Preise",
        "markt": "Markt"
      }
    },
    "strategyPostIts": {
      "title": "Vorschläge — als Notiz",
      "subtitle": "Pinnen, als Sub-Pendenz erstellen oder an Kontakt / Firma / Immobilie heften.",
      "types": {
        "research": "Recherche",
        "email": "E-Mail",
        "note": "Notiz",
        "subtask": "Sub-Pendenz"
      },
      "actions": {
        "pin": "An Ziel/Kontext heften",
        "subtask": "Sub-Pendenz erstellen",
        "attach": "An Kontakt / Firma / Immobilie heften",
        "attachShort": "Anhängen an…"
      },
      "pinned": "Vorschlag als Notiz gepinnt",
      "pinError": "Vorschlag konnte nicht gepinnt werden",
      "subtaskCreated": "Sub-Pendenz erstellt",
      "subtaskError": "Sub-Pendenz konnte nicht erstellt werden",
      "attachError": "Verknüpfung fehlgeschlagen"
    },
    "postItCard": {
      "kinds": {
        "advice": "Empfehlung",
        "strategy": "Strategie",
        "research": "Recherche",
        "fact": "Fakt",
        "action": "Aktion"
      },
      "handled": "Erledigt",
      "attachedTo": "📎 angeheftet an {{label}}",
      "actions": {
        "pin": "Pinnen",
        "subtask": "Sub-Pendenz",
        "attach": "Anhängen an…"
      },
      "notFound": "Notiz nicht gefunden",
      "pinned": "Als Notiz gepinnt",
      "pinError": "Karte konnte nicht gepinnt werden",
      "subtaskCreated": "Sub-Pendenz erstellt",
      "subtaskError": "Sub-Pendenz konnte nicht erstellt werden",
      "attachError": "Verknüpfung fehlgeschlagen"
    },
    "statusChangeError": "Status konnte nicht geändert werden",
    "subject": "Betreff",
    "subjectPlaceholder": "E-Mail-Betreff",
    "taskNotFound": "Pendenz nicht gefunden",
    "template": "Vorlage",
    "progress": {
      "queued": "Wird vorbereitet …",
      "elapsed": "{{seconds}}s",
      "longRunning": "Längere Recherche läuft – das Ergebnis erscheint automatisch. Du kannst jederzeit abbrechen."
    },
    "thinking": "Denke nach...",
    "to": "An",
    "treeNav": {
      "addToContext": "Zum Kontext hinzufügen",
      "contextSelected": "im Kontext ausgewählt",
      "hint": "Klick = Details, Doppelklick = Öffnen",
      "navigateTo": "Zur Pendenz navigieren",
      "noHierarchy": "Keine Hierarchie verfügbar",
      "openTask": "Pendenz öffnen",
      "removeFromContext": "Aus Kontext entfernen",
      "selectHint": "Klicke auf einen Eintrag im Baum, um die Details zu sehen.",
      "title": "Pendenzen-Baum"
    },
    "ttsError": "Vorlesen fehlgeschlagen.",
    "ttsPlay": "Antwort vorlesen",
    "ttsStop": "Vorlesen stoppen",
    "voiceDenied": "Mikrofon-Zugriff verweigert. Bitte in den Browser-Einstellungen erlauben.",
    "voiceError": "Fehler bei der Spracherkennung.",
    "voiceMaxDurationHint": "Max. {{minutes}} Min.",
    "voiceMicError": "Mikrofon konnte nicht aktiviert werden.",
    "voiceNoSpeech": "Keine Sprache erkannt. Bitte versuche es erneut.",
    "voiceNotSupported": "Spracheingabe wird in diesem Browser nicht unterstützt. Bitte Chrome oder Edge verwenden.",
    "voiceStart": "Spracheingabe starten",
    "voiceStop": "Aufnahme stoppen",
    "voiceTimeout": "Aufnahme zu lang – die Transkription hat das Zeitlimit überschritten. Bitte mache kürzere Aufnahmen.",
    "voiceTooLong": "Aufnahme zu lang (max. 25 MB / ~25 Min). Bitte mache kürzere Aufnahmen.",
    "voiceTranscribing": "Transkription läuft...",
    "voiceTranscribingShort": "Transkribiere…",
    "welcome": "Was möchtest du mit dieser Pendenz machen?",
    "workflow": {
      "advanceError": "Workflow-Schritt konnte nicht fortgesetzt werden",
      "completed": "Workflow abgeschlossen!",
      "startError": "Workflow konnte nicht gestartet werden"
    },
    "pinTarget": {
      "title": "Wohin pinnen?",
      "description": "Du befindest dich in einer Sub-Pendenz. Wähle, an welcher Pendenz die Notiz erscheinen soll.",
      "sub": "An diese Sub-Pendenz",
      "main": "An die Hauptpendenz",
      "mainFallback": "Hauptpendenz"
    },
    "demoMessage": {
      "label": "Nachricht des Interessenten"
    }
  },
  "changelog": {
    "title": "Neuigkeiten",
    "typeFixed": "Behoben",
    "typeImproved": "Verbessert",
    "typeNew": "Neu"
  },
  "chunkAttach": {
    "attachAction": "An Entität anhängen",
    "attachError": "Notiz konnte nicht verknüpft werden",
    "attached": "Notiz verknüpft",
    "badgeCompany": "Organisation",
    "badgeContact": "Kontakt",
    "badgeProperty": "Immobilie",
    "badgeTask": "Pendenz",
    "detachConfirm": "Verknüpfung wirklich entfernen?",
    "detachError": "Verknüpfung konnte nicht entfernt werden",
    "detachHint": "Klick zum Entfernen",
    "detached": "Verknüpfung entfernt",
    "minChars": "Mindestens 2 Zeichen eingeben",
    "noResults": "Keine Ergebnisse gefunden",
    "searchCompany": "Organisation suchen...",
    "searchContact": "Kontakt suchen...",
    "searchProperty": "Immobilie suchen...",
    "startTyping": "Beginne zu tippen, um zu suchen.",
    "subtitle": "Mit welcher Entität soll die Notiz verknüpft werden?",
    "tabCompany": "Organisation",
    "tabContact": "Kontakt",
    "tabProperty": "Immobilie",
    "tabsAriaLabel": "Entitätstyp wählen",
    "title": "Notiz anhängen"
  },
  "createFromChunk": {
    "headerContact": "Kontakt im CRM erstellen",
    "headerCompany": "Organisation im CRM erstellen",
    "subtitle": "Aus dieser Notiz",
    "chunkSource": "Notiz",
    "parsing": "Notiz wird analysiert...",
    "parseError": "Notiz konnte nicht analysiert werden.",
    "parseFailed": "Analyse fehlgeschlagen",
    "parsedContact": "Erkannter Kontakt",
    "parsedCompany": "Erkannte Organisation",
    "unnamed": "Unbenannt",
    "possibleDuplicates": "Mögliche Duplikate ({{count}})",
    "duplicateHint": "Es gibt bereits Einträge mit diesem Namen. Wähle eine Aktion:",
    "actionMerge": "Zusammenführen",
    "actionAttach": "Als Notiz anhängen",
    "actionCreateContact": "Kontakt erstellen",
    "actionCreateCompany": "Organisation erstellen",
    "actionCreateAnyway": "Trotzdem neu erstellen",
    "created": "Neuer Eintrag wurde erstellt.",
    "createdToast": "Eintrag erstellt",
    "createError": "Eintrag konnte nicht erstellt werden",
    "merged": "Eintrag wurde mit neuen Informationen aktualisiert.",
    "mergedToast": "Eintrag mit neuen Infos angereichert",
    "mergeError": "Anreicherung fehlgeschlagen",
    "attached": "Notiz wurde angehängt.",
    "attachedToast": "Als Notiz angehängt",
    "attachError": "Anhängen fehlgeschlagen",
    "success": "Geschafft!"
  },
  "commissions": {
    "chart": {
      "atPrice": "bei",
      "commission": "Honorar",
      "rate": "Eff. Satz",
      "title": "Honorarverlauf"
    },
    "default": "Standard",
    "loading": "Honorarmodelle laden...",
    "settings": {
      "addBracket": "Stufe hinzufügen",
      "bracketFrom": "Von",
      "bracketRate": "Satz",
      "bracketTo": "Bis",
      "brackets": "Stufen",
      "bracketsHint": "Die erste Stufe beginnt immer bei CHF 0. Der Satz gilt jeweils nur für den Betrag innerhalb der Stufe.",
      "bracketsLabel": "Marginal-Stufen",
      "createNew": "Neues Modell",
      "createSuccess": "Honorarmodell erfolgreich erstellt",
      "createTitle": "Honorarmodell erstellen",
      "default": "Standard",
      "defaultBadge": "Standard",
      "deleteConfirm": "Möchten Sie das Modell «{{name}}» wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteError": "Fehler beim Löschen",
      "deleteSuccess": "Honorarmodell erfolgreich gelöscht",
      "deleteTitle": "Honorarmodell löschen",
      "editTitle": "Honorarmodell bearbeiten",
      "flatRate": "Pauschal-Satz",
      "namePlaceholder": "z.B. Standard-Marginalmodell",
      "noModels": "Keine Honorarmodelle vorhanden",
      "rate": "Satz / Stufen",
      "saveError": "Fehler beim Speichern",
      "setActive": "Aktiv",
      "setDefault": "Als Standard-Modell setzen",
      "subtitle": "Honorarmodelle für Verträge erstellen und verwalten",
      "title": "Honorarmodelle",
      "type": "Typ",
      "typeHints": {
        "FLAT": "Einheitlicher Satz",
        "MARGINAL": "Degressive Stufen"
      },
      "types": {
        "FLAT": "Flat Rate",
        "MARGINAL": "Marginal"
      },
      "updateSuccess": "Honorarmodell erfolgreich aktualisiert"
    },
    "source": {
      "appendix_b": "Anhang B",
      "property": "Objekt",
      "framework": "Rahmenvertrag",
      "default": "Standard",
      "none": "Keine",
      "hint": "Quelle der geltenden Kondition: {{source}}"
    }
  },
  "common": {
    "actions": "Aktionen",
    "active": "Aktiv",
    "add": "Hinzufügen",
    "address": "Adresse",
    "all": "Alle",
    "back": "Zurück",
    "cancel": "Abbrechen",
    "check": "Prüfen",
    "city": "Ort",
    "clearFilters": "Filter zurücksetzen",
    "clearSelection": "Auswahl aufheben",
    "close": "Schliessen",
    "confirm": "Bestätigen",
    "copy": "Kopieren",
    "create": "Erstellen",
    "createNew": "Neu erstellen",
    "date": "Datum",
    "days": "Tage",
    "delete": "Löschen",
    "deleted": "Entfernt",
    "description": "Beschreibung",
    "deselectAll": "Alle abwählen",
    "details": "Details",
    "done": "Fertig",
    "download": "Herunterladen",
    "edit": "Bearbeiten",
    "email": "E-Mail",
    "employees": "Mitarbeiter",
    "error": "Fehler",
    "export": "Exportieren",
    "field": "Feld",
    "filter": "Filtern",
    "filtered": "gefiltert",
    "firstName": "Vorname",
    "import": "Importieren",
    "inactive": "Inaktiv",
    "industry": "Branche",
    "info": "Info",
    "languages": {
      "de": "Deutsch",
      "en": "English",
      "fr": "Français",
      "it": "Italiano"
    },
    "lastName": "Nachname",
    "less": "Weniger",
    "linkedin": "LinkedIn",
    "loading": "Laden...",
    "location": "Standort",
    "merge": "Zusammenführen",
    "more": "Mehr",
    "name": "Name",
    "new": "NEU",
    "next": "Weiter",
    "no": "Nein",
    "noResults": "Keine Ergebnisse",
    "none": "Keine",
    "notFound": "Nicht gefunden",
    "notes": "Notizen",
    "nothingRecorded": "Noch nichts erfasst",
    "phone": "Telefon",
    "pin": "Anpinnen",
    "position": "Position",
    "preview": "Vorschau",
    "previous": "Zurück",
    "refresh": "Aktualisieren",
    "refreshed": "Aktualisiert",
    "remove": "Entfernen",
    "required": "Pflichtfeld",
    "reset": "Zurücksetzen",
    "resizeColumn": "Spaltenbreite anpassen (Doppelklick zum Zurücksetzen)",
    "resizePanes": "Trennlinie verschieben (Pfeiltasten zum Anpassen)",
    "retry": "Erneut versuchen",
    "revenue": "Umsatz",
    "save": "Speichern",
    "saveAndClose": "Speichern und schliessen",
    "saved": "Gespeichert",
    "saving": "Wird gespeichert...",
    "saveStatus": {
      "idle": "Synchronisiert",
      "pending": "Änderungen ausstehend",
      "saving": "Wird gespeichert...",
      "saved": "Gespeichert",
      "error": "Speichern fehlgeschlagen"
    },
    "unsavedChanges": {
      "title": "Ungespeicherte Änderungen",
      "description": "Sie haben ungespeicherte Änderungen. Möchten Sie diese verwerfen und schliessen?",
      "discard": "Verwerfen & schliessen",
      "keepEditing": "Weiter bearbeiten"
    },
    "search": "Suchen",
    "select": "Bitte auswählen",
    "selectAll": "Alle auswählen",
    "showAll": "Alle anzeigen",
    "skip": "Überspringen",
    "status": "Status",
    "street": "Strasse",
    "success": "Erfolg",
    "uid": "UID",
    "unknown": "Unbekannt",
    "unknownError": "Unbekannter Fehler",
    "unpin": "Pin entfernen",
    "view": "Ansehen",
    "warning": "Warnung",
    "website": "Website",
    "yes": "Ja",
    "zip": "PLZ",
    "optional": "Optional",
    "print": "Drucken",
    "clear": "Leeren"
  },
  "companies": {
    "merge": {
      "activities": "Aktivitäten",
      "campaigns": "Kampagnen",
      "clickToSelect": "Wert anklicken um ihn auszuwählen",
      "contacts": "Kontakte",
      "contracts": "Verträge",
      "dataMergeDirection": "Daten werden in die Hauptfirma übernommen",
      "emailAccounts": "E-Mail-Konten",
      "emails": "E-Mails",
      "investorGroups": "Investorengruppen",
      "listings": "Listings",
      "mergeButton": "Zusammenführen",
      "offers": "Angebote",
      "phones": "Telefonnummern",
      "previewError": "Vergleich konnte nicht geladen werden",
      "previewFailed": "Vorschau fehlgeschlagen.",
      "properties": "Objekte",
      "relatedRecords": "Verbundene Datensätze",
      "secondaryDeactivated": "Sekundäre Organisationen werden deaktiviert, nicht gelöscht.",
      "tasks": "Pendenzen",
      "companiesSelected": "{{count}} Organisationen ausgewählt"
    },
    "name": "Firmenname"
  },
  "company": {
    "all": "Alle Firmen",
    "count": "{{count}} Firmen",
    "done": "Fertig",
    "filter": "Firmen-Filter",
    "noSelection": "Keine Firma",
    "switch": "Firma wechseln",
    "switchError": "Mandant konnte nicht gewechselt werden"
  },
  "companyContacts": {
    "columns": {
      "actions": "Aktionen",
      "email": "E-Mail",
      "functions": "Funktion(en)",
      "name": "Name",
      "organisation": "Organisation",
      "signature": "Zeichnung",
      "source": "Quelle",
      "status": "Status",
      "verified": "Verifiziert"
    },
    "duplicate": {
      "dialogLabel": "Kontakte zusammenführen",
      "hint": "Möglicherweise dieselbe Person",
      "merge": "Zusammenführen",
      "mergeSuccess": "Kontakte zusammengeführt",
      "mergeWith": "Mit {{name}} zusammenführen",
      "notSame": "Nicht dieselbe Person",
      "notSameAs": "Nicht dieselbe Person wie {{name}}",
      "notSameSaved": "Als verschiedene Personen gespeichert",
      "reasonFirstName": "Gleicher Nachname, ähnlicher Vorname",
      "reasonInitial": "Gleicher Nachname, Initiale passt"
    },
    "filters": {
      "active": "Aktiv",
      "import": "Import",
      "inactive": "Inaktiv",
      "label": "Kontakte filtern",
      "labelCompanies": "Organisationen filtern",
      "manual": "Manuell",
      "search": "Kontakte durchsuchen",
      "searchCompanies": "Organisationen durchsuchen",
      "withoutEmail": "Ohne E-Mail",
      "zefix": "Handelsregister"
    },
    "functions": {
      "add": "Funktion hinzufügen",
      "empty": "Keine Funktion erfasst",
      "listLabel": "Erfasste Funktionen",
      "remove": "Funktion «{{name}}» entfernen"
    },
    "groups": {
      "inactive": "Inaktiv ({{count}})",
      "other": "Weitere Kontakte",
      "otherCompanies": "Weitere Organisationen",
      "register": "Zeichnungsberechtigte (Handelsregister)",
      "registerCompanies": "Zeichnungsberechtigt (Handelsregister)"
    },
    "noResults": "Keine Kontakte für diese Filter",
    "noResultsCompanies": "Keine Organisationen für diese Filter",
    "removeCompany": "Organisation entfernen",
    "removeFromContact": "von diesem Kontakt entfernen?",
    "tableCaption": "Kontakte dieser Organisation",
    "tableCaptionCompanies": "Organisationen dieses Kontakts",
    "verified": "Verifiziert",
    "verifiedOn": "Verifiziert am {{date}}"
  },
  "companyDedup": {
    "fieldComparison": "Feldvergleich",
    "loadingPreview": "Vergleich wird geladen...",
    "mergeSuccess": "Organisationen erfolgreich zusammengeführt",
    "mergeTitle": "Organisationen zusammenführen"
  },
  "companyLookup": {
    "address": "Adresse",
    "createError": "Kontakte konnten nicht erstellt werden",
    "creating": "Kontakte werden erstellt...",
    "legalForm": "Rechtsform",
    "noSignatories": "Keine Zeichnungsberechtigten gefunden",
    "noSignatoriesHint": "Die SHAB-Daten für diese Firma sind nicht verfügbar (ältere Firmen oder fehlende Publikationen). Bitte tragen Sie die Zeichnungsberechtigten manuell ein.",
    "purpose": "Zweck",
    "searchLabel": "Firma aus Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "uid": "UID"
  },
  "companyRelations": {
    "add": "Verknüpfen",
    "added": "Organisation verknüpft",
    "addTitle": "Organisation verknüpfen",
    "auditedBy": "Revisionsstelle",
    "audits": "revidiert",
    "confirmDelete": "Verknüpfung wirklich entfernen?",
    "editTitle": "Verknüpfung bearbeiten",
    "empty": "Noch keine verbundenen Organisationen",
    "emptyHint": "Verbinden Sie Organisationen, die zusammengehören (z. B. Mutter/Tochter, Partner oder Schwestergesellschaft).",
    "loadFailed": "Verknüpfungen konnten nicht geladen werden",
    "notesLabel": "Notiz",
    "notesPlaceholder": "Optionale Notiz zur Beziehung (z. B. Tochterfirma, Schwesterfirma)...",
    "removed": "Verknüpfung entfernt",
    "targetLabel": "Organisation",
    "title": "Verbundene Organisationen",
    "types": {
      "auditor": "Revisionsstelle",
      "customer": "Kunde",
      "other": "Sonstige",
      "parent_subsidiary": "Mutter/Tochter",
      "partner": "Partner",
      "predecessor": "Vorgänger",
      "sister": "Schwesterfirma",
      "supplier": "Lieferant"
    },
    "updated": "Verknüpfung aktualisiert"
  },
  "companyResearch": {
    "approveError": "Fehler beim Anlegen",
    "approved": "Firma und Kontakte wurden angelegt",
    "approving": "Wird angelegt...",
    "extracting": "Extrahiere Firma und Kontakte...",
    "unknownCompany": "Firma",
    "openFullProfile": "Vollständiges Profil anzeigen",
    "companyDraft": "Firma-Entwurf",
    "name": "Firmenname",
    "legalForm": "Rechtsform",
    "street": "Strasse",
    "houseNr": "Nr.",
    "zip": "PLZ",
    "city": "Ort",
    "canton": "Kanton",
    "website": "Website",
    "phone": "Telefon",
    "email": "E-Mail",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "role": "Funktion",
    "results": "Recherche-Ergebnis",
    "contacts": "Kontakte",
    "addContact": "Kontakt hinzufügen",
    "approve": "Firma + Kontakte anlegen",
    "empty": "Keine KI-Recherche vorhanden. Frage den Agenten, eine Firma oder Person zu recherchieren."
  },
  "contactDedup": {
    "assignCompany": "Weitere Firma zuordnen (optional)",
    "backToScan": "Zurück zum Scan",
    "companySection": "Firmen-Zuordnungen",
    "companySectionDesc": "Alle Firmen-Verknüpfungen werden auf den Hauptkontakt übertragen.",
    "companyWillBeAssigned": "Wird nach dem Zusammenführen zugeordnet",
    "contactsAffected": "Betroffene Kontakte",
    "empty": "(leer)",
    "executeMerge": "Zusammenführen",
    "field": "Feld",
    "fieldComparison": "Feldvergleich",
    "fieldComparisonDesc": "Wähle für jedes Feld welcher Wert übernommen werden soll.",
    "groupsFound": "Duplikat-Gruppen",
    "loadingCompanies": "Firmen werden geladen...",
    "loadingPreview": "Vergleich wird geladen...",
    "merge": "Zusammenführen",
    "mergeError": "Fehler beim Zusammenführen:",
    "mergeSuccess": "Kontakte erfolgreich zusammengeführt!",
    "mergeWarning": "Die sekundären Kontakte werden deaktiviert (nicht gelöscht).",
    "minScore": "Min. Score",
    "noCompanyLinks": "Keine Firmen-Zuordnungen vorhanden",
    "noDuplicates": "Keine Duplikate gefunden",
    "noDuplicatesDesc": "Alle Kontakte sind einzigartig.",
    "primaryContact": "Hauptkontakt",
    "related": {
      "activities": "Aktivitäten",
      "campaignRecipients": "Kampagnen-Empfänger",
      "companyAssignments": "Firmen-Zuordnungen",
      "contracts": "Verträge",
      "emailAddresses": "E-Mail-Adressen",
      "infoOwners": "Info-Berechtigungen",
      "investorGroups": "Investoren-Gruppen",
      "knowledgeChunks": "Wissens-Abschnitte",
      "notifications": "Benachrichtigungen",
      "propertyRefs": "Objekt-Verknüpfungen",
      "signatures": "Unterschriften",
      "syncedEmails": "Synchronisierte E-Mails",
      "tags": "Tags",
      "tasks": "Pendenzen",
      "tokens": "Zugangs-Links",
      "userAccount": "Benutzerkonto"
    },
    "relatedSection": "Wird übernommen",
    "relatedSectionDesc": "Diese Datensätze der sekundären Kontakte werden auf den Hauptkontakt umgehängt.",
    "scan": "Duplikate suchen",
    "scanMore": "Weitere Duplikate suchen",
    "searchCompany": "Firma suchen und zuordnen...",
    "selectPrimary": "Primären Kontakt wählen",
    "selectPrimaryDesc": "Der primäre Kontakt bleibt erhalten. Alle anderen werden zusammengeführt.",
    "setAsPrimary": "Als Hauptkontakt",
    "source": "Quelle",
    "step1": "Duplikate suchen",
    "step2": "Prüfen & Zusammenführen",
    "step3": "Ergebnis",
    "subtitle": "Duplikate erkennen und zusammenführen",
    "title": "Kontakt-Deduplizierung",
    "totalContacts": "Kontakte gesamt",
    "userAccountConflictDesc": "Ein Kontakt darf nur ein Benutzerkonto haben. Das Zusammenführen wird deshalb abgelehnt. Deaktiviere zuerst eines der beiden Konten oder wähle den Kontakt mit dem gewünschten Konto als Hauptkontakt.",
    "userAccountConflictTitle": "Beide Kontakte haben ein Benutzerkonto"
  },
  "contactImport": {
    "backToOverview": "Zurück zur Übersicht",
    "clickToExclude": "Klicke auf einen Kontakt um ihn vom Import auszuschliessen.",
    "confirmImport": "Import bestätigen",
    "connected": "Verbunden",
    "continueImport": "Import fortsetzen",
    "duplicates": "Duplikate",
    "enrichExisting": "Bestehende anreichern:",
    "enrichableLabel": "Anreicherbar",
    "errorLoading": "Fehler beim Laden",
    "finishAnyway": "Trotzdem abschliessen",
    "goToContacts": "Zu den Kontakten",
    "goToSettings": "Zu den Einstellungen",
    "google": {
      "checkAccount": "Bitte Google-Konto prüfen.",
      "contacts": "Google Kontakte",
      "enrichExisting": "Bestehende Kontakte mit Google-Daten anreichern",
      "loading": "Google Kontakte werden geladen...",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Google-Konto in Immotron.",
      "title": "Google Kontakte importieren",
      "titleShort": "Google Import"
    },
    "importButton": "Importieren",
    "importComplete": "Import abgeschlossen",
    "importFailed": "Import fehlgeschlagen",
    "importNow": "Jetzt importieren",
    "importing": "Importiere...",
    "inImmotron": "In Immotron",
    "inactive": "Deaktiviert",
    "linkedinDesc": "JSON-Upload oder Browser-Extension",
    "microsoft": {
      "allFolders": "Alle Ordner (empfohlen)",
      "allFoldersHint": "Durchsucht das gesamte Postfach — alle Kontaktordner ab Root rekursiv",
      "backToFolders": "Zurück zur Ordnerübersicht",
      "changeFolder": "Ordner wechseln",
      "checkAccount": "Bitte Microsoft-Konto prüfen.",
      "chooseAnotherFolder": "Anderen Ordner wählen",
      "chooseFolderHint": "Wähle den Kontaktordner oder nutze «Alle Ordner» um das gesamte Postfach ab Root rekursiv zu durchsuchen.",
      "contacts": "Microsoft Kontakte",
      "empty": "Leer",
      "emptyFolderHint": "Der gewählte Ordner ist leer — versuche «Alle Ordner» um das gesamte Postfach zu durchsuchen.",
      "enrichExisting": "Bestehende Kontakte mit Microsoft-Daten anreichern",
      "expiredHint": "Die Microsoft-Verbindung ist abgelaufen — verbinde dein Konto unter Einstellungen neu.",
      "includeSubfolders": "Unterordner einschliessen",
      "includeSubfoldersHint": "Beim Import eines Ordners werden auch alle darunter liegenden Ordner durchsucht.",
      "loading": "Microsoft Kontakte werden geladen...",
      "loadingFolders": "Kontaktordner werden geladen...",
      "noContactsFound": "Keine Kontakte gefunden",
      "noContactsHint": "Dieser Ordner enthält keine Kontakte. Das kann folgende Gründe haben:",
      "reconnectAccount": "Konto neu verbinden",
      "subtitle": "Importiere Kontakte aus deinem verbundenen Microsoft 365 Konto in Immotron.",
      "title": "Microsoft 365 Kontakte importieren",
      "titleShort": "Microsoft Import",
      "tokenExpired": "Microsoft-Verbindung abgelaufen",
      "tokenExpiredDetail": "Der Zugriff auf dein Microsoft-Konto ist abgelaufen. Bitte verbinde dein Konto unter Einstellungen neu und versuche es erneut."
    },
    "needsReauth": "Erneut verbinden",
    "newContacts": "Neue Kontakte",
    "newContactsToImport": "Neue Kontakte importieren:",
    "newImport": "Neu importieren",
    "nextConfirm": "Weiter: Import bestätigen",
    "nextReview": "Weiter: Kontakte prüfen",
    "noAccounts": "Keine E-Mail-Konten verbunden",
    "noAccountsHint": "Verbinde ein Google- oder Microsoft-Konto unter Einstellungen → E-Mail-Konten, um Kontakte zu importieren.",
    "noEmail": "Ohne E-Mail",
    "noLastName": "Ohne Nachnamen",
    "noLastNameBadge": "Kein Nachname",
    "noLastNameDescription": "Diese Kontakte haben keinen Nachnamen und werden standardmässig nicht importiert. Klicke um einzelne hinzuzufügen.",
    "notInImmotron": "noch nicht in Immotron",
    "onlyInImmotron": "Nur in Immotron",
    "partiallyDone": "Import teilweise abgeschlossen",
    "progressSoFar": "Bisheriger Fortschritt:",
    "refresh": "Aktualisieren",
    "selectSeparately": "separat auswählbar",
    "skipped": "Übersprungen:",
    "steps": {
      "analyze": "Analysieren",
      "done": "Fertig",
      "folders": "Ordner",
      "import": "Import",
      "review": "Prüfen"
    },
    "subtitle": "Kontakte aus verbundenen Konten oder LinkedIn importieren",
    "summary": "Import-Zusammenfassung",
    "title": "Kontaktimport"
  },
  "contacts": {
    "addAddress": "Adresse hinzufügen",
    "addCompany": "Organisation hinzufügen",
    "addContact": "Neuer Kontakt",
    "addInfoOwner": "Info-Eigner hinzufügen",
    "newContactPlaceholder": "Neuer Kontakt",
    "addTagPlaceholder": "Tag hinzufugen...",
    "address": "Adresse",
    "addressAdded": "Adresse hinzugefügt",
    "addressCity": "Ort",
    "addressCountry": "Land",
    "addressRemoved": "Adresse entfernt",
    "addressStreet": "Strasse",
    "addressZip": "PLZ",
    "allCompanies": "Firma",
    "allTags": "Tags",
    "alreadyRecorded": "Bereits erfasst",
    "assignedViaCompanies": "Über Firmen zugeordnet",
    "birthday": "Geburtstag",
    "companies": "Organisationen",
    "company": "Firma",
    "companyAdded": "Organisation erfolgreich zugeordnet",
    "companyAssignments": "Firmenzuordnungen",
    "companyCreated": "Firma aus Zefix angelegt",
    "companyOnly": "Nur mit Firma",
    "companyRemoved": "Zuordnung entfernt",
    "companyRoles": "Organisations-Zuordnungen",
    "companyUpdated": "Zuordnung aktualisiert",
    "confirmDelete": "Möchten Sie diesen Kontakt wirklich löschen?",
    "confirmRemoveCompany": "Möchten Sie diese Zuordnung wirklich entfernen?",
    "contact": "Kontakt",
    "createNewCompany": "Als Firma neu anlegen: «{{query}}»",
    "createNewPerson": "Als Person neu anlegen: «{{query}}»",
    "createSuccess": "Kontakt erfolgreich erstellt",
    "createUser": "User erstellen",
    "createdAt": "Erstellt",
    "creatingCompany": "Firma wird angelegt...",
    "currentPosition": "Aktuelle Position",
    "deleteContact": "Kontakt löschen",
    "deleteSuccess": "Kontakt erfolgreich gelöscht",
    "detailsLoadFailed": "Details konnten nicht geladen werden",
    "directlyAssigned": "Direkt zugeordnet",
    "duplicateBannerHint": "Prüfen und bei Bedarf zusammenführen.",
    "duplicateBannerMany": "{{count}} mögliche Duplikate",
    "duplicateBannerOne": "1 mögliches Duplikat",
    "duplicateCheckAria": "Duplikat {{name}} prüfen",
    "editContact": "Kontakt bearbeiten",
    "email": "E-Mail",
    "emailOptional": "E-Mail (optional)",
    "emailStatuses": {
      "BOUNCED": "Zurückgewiesen",
      "CLICKED": "Geklickt",
      "DELIVERED": "Zugestellt",
      "FAILED": "Fehlgeschlagen",
      "OPENED": "Geöffnet",
      "PENDING": "Ausstehend",
      "SENT": "Gesendet"
    },
    "emails": {
      "campaign": "Kampagne",
      "contract": "Vertrag",
      "empty": "Keine E-Mails gesendet",
      "property": "Immobilie",
      "resend": "Erneut senden",
      "resendSuccess": "E-Mail wurde erneut gesendet",
      "source": "Quelle",
      "subject": "Betreff",
      "title": "E-Mails"
    },
    "existingCompanies": "Bestehende Firmen",
    "firstName": "Vorname",
    "function": "Funktion",
    "functionPlaceholder": "z.B. Geschäftsführer",
    "gender": "Geschlecht",
    "genderFemale": "Weiblich",
    "genderMale": "Männlich",
    "genderNotSet": "Nicht angegeben",
    "googleImport": "Google Import",
    "hasAccount": "Aktiv",
    "import": "Import",
    "infoOwnerAdded": "Info-Eigner hinzugefügt",
    "infoOwnerRemoved": "Info-Eigner entfernt",
    "infoOwners": "Info-Eigner",
    "langDe": "Deutsch",
    "langEn": "English",
    "langFr": "Français",
    "langIt": "Italiano",
    "languageAuto": "Automatisch (Deutsch)",
    "lastName": "Nachname",
    "lastNameRequired": "Nachname *",
    "localOnly": "Lokal",
    "location": "Ort",
    "manuallySelected": "Manuell ausgewählt",
    "markVerified": "Als verifiziert markieren",
    "merge": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "contact": "Kontakt",
      "createAndImport": "Neu erstellen & Importieren",
      "enrichCompany": "Bestehende Firma wird mit neuen Infos ergänzt (leere Felder)",
      "enrichContact": "Bestehender Kontakt wird mit neuen Infos ergänzt",
      "existingRecord": "Bestand (Immotron)",
      "field": "Feld",
      "leadResearch": "Lead (Recherche)",
      "loadingComparison": "Lade Vergleichsdaten...",
      "match": "Übereinstimmung",
      "matchLabel": "Match",
      "mergeAndImport": "Zusammenführen & Importieren",
      "newEntry": "Neuer Eintrag",
      "researchExtras": "Zusatzinfos aus der Recherche",
      "source": "Quelle",
      "subtitleCompare": "Prüfe die Übereinstimmung vor dem Import",
      "subtitleNew": "Kein bestehendes Match gefunden — wird neu erstellt",
      "titleCompare": "Lead importieren — Vergleich",
      "titleNew": "Lead als neu importieren",
      "whatHappens": "Was passiert beim Import?",
      "willBeCreated": "wird neu erstellt",
      "willBeCreatedShort": "Wird neu erstellt"
    },
    "mergeSuccess": "Kontakte erfolgreich zusammengeführt",
    "metadata": "Metadaten",
    "microsoftImport": "Microsoft Import",
    "name": "Name",
    "noAccount": "Kein Account",
    "noCompanies": "Keine Organisationszuordnungen",
    "noCompaniesFound": "Keine Firmen gefunden",
    "noCompanyAssignment": "Keine Firmenzuordnung",
    "noCompanyAssignmentHint": "Fügen Sie eine Firma hinzu, um Rollen und Zeichnungsrechte zu definieren.",
    "noContacts": "Keine Kontakte gefunden",
    "noContactsFound": "Keine Kontakte gefunden",
    "noLinkedinData": "Keine LinkedIn-Daten",
    "noLinkedinDataHint": "Dieser Kontakt wurde noch nicht mit LinkedIn synchronisiert.",
    "noTags": "Keine Tags",
    "notes": "Notizen",
    "notesPlaceholder": "Interne Notizen zum Kontakt...",
    "openProfile": "Profil öffnen",
    "owner": "Haupteigner",
    "ownerAll": "Alle Besitzer",
    "personsRegistered": "{{count}} eingetragene Personen",
    "phone": "Telefon",
    "position": "Position",
    "possibleDuplicate": "Mögliches Duplikat",
    "possibleDuplicates": "Mögliche Duplikate",
    "preferredLanguage": "Sprache",
    "primaryAddress": "Primäre Adresse",
    "privatePerson": "Privatperson",
    "rawDataJson": "Rohdaten (JSON)",
    "reSyncPending": "Re-Sync angefordert",
    "reSyncRequested": "Re-Sync angefordert. Starten Sie einen neuen Sync im LinkedIn Scraper.",
    "requestReSync": "Re-Sync anfordern",
    "resultsLabel": "Kontakte",
    "searchCompanyPlaceholder": "Firma suchen...",
    "searchContact": "Kontakt suchen...",
    "searchCriteria": {
      "areaRange": "Fläche m²",
      "areaRangePlaceholder": "z. B. 800–2’500",
      "cantons": "Kantone",
      "condition": "Zustand",
      "constructionYear": "Baujahr",
      "constructionYearPlaceholder": "z. B. ab 1990 oder Neubau",
      "decisionProcess": "Entscheidungsprozess",
      "energyRequirements": "Energie / Nachhaltigkeit",
      "excluded": "Ausgeschlossen",
      "grossYieldMin": "Bruttorendite min.",
      "grossYieldMinPercent": "Bruttorendite min. (%)",
      "location": "Lage",
      "locationNotes": "Lage-Notizen",
      "macro": "Makro",
      "macroLocation": "Makrolage",
      "micro": "Mikro",
      "microLocation": "Mikrolage",
      "minUnits": "Mindestgrösse",
      "minUnitsPlaceholder": "z. B. 6 Wohnungen",
      "netYieldTarget": "Nettorendite-Ziel",
      "noGos": "No-Gos",
      "price": "Preis (Mio CHF)",
      "priceMax": "Preis max. (Mio CHF)",
      "priceMin": "Preis min. (Mio CHF)",
      "priceMinHard": "Unter Preis min. ausgeschlossen (harte Grenze)",
      "priceNotes": "Preisnotiz",
      "propertyTypes": "Objekttypen",
      "regions": "Regionen",
      "sought": "Gesucht",
      "specialRequirements": "Sonderanforderungen",
      "timeline": "Timeline"
    },
    "searchFailed": "Suche fehlgeschlagen",
    "searchNameOrEmail": "Name oder E-Mail suchen...",
    "searchPlaceholder": "Suchen nach Name oder E-Mail...",
    "selectCompany": "Firma wählen...",
    "selectMergeTarget": "Kontakt zum Zusammenführen auswählen",
    "sendPasswordReset": "Passwort-Reset senden",
    "setPrimary": "Als primär setzen",
    "showCampaignContacts": "Kampagnen-Kontakte",
    "signature": "Unterschrift",
    "signatureCollectiveMore": "Kollektivunterschrift zu mehreren",
    "signatureCollectiveTwo": "Kollektivunterschrift zu zweit",
    "signatureNone": "Keine",
    "signatureSingle": "Einzelunterschrift",
    "signatureType": "Zeichnungsberechtigung",
    "signatures": "Unterschriften",
    "source": "Quelle",
    "sourceAll": "Quelle",
    "sourceCampaign": "Kampagne",
    "sourceGoogle": "Google",
    "sourceLabel": "Quelle",
    "sourceManual": "Manuell",
    "subtitle": "Alle Zeichnungsberechtigten und Ansprechpersonen",
    "syncStatus": "Sync Status",
    "synced": "Synchronisiert",
    "contracts": {
      "empty": "Keine Verträge vorhanden",
      "propertyLabel": "Immobilie"
    },
    "tabs": {
      "addressContact": "Adresse & Kontakt",
      "companies": "Organisationen",
      "contracts": "Verträge",
      "knowledge": "Wissen",
      "linkedin": "LinkedIn",
      "masterData": "Stammdaten",
      "notes": "Notizen",
      "responsibility": "Zuständigkeit"
    },
    "tagAdded": "Tag zugewiesen",
    "tagRemoved": "Tag entfernt",
    "tags": "Tags",
    "title": "Kontakte",
    "tryZefix": "In Zefix suchen",
    "typeNameOrEmail": "Tippen Sie einen Namen oder eine E-Mail-Adresse...",
    "unverified": "Nicht verifiziert",
    "updateSuccess": "Kontakt erfolgreich aktualisiert",
    "userAccount": "User-Account",
    "verified": "Verifiziert",
    "verifiedSuccess": "Zuordnung verifiziert",
    "verifiedVia": "Verifiziert via",
    "website": "Website",
    "withUser": "Mit User-Account",
    "withUserOnly": "Nur mit Benutzer",
    "withoutUser": "Ohne User-Account",
    "zefixSearch": "Zefix-Suche",
    "zefixSearchPlaceholder": "Firma in Zefix suchen (Name oder UID)...",
    "phoneAdded": "Telefonnummer hinzugefuegt",
    "phoneRemoved": "Telefonnummer entfernt",
    "phones": "Telefonnummern",
    "noCompanyAssigned": "Keine Firma zugeordnet",
    "addresses": "Adressen",
    "researchSuccess": "Recherche abgeschlossen",
    "researchFailed": "Recherche fehlgeschlagen",
    "researching": "Recherchiere...",
    "startResearch": "KI-Recherche starten",
    "researchError": "Recherche fehlgeschlagen. Bitte erneut versuchen.",
    "researchResult": "Recherche-Ergebnis",
    "lastResearch": "Letzte Recherche",
    "noResearchYet": "Noch keine KI-Recherche durchgeführt",
    "researchDescription": "Perplexity durchsucht das Web nach Informationen zu dieser Person",
    "infoOwnerRole": "Info",
    "noOwner": "-- Kein Haupteigner --",
    "notesAutoSaveHint": "Änderungen werden automatisch gespeichert.",
    "removeInfoOwner": "Info-Eigner entfernen"
  },
  "contractTermination": {
    "clause": "Klausel",
    "clauseLabel": "Verletzte Klausel (optional)",
    "confirmButton": "Jetzt kündigen",
    "confirmSummary": "Zusammenfassung:",
    "contract": "Vertrag",
    "description": "Vertrag {{number}} wird gekündigt. Bitte geben Sie den Grund an.",
    "error": "Fehler beim Kündigen des Vertrags",
    "reason": "Grund",
    "reasonLabel": "Begründung",
    "reasonPlaceholder": "Beschreiben Sie den Grund für die Kündigung...",
    "reasonRequired": "Bitte geben Sie einen Grund an",
    "selectClause": "-- Klausel wählen --",
    "success": "Vertrag wurde gekündigt",
    "title": "Vertrag kündigen",
    "warningText": "Nach der Kündigung bleiben alle Schutzklauseln (§6 Kontaktschutz, §7 Konventionalstrafe) für weitere 6 Monate in Kraft.",
    "warningTitle": "Achtung: Nachlauf beachten"
  },
  "contractWizard": {
    "errors": {
      "generateFailed": "Vertrag konnte nicht generiert werden",
      "loadCompaniesFailed": "Firmen konnten nicht geladen werden",
      "loadSignatoriesFailed": "Zeichnungsberechtigte konnten nicht geladen werden",
      "noCompany": "Bitte wählen Sie eine Firma",
      "noPartner": "Bitte geben Sie einen Vertragspartner an",
      "noPartnerContact": "Bitte wählen Sie einen Unterzeichner des Vertragspartners",
      "noRoles": "Bitte wählen Sie mindestens eine Rolle",
      "noSignatories": "Bitte wählen Sie mindestens einen Unterzeichner"
    },
    "hidePreview": "Vorschau ausblenden",
    "navigation": {
      "back": "Zurück",
      "cancel": "Abbrechen",
      "next": "Weiter"
    },
    "showPreview": "Vorschau anzeigen",
    "signatories": {
      "loading": "Unterzeichner werden geladen...",
      "none": "Keine Unterzeichner verfügbar",
      "subtitle": "Wählen Sie die Unterzeichner für diesen Vertrag",
      "title": "Unterzeichner"
    },
    "step1": {
      "loading": "Firmen werden geladen...",
      "subtitle": "Wählen Sie die Firma, die den Vertrag ausstellt",
      "title": "Mandant auswählen"
    },
    "step2": {
      "city": "Ort",
      "contactName": "Kontaktperson (Unterzeichner)",
      "email": "E-Mail",
      "manualEntry": "Manuell erfassen",
      "name": "Name / Firma",
      "partnerSignatory": "Unterzeichner des Vertragspartners",
      "partnerSignatoryHint": "Bei Kollektivunterschrift mehrere Personen auswählen.",
      "searchPartner": "Vertragspartner suchen (Person/Firma — CRM & Zefix)",
      "searchPartnerPlaceholder": "Name, Firma oder Zefix durchsuchen...",
      "searchPartnerHint": "Sucht in CRM-Kontakten, CRM-Firmen und im Zefix-Handelsregister. Nicht gefunden? Direkt neu im CRM anlegen.",
      "creatingPartner": "Vertragspartner wird im CRM angelegt...",
      "partnerCreated": "Vertragspartner im CRM angelegt",
      "partnerCreateFailed": "Vertragspartner konnte nicht angelegt werden",
      "personBadge": "Privatperson (CRM)",
      "companyBadge": "Firma (CRM/Zefix)",
      "personIsSignatory": "Diese Person ist der Unterzeichner des Vertrags.",
      "signerEmail": "E-Mail des Unterzeichners",
      "emailSavedToCrm": "E-Mail im CRM gespeichert",
      "sourceCrm": "Im CRM",
      "sourceZefixNew": "Zefix — noch nicht im CRM",
      "sourceCrmGone": "Im CRM — nicht mehr im Register",
      "noSignatoriesFound": "Keine Unterzeichner gefunden. Bitte zuerst im CRM erfassen.",
      "searchCompany": "Firma suchen (Zefix)",
      "searchPlaceholder": "Firma suchen...",
      "signingEmailPlaceholder": "E-Mail für Signing-Link",
      "street": "Strasse",
      "subtitle": "Wählen Sie einen bestehenden Partner oder erfassen Sie einen neuen",
      "title": "Vertragspartner",
      "zipCode": "PLZ"
    },
    "step3": {
      "broker": "Vermittler",
      "brokerDesc": "Co-Brokerage, Netzwerkzugang, Honorar-Splitting",
      "brokerDescription": "Honoraraufteilung mit Partner-Makler",
      "buyer": "Käufer",
      "buyerDesc": "Zugang zu Off-Market Immobilien, Suchprofil, Due-Diligence-Unterstützung",
      "buyerDescription": "Käufervertrag mit Finders Fee und Suchprofil",
      "seller": "Verkäufer",
      "sellerDesc": "Immobilienvermarktung, Käufer-Matching, Transaktionsbegleitung",
      "sellerDescription": "Maklervertrag mit Honorar und Exklusivität",
      "subtitle": "Welche Rolle hat der Partner?",
      "title": "Vertragstyp wählen"
    },
    "step4": {
      "brokerCommission": "Honorar",
      "brokerSection": "Vermittler-Konditionen",
      "buyerSection": "Käufer-Konditionen",
      "commission": "Maklerhonorar",
      "commissionMode": "Konditionen",
      "commissionModeFixed": "Fest im Vertrag",
      "commissionModeFixedDesc": "Die Prozentsätze werden im Vertrag festgeschrieben.",
      "commissionModeFixedRequired": "Bitte für jede gewählte Rolle einen Satz grösser als 0 % erfassen.",
      "commissionModeVariable": "Je Objekt (Anhang B)",
      "commissionModeVariableDesc": "Die Konditionen werden pro Objekt vereinbart.",
      "commissionModeVariableHint": "Ohne feste Prozentsätze im Vertrag: Die Konditionen werden pro Objekt in Anhang B vereinbart und vor dem Zugang zum Objekt bestätigt.",
      "conditions": "Vermittlungsbedingungen",
      "contractDuration": "Vertragsdauer",
      "exclusivity": "Exklusivmandat",
      "exclusivityDuration": "Exklusivitätsdauer",
      "exclusivityHint": "Exklusiver Vermarktungsauftrag",
      "findersFee": "Finder's Fee",
      "globalSection": "Allgemeine Konditionen",
      "ourShare": "Unser Anteil",
      "partnerShare": "Partner-Anteil",
      "protectionDuration": "Kontaktschutz",
      "searchProfile": "Suchprofil",
      "sellerSection": "Verkäufer-Konditionen",
      "subtitle": "Typspezifische Einstellungen",
      "title": "Konfiguration"
    },
    "step5": {
      "company": "Firma",
      "configuration": "Konfiguration",
      "contractType": "Vertragstyp",
      "generate": "Vertrag generieren",
      "generating": "Wird generiert...",
      "partner": "Partner",
      "subtitle": "Prüfen Sie die Angaben und generieren Sie den Vertrag",
      "title": "Zusammenfassung & Generierung"
    },
    "steps": {
      "company": "Firma",
      "config": "Konfiguration",
      "partner": "Partner",
      "preview": "Vorschau",
      "type": "Vertragstyp"
    },
    "subtitle": "Neuen Vertrag erstellen",
    "success": "Vertrag erfolgreich erstellt",
    "title": "Neuer Vertrag",
    "validation": {
      "collectiveMore": "Kollektivunterschrift: Bitte wählen Sie mindestens 2 Unterzeichner.",
      "collectiveTwo": "Kollektivunterschrift zu zweit: Bitte wählen Sie genau 2 Unterzeichner.",
      "singleOnly": "Einzelunterschrift: Bitte wählen Sie genau 1 Unterzeichner."
    },
    "searchMandate": {
      "companyLoadError": "Firma konnte nicht geladen werden",
      "onlyImages": "Nur Bilddateien erlaubt (PNG, JPG, WebP)",
      "fileTooLarge": "Maximale Dateigrösse: 2 MB",
      "logoUploaded": "Logo hochgeladen",
      "logoUploadFailed": "Logo-Upload fehlgeschlagen",
      "letterGenerated": "Anschreiben-Text generiert",
      "letterGenerateFailed": "Text konnte nicht generiert werden",
      "mandateCreated": "Suchmandat erstellt!",
      "createError": "Fehler beim Erstellen des Suchmandats",
      "title": "Suchmandat erstellen",
      "ourCompany": "Unsere Firma",
      "client": "Auftraggeber (Investor)",
      "searchCompany": "Firma suchen (Zefix)",
      "manualEntry": "Manuell eingeben",
      "signatories": "Unterzeichner des Vertragspartners",
      "signatoriesHint": "Bei Kollektivunterschrift mehrere Personen auswählen.",
      "clientLogo": "Logo des Auftraggebers",
      "clientLogoHint": "Das Logo erscheint oben rechts im Anschreiben. Das Anschreiben wird im Namen des Auftraggebers erstellt.",
      "logoUploadHint": "Logo hochladen oder hierhin ziehen (PNG, JPG, max. 2 MB)",
      "aiCoverLetter": "Anschreiben — KI-Textgenerator",
      "aiCoverLetterHint": "Stichworte zum Auftraggeber eingeben — die KI generiert ein professionelles Anschreiben.",
      "clientKeywords": "Stichworte zum Auftraggeber",
      "generating": "Wird generiert...",
      "generateLetter": "Anschreiben generieren",
      "generatedText": "Generierter Text (bearbeitbar)",
      "textEditable": "Text kann vor dem Erstellen angepasst werden.",
      "searchCriteria": "Suchkriterien",
      "propertyType": "Objektart",
      "noGoCriteria": "No-Go Kriterien",
      "noGoHint": "Was kommt für den Investor nicht in Frage?",
      "noGoCustom": "Weitere No-Gos (Freitext)",
      "regionLabel": "Region (Mehrfachauswahl)",
      "cantonsLabel": "Kantone (Mehrfachauswahl)",
      "macroLocation": "Makrolage",
      "noRestriction": "Keine Einschraenkung",
      "macroA": "A — Top-Standort (Zuerich, Genf, Basel)",
      "macroB": "B — Guter Standort (Agglomeration, Mittelstaedte)",
      "macroC": "C — Peripherer Standort (laendlich, Kleinstaedte)",
      "microLocation": "Mikrolage",
      "microA": "A — Beste Mikrolage (zentral, ruhig, top Anbindung)",
      "microB": "B — Gute Mikrolage (durchschnittlich, solide)",
      "microC": "C — Einfache Mikrolage (Randlage, maessige Anbindung)",
      "investmentVolume": "Investitionsvolumen",
      "investmentAndYield": "Investitionsvolumen & Rendite",
      "priceRange": "Kaufpreis-Bandbreite",
      "minimum": "Minimum",
      "maximum": "Maximum",
      "grossYieldMin": "Bruttorendite min.",
      "netYieldTarget": "Nettorendite Ziel",
      "timeline": "Zeitrahmen",
      "buildingAndTimeline": "Gebaeude & Zeitrahmen",
      "conditionLabel": "Zustand (Mehrfachauswahl)",
      "timelineNow": "Sofort",
      "timeline3m": "Innerhalb 3 Monaten",
      "timeline6m": "Innerhalb 6 Monaten",
      "timeline12m": "Innerhalb 12 Monaten",
      "timelineFlexible": "Flexibel",
      "specialRequirements": "Besondere Anforderungen",
      "conditions": "Konditionen",
      "feeNote": "des Kaufpreises, zzgl. MWST",
      "protectionDuration": "Kontaktschutz (Monate)",
      "contractDuration": "Mandatsdauer (Monate)",
      "hidePreview": "Vorschau ausblenden",
      "showPreview": "Vorschau anzeigen",
      "tabCoverLetter": "Anschreiben",
      "tabCriteria": "Suchkriterien",
      "tabAgreement": "Mandatsvereinbarung",
      "creating": "Wird erstellt...",
      "createMandate": "Suchmandat erstellen"
    }
  },
  "contracts": {
    "actions": {
      "cancel": "Vertrag stornieren",
      "createNew": "Neuer Vertrag",
      "downloadPdf": "PDF herunterladen",
      "generate": "Erstellen",
      "preview": "Vorschau",
      "proceedToSign": "Zur Unterschrift",
      "send": "Vertrag senden",
      "terminate": "Vertrag kündigen"
    },
    "cancel": "Stornieren",
    "cancelFailed": "Vertrag konnte nicht storniert werden.",
    "cancelSuccess": "Vertrag wurde storniert.",
    "categories": {
      "compliance": "Compliance",
      "contracts": "Verträge",
      "legitimation": "Legitimationen",
      "v2": "Neue Verträge"
    },
    "collectiveSignatureWarning": "Kollektivunterschrift zu zweien: Bitte wählen Sie mindestens 2 Personen aus.",
    "complete": {
      "contractNumber": "Vertragsnummer",
      "createdAt": "Erstellt am",
      "description": "Ihr Vertrag {{number}} wurde generiert.",
      "sentDescription": "Der Vertrag {{number}} wurde zur Unterschrift versendet. Die Unterzeichner erhalten eine E-Mail.",
      "sentTitle": "Vertrag versendet!",
      "signedDescription": "Der Vertrag {{number}} wurde von allen Parteien unterzeichnet.",
      "signedTitle": "Vertrag erfolgreich unterzeichnet!",
      "status": "Status",
      "title": "Vertrag erfolgreich erstellt!",
      "usersCreated": "{{count}} Benutzerkonten automatisch erstellt"
    },
    "confirmCancel": "Möchten Sie diesen Vertrag wirklich stornieren?",
    "confirmCancelCustomerSigned": "ACHTUNG: Externe Parteien haben diesen Vertrag bereits unterschrieben. Möchten Sie den Vertrag trotzdem stornieren?",
    "confirmCancelSent": "Dieser Vertrag wurde bereits versendet. Unterzeichner haben den Link erhalten. Trotzdem stornieren?",
    "confirmDelete": "Möchten Sie diesen Vertrag wirklich löschen?",
    "confirmDeleteDescription": "Sind Sie sicher, dass Sie diesen Vertrag löschen möchten?",
    "confirmSend": "Sind Sie sicher, dass Sie diesen Vertrag senden möchten?",
    "confirmTerminate": "Möchten Sie diesen Vertrag wirklich kündigen? Dieser Vorgang kann nicht rückgängig gemacht werden.",
    "confirmTerminateDescription": "Sind Sie sicher, dass Sie diesen Vertrag kündigen möchten?",
    "deleteFailed": "Vertrag konnte nicht gelöscht werden.",
    "deleteSuccess": "Vertrag wurde gelöscht.",
    "detail": {
      "aiSuggest": "KI-Vorschlag",
      "aiSuggestFailed": "KI-Vorschlag fehlgeschlagen",
      "appendices": "Anhänge ({{count}})",
      "appendicesInvestorHint": "Anhänge halten die Konditionen fest, die für ein einzelnes Objekt gelten.",
      "appendixProperty": "Objekt #{{id}}",
      "autoRenewal": "automatische Verlängerung",
      "brokerCommission": "Maklerhonorar",
      "buyer": "Käufer",
      "buyerCommission": "Käuferhonorar",
      "cancelContract": "Vertrag stornieren",
      "commissionRate": "Honorar",
      "companyLink": "Firma anzeigen",
      "companyName": "Firma",
      "config": "Konfiguration",
      "confirmSend": "Vertrag versenden?",
      "confirmSendDescription": "Der Vertrag wird an alle Unterzeichner per E-Mail versendet.",
      "contactLink": "Kontakt anzeigen",
      "contractDuration": "Vertragsdauer",
      "contractNumber": "Vertragsnummer",
      "contractTerms": "Vertragskonditionen",
      "createdAt": "Erstellt am",
      "deleteContract": "Vertrag löschen",
      "documents": "Dokumente",
      "downloadPdf": "PDF herunterladen",
      "emailStatus": "E-Mail-Zustellung",
      "exclusive": "Exklusivmandat",
      "exclusivity": "Exklusivität",
      "expiresAt": "Gültig bis",
      "goToCountersign": "Zur Gegenzeichnung",
      "hidePdf": "PDF ausblenden",
      "months": "Monate",
      "noAppendices": "Zu diesem Vertrag gibt es noch keine Anhänge.",
      "noData": "Keine Daten verfügbar",
      "nonExclusive": "Nicht-exklusiv",
      "parties": "Vertragsparteien",
      "partner": "Partner",
      "pdfNotAvailable": "PDF nicht verfügbar",
      "pdfNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "pdfPreviewNotSupported": "PDF-Vorschau wird auf diesem Gerät nicht unterstützt.",
      "personalMessage": "Persönliche Nachricht (optional)",
      "personalMessagePlaceholder": "z.B. Bitte unterschreiben Sie bis Freitag...",
      "plotNumber": "Parzellen-Nr.",
      "property": "Immobilie",
      "propertyDetails": "Immobiliendetails",
      "propertyType": "Objektart",
      "protectionDuration": "Schutzdauer",
      "resetSignaturesConfirm": "Zurücksetzen & neu versenden",
      "resetSignaturesDescription": "Alle Unterschriften werden gelöscht und neue Unterzeichnungslinks per E-Mail versendet. Die Unterzeichner müssen erneut unterschreiben.",
      "resetSignaturesFailed": "Zurücksetzen fehlgeschlagen",
      "resetSignaturesTitle": "Unterschriften zurücksetzen?",
      "roles": "Rollen",
      "seller": "Verkäufer",
      "sellerCommission": "Verkäuferhonorar",
      "sendContract": "Vertrag versenden",
      "sentAt": "Versendet am",
      "signatures": "Unterschriften",
      "signedAt": "Unterzeichnet am",
      "template": "Vorlage",
      "terminateContract": "Vertrag kündigen",
      "title": "Vertragsdetails",
      "viewDetails": "Details ansehen",
      "viewPdf": "PDF anzeigen"
    },
    "download": "Herunterladen",
    "downloadFailed": "Download fehlgeschlagen.",
    "errors": {
      "downloadFailed": "Download fehlgeschlagen",
      "generateFailed": "Vertrag konnte nicht erstellt werden",
      "loadFailed": "Vorlagen konnten nicht geladen werden",
      "missingEmails": "E-Mail fehlt für",
      "missingSignatures": "Fehlende Unterschriften",
      "previewFailed": "Vorschau konnte nicht erstellt werden",
      "sendFailed": "Vertrag konnte nicht versendet werden",
      "signingFailed": "Unterschrift fehlgeschlagen"
    },
    "form": {
      "agentEmail": "E-Mail des Bevollmächtigten",
      "agentName": "Bevollmächtigter",
      "authorizedEmail": "E-Mail der Person",
      "authorizedPerson": "Zeichnungsberechtigte Person",
      "buyerAddress": "Adresse des Käufers",
      "buyerCommissionRate": "Honorar Käuferseite",
      "buyerEmail": "E-Mail des Käufers",
      "buyerName": "Name des Käufers",
      "commissionRate": "Honorar",
      "companyAddress": "Firmenadresse",
      "companyName": "Firmenname",
      "exclusive": "Exklusiv",
      "exclusiveDescription": "Exklusivmandat: Der Verkäufer verpflichtet sich, keine Drittparteien mit der Vermarktung zu beauftragen und potenzielle Käufer nicht direkt zu kontaktieren, sofern diese über Immotron identifiziert wurden.",
      "exclusivity": "Exklusivität",
      "exclusivityDescription": "§5 Exklusivität — Bestimmt, ob der Verkäufer während der Vertragsdauer andere Vermittler beauftragen darf.",
      "exclusivityDuration": "Exklusivitätsdauer",
      "groups": {
        "agent": "Vertretung",
        "buyer": "Käufer",
        "company": "Organisation",
        "config": "Konfiguration",
        "general": "Allgemein",
        "partner": "Partner",
        "property": "Immobilie",
        "seller": "Verkäufer"
      },
      "nonExclusive": "Nicht-exklusiv",
      "nonExclusiveDescription": "Nicht-exklusives Mandat: Der Verkäufer bleibt verpflichtet, Immotron jeden Kontakt oder jede Anfrage, die durch Immotron ausgelöst wurde, sofort zu melden.",
      "partnerAddress": "Adresse des Partners",
      "partnerEmail": "E-Mail des Partners",
      "partnerName": "Name des Partners",
      "plotNumber": "Parzellen-Nr.",
      "principalName": "Vollmachtgeber",
      "propertyAddress": "Adresse der Immobilie",
      "propertyType": "Objektart",
      "protectionDuration": "Schutzdauer",
      "protectionDurationBuyerDescription": "§8 No-Circumvention — Schutzklausel gegen Umgehung. Jede Transaktion mit einem durch die Plattform bekannt gemachten Verkäufer oder Objekt gilt als vermittelt. Bei Verstoss: doppeltes Honorar als Konventionalstrafe.",
      "protectionDurationSellerDescription": "§7 No-Circumvention — Schutzklausel gegen Umgehung. Jede Transaktion mit einem durch die Plattform bekannt gemachten Käufer gilt als vermittelt. Bei Verstoss: doppeltes Honorar als Konventionalstrafe.",
      "sellerAddress": "Adresse des Verkäufers",
      "sellerCommissionRate": "Honorar Verkäuferseite",
      "sellerEmail": "E-Mail des Verkäufers",
      "sellerName": "Name des Verkäufers"
    },
    "generate": "Vertrag generieren",
    "generateClause": "KI-Klausel generieren",
    "generatingClause": "Generiere...",
    "generator": {
      "subtitle": "Erstellen Sie professionelle Verträge in wenigen Schritten",
      "title": "Vertragsgenerator"
    },
    "issuer": "Vertragsaussteller",
    "list": {
      "allSigned": "alle",
      "appendix": "Anhang",
      "appendixTypes": {
        "ANHANG_A": "Anhang A",
        "ANHANG_B": "Anhang B"
      },
      "buyer": "Käufer",
      "contractNumber": "Vertragsnummer",
      "created": "Erstellt",
      "createdAt": "Erstellt am",
      "dates": "Datum",
      "empty": {
        "description": "Erstellen Sie Ihren ersten Vertrag",
        "title": "Keine Verträge vorhanden"
      },
      "page": "Seite {{current}} von {{total}}",
      "parties": "Parteien",
      "searchMandate": "Suchmandat",
      "searchNoResults": "Keine Verträge gefunden",
      "searchPlaceholder": "Suche nach Vertragsnummer, Käufer, Verkäufer...",
      "seller": "Verkäufer",
      "sent": "Versendet",
      "signatories": "Unterzeichner",
      "signed": "unterschrieben",
      "signedDate": "Unterschrieben",
      "subtitle": "Verwalten Sie Ihre erstellten Verträge",
      "template": "Vorlage",
      "toParentContract": "zum Rahmenvertrag",
      "typeFilter": "Vertragsart",
      "typeGroups": {
        "ALL": "Alle",
        "BROKER": "Vermittler",
        "BUYER": "Käufer",
        "OTHER": "Sonstige",
        "SELLER": "Verkäufer"
      },
      "us": "Uns"
    },
    "livePreview": {
      "error": "Vorschau konnte nicht aktualisiert werden.",
      "hidePreview": "Formular anzeigen",
      "loading": "Vorschau wird generiert...",
      "pages": "Seiten",
      "placeholder": "Bitte Formulardaten ausfüllen, um die Vorschau zu aktivieren.",
      "previewLabel": "Vorschau",
      "print": "Drucken",
      "printTitle": "Vertrag Vorschau",
      "showPreview": "Vorschau anzeigen",
      "title": "Live-Vorschau"
    },
    "loadingSignatories": "Lade Zeichnungsberechtigte...",
    "newContract": "Neuer Vertrag",
    "newSearchMandate": "Suchmandat",
    "noContracts": "Keine Verträge",
    "ourCompany": "Unsere Firma",
    "preview": {
      "document": "Dokumentvorschau",
      "title": "Vorschau"
    },
    "resultsLabel": "Verträge",
    "roles": {
      "BROKER": "Vermittler",
      "BUYER": "Käufer",
      "SELLER": "Verkäufer",
      "buyer": "Käufer",
      "partner": "Partner",
      "seller": "Verkäufer"
    },
    "selectSignatoriesFor": "Wählen Sie die Zeichnungsberechtigten für {{company}} aus:",
    "selectedPersons": "{{count}} Person(en) ausgewählt",
    "send": "Senden",
    "sendFailed": "Vertrag konnte nicht gesendet werden.",
    "sendSuccess": "Vertrag wurde gesendet.",
    "sign": "Unterschreiben",
    "signatoryLoadError": "Zeichnungsberechtigte konnten nicht geladen werden.",
    "signatoryTypes": {
      "AGENT": "Bevollmächtigter",
      "BUYER": "Käufer",
      "COMPANY_REP": "Bevollmächtigtes Organ",
      "IMMOTRON": "Vermittlerin",
      "PARTNER": "Partner",
      "SELLER": "Verkäufer",
      "USER": "Benutzer"
    },
    "signaturePad": {
      "complete": "Vertrag abschliessen",
      "description": "Bitte unterschreiben Sie in den Feldern. Alle Unterschriften sind erforderlich.",
      "placeholder": "unterschreibt hier",
      "signaturesRequired": "Unterschrift(en) erforderlich",
      "signed": "unterschrieben",
      "skipAndSaveDraft": "Als Entwurf speichern",
      "title": "Unterschriften sammeln"
    },
    "signing": {
      "modeDescription": "Wie soll der Vertrag unterschrieben werden?",
      "modeTitle": "Unterschriftsmodus wählen",
      "onsite": "Vor Ort unterschreiben",
      "onsiteDescription": "Unterschriften direkt auf dem Gerät sammeln (z.B. iPad, Tablet).",
      "remote": "Zur Unterschrift versenden",
      "remoteDescription": "Den Vertrag per E-Mail an die Unterzeichner senden."
    },
    "slider": {
      "months": "Monate",
      "monthsUnit": "Mt.",
      "months_one": "{{count}} Monat",
      "months_other": "{{count}} Monate",
      "noProtection": "Kein Schutz",
      "years": "Jahre",
      "yearsAndMonths": "{{years}} Jahr(e) und {{months}} Monat(e)",
      "years_one": "{{count}} Jahr",
      "years_other": "{{count}} Jahre"
    },
    "specialConditions": "Besondere Bestimmungen",
    "statuses": {
      "CANCELLED": "Storniert",
      "CUSTOMER_SIGNED": "Kundenunterschrift",
      "DRAFT": "Entwurf",
      "EXPIRED": "Abgelaufen",
      "PARTIALLY_SIGNED": "Teilunterschrift",
      "PENDING": "Ausstehend",
      "SENT": "Versendet",
      "SIGNED": "Unterzeichnet",
      "TERMINATED": "Gekündigt"
    },
    "steps": {
      "complete": "Fertig",
      "form": "Daten",
      "preview": "Vorschau",
      "select": "Vorlage",
      "sign": "Unterschrift"
    },
    "terminate": "Kündigen",
    "terminateFailed": "Kündigung fehlgeschlagen.",
    "terminateSuccess": "Vertrag wurde gekündigt.",
    "termination": {
      "clause": "Kündigungsklausel",
      "clauseLabel": "Klausel auswählen",
      "confirmButton": "Kündigung bestätigen",
      "confirmSummary": "Zusammenfassung der Kündigung",
      "contract": "Vertrag",
      "description": "Geben Sie den Grund für die Kündigung an.",
      "error": "Kündigung konnte nicht durchgeführt werden.",
      "reason": "Kündigungsgrund",
      "reasonLabel": "Grund",
      "reasonPlaceholder": "Bitte geben Sie den Kündigungsgrund ein...",
      "reasonRequired": "Ein Kündigungsgrund ist erforderlich.",
      "selectClause": "Klausel auswählen",
      "success": "Vertrag wurde erfolgreich gekündigt.",
      "title": "Vertrag kündigen",
      "warningText": "Diese Aktion kann nicht rückgängig gemacht werden.",
      "warningTitle": "Achtung"
    },
    "title": "Verträge",
    "types": {
      "BROKER_AGREEMENT": "Vermittlervertrag",
      "PLATFORM_AGREEMENT": "Plattformvertrag",
      "SEARCH_MANDATE": "Suchmandat"
    },
    "v2": {
      "addAppendixB": "Neuen Anhang B erstellen",
      "aiClause": {
        "clauseNumber": "Klausel {{number}}",
        "confirmDelete": "Löschen?",
        "context": "Kontext (optional)",
        "contextPlaceholder": "z.B. Renovationsstau, Erbengemeinschaft, Baurecht...",
        "defaultDescription": "Besondere Bestimmung",
        "editClause": "Klausel bearbeiten",
        "empty": "Noch keine Klauseln. Kontext eingeben und generieren.",
        "error": "Fehler beim Generieren der Klausel",
        "generate": "Klausel generieren",
        "generating": "Generiere...",
        "hint": "Der KI-Klauselgenerator erstellt massgeschneiderte Spezialklauseln basierend auf den Objektdaten. Sie können den generierten Text anschliessend bearbeiten.",
        "placeholder": "Hier werden die KI-generierten Spezialklauseln angezeigt...",
        "regenerate": "Nochmals generieren",
        "tags": {
          "buildingRight": "Baurecht",
          "divorce": "Scheidung",
          "estateManagement": "Nachlassverwaltung",
          "forcedSale": "Zwangsverwertung",
          "heirsCompany": "Erbengemeinschaft",
          "liquidityShortfall": "Liquiditätsengpass",
          "relocation": "Standortwechsel",
          "renovationBacklog": "Renovationsstau"
        },
        "title": "KI-Klauselgenerator"
      },
      "appendices": "Anhänge",
      "appendix": {
        "b": "Anhang B: Objektfreigabe"
      },
      "appendixB": {
        "add": "Objektfreigabe hinzufügen",
        "commissionModel": "Honorarmodell",
        "description": "Immobilien freigeben, die über die Plattform vermarktet werden sollen.",
        "empty": "Noch keine Objektfreigaben. Sie können Anhang B auch nachträglich zum Rahmenvertrag hinzufügen.",
        "exclusivity": "Exklusivität",
        "inheritedFromParent": "vom Rahmenvertrag",
        "newProperty": {
          "canton": "Kanton",
          "city": "Ort",
          "cityPlaceholder": "z.B. Zürich",
          "create": "Neue Immobilie erstellen",
          "createError": "Fehler beim Erstellen der Immobilie",
          "hint": "Die Immobiliendetails können später ergänzt werden.",
          "propertyType": "Objekttyp",
          "streetAddress": "Adresse",
          "streetAddressPlaceholder": "z.B. Musterstrasse 1",
          "submit": "Erstellen & auswählen",
          "title": "Neue Immobilie erfassen"
        },
        "overrideExclusivity": "Abweichend vom Rahmenvertrag",
        "protectionDuration": "Schutzdauer",
        "selectCommissionModel": "Modell wählen...",
        "selectProperty": "Immobilie auswählen",
        "selectPropertyPlaceholder": "Immobilie wählen...",
        "title": "Objektfreigabe"
      },
      "buyerPlatform": "Käufer-Plattformvertrag",
      "noAppendices": "Keine Anhänge vorhanden.",
      "parentContract": "Gehört zu Rahmenvertrag",
      "sellerFramework": "Verkäufer-Rahmenvertrag",
      "viewParent": "Rahmenvertrag anzeigen"
    },
    "validation": {
      "collectiveRequiresTwo": "Kollektivunterschrift: Es sind mindestens 2 zeichnungsberechtigte Personen erforderlich"
    },
    "searchMandate": "Suchauftrag",
    "countersign": "Gegenzeichnung"
  },
  "countersignPage": {
    "breadcrumb": {
      "contracts": "Verträge",
      "countersign": "Gegenzeichnung"
    },
    "buyer": "Käufer",
    "contractDetails": "Vertragsdetails",
    "contractNumber": "Vertragsnummer",
    "contractType": "Vertragsart",
    "customerSignedAt": "Kunde unterschrieben am",
    "days": "Tage",
    "error": {
      "loadFailed": "Vertragsdaten konnten nicht geladen werden.",
      "noSlots": "Keine Signatur-Slots verfügbar, für die Sie berechtigt sind.",
      "notFound": "Vertrag nicht gefunden.",
      "submitFailed": "Die Gegenzeichnung konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
      "title": "Fehler",
      "unauthorized": "Sie sind nicht berechtigt, diesen Signatur-Slot zu unterzeichnen.",
      "wrongStatus": "Dieser Vertrag ist nicht zur Gegenzeichnung bereit."
    },
    "geoConsent": "Standort für rechtliche Dokumentation freigeben",
    "hidePdf": "Vertrag ausblenden",
    "legalNotice": "Mit Ihrer Gegenzeichnung bestätigen Sie als befugter Vertreter, dass der Vertrag geprüft und genehmigt wurde.",
    "loading": "Vertragsdaten werden geladen...",
    "pdfTitle": "Vertragsvorschau",
    "selectSlot": "Auswählen",
    "selectedSlot": "Ausgewählt",
    "seller": "Verkäufer",
    "signatureLabel": "Unterschrift",
    "signatureSlots": "Signatur-Slots",
    "signatureTitle": "Ihre Gegenzeichnung",
    "slotAvailable": "Verfügbar für Sie",
    "slotLocked": "Nicht berechtigt",
    "slotSigned": "Bereits signiert",
    "submit": "Gegenzeichnen",
    "submitting": "Wird gegengezeichnet...",
    "subtitle": "Interne Gegenzeichnung des Vertrags",
    "success": {
      "allComplete": "Alle Unterschriften sind vollständig. Der Vertrag ist nun rechtsgültig.",
      "description": "Ihre Gegenzeichnung wurde erfolgreich übermittelt.",
      "moreRequired": "Es sind noch weitere interne Signaturen erforderlich.",
      "title": "Erfolgreich gegengezeichnet!"
    },
    "title": "Gegenzeichnung",
    "viewPdf": "Vertrag anzeigen",
    "waitingDays": "Wartezeit"
  },
  "crm": {
    "activities": {
      "placeholder": "Aktivitätenverwaltung",
      "placeholderDescription": "Die CRM-Aktivitätenverwaltung wird in einer zukünftigen Version verfügbar sein.",
      "title": "Aktivitäten"
    },
    "contacts": {
      "addFirst": "Zur Kontaktübersicht",
      "backToContacts": "Zurück zu Kontakte",
      "backToList": "Zurück zur Liste",
      "companySearchCriteria": "Suchprofile verknüpfter Firmen",
      "contactInfo": "Kontaktdaten",
      "dedup": "Deduplizierung",
      "details": "Details",
      "emptyDescription": "Erstellen Sie Ihren ersten Kontakt, um mit der CRM-Verwaltung zu beginnen.",
      "emptyTitle": "Noch keine Kontakte",
      "filterAll": "Alle",
      "filterWithCompany": "Mit Firma",
      "filterWithoutCompany": "Ohne Firma",
      "goToCompany": "Zur Firma",
      "import": "Import",
      "keyFigures": "Kennzahlen",
      "lastActivity": "Letzte Aktivität",
      "noCompanyCriteria": "Keine Suchkriterien hinterlegt",
      "noResults": "Keine Kontakte gefunden",
      "notFound": "Kontakt nicht gefunden",
      "openDetail": "Öffnen",
      "ownSearchCriteria": "Eigenes Suchprofil",
      "ownership": "Zuständigkeit",
      "personalData": "Kontaktdaten",
      "placeholder": "Kontaktverwaltung",
      "placeholderDescription": "Die CRM-Kontaktverwaltung wird in einer zukünftigen Version verfügbar sein.",
      "previewTitle": "Kurzvorschau",
      "searchPlaceholder": "Name, E-Mail, Telefon oder Firma suchen...",
      "subtitle": "CRM-Kontaktverwaltung",
      "tabOverview": "Übersicht",
      "tabResearch": "KI-Recherche",
      "tabSearchCriteria": "Suchprofil",
      "tabTimeline": "Aktivitäten",
      "title": "Kontakte",
      "tryDifferentSearch": "Versuchen Sie einen anderen Suchbegriff",
      "unverifyConfirmText": "Diese Person verliert die CRM-Verifikation für die Vertragsunterzeichnung. Ohne Zefix-Zeichnungsberechtigung wird das Onboarding-Gate sie abweisen. Diese Änderung ist audit-relevant.",
      "unverifyConfirmTitle": "Verifikation entfernen?",
      "verificationSection": "Verifikation",
      "verifiedBadge": "Verifiziert für Vertragsunterzeichnung",
      "verifiedForSigningHint": "Öffnet die Self-Service-Vertragsanforderung für diese Person auch ohne Zefix-Zeichnungsberechtigung.",
      "verifiedForSigningLabel": "Für Vertragsunterzeichnung verifiziert",
      "verifiedRemovedSuccess": "Verifikation entfernt",
      "verifiedSetSuccess": "Verifikation gesetzt",
      "verifiedUpdateError": "Verifikation konnte nicht aktualisiert werden",
      "verifyConfirmText": "Diese Person wird für die Vertragsunterzeichnung freigegeben und kann das Onboarding auch ohne Zefix-Eintrag abschliessen. Diese Änderung ist audit-relevant.",
      "verifyConfirmTitle": "Verifikation setzen?",
      "masterDataCard": "Stammdaten",
      "channelsCard": "Adresse & Kontaktwege",
      "rolesCard": "Firmenrollen",
      "addRole": "Rolle hinzufügen",
      "roleAlreadyLinked": "Diese Organisation ist bereits verknüpft",
      "rolePersonNotAllowed": "Bitte eine Organisation wählen, keine Person",
      "contractsCard": "Verträge",
      "linkedinCard": "LinkedIn",
      "knowledgeTab": "Wissen"
    },
    "organizations": {
      "addContact": "Kontakt hinzufügen",
      "addFirst": "Zur Organisationsübersicht",
      "addInvestorGroup": "Investorengruppe zuordnen",
      "addNew": "Neue Organisation",
      "addSearchCriteria": "Suchprofil erfassen",
      "address": "Adresse",
      "allContacts": "Kontakte: alle",
      "canton": "Kanton",
      "capital": "Kapital",
      "contactAdded": "Kontakt hinzugefügt",
      "contactCreatedAndLinked": "Kontakt erstellt und verknüpft",
      "contactInfo": "Stammdaten",
      "contactRemoved": "Kontakt entfernt",
      "createdAt": "Erstellt am",
      "details": "Details",
      "employees": "Mitarbeiter",
      "emptyDescription": "Erstellen Sie Ihre erste Organisation, um mit der CRM-Verwaltung zu beginnen.",
      "emptyTitle": "Noch keine Organisationen",
      "hasContacts": "Mit Kontakten",
      "hasSearchCriteria": "Suchprofil vorhanden",
      "industry": "Branche",
      "industryPlaceholder": "Branche wählen...",
      "industriesFilter": "Branchen",
      "removeIndustry": "Branche entfernen",
      "investorGroupsTab": "Investorengruppen",
      "investorGroupsFilter": "Investorengruppen",
      "lastActivity": "Letzte Aktivität",
      "lastResearched": "Zuletzt recherchiert",
      "legalForm": "Rechtsform",
      "newContact": "Neuer Kontakt",
      "noContacts": "Ohne Kontakte",
      "noContactsFound": "Keine Kontakte gefunden",
      "noInvestorGroups": "Keine Investorengruppen zugeordnet",
      "noResults": "Keine Organisationen gefunden",
      "noResultsDescription": "Versuchen Sie, Ihre Suchbegriffe oder Filter anzupassen.",
      "noSearchCriteria": "Kein Suchprofil hinterlegt",
      "notes": "Notizen",
      "overviewTab": "Übersicht",
      "ownership": "Zuständigkeit",
      "parentCompany": "Muttergesellschaft",
      "pendingProposal": "Recherche-Vorschlag ausstehend — klicken zum Prüfen",
      "placeholder": "Organisationen-Verwaltung",
      "placeholderDescription": "Die CRM-Organisationsverwaltung wird in einer zukünftigen Version verfügbar sein.",
      "primaryContact": "Ansprechpartner",
      "properties": {
        "contractActive": "Vertrag aktiv",
        "contractExpired": "Vertrag abgelaufen",
        "contractMissing": "Kein Vertrag",
        "empty": "Keine Immobilien dieser Organisation vorhanden",
        "groupBy": "Gruppieren nach",
        "groupByCanton": "Kanton",
        "groupByNone": "keine",
        "groupByStatus": "Status",
        "groupByType": "Nutzung",
        "groupByVia": "Bezug",
        "groupCount": "{{count}} Objekte",
        "groupCountOne": "1 Objekt",
        "groupNoValue": "Ohne Angabe",
        "groupSumMillions": "CHF {{value}} Mio",
        "groupTotal": "{{count}} Objekte · {{sum}}",
        "groupTotalOne": "1 Objekt · {{sum}}",
        "groupViaCompany": "Firma",
        "groupViaContact": "über Kontakt",
        "propertyLabel": "Immobilie",
        "sectionImmotron": "Auf Immotron",
        "viaContact": "über Kontakt: {{name}}"
      },
      "propertiesTab": "Immobilien",
      "purpose": "Zweck",
      "registerDetails": "Registerauszug",
      "removeContact": "Kontakt entfernen",
      "removeFromOrg": "von dieser Organisation entfernen?",
      "removePrimaryContact": "Ansprechpartner entfernen",
      "knowledgeTab": "Wissen",
      "researchTab": "KI-Recherche",
      "roleUpdated": "Rolle aktualisiert",
      "searchContact": "Kontakt suchen...",
      "searchCriteriaTab": "Suchprofil",
      "nlSearch": {
        "placeholder": "Frei fragen, z.B. «alle die Gewerbe in Zürich suchen»",
        "ariaLabel": "Natürlichsprachliche Organisationssuche",
        "submit": "Suchen",
        "understoodAs": "Verstanden als:",
        "reset": "Zurücksetzen",
        "searchIn": "Sucht in:",
        "sourceCriteria": "Suchkriterien",
        "sourcePurpose": "Zefix-Zweck",
        "onlyWithCriteria": "nur mit Mandat",
        "parseError": "Frage konnte nicht interpretiert werden. Bitte erneut versuchen.",
        "unrecognizedHint": "Nicht eindeutig zugeordnet — nicht als Filter angewendet",
        "removeChip": "Filter entfernen",
        "reasonMandate": "Suchmandat-Treffer",
        "reasonPurpose": "Zefix-Zweck-Treffer",
        "noMandate": "kein hinterlegtes Suchmandat",
        "chipType": "Objektart",
        "chipRegion": "Region",
        "chipCanton": "Kanton",
        "chipYield": "Rendite ab",
        "chipPriceMin": "Preis ab",
        "chipPriceMax": "Preis bis",
        "chipUnits": "Min. Einheiten",
        "chipText": "Text",
        "noResultsTitle": "Keine Treffer",
        "noResultsHelp": "Versuchen Sie, einen Filter zu lockern:",
        "loosenRemove": "Ohne «{{label}}»",
        "loosenSources": "Beide Quellen durchsuchen",
        "loosenMandate": "Auch ohne Suchmandat"
      },
      "searchPlaceholder": "Name, UID oder Branche suchen...",
      "selectGroup": "Gruppe wählen...",
      "setPrimaryContact": "Als Ansprechpartner setzen",
      "subtitle": "Firmen und Organisationen verwalten",
      "title": "Organisationen",
      "backToList": "Zurück zur Liste",
      "notFound": "Organisation nicht gefunden",
      "openDetail": "Öffnen",
      "previewTitle": "Kurzvorschau",
      "keyFigures": "Kennzahlen",
      "recentActivities": "Letzte Aktivitäten",
      "noActivities": "Noch keine Aktivitäten erfasst",
      "zefixRevert": "Zefix entfernen",
      "zefixRevertTitle": "Zefix-Daten rückgängig machen",
      "zefixRevertConfirm": "Alle Zefix-Kontakte dieser Organisation werden deaktiviert und die Zefix-Verknüpfung entfernt. Angepinnte Kontakte bleiben erhalten.",
      "zefixRevertConfirmLabel": "Rückgängig machen",
      "zefixRevertFailed": "Zefix-Revert fehlgeschlagen"
    },
    "createOrganization": {
      "stepSearch": "Schritt 1 von 2 — Suchen",
      "stepDetails": "Schritt 2 von 2 — Angaben",
      "searchIntro": "Zuerst in CRM und Handelsregister suchen — so entstehen keine Doppeleinträge.",
      "manualEntry": "Ohne Suche erfassen",
      "existingCompany": "Diese Organisation ist bereits erfasst",
      "existingContact": "Dieser Eintrag ist bereits als Person erfasst",
      "openExisting": "Zu bestehendem Eintrag",
      "duplicateGeneric": "Diese Organisation ist bereits erfasst.",
      "fromZefix": "Aus dem Handelsregister übernommen",
      "nameRequired": "Name ist erforderlich",
      "seat": "Sitz",
      "seatRequired": "Sitz ist erforderlich",
      "detailsHint": "Alles Weitere — Adressen, Kontaktwege, Notizen — pflegen Sie danach auf der Detailseite.",
      "submit": "Organisation erstellen"
    },
    "createContact": {
      "subtitle": "Nur die nötigsten Angaben — alles Weitere auf der Detailseite.",
      "duplicateEmail": "Diese E-Mail ist bereits erfasst",
      "openExisting": "Zu bestehendem Eintrag",
      "lastNameRequired": "Nachname ist erforderlich",
      "firstNameRequired": "Vorname ist erforderlich",
      "emailOptional": "E-Mail (optional)",
      "checkingEmail": "E-Mail wird geprüft...",
      "organizationOptional": "Organisation (optional)",
      "personPicked": "Das ist eine Person — bitte eine Organisation wählen.",
      "companyWillBeCreated": "Diese Organisation wird mit angelegt und verknüpft.",
      "submit": "Person erstellen"
    }
  },
  "crmActivities": {
    "activityType": "Typ",
    "addFailed": "Aktivität konnte nicht erstellt werden",
    "addSuccess": "Aktivität erstellt",
    "description": "Beschreibung",
    "descriptionPlaceholder": "Optionale Details...",
    "emptyTimeline": "Keine Aktivitäten",
    "emptyTimelineHint": "Für diesen Eintrag sind noch keine Aktivitäten vorhanden.",
    "entityCompany": "Firma",
    "entityContact": "Kontakt",
    "filterActivities": "Aktivitäten",
    "filterEmails": "E-Mails",
    "filterTasks": "Pendenzen",
    "loadFailed": "Aktivitäten konnten nicht geladen werden",
    "newActivity": "Neue Aktivität",
    "searchPlaceholder": "Kontakt oder Firma suchen...",
    "selectEntity": "Kontakt oder Firma auswählen",
    "selectEntityHint": "Suchen Sie einen Kontakt oder eine Firma, um deren Aktivitäten-Timeline anzuzeigen.",
    "subject": "Betreff",
    "subjectPlaceholder": "Kurze Beschreibung...",
    "subtitle": "CRM-Timeline für Kontakte und Firmen",
    "title": "Aktivitäten",
    "types": {
      "call": "Anruf",
      "email": "E-Mail",
      "meeting": "Meeting",
      "note": "Notiz",
      "task": "Pendenz"
    }
  },
  "dashboard": {
    "actions": {
      "addProperty": "Neue Immobilie erfassen",
      "createContract": "Vertrag erstellen",
      "manageUsers": "Benutzer verwalten",
      "searchProperties": "Immobilien suchen"
    },
    "activity": {
      "daysAgo": "Vor {{count}} Tagen",
      "hoursAgo": "Vor {{count}} Std.",
      "justNow": "Gerade eben"
    },
    "awaitingCountersign": "Gegenzeichnung",
    "conversionRate": "Abschlussrate",
    "countersign": "Gegenzeichnung erforderlich",
    "customize": "Dashboard anpassen",
    "dealflowPipeline": "Dealflow Pipeline",
    "errors": {
      "loadFailed": "Dashboard konnte nicht geladen werden"
    },
    "investor": {
      "availableProperties": "Weitere verfügbare Objekte",
      "dossierAccess": "Dossier-Zugang",
      "goToSearch": "Zur Immobiliensuche",
      "kpi": {
        "activeListings": "Aktive Objekte",
        "availableForYou": "Für Sie verfügbar",
        "buying": "Kaufen",
        "inPreparation": "In Vorbereitung",
        "inSale": "Im Verkauf",
        "myProperties": "Meine Objekte",
        "selling": "Verkaufen",
        "sold": "Verkauft",
        "viewed": "Eingesehen"
      },
      "myProperties": "Meine freigegebenen Immobilien",
      "noProperties": "Keine Immobilien verfügbar",
      "noPropertiesHint": "Derzeit sind keine Immobilien für Sie sichtbar.",
      "pendingAccess": "Ohne Zugang",
      "propertiesAvailable": "Verfügbare Immobilien",
      "recentlyViewed": "Zuletzt besucht",
      "recentlyViewedEmpty": "Noch keine Objekte besucht — starte mit der Suche!",
      "ndaSigned": "NDA unterzeichnet",
      "favorites": "Favoriten",
      "newlyAdded": "Neu hinzugefügt"
    },
    "noActivity": "Keine Aktivitäten vorhanden",
    "overdue": "Überfällig",
    "pendingSignatures": "Versendet — warten auf Unterschrift",
    "quickActions": "Schnellaktionen",
    "recentActivity": "Letzte Aktivitäten",
    "resetLayout": "Zurücksetzen",
    "role": "Rolle: {{role}}",
    "showAll": "Alle anzeigen",
    "statistics": "Statistiken",
    "stats": {
      "contactsTotal": "Kontakte gesamt",
      "contractsDraft": "Entwürfe",
      "contractsPending": "Offene Verträge",
      "contractsSigned": "Unterzeichnet",
      "contractsTotal": "Verträge gesamt",
      "propertiesActive": "Aktive Immobilien",
      "propertiesTotal": "Immobilien gesamt"
    },
    "statusBreakdown": "Vertragsstatus-Übersicht",
    "statusCancelled": "Storniert",
    "statusDraft": "Entwurf",
    "statusPending": "Offen",
    "statusSigned": "Unterzeichnet",
    "title": "Dashboard",
    "welcome": "Willkommen, {{name}}",
    "widgets": {
      "activity": "Letzte Aktivitäten",
      "countersign": "Gegenzeichnung",
      "dealflow": "Dealflow Pipeline",
      "investorAvailable": "Verfügbare Objekte",
      "investorKpi": "KPI-Übersicht",
      "investorNetflix": "Immobilien entdecken",
      "investorProperties": "Meine Objekte",
      "pendingSignatures": "Ausstehende Unterschriften",
      "statCards": "Statistik-Kacheln",
      "tasks": "Pendenzen"
    },
    "colSpan": {
      "title": "Spaltenbreite"
    },
    "customizeHint": "Widgets per Drag & Drop sortieren. Klicke auf das Spalten-Icon für die Breite."
  },
  "deals": {
    "actions": {
      "cancel": "Deal abbrechen"
    },
    "confirmCancel": "Möchten Sie diesen Deal wirklich abbrechen?",
    "confirmDelete": "Möchten Sie diesen Deal wirklich löschen?",
    "confirmPhaseChange": "Phase wechseln zu {{phase}}?",
    "create": "Neuer Deal",
    "detail": {
      "dealNumber": "Deal-Nr.",
      "financingPhase": "Finanzierungsphase",
      "listing": "Teaser / Objekt",
      "ourCompany": "Unsere Firma",
      "phaseDetails": "Phasen-Details",
      "qaPhase": "Q&A-Phase",
      "seller": "Verkäufer",
      "title": "Titel"
    },
    "documents": {
      "noneRequired": "Keine Dokumente erforderlich.",
      "progress": "Vollständigkeit",
      "title": "Dokumente"
    },
    "empty": {
      "description": "Erstellen Sie einen neuen Deal, um zu beginnen.",
      "title": "Keine Deals vorhanden"
    },
    "errors": {
      "cancelFailed": "Deal konnte nicht abgebrochen werden.",
      "loadFailed": "Deals konnten nicht geladen werden.",
      "phaseChangeFailed": "Phasenwechsel fehlgeschlagen."
    },
    "phases": {
      "ACTIVE": "Aktiv",
      "CANCELLED": "Abgebrochen",
      "CLOSING": "Abschluss",
      "COMPLETED": "Abgeschlossen",
      "DRAFT": "Entwurf",
      "DUE_DILIGENCE": "Due Diligence",
      "FINANCING": "Finanzierung",
      "QA_PHASE": "Q&A"
    },
    "searchPlaceholder": "Deal-Nr. oder Titel suchen...",
    "subtitle": "Immobilientransaktionen verwalten",
    "timeline": {
      "addEvent": "Event hinzufügen",
      "empty": "Noch keine Events vorhanden.",
      "eventPlaceholder": "Beschreibung des Events...",
      "title": "Timeline"
    },
    "title": "Deals"
  },
  "deletionBlockers": {
    "description": "kann nicht gelöscht werden, da noch Abhängigkeiten bestehen:",
    "forceDelete": "Trotzdem löschen (Admin)",
    "hint": "Bitte entfernen oder übertragen Sie die oben aufgeführten Abhängigkeiten zuerst.",
    "title": "Löschen nicht möglich"
  },
  "deletionWizard": {
    "actionDelete": "Löschen",
    "actionIgnore": "Ignorieren",
    "actionReassign": "Umhängen",
    "confirmDelete": "Endgültig löschen",
    "confirmDescription": "«{{name}}» und die gewählten Abhängigkeiten werden unwiderruflich gelöscht.",
    "confirmWarning": "Achtung: Dieser Vorgang kann nicht rückgängig gemacht werden!",
    "continue": "Weiter",
    "deleteSuccess": "Organisation und Abhängigkeiten gelöscht",
    "dependencySummary": "Diese Organisation hat {{count}} Abhängigkeit(en). Wählen Sie für jede Gruppe eine Aktion.",
    "endpointNotReady": "Die Abhängigkeits-Prüfung ist noch nicht verfügbar.",
    "loadError": "Fehler beim Laden der Abhängigkeiten.",
    "loadingDependencies": "Abhängigkeiten werden geprüft…",
    "noDependencies": "Keine Abhängigkeiten gefunden — Organisation kann gelöscht werden.",
    "selectTargetCompany": "Zielfirma suchen…",
    "stepActions": "Aktionen wählen",
    "stepConfirm": "Bestätigen",
    "title": "Organisation löschen — Abhängigkeiten"
  },
  "developer": {
    "booking": {
      "amount": "Betrag (CHF)",
      "amountInvalid": "Aufladung muss grösser als 0 sein, Korrektur darf nicht 0 sein.",
      "forbidden": "Für diese Firma dürfen Sie kein Guthaben buchen.",
      "kind": "Art",
      "kindCorrection": "Korrektur",
      "kindTopupInvoice": "Aufladung auf Rechnung",
      "note": "Notiz",
      "open": "Guthaben buchen",
      "reference": "Referenz (Rechnungsnummer)",
      "saved": "Gebucht — neuer Saldo CHF {{balance}}",
      "sectionTitle": "Guthaben dieser Firma",
      "submit": "Buchen"
    },
    "credits": {
      "amount": "Betrag (CHF)",
      "balance": "Aktuelles Guthaben",
      "bookings": "Buchungen",
      "colAmount": "Betrag",
      "colBalance": "Saldo danach",
      "colDate": "Datum",
      "colKind": "Art",
      "colReference": "Referenz",
      "empty": "Noch keine Buchungen.",
      "kinds": {
        "charge": "Objektauswertung",
        "correction": "Korrektur",
        "topup_card": "Aufladung Karte/Twint",
        "topup_invoice": "Aufladung auf Rechnung"
      },
      "low": "Guthaben fast aufgebraucht — bitte aufladen.",
      "noCompany": "Diesem Zugang ist keine Firma zugeordnet.",
      "paymentsDisabled": "Zahlung derzeit nicht verfügbar. Bitte wenden Sie sich an Immotron.",
      "receipt": "Quittung",
      "tab": "Guthaben",
      "topup": "Guthaben aufladen",
      "topupCancelled": "Zahlung abgebrochen.",
      "topupHint": "Zahlung per Kreditkarte oder Twint über Stripe. Das Guthaben wird nach der Zahlung sofort gutgeschrieben.",
      "topupSuccess": "Zahlung erhalten — das Guthaben ist gutgeschrieben."
    },
    "guide": {
      "copied": "Kopiert",
      "copy": "Kopieren",
      "intro": "In drei Schritten ist Ihr Assistent angebunden.",
      "priceNote": "Jede Objektauswertung ist ein Abruf und wird mit CHF 30 vom Guthaben abgezogen. Guthaben laden Sie im Reiter «Guthaben» auf; die Nutzung sehen Sie im Reiter «Nutzung».",
      "step1": "Erstellen Sie im Reiter «API-Keys» einen Schlüssel und kopieren Sie ihn sofort — er wird nur einmal angezeigt.",
      "step1Title": "API-Key erstellen",
      "step2": "Ihr Assistent verbindet sich mit dieser Adresse (MCP, Streamable HTTP) und sendet den Schlüssel als Bearer-Token.",
      "step2Title": "Adresse des Dienstes",
      "step3": "Beispiele für gängige Assistenten — tragen Sie Adresse und Schlüssel ein, danach steht das Werkzeug «Objektauswertung» zur Verfügung.",
      "step3Title": "Assistent konfigurieren"
    },
    "navLabel": "Entwickler",
    "subtitle": "API-Keys verwalten und Ihren KI-Assistenten mit Immotron verbinden.",
    "tabs": {
      "guide": "Anleitung",
      "keys": "API-Keys",
      "usage": "Nutzung"
    },
    "title": "Entwickler-Zugang",
    "usage": {
      "colCalls": "Abrufe",
      "colChf": "CHF",
      "colMonth": "Monat",
      "colTool": "Werkzeug",
      "csv": "CSV herunterladen",
      "empty": "Im gewählten Zeitraum keine Abrufe.",
      "forbidden": "Keine Berechtigung für diese Firma.",
      "mandantTitle": "Entwickler-Nutzung (API)",
      "rangeLastMonth": "Letzter Monat",
      "rangeThisMonth": "Dieser Monat",
      "rangeThisYear": "Dieses Jahr",
      "title": "Nutzung",
      "tools": {
        "property_evaluate": "Objektauswertung"
      },
      "total": "Total"
    }
  },
  "documentViewer": {
    "deselectAll": "Alle abwählen",
    "downloadComplete": "Download abgeschlossen",
    "downloadDossier": "Gesamtdossier herunterladen",
    "downloadFailed": "Download fehlgeschlagen",
    "downloading": "Wird heruntergeladen...",
    "exitFullscreen": "Vollbild beenden",
    "fullscreen": "Vollbild",
    "noDocuments": "Keine Dokumente vorhanden",
    "of": "von",
    "page": "Dokument",
    "selectDocuments": "Dokumente auswählen",
    "selectedCount": "{{count}} Dokumente",
    "viewer": "Dokumentenansicht",
    "zoomIn": "Vergrössern",
    "zoomOut": "Verkleinern"
  },
  "documents": {
    "addCustomCategory": "Kategorie hinzufügen",
    "allCategories": "Alle Kategorien",
    "categories": {
      "bo": "BO – verbindliches Angebot",
      "grundbuchauszug": "Grundbuchauszug",
      "korrespondenz": "Korrespondenz",
      "legitimation": "Legitimation",
      "nbo": "NBO – indikatives Angebot",
      "nda": "NDA",
      "sonstiges": "Sonstiges",
      "vertrag": "Vertrag"
    },
    "categoriesFilled": "{{done}} von {{total}} Kategorien belegt",
    "category": "Kategorie",
    "categoryChanged": "Kategorie geändert",
    "changeCategory": "Kategorie ändern",
    "combinedDownload": "Kombinierter Download",
    "customCategoryPlaceholder": "Name der Kategorie...",
    "delete": "Dokument löschen",
    "deleteConfirm": "Möchten Sie «{{name}}» wirklich löschen?",
    "deleteSuccess": "Dokument gelöscht",
    "description": "Beschreibung",
    "documentPlural": "Dokumente",
    "documentSingular": "Dokument",
    "documentsCount": "Dokument(e)",
    "dossierCategories": {
      "amtliche_schaetzung": "Amtliche Schätzung",
      "baubeschrieb": "Baubeschrieb",
      "bewertungsgutachten": "Bewertungsgutachten",
      "grundbuchauszug": "Grundbuchauszug",
      "grundrisse": "Grundrisse / Pläne",
      "investitionen": "Investitionen",
      "investorendossier": "Exposé",
      "katasterplan": "Katasterplan / ÖREB",
      "liegenschaftenabrechnung": "Liegenschaftenabrechnung",
      "mieterspiegel": "Mieterspiegel",
      "mietvertraege": "Mietverträge",
      "renovationen": "Renovationen"
    },
    "dossierGroups": {
      "custom": "Benutzerdefiniert",
      "investor_dossier": "Exposé",
      "supplementary": "Ergänzende Dokumente",
      "valuation": "Bewertungsunterlagen"
    },
    "dossierProgress": "Dossier-Vollständigkeit",
    "dossierSummary": "{{total}} Dokument(e) in {{categories}} von {{totalCategories}} Kategorien",
    "dossierTooltips": {
      "amtliche_schaetzung": "Aktueller amtlicher Schätzungsbericht der kantonalen Steuerbehörde oder Gebäudeversicherung.",
      "baubeschrieb": "Offizieller Baubeschrieb des Objekts gemäss Baueingabe oder Verkaufsdokumentation mit Angaben zu Bauweise, Materialien und Ausbaustandard.",
      "bewertungsgutachten": "Unabhängiges Verkehrswert- oder Marktwertgutachten eines anerkannten Schätzungsexperten.",
      "grundbuchauszug": "Aktueller, amtlicher Grundbuchauszug der zuständigen Grundbuchbehörde (nicht älter als 6 Monate). Das Dokument muss Eigentümer, Parzellennummer, Dienstbarkeiten und Grundpfandrechte enthalten.",
      "grundrisse": "Massstabsgerechte Grundrisspläne aller Geschosse inklusive Flächenangaben.",
      "investitionen": "Dokumentierte Investitionen der letzten Jahre mit Rechnungen oder Zusammenstellung grösserer Renovationen.",
      "investorendossier": "Vollständiges Exposé mit Objektbeschreibung, Finanzkennzahlen und Lageanalyse.",
      "katasterplan": "Amtlicher Katasterplan des zuständigen Vermessungsamtes mit Parzellengrenzen, Flurnummern und Lagebezeichnung. Inklusive ÖREB-Auszug falls vorhanden.",
      "liegenschaftenabrechnung": "Letzte Jahresabrechnung der Liegenschaft mit Betriebs- und Unterhaltskosten.",
      "mieterspiegel": "Übersicht aller Mietparteien mit Mietzins, Fläche und Vertragsbeginn.",
      "mietvertraege": "Vollständige, unterzeichnete Mietverträge aller bestehenden Mietverhältnisse inklusive Nachträge und Vereinbarungen.",
      "renovationen": "Übersicht oder Dokumentation durchgeführter Renovationen mit Datum und Umfang der Arbeiten."
    },
    "download": "Herunterladen",
    "fileSize": "Grösse",
    "fileTooLarge": "Datei «{{name}}» ist zu gross (max. 50 MB)",
    "filename": "Dateiname",
    "generate": "Generieren",
    "generateFailed": "Dokumentgenerierung fehlgeschlagen",
    "generated": "{{type}} erfolgreich generiert",
    "generatedAt": "Generiert am",
    "immotronDocuments": "Immotron-Dokumente",
    "inCategories": "in {{count}} Kategorien",
    "link": "Verknüpfen",
    "linkExisting": "Dokument verknüpfen",
    "linkNoResults": "Keine Dokumente gefunden",
    "linkSearchPlaceholder": "Dokument suchen...",
    "linkSuccess": "Dokument verknüpft",
    "mergingDocuments": "Dokumente werden zusammengeführt...",
    "noCategory": "Ohne Kategorie",
    "noDocuments": "Keine Dokumente vorhanden",
    "noDocumentsShort": "Noch keine Dokumente",
    "notGenerated": "Noch nicht generiert",
    "onlyMissing": "Nur fehlende",
    "openInBrowser": "Im Browser öffnen",
    "originalDocuments": "Original-Dokumente",
    "pageOf": "Seite {{current}} von {{total}}",
    "preview": "Vorschau",
    "previewUnavailable": "Vorschau nicht verfügbar",
    "regenerate": "Neu generieren",
    "requiredDocsTitle": "Pflichtunterlagen",
    "requiredDocsProgress": "{{done}} von {{total}} Pflichtunterlagen vorhanden",
    "saveAsDraft": "Als Entwurf speichern",
    "saveFirstForDocuments": "Bitte speichern Sie die Immobilie zuerst, um Dokumente hochladen zu können.",
    "selectCategory": "Kategorie wählen",
    "showOnlyMissing": "Nur fehlende Dokumente anzeigen",
    "subgroup": {
      "label": "Untergruppe",
      "placeholder": "z. B. ÖREB-Auszüge",
      "saved": "Untergruppe gespeichert"
    },
    "title": "Dokumente",
    "uncategorized": "Nicht zugeordnete Dokumente",
    "unsupportedType": "Dateityp von «{{name}}» wird nicht unterstützt",
    "upload": "Dokument hochladen",
    "uploadCategory": "Kategorie für neue Dokumente",
    "uploadDragDrop": "Dateien hierher ziehen oder klicken zum Hochladen",
    "uploadFirst": "Laden Sie das erste Dokument hoch",
    "uploadHint": "PDF, Word, Excel, Bilder. Max. 50 MB.",
    "uploadMore": "Weitere Dateien hochladen",
    "uploadSuccess": "Dokument hochgeladen",
    "uploadedAt": "Hochgeladen am",
    "viaContact": "über {{name}}"
  },
  "emailAccounts": {
    "addImap": "IMAP-Konto hinzufügen",
    "autoFillHint": "Felder wurden aus Ihrem Profil vorausgefüllt",
    "cancel": "Abbrechen",
    "changeScope": "Firmenzuordnung ändern",
    "company": "Firma",
    "companyAccounts": "Firmen-Postfächer",
    "connect": "Verbinden",
    "connectGoogle": "Google verbinden",
    "connectMicrosoft": "Microsoft verbinden",
    "connected": "Verbunden",
    "connecting": "Verbinde...",
    "deactivated": "Deaktiviert",
    "disconnect": "Konto trennen",
    "displayName": "Anzeigename",
    "emailAddress": "E-Mail-Adresse",
    "errors": {
      "connectFailed": "Verbindung fehlgeschlagen",
      "deleteFailed": "Fehler beim Trennen",
      "invalidOAuthState": "Ungültiger OAuth-State — bitte erneut versuchen",
      "loadFailed": "E-Mail-Konten konnten nicht geladen werden",
      "oauthFailed": "OAuth-Verbindung fehlgeschlagen",
      "scopeChangeFailed": "Firmenzuordnung konnte nicht geändert werden",
      "tokenRefreshFailed": "Token-Erneuerung fehlgeschlagen — erneut verbinden"
    },
    "goToSettings": "Zu den Einstellungen",
    "imapFormTitle": "IMAP/SMTP-Konto manuell hinzufügen",
    "imapHost": "IMAP-Server",
    "imapPort": "IMAP-Port",
    "loadError": "E-Mail-Konten konnten nicht geladen werden",
    "loading": "Konten werden geladen...",
    "noAccounts": "Noch keine E-Mail-Konten verknüpft",
    "noAccountsHint": "Verbinden Sie ein Google-, Microsoft- oder IMAP-Konto",
    "notSynced": "Noch nicht synchronisiert",
    "password": "Passwort",
    "private": "Privat",
    "privateAccounts": "Private Postfächer",
    "reconnect": "Erneut verbinden",
    "refreshToken": "Token erneuern",
    "scope": "Zuordnung",
    "scopePrivate": "Privat (nur für mich)",
    "smtpHost": "SMTP-Server",
    "smtpPort": "SMTP-Port",
    "subtitle": "Verknüpfen Sie Google-, Microsoft- oder IMAP-Postfächer",
    "success": {
      "connected": "E-Mail-Konto verbunden",
      "deleted": "E-Mail-Konto getrennt",
      "scopeChanged": "Firmenzuordnung aktualisiert",
      "tokenRefreshed": "Token erneuert"
    },
    "syncTime": {
      "justNow": "gerade eben"
    },
    "thisCompany": "diese Firma",
    "title": "E-Mail-Konten",
    "useTls": "TLS verwenden"
  },
  "emailScore": {
    "level": "E-Mail-Score: {{level}}/5",
    "star1": "Syntax gültig",
    "star2": "Domain existiert",
    "star3": "MX-Record vorhanden",
    "star4": "Postfach erreichbar",
    "star5": "Zustellung bestätigt"
  },
  "emailAttachments": {
    "addShort": "Anhängen",
    "all": "Alle",
    "confirm": "Übernehmen",
    "empty": "Keine Dokumente vorhanden. Laden Sie eine Datei hoch.",
    "emptyFilter": "Keine Dokumente in dieser Kategorie.",
    "selected": "{{count}} ausgewählt",
    "sourceCompany": "Firma",
    "sourceContact": "Kontakt",
    "sourceProperty": "Objekt",
    "sourceTask": "Pendenz",
    "title": "Dokumente anhängen",
    "uploadHint": "Datei hochladen",
    "uploading": "Wird hochgeladen..."
  },
  "emailSignature": {
    "defaultTemplate": "Standard-Vorlage",
    "emailHint": "Wird vom E-Mail-Konto übernommen (Tab «E-Mail-Konten»).",
    "errors": {
      "loadFailed": "Signaturen konnten nicht geladen werden",
      "previewFailed": "Vorschau konnte nicht geladen werden",
      "saveFailed": "Signatur konnte nicht gespeichert werden"
    },
    "fields": {
      "email": "E-Mail",
      "function": "Funktion",
      "name": "Name",
      "phone": "Telefon"
    },
    "fullPreview": "Vollständige E-Mail-Vorschau",
    "infoText": "Hier konfigurieren Sie Ihre persönliche E-Mail-Signatur pro Mandant. Name, Funktion und E-Mail werden aus Ihrem Profil übernommen. Die Telefonnummer und Vorlage können Sie hier anpassen.",
    "livePreview": "Live-Vorschau",
    "noCompanies": "Keine Firmenzugehörigkeit",
    "noCompaniesDesc": "Sie sind keinem Mandanten zugeordnet. Bitten Sie einen Administrator, Sie hinzuzufügen.",
    "noSignatureYet": "Noch keine Signatur-Daten vorhanden. Bitte ergänzen Sie Ihr Profil.",
    "noTemplate": "Keine Vorlage (nur Signatur)",
    "personal": "Persönlich",
    "preview": "Vorschau",
    "previewTitle": "E-Mail-Vorschau — {{company}}",
    "saved": "E-Mail-Signatur gespeichert",
    "signatureDetails": "Signatur-Details",
    "signaturePreview": "Signatur-Vorschau",
    "subtitle": "Konfigurieren Sie Ihre E-Mail-Signatur und Standard-Vorlage pro Mandant",
    "tabLabel": "E-Mail Signatur",
    "template": "Vorlage",
    "templateHint": "Nur persönliche Vorlagen werden angezeigt. Die Vorlage wird für E-Mails des CEO-Agents verwendet.",
    "templateReadonlyHint": "Die Vorlage wird unter Einstellungen > E-Mail Vorlagen vom Administrator verwaltet.",
    "title": "Persönliche E-Mail-Signatur"
  },
  "emailTemplates": {
    "active": "Aktiv",
    "allCompanies": "Alle Mandanten",
    "categories": {
      "all": "Alle",
      "contract-signing": "Vertragsunterzeichnung",
      "marketing": "Marketing",
      "notification": "Benachrichtigungen"
    },
    "category": "Kategorie",
    "categoryPlaceholder": "z.B. Immobilien, Newsletter",
    "confirmDelete": "Möchten Sie diese Vorlage wirklich löschen?",
    "confirmDeleteDescription": "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
    "createSuccess": "Vorlage erfolgreich erstellt",
    "deleteSuccess": "Vorlage erfolgreich gelöscht",
    "deleteTemplate": "Vorlage löschen",
    "deleted": "Vorlage wurde gelöscht.",
    "description": "Beschreibung",
    "editTemplate": "Vorlage bearbeiten",
    "errors": {
      "deleteFailed": "Vorlage konnte nicht gelöscht werden.",
      "loadFailed": "Vorlagen konnten nicht geladen werden",
      "saveFailed": "Vorlage konnte nicht gespeichert werden."
    },
    "inactive": "Inaktiv",
    "list": {
      "empty": {
        "description": "Erstellen Sie Ihre erste E-Mail-Vorlage",
        "title": "Keine Vorlagen vorhanden"
      }
    },
    "name": "Name",
    "newTemplate": "Neue Vorlage",
    "personalOnly": "Persönliche Vorlage (nur für mich sichtbar)",
    "saved": "Vorlage wurde gespeichert.",
    "scopeCompany": "Firmenvorlage",
    "scopeCompanyLabel": "Firma",
    "scopePersonal": "Persönliche Vorlage",
    "scopePersonalLabel": "Persönlich",
    "search": "Vorlagen durchsuchen...",
    "subtitle": "Wiederverwendbare Vorlagen für Kampagnen",
    "title": "E-Mail-Vorlagen",
    "updateSuccess": "Vorlage erfolgreich aktualisiert"
  },
  "emailTracking": {
    "expired": "Abgelaufen",
    "pending": "Ausstehend",
    "resend": "Erneut senden",
    "resendConfirm": "Signing-E-Mail erneut an {{name}} senden?",
    "resendFailed": "E-Mail konnte nicht gesendet werden",
    "resendSuccess": "E-Mail erneut gesendet an {{email}}",
    "steps": {
      "clicked": "Link geklickt",
      "opened": "Geöffnet",
      "sent": "Gesendet",
      "signed": "Unterschrieben"
    },
    "title": "Unterschriften & Zustellung"
  },
  "emails": {
    "account": "Konto:",
    "attachments": "Anhänge",
    "bulkDeleteConfirmDescription": "Die ausgewählten Emails werden dauerhaft gelöscht und können nicht wiederhergestellt werden. Sie werden auch beim E-Mail-Provider entfernt.",
    "bulkDeleteConfirmLabel": "Alle löschen",
    "bulkDeleteFailed": "Emails konnten nicht gelöscht werden",
    "classification": {
      "actionable": "Aktion",
      "ignored": "Ignoriert"
    },
    "createTask": "Pendenz erstellen",
    "date": "Datum:",
    "deleteConfirmDescription": "Die Email wird dauerhaft gelöscht und kann nicht wiederhergestellt werden. Sie wird auch beim E-Mail-Provider entfernt.",
    "deleteConfirmTitle": "Email löschen?",
    "deleteEmail": "Email löschen",
    "deleteFailed": "Email konnte nicht gelöscht werden",
    "deleted": "Email gelöscht",
    "deselectAll": "Auswahl aufheben",
    "detailLoadFailed": "Email konnte nicht geladen werden",
    "editor": {
      "bold": "Fett (Ctrl+B)",
      "bulletList": "Aufzählung",
      "enterImageUrl": "Bild-URL eingeben:",
      "enterUrl": "URL eingeben:",
      "heading1": "Überschrift 1",
      "heading2": "Überschrift 2",
      "heading3": "Überschrift 3",
      "insertImage": "Bild einfügen (URL)",
      "insertLink": "Link einfügen",
      "italic": "Kursiv (Ctrl+I)",
      "orderedList": "Nummerierte Liste",
      "redo": "Wiederholen (Ctrl+Shift+Z)",
      "removeColor": "Farbe entfernen",
      "removeLink": "Link entfernen",
      "textColor": "Textfarbe",
      "underline": "Unterstrichen (Ctrl+U)",
      "undo": "Rückgängig (Ctrl+Z)"
    },
    "enrichContact": "Kontakt anreichern",
    "filters": {
      "actionable": "Aktion nötig",
      "alert": "Alert",
      "allAccounts": "Alle Konten",
      "allDirections": "Alle Richtungen",
      "allTypes": "Alle Typen",
      "ignored": "Ignoriert",
      "inbound": "Eingehend",
      "informational": "Info",
      "outbound": "Gesendet",
      "read": "Gelesen",
      "unread": "Ungelesen"
    },
    "from": "Von:",
    "goToTask": "Zur Pendenz",
    "loadFailed": "Emails konnten nicht geladen werden",
    "markRead": "Als gelesen markieren",
    "markUnread": "Als ungelesen markieren",
    "noContent": "Kein Inhalt verfügbar",
    "noEmails": "Keine Emails vorhanden",
    "noResults": "Keine Ergebnisse",
    "noSubject": "(Kein Betreff)",
    "replyNotAvailable": "Antworten ist direkt im E-Mail-Konto möglich — Immotron zeigt die Konversation nur an.",
    "searchPlaceholder": "Emails durchsuchen...",
    "syncFailed": "Sync fehlgeschlagen",
    "taskCreateFailed": "Pendenz konnte nicht erstellt werden",
    "thread": {
      "empty": "Keine Nachrichten in dieser Konversation",
      "inbound": "Empfangen",
      "loadFailed": "Konversation konnte nicht geladen werden",
      "messages": "{{count}} Nachrichten",
      "openEmail": "E-Mail öffnen: {{subject}}",
      "openInInbox": "Im Postfach öffnen",
      "outbound": "Gesendet",
      "reply": "Antworten",
      "title": "Konversation"
    },
    "title": "Emails",
    "to": "An:",
    "updateFailed": "Fehler beim Aktualisieren"
  },
  "entityInput": {
    "addPersonManually": "Person manuell hinzufügen",
    "address": "Adresse",
    "addressPlaceholder": "Strasse, PLZ Ort",
    "available": "verfügbar",
    "buyerName": "Name des Käufers",
    "capital": "Kapital",
    "clearSelection": "Auswahl löschen",
    "collectiveMoreRequired": "Kollektivunterschrift: mindestens 2 Personen erforderlich",
    "collectiveTwoRequired": "Kollektivunterschrift zu zweien: mindestens 2 Personen erforderlich",
    "company": "Firma",
    "companyName": "Firmenname",
    "crmBadge": "CRM",
    "crmContactsSection": "CRM-Kontakte",
    "deselectAll": "Keine auswählen",
    "email": "E-Mail",
    "emailForSignature": "E-Mail-Adresse für Vertragsunterschrift",
    "emailPlaceholder": "E-Mail-Adresse eingeben",
    "emailRequiredForSignature": "E-Mail wird für die Signatur benötigt",
    "fetchPdfFromRegister": "PDF vom Handelsregister abrufen",
    "fetchedAt": "Abgerufen",
    "fullNamePlaceholder": "Vor- und Nachname",
    "loadingCrmContacts": "Lade CRM-Kontakte...",
    "manualPersonHint": "Erfassen Sie eine Person, die gemäss internem Kontrollsystem (IKS) zeichnungsberechtigt ist, aber nicht im Handelsregister eingetragen.",
    "manuallyAdded": "Manuell erfasst (IKS)",
    "noSignatoriesFound": "Keine Zeichnungsberechtigten in der Zefix-API gefunden.",
    "noSignatoriesInPdf": "Keine Zeichnungsberechtigten im PDF gefunden",
    "partnerName": "Name des Partners",
    "pdfFetchFailed": "PDF konnte nicht abgerufen werden",
    "pdfFetchHint": "Dies kann einige Sekunden dauern",
    "pdfFetching": "PDF wird abgerufen...",
    "private": "Privatperson",
    "searchCommercialRegister": "Firma im Handelsregister suchen",
    "searchPlaceholder": "Firmenname oder UID eingeben...",
    "selectAll": "Alle auswählen",
    "selectSignatories": "Zeichnungsberechtigte auswählen",
    "sellerName": "Name des Verkäufers",
    "signatories": "Zeichnungsberechtigte",
    "signatureType": "Unterschriftstyp",
    "zefixBadge": "Zefix",
    "zefixRevert": "Zefix entfernen",
    "zefixRevertTitle": "Zefix-Daten rückgängig machen",
    "zefixRevertConfirm": "Alle Zefix-Kontakte dieser Organisation werden deaktiviert und die Zefix-Verknüpfung entfernt. Angepinnte Kontakte bleiben erhalten.",
    "zefixRevertConfirmLabel": "Rückgängig machen",
    "zefixRevertFailed": "Zefix-Revert fehlgeschlagen"
  },
  "entityAttachPicker": {
    "title": "Notiz anheften",
    "subtitle": "An welche Entität soll die Notiz geheftet werden?",
    "tabsAriaLabel": "Entitätstyp wählen",
    "tabContact": "Kontakt",
    "tabCompany": "Firma",
    "tabProperty": "Immobilie",
    "searchContact": "Kontakt suchen...",
    "searchCompany": "Firma suchen...",
    "searchProperty": "Immobilie suchen...",
    "minChars": "Mindestens 2 Zeichen eingeben",
    "noResults": "Keine Ergebnisse gefunden",
    "startTyping": "Beginne zu tippen, um zu suchen.",
    "suggestionsHeading": "Aus Pendenz-Kontext",
    "suggestionCount": "{{count}} Vorschlag",
    "suggestionCount_other": "{{count}} Vorschläge",
    "attached": "Notiz an {{label}} angeheftet",
    "attachError": "Anheften fehlgeschlagen"
  },
  "entityKnowledge": {
    "createdBy": "Erfasst von {{name}}",
    "emptyCompany": "Noch kein Wissen zu dieser Firma. Heften Sie Notizen in einer Pendenz an die Firma, damit sie hier erscheinen.",
    "emptyContact": "Noch kein Wissen zu diesem Kontakt. Heften Sie Notizen in einer Pendenz an den Kontakt, damit sie hier erscheinen.",
    "emptyProperty": "Noch kein Wissen zu dieser Immobilie. Heften Sie Notizen in einer Pendenz an die Immobilie, damit sie hier erscheinen.",
    "loadError": "Wissen konnte nicht geladen werden.",
    "openTask": "Pendenz öffnen",
    "subtitle": "{{count}} Notizen — geheftet aus Pendenzen."
  },
  "errors": {
    "duplicateEmail": {
      "companyTitle": "E-Mail bereits bei einer Organisation hinterlegt",
      "contactTitle": "E-Mail bereits bei einem Kontakt hinterlegt",
      "existingEntry": "Bestehender Eintrag",
      "openCompany": "Organisation öffnen",
      "openContact": "Kontakt öffnen"
    },
    "forbidden": "Zugriff verweigert",
    "general": "Ein Fehler ist aufgetreten",
    "network": "Netzwerkfehler",
    "notFound": "Nicht gefunden",
    "server": "Serverfehler",
    "unauthorized": "Nicht autorisiert",
    "unexpected": "Unerwarteter Fehler",
    "unexpectedDescription": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    "validation": "Validierungsfehler"
  },
  "favorites": {
    "addToList": "Zur Merkliste hinzufügen",
    "added": "Zu Merkliste hinzugefügt",
    "allCantons": "Alle Kantone",
    "allStatuses": "Alle Status",
    "allTypes": "Alle Typen",
    "browseProperties": "Objekte durchsuchen",
    "empty": "Keine Favoriten gespeichert",
    "emptyHint": "Markieren Sie Objekte mit dem Lesezeichen-Symbol, um sie hier zu sehen",
    "filterCanton": "Kanton",
    "filterStatus": "Status",
    "filterType": "Objekttyp",
    "notifications": {
      "active": "aktiv",
      "award": "Zuschlag",
      "disableAll": "Alle aus",
      "enableAll": "Alle an",
      "newDocuments": "Neue Dokumente",
      "offerPhase": "Angebotsphase",
      "priceChange": "Preisänderungen",
      "statusChange": "Statusänderungen",
      "title": "Benachrichtigungen"
    },
    "properties": "Objekte",
    "removeFromList": "Von Merkliste entfernen",
    "removed": "Von Merkliste entfernt",
    "sortBy": "Sortieren nach",
    "sortCity": "Ort",
    "sortDate": "Datum",
    "sortPrice": "Preis",
    "title": "Merkliste",
    "toggleFailed": "Fehler beim Aktualisieren der Merkliste"
  },
  "fundRadar": {
    "asOf": "Stand: {{date}}",
    "capacity": "Kaufkraft",
    "capacityGreen": "frisches Geld",
    "capacityGrey": "kein Hinweis",
    "capacityRed": "blockiert",
    "capacityYellow": "möglich",
    "colAgio": "Agio",
    "colAsOf": "Stand",
    "colAum": "AUM",
    "colCompany": "Firma",
    "colFund": "Vehikel",
    "colLtv": "LTV",
    "colReason": "Warum",
    "colSignals": "Ampeln",
    "empty": "Keine Vehikel mit diesem Signal.",
    "filterAll": "Alle",
    "filterAria": "Nach Signal filtern",
    "filterBuy": "Kauft",
    "filterNone": "Ohne Signal",
    "filterSell": "Verkauft",
    "noValue": "Keine Angabe",
    "openCompany": "Organisation «{{name}}» öffnen",
    "pressure": "Verkaufsdruck",
    "pressureGrey": "kein Hinweis",
    "pressureRed": "hoch",
    "pressureYellow": "mittel",
    "searchLabel": "Vehikel oder Firma suchen",
    "searchPlaceholder": "Vehikel oder Firma suchen …",
    "subtitle": "Verkaufsdruck rot = Laufzeitende, Fusion oder Rücknahmen. Kaufkraft grün = frisches Geld (Kapitalerhöhung, Zeichnungen offen). Disagio = kann kein Eigenkapital aufnehmen, muss aber nicht verkaufen.",
    "title": "Fondsradar"
  },
  "help": {
    "close": "Schliessen",
    "contacts": {
      "description": "Verwalten Sie alle Ansprechpersonen und Zeichnungsberechtigte.",
      "steps": [
        "Erstellen Sie neue Kontakte mit 'Neuer Kontakt'",
        "Ordnen Sie Kontakte einer oder mehreren Firmen zu",
        "Erstellen Sie bei Bedarf einen User-Account für den Kontakt"
      ],
      "tips": [
        "Kontakte können mehreren Firmen zugeordnet sein",
        "Die Zeichnungsberechtigung wird pro Firma festgelegt",
        "User-Accounts ermöglichen den Login in die Plattform"
      ],
      "title": "Kontakte"
    },
    "contextual": "Hilfe für diese Seite",
    "contractGenerator": {
      "description": "Erstellen Sie professionelle Verträge in wenigen Schritten.",
      "steps": [
        "Schritt 1: Wählen Sie eine Vorlage (AGB, Käufervertrag, etc.)",
        "Schritt 2: Füllen Sie die erforderlichen Daten aus",
        "Schritt 3: Prüfen Sie die Vorschau des Vertrags",
        "Schritt 4: Sammeln Sie die Unterschriften",
        "Schritt 5: Laden Sie den fertigen PDF herunter"
      ],
      "tips": [
        "Nutzen Sie die Zefix-Suche um Firmendaten automatisch zu laden",
        "Die Unterschrift kann mit der Maus oder auf Touch-Geräten mit dem Finger erfolgen",
        "E-Mail-Adressen werden auf Gültigkeit geprüft (MX-Record)"
      ],
      "title": "Vertragsgenerator"
    },
    "contracts": {
      "description": "Erstellen und verwalten Sie Ihre Verträge digital.",
      "steps": [
        "Klicken Sie auf 'Neuer Vertrag' um einen Vertrag zu erstellen",
        "Wählen Sie eine Vertragsvorlage aus",
        "Füllen Sie die Parteien und Daten aus",
        "Prüfen Sie die Vorschau",
        "Sammeln Sie die digitalen Unterschriften"
      ],
      "tips": [
        "Verträge können nur im Status 'Entwurf' gelöscht werden",
        "Sie können Verträge als Entwurf speichern und später unterschreiben",
        "Alle Unterschriften werden mit Zeitstempel und optional mit Standort gespeichert"
      ],
      "title": "Verträge"
    },
    "dashboard": {
      "description": "Ihre zentrale Übersicht über alle wichtigen Informationen und Schnellaktionen.",
      "steps": [
        "Sehen Sie Ihre Statistiken auf einen Blick",
        "Nutzen Sie die Schnellaktionen für häufige Aufgaben",
        "Wechseln Sie zwischen Ihren zugeordneten Firmen"
      ],
      "tips": [
        "Mit dem Firmen-Filter oben rechts können Sie die Daten nach Firma filtern"
      ],
      "title": "Dashboard"
    },
    "general": "Allgemeine Hilfe",
    "organizations": {
      "description": "Verwalten Sie Firmen und deren Zeichnungsberechtigte.",
      "steps": [
        "Firmen werden automatisch beim Vertragsabschluss erfasst",
        "Klicken Sie auf eine Firma um die Kontakte anzuzeigen",
        "Nutzen Sie 'Zefix aktualisieren' um aktuelle HR-Daten zu laden"
      ],
      "tips": [
        "Gepinnte Kontakte werden beim Zefix-Sync nicht deaktiviert",
        "Manuelle Kontakte sind automatisch gepinnt",
        "Kontakte mit Vertragsunterschriften können nicht gelöscht werden"
      ],
      "title": "Organisationen"
    },
    "properties": {
      "description": "Verwalten Sie Ihr Immobilienportfolio.",
      "steps": [
        "Erfassen Sie neue Immobilien mit allen Details",
        "Laden Sie Bilder und Dokumente hoch",
        "Verwalten Sie den Status (Entwurf, Aktiv, Reserviert, Verkauft)"
      ],
      "tips": [
        "Immobilien im Status 'Entwurf' sind noch nicht öffentlich sichtbar",
        "Mehrsprachige Beschreibungen sind möglich"
      ],
      "title": "Immobilien"
    },
    "settings": {
      "description": "Systemkonfiguration und Verwaltung.",
      "steps": [
        "Verwalten Sie interne Zeichnungsberechtigte",
        "Sehen Sie das Datenbank-Schema ein"
      ],
      "tips": [
        "Interne Zeichnungsberechtigte werden hier verwaltet"
      ],
      "title": "Einstellungen"
    },
    "signatories": {
      "description": "Verwalten Sie die internen Zeichnungsberechtigten Ihrer Firma.",
      "steps": [
        "Wählen Sie einen bestehenden Kontakt aus",
        "Legen Sie die Funktion fest (z.B. Geschäftsführer)",
        "Definieren Sie die Zeichnungsberechtigung (Einzel oder Kollektiv)"
      ],
      "tips": [
        "Diese Personen erscheinen als Unterschreibende bei Immotron-Verträgen",
        "Der Unterschriftstext erscheint unter der Signatur im PDF"
      ],
      "title": "Zeichnungsberechtigte"
    },
    "title": "Hilfe",
    "users": {
      "description": "Verwalten Sie Benutzerkonten und Berechtigungen.",
      "steps": [
        "Erstellen Sie neue Benutzer mit 'Benutzer hinzufügen'",
        "Weisen Sie eine Rolle zu (Admin, Sales, Investor)",
        "Optional: Verknüpfen Sie den User mit einem Kontakt"
      ],
      "tips": [
        "Admins haben Zugriff auf alle Funktionen",
        "Sales-User können Verträge und Immobilien verwalten",
        "Investoren können nur suchen und ihr Portfolio sehen"
      ],
      "title": "Benutzerverwaltung"
    }
  },
  "investor": {
    "access": {
      "accessCount": "{{count}} Investor(en) mit Zugang",
      "accessGranted": "Zugang erteilt",
      "accessViaDirect": "direkt",
      "accessViaGroup": "via Gruppe {{name}}",
      "date": "Datum",
      "emailBounced": "E-Mail nicht zustellbar",
      "emailClicked": "Link geklickt",
      "emailNotSent": "E-Mail nicht gesendet",
      "emailOpened": "E-Mail geöffnet",
      "emailSent": "E-Mail gesendet",
      "grantAccess": "Zugang gewähren",
      "grantSuccess": "Zugang erfolgreich gewährt",
      "grantSuccessWithEmail": "Zugang gewährt — Investor wird per E-Mail benachrichtigt",
      "groupAccessHint": "Zugang via Gruppe — nur durch Gruppenentfernung widerrufbar",
      "manual": "Manuell",
      "noInvestors": "Noch keine Investoren mit Zugang",
      "revokeAccess": "Zugang entziehen",
      "revokeConfirm": "Möchten Sie den Zugang für diesen Investor wirklich entziehen?",
      "revokeSuccess": "Zugang erfolgreich entzogen",
      "searchHint": "Suchen Sie nach Name oder E-Mail",
      "searchInvestor": "Investor suchen...",
      "selfService": "Selbst",
      "source": "Herkunft",
      "title": "Investoren-Zugang"
    },
    "activity": {
      "bounced": "Nicht zustellbar",
      "clicked": "Geklickt",
      "failed": "Fehlgeschlagen",
      "noActivity": "Noch keine Benachrichtigungen",
      "opened": "Geöffnet",
      "sent": "Gesendet",
      "title": "Benachrichtigungen",
      "type": {
        "ACCESS_GRANTED": "Zugang freigeschaltet",
        "DOSSIER_UPDATE": "Neues Dokument",
        "INTEREST_EXPRESSED": "Interesse bestätigt",
        "INTEREST_SALES_NOTIFY": "Sales informiert"
      }
    },
    "dossier": {
      "backToTeaser": "Zurück zur Übersicht",
      "clearSelection": "Auswahl aufheben",
      "documentsCount": "{{count}} Dokument(e)",
      "documentsLabel": "Dokumente",
      "download": "Herunterladen",
      "downloadPdf": "Dossier als PDF",
      "downloadUnavailable": "Download nicht verfügbar",
      "groups": {
        "custom": "Benutzerdefiniert",
        "investor_dossier": "Exposé",
        "supplementary": "Ergänzende Dokumente",
        "valuation": "Bewertungsunterlagen"
      },
      "lastUpload": "Letzter Upload",
      "newBadge": "Neu",
      "newCount": "{{count}} neu",
      "noAccess": "Kein Zugang",
      "noAccessHint": "Sie benötigen Zugang zum Exposé. Bitte bekunden Sie zuerst Ihr Interesse.",
      "noDocuments": "Keine Dokumente in dieser Kategorie",
      "offerHint": "Festpreis-Verkauf — Ihr Angebot erfassen Sie auf der Objektseite.",
      "pdfDownloaded": "Dossier-PDF heruntergeladen",
      "pdfFailed": "PDF-Download fehlgeschlagen",
      "previewSelected": "Vorschau",
      "selected": "ausgewählt",
      "subtitle": "Vollständige Dokumentation",
      "title": "Exposé"
    },
    "expose": {
      "pages": "{{count}} Seiten",
      "read": "Exposé lesen",
      "title": "Exposé"
    },
    "interest": {
      "agbNote": "Mit der Interessensbekundung bestätigen Sie, dass die geltenden AGB und NDA-Bestimmungen Ihres Plattform-Abonnements Anwendung finden.",
      "alreadyExpressed": "Sie haben bereits Interesse an diesem Objekt bekundet.",
      "confirm": "Interesse bestätigen",
      "description": "Hiermit bekunden Sie Ihr Interesse an folgendem Objekt:",
      "salesNotified": "Das Sales-Team wurde über Ihr Interesse informiert.",
      "success": "Interesse erfolgreich bekundet",
      "successHint": "Sie haben nun Zugang zum vollständigen Exposé.",
      "successWithEmail": "Bestätigung per E-Mail gesendet. Sie haben nun Zugang zum Dossier.",
      "title": "Interesse bekunden"
    },
    "listing": {
      "includedProperties": "Enthaltene Objekte",
      "ndaConfirmAccess": "NDA bestätigen & Zugang erhalten",
      "ndaConfirmHint": "Bestätigen Sie die Vertraulichkeitserklärung, um Zugang zum vollständigen Dossier zu erhalten.",
      "properties": "Objekte",
      "propertyIndex": "Objekt {{index}}",
      "submitOffer": "Angebot abgeben",
      "totalPrice": "Gesamtpreis"
    },
    "nda": {
      "bracketFrom": "ab {{from}}",
      "bracketRange": "{{from}} bis {{to}}",
      "bracketsTitle": "Käuferprovision (Stufen auf den Kaufpreis):",
      "checkbox": "Ich habe die Vertraulichkeitserklärung gelesen und akzeptiere sie.",
      "commissionModel": "Provisionsmodell",
      "conditionsCheckbox": "Ich habe die Konditionen für dieses Objekt gelesen und akzeptiere sie.",
      "conditionsLoading": "Konditionen werden geladen …",
      "conditionsTitle": "Konditionen für dieses Objekt",
      "confidentialityText": "Alle Informationen, die Ihnen im Rahmen dieses Exposés zur Verfügung gestellt werden, sind streng vertraulich. Sie verpflichten sich, diese Informationen nicht an Dritte weiterzugeben und ausschliesslich zur Prüfung der Investitionsmöglichkeit zu verwenden.",
      "confidentialityTitle": "Vertraulichkeit",
      "confirm": "Bestätigen & Dossier öffnen",
      "criteriaText": "Sie bestätigen, dass dieses Objekt Ihren Investitionskriterien entspricht und Sie über die notwendigen finanziellen Mittel verfügen, um eine mögliche Transaktion durchzuführen.",
      "criteriaTitle": "Investitionskriterien",
      "decline": "Zurück",
      "dueNote": "Die Provision wird bei Beurkundung des Kaufvertrags fällig.",
      "findersFeeText": "Bei Zustandekommen einer Transaktion wird eine Vermittlungsgebühr gemäss den vereinbarten Konditionen fällig. Ein Umgehen des Vermittlers ist unzulässig.",
      "findersFeeTitle": "Vermittlungsgebühr",
      "flatRate": "Einheitssatz: {{rate}} des Kaufpreises.",
      "noModel": "Für dieses Objekt ist aktuell kein Provisionsmodell hinterlegt. Die Konditionen werden im Käufer-Rahmenvertrag bzw. im Anhang B zum Objekt geregelt.",
      "sourceAppendixB": "Objektspezifisch (Anhang B)",
      "sourceDefault": "Standardkonditionen",
      "specialConditionsTitle": "Sonderkonditionen",
      "successContinue": "Weiter zum Dossier",
      "successText": "Ihre Bestätigung wurde protokolliert. Diesen Konditionen haben Sie zugestimmt:",
      "successTitle": "NDA und Konditionen bestätigt",
      "title": "Vertraulichkeitserklärung (NDA)",
      "vatNote": "Alle Provisionsangaben verstehen sich zzgl. gesetzlicher MwSt.",
      "objection": {
        "button": "Konditionen nicht akzeptieren",
        "title": "Konditionen ablehnen",
        "intro": "Nennen Sie den gewünschten Satz und begründen Sie Ihren Einwand. Die Verkäuferseite prüft den Gegenvorschlag — bis dahin erhalten Sie keinen Zugang zu den Objektdaten.",
        "rateLabel": "Gewünschter Satz (optional)",
        "ratePlaceholder": "z. B. 2.5",
        "rateHint": "Prozent des Kaufpreises. Ohne Angabe wird nur die Begründung übermittelt.",
        "reasonLabel": "Begründung",
        "reasonPlaceholder": "Warum akzeptieren Sie die Konditionen nicht?",
        "reasonRequired": "Ohne Begründung kann der Einwand nicht gesendet werden.",
        "back": "Zurück",
        "submit": "Einwand senden",
        "sentTitle": "Einwand übermittelt",
        "sentText": "Ihr Einwand wurde erfasst. Die Verkäuferseite prüft Ihren Gegenvorschlag und meldet sich bei Ihnen. Bis dahin bleiben die Objektdaten geschlossen."
      }
    },
    "search": {
      "accessGranted": "Zugang erteilt",
      "allCantons": "Alle Kantone",
      "allTypes": "Alle Typen",
      "areaFrom": "Fläche ab (m²)",
      "areaTo": "Fläche bis (m²)",
      "canton": "Kanton",
      "clearFilters": "Filter zurücksetzen",
      "contractError": {
        "CONTRACT_EXPIRED": {
          "message": "Ihr Plattformvertrag ist abgelaufen. Bitte kontaktieren Sie Ihren Ansprechpartner zur Verlängerung.",
          "title": "Plattformvertrag abgelaufen"
        },
        "NO_ACTIVE_CONTRACT": {
          "message": "Es liegt kein aktiver Plattformvertrag vor. Bitte kontaktieren Sie Ihren Ansprechpartner.",
          "title": "Kein aktiver Plattformvertrag"
        }
      },
      "errorTitle": "Fehler beim Laden",
      "filters": "Filter",
      "loadError": "Immobilien konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "noResults": "Keine Immobilien gefunden",
      "noResultsHint": "Passen Sie Ihre Suchkriterien an",
      "placeholder": "Stadt, Region oder PLZ...",
      "priceFrom": "Preis ab (CHF)",
      "priceRange": "Preisbereich",
      "priceTo": "Preis bis (CHF)",
      "resultsCount": "{{count}} Immobilien gefunden",
      "sortNewest": "Neueste zuerst",
      "sortPriceAsc": "Preis aufsteigend",
      "sortPriceDesc": "Preis absteigend",
      "sortSizeDesc": "Grösste zuerst",
      "subtitle": "Finden Sie Ihre nächste Investition",
      "title": "Immobiliensuche"
    },
    "teaser": {
      "accessGranted": "Zugang gewährt",
      "accessGrantedHint": "Sie haben Zugang zum vollständigen Exposé dieses Objekts.",
      "approximateLocation": "Ungefährer Standort",
      "atAGlance": "Auf einen Blick",
      "backToSearch": "Zurück zur Suche",
      "buildingPermit": "Baubewilligung",
      "confirmNda": "Ich bestätige die Vertraulichkeitserklärung (NDA)",
      "description": "Beschreibung",
      "emptyGallery": "Bilder folgen in Kürze",
      "exclusiveMandate": "Exklusives Off-Market-Mandat",
      "financial": {
        "title": "Finanzkennzahlen",
        "grossYield": "Bruttorendite",
        "netYield": "Nettorendite",
        "annualIncome": "Mietertrag p.a.",
        "factor": "Faktor (× Jahresmiete)",
        "vacancy": "Leerstand",
        "pricePerSqm": "Kaufpreis/m²",
        "rentPerSqm": "Miete/m² p.a.",
        "netYieldAssumption": "Annahme: 18% Bewirtschaftungskosten"
      },
      "locked": "Nach NDA",
      "lockedLocation": "Standort nach NDA",
      "lockedLocationHint": "Der genaue Standort wird nach Unterzeichnung der Vertraulichkeitserklärung sichtbar.",
      "region": "Region {{canton}}",
      "regionAddress": "{{region}} · genaue Adresse nach NDA",
      "ndaRequired": "NDA erforderlich",
      "lockedLocationPlaceholder": "Die Lage liegt verkehrsgünstig in einer etablierten Gemeinde mit guter Anbindung an den öffentlichen Verkehr sowie Einkaufsmöglichkeiten und Schulen in unmittelbarer Nähe.",
      "signNda": "NDA unterzeichnen",
      "technicalDetails": "Technische Details",
      "detailLabels": {
        "buildingCount": "Anzahl Gebäude",
        "cadastreNumber": "Kataster-Nr.",
        "commercialUnits": "Gewerbeeinheiten",
        "condition": "Zustand",
        "constructionYear": "Baujahr",
        "egridNumber": "E-GRID Nr.",
        "garageParking": "Garagenparkplätze",
        "heatingSystem": "Heizanlage",
        "lotSize": "Grundstücksfläche",
        "outdoorParking": "Aussenparkplätze",
        "propertyType": "Kategorie / Nutzungsart",
        "renovation": "Sanierung",
        "residentialUnits": "Wohneinheiten",
        "usableArea": "Nutzfläche",
        "utilizationFactor": "Ausnützungsziffer",
        "volume": "Volumen"
      },
      "details": "Details",
      "expressInterest": "Interesse bekunden",
      "grossYield": "Bruttorendite",
      "highlights": "Investment-Highlights",
      "interestedHint": "Bekunden Sie Ihr Interesse, um Zugang zum vollständigen Dossier zu erhalten.",
      "interestedTitle": "Interesse an diesem Objekt?",
      "keyFacts": "Kennzahlen",
      "location": "Standort",
      "macroLocation": "Makrolage",
      "microLocation": "Mikrolage",
      "netYield": "Nettorendite",
      "ownership": "Eigentumsart",
      "openInGoogleMaps": "In Google Maps öffnen",
      "price": "Preis",
      "privateListingNotice": "Dieses Objekt ist ein Privatangebot und nur für ausgewählte Investoren zugänglich.",
      "salesContact": "Ihr Ansprechpartner",
      "title": "Objektübersicht",
      "type": "Typ",
      "usableArea": "Nutzfläche",
      "viewDossier": "Zum Dossier",
      "viewOnMaps": "Auf Google Maps anzeigen",
      "yearBuilt": "Baujahr",
      "gallery": {
        "openFullscreen": "Galerie im Vollbild öffnen",
        "close": "Vollbild schliessen"
      },
      "preview": {
        "previewAs": "Vorschau als",
        "levels": {
          "buyer_no_nda": "Käufer ohne NDA",
          "buyer_nda": "Käufer mit NDA",
          "internal": "Intern"
        },
        "internalBlockTitle": "Interner Bereich",
        "internalBlockHint": "Nur für interne Nutzer sichtbar — nicht Teil der Käufer-Ansicht.",
        "investorGroups": "Investorengruppen",
        "noInvestorGroups": "Keine Investorengruppen zugewiesen.",
        "memberCount": "{{count}} Mitglieder",
        "noMembers": "Keine Mitglieder",
        "memberType": {
          "user": "Benutzer",
          "company": "Firma",
          "contact": "Kontakt"
        }
      }
    },
    "viewer": {
      "close": "Vorschau schliessen",
      "exitFullscreen": "Vollbild beenden",
      "fullscreen": "Vollbild",
      "loadError": "Die Vorschau konnte nicht geladen werden.",
      "page": "Seite {{current}} von {{total}}"
    },
    "dealStage": {
      "bo": "BO abgegeben",
      "nbo": "NBO abgegeben",
      "offer": "Angebot abgegeben",
      "nda": "NDA unterzeichnet",
      "teaser": "Teaser verfügbar"
    }
  },
  "investorContracts": {
    "active": "Aktive Verträge",
    "expired": "Abgelaufene Verträge",
    "subtitle": "Übersicht Ihrer Verträge",
    "title": "Meine Verträge"
  },
  "investorGroups": {
    "addGroupAccess": "Gruppen-Zugang gewähren",
    "addMember": "Mitglied hinzufügen",
    "addMemberSuccess": "Mitglied erfolgreich hinzugefügt",
    "createGroup": "Gruppe erstellen",
    "createSuccess": "Gruppe erfolgreich erstellt",
    "deleteConfirm": "Möchten Sie die Gruppe «{{name}}» wirklich löschen? Alle Gruppenzugänge werden entzogen.",
    "deleteGroup": "Gruppe löschen",
    "deleteSuccess": "Gruppe erfolgreich gelöscht",
    "description": "Beschreibung",
    "editGroup": "Gruppe bearbeiten",
    "grantAccessSuccess": "Gruppen-Zugang erfolgreich gewährt",
    "groupAccess": "Gruppen-Zugang",
    "hideRecipients": "Empfänger von {{name}} ausblenden",
    "memberCompanyCount": "{{count}} Firmen",
    "memberCount": "{{count}} Mitglied(er)",
    "memberTypeCompany": "Firma",
    "memberTypeContact": "Kontakt",
    "members": "Mitglieder",
    "name": "Name",
    "noGroups": "Noch keine Investorengruppen erstellt",
    "noMembers": "Noch keine Mitglieder in dieser Gruppe",
    "noRecipients": "kein Empfänger",
    "recipientCount": "{{count}} Empfänger",
    "removeGroupAccess": "Gruppen-Zugang entziehen",
    "removeMember": "Mitglied entfernen",
    "removeMemberConfirm": "Möchten Sie diesen Investor wirklich aus der Gruppe entfernen?",
    "removeMemberSuccess": "Mitglied erfolgreich entfernt",
    "revokeAccessSuccess": "Gruppen-Zugang erfolgreich entzogen",
    "searchInvestor": "Kontakt oder Firma suchen …",
    "searchNoResults": "Keine Kontakte oder Firmen gefunden",
    "selectGroup": "Gruppe auswählen",
    "showRecipients": "Empfänger von {{name}} anzeigen",
    "skippedWithoutEmail": "{{count}} Kontakte ohne E-Mail",
    "subtitle": "Investoren gruppieren und Zugang gebündelt verwalten",
    "title": "Investorengruppen",
    "updateSuccess": "Gruppe erfolgreich aktualisiert"
  },
  "investorSettings": {
    "activities": {
      "empty": "Keine Aktivitäten in diesem Zeitraum",
      "emptyAll": "Noch keine Aktivitäten vorhanden",
      "emptyHint": "Erweitern Sie den Zeitraum oder wählen Sie «Alle», um weitere Einträge zu sehen.",
      "entries": "Einträge",
      "errorHint": "Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.",
      "errorRetry": "Erneut laden",
      "filter30d": "30 Tage",
      "filter7d": "7 Tage",
      "filter90d": "90 Tage",
      "filterAll": "Alle",
      "filterLabel": "Zeitraum",
      "loadError": "Aktivitäten konnten nicht geladen werden",
      "title": "Meine Aktivitäten",
      "type": {
        "CONTRACT_SIGNED": "Vertrag unterschrieben",
        "DOCUMENTS_RECEIVED": "Dokumente erhalten",
        "FAVORITE_ADDED": "Favorit hinzugefügt",
        "INQUIRY_RECEIVED": "Neue Anfrage erhalten",
        "INTEREST_EXPRESSED": "Interesse bekundet",
        "INVESTOR_INTEREST_RECEIVED": "Neue Interessensbekundung erhalten",
        "LISTING_CREATED": "Angebot erstellt",
        "LISTING_PUBLISHED": "Angebot veröffentlicht",
        "MESSAGE_RECEIVED": "Nachricht erhalten",
        "NDA_CONFIRMED": "NDA bestätigt",
        "OFFER_SUBMITTED": "Angebot verschickt",
        "PROFILE_UPDATED": "Profil aktualisiert",
        "PROPERTY_CREATED": "Immobilie erstellt",
        "VIEWING_CONFIRMED": "Besichtigung bestätigt"
      }
    },
    "contracts": {
      "contactUs": "Kontakt aufnehmen",
      "downloadPdf": "Vertrag als PDF herunterladen",
      "empty": "Keine Verträge vorhanden",
      "expiredNotice": "Dieser Vertrag ist abgelaufen. Bitte kontaktieren Sie uns für eine Verlängerung.",
      "expiresAt": "Läuft ab am",
      "signedAt": "Unterzeichnet am",
      "status": {
        "CANCELLED": "Storniert",
        "CUSTOMER_SIGNED": "Vom Kunden unterzeichnet",
        "DRAFT": "Entwurf",
        "EXPIRED": "Abgelaufen",
        "SENT": "Versendet",
        "SIGNED": "Unterzeichnet",
        "TERMINATED": "Gekündigt"
      },
      "type": {
        "BROKER_AGREEMENT": "Maklervertrag",
        "PLATFORM_AGREEMENT": "Plattformvertrag",
        "SEARCH_MANDATE": "Suchmandat"
      }
    },
    "passkeys": {
      "addPasskey": "Passkey hinzufügen",
      "confirmDelete": "Wirklich entfernen?",
      "confirmDeleteBtn": "Entfernen bestätigen",
      "deleteError": "Passkey konnte nicht entfernt werden",
      "deleteSuccess": "Passkey erfolgreich entfernt",
      "deviceName": "Gerätename",
      "deviceNamePlaceholder": "z.B. iPhone von Max",
      "editName": "Name bearbeiten",
      "empty": "Noch keine Passkeys registriert",
      "lastPasskeyWarning": "Dies ist Ihr einziger Passkey. Nach dem Entfernen können Sie sich weiterhin mit Ihrem Passwort anmelden.",
      "lastUsed": "Letzter Login",
      "notSupported": "Ihr Browser unterstützt keine Passkeys. Bitte verwenden Sie einen aktuellen Browser.",
      "registerError": "Passkey konnte nicht registriert werden",
      "registerSuccess": "Passkey erfolgreich registriert",
      "registeredAt": "Registriert",
      "registrationCancelled": "Passkey-Registrierung abgebrochen",
      "removePasskey": "Passkey entfernen",
      "renameError": "Gerätename konnte nicht gespeichert werden",
      "renameSuccess": "Gerätename gespeichert",
      "subtitle": "Passkeys für schnelleres und sicheres Anmelden verwalten",
      "title": "Anmeldemethoden",
      "unnamedDevice": "Unbenanntes Gerät"
    },
    "profile": {
      "changePassword": "Passwort ändern",
      "changePasswordBtn": "Passwort ändern",
      "companies": "Firmenzugehörigkeit",
      "confirmPassword": "Passwort bestätigen",
      "currentPassword": "Aktuelles Passwort",
      "currentPasswordWrong": "Das aktuelle Passwort ist nicht korrekt",
      "email": "E-Mail-Adresse",
      "firstName": "Vorname",
      "forgotCurrentPassword": "Aktuelles Passwort unbekannt? Passwort per E-Mail neu festlegen",
      "hidePassword": "Passwort verbergen",
      "lastName": "Nachname",
      "newPassword": "Neues Passwort",
      "noPasswordSet": "Für dieses Konto ist kein Passwort gesetzt. Legen Sie es per E-Mail-Link fest.",
      "passwordError": "Passwort konnte nicht geändert werden. Bitte prüfen Sie Ihr aktuelles Passwort.",
      "passwordLinkError": "Der Link konnte nicht gesendet werden. Bitte versuchen Sie es später erneut.",
      "passwordLinkSent": "Wir haben Ihnen einen Link an {{email}} geschickt. Damit legen Sie Ihr Passwort fest.",
      "passwordMismatch": "Die Passwörter stimmen nicht überein",
      "passwordSuccess": "Passwort erfolgreich geändert",
      "personalInfo": "Persönliche Informationen",
      "readOnly": "Schreibgeschützt",
      "saveError": "Profil konnte nicht gespeichert werden",
      "saveSuccess": "Profil erfolgreich gespeichert",
      "sendPasswordLink": "Link per E-Mail senden",
      "setPassword": "Passwort festlegen",
      "setPasswordHint": "Für dieses Konto ist noch kein Passwort gesetzt — Sie melden sich per Link, Passkey oder Handy-Signatur an. Wir senden Ihnen einen E-Mail-Link, mit dem Sie ein Passwort festlegen.",
      "showPassword": "Passwort anzeigen",
      "weakPassword": "Das Passwort erfüllt die Anforderungen nicht"
    },
    "subtitle": "Ihr Konto und Ihre Verträge verwalten",
    "tabs": {
      "activities": "Aktivitäten",
      "contracts": "Verträge",
      "invoices": "Rechnungen",
      "notifications": "Benachrichtigungen",
      "privacy": "Privatsphäre",
      "profile": "Profil"
    },
    "title": "Einstellungen"
  },
  "invoices": {
    "columns": {
      "actions": "Aktionen",
      "amount": "Betrag",
      "date": "Datum",
      "dueDate": "Fällig am",
      "number": "Rechnungsnr.",
      "property": "Objekt",
      "status": "Status"
    },
    "download": "PDF herunterladen",
    "downloadFailed": "PDF-Download fehlgeschlagen",
    "empty": "Keine Rechnungen vorhanden",
    "emptyHint": "Ihre Rechnungen erscheinen hier, sobald sie erstellt werden",
    "filters": {
      "allStatuses": "Alle Status",
      "fromDate": "Von",
      "status": "Status",
      "toDate": "Bis"
    },
    "loadFailed": "Rechnungen konnten nicht geladen werden",
    "openWarning": "Sie haben {{count}} offene oder überfällige Rechnung(en)",
    "statuses": {
      "CANCELLED": "Storniert",
      "OPEN": "Offen",
      "OVERDUE": "Überfällig",
      "PAID": "Bezahlt"
    },
    "title": "Rechnungen"
  },
  "kyc": {
    "badge": {
      "exempt": "Keine Identifikation nötig",
      "exemptHint": "Ihre Firma ist beaufsichtigt (FINMA o. ä.) — eine persönliche Identifikation ist nicht nötig.",
      "pending": "Identifikation ausstehend",
      "verified": "Identifiziert"
    },
    "capture": {
      "analysis": {
        "continueAnyway": "Trotzdem weiter",
        "critiqueTitle": "Bitte nehmen Sie die {{slot}} neu auf.",
        "prefilled": "Wir haben Ihren Ausweis ausgelesen — bitte kurz prüfen.",
        "quality": {
          "blurry": "Das Bild ist unscharf.",
          "cut_off": "Der Ausweis ist nicht ganz im Bild.",
          "glare": "Auf dem Bild spiegelt es — bitte ohne direkte Lichtquelle neu aufnehmen.",
          "not_document": "Wir konnten keinen Ausweis erkennen."
        },
        "retake": "Neu aufnehmen",
        "skip": "Ohne Prüfung weiter und selbst ausfüllen",
        "waitHint": "Das kann einen Moment dauern.",
        "waitTitle": "Ihr Ausweis wird geprüft …"
      },
      "camera": {
        "backDefault": "Rückkamera (Standard)",
        "denied": "Wir dürfen nicht auf Ihre Kamera zugreifen. Erlauben Sie den Zugriff im Browser oder laden Sie stattdessen Fotos hoch.",
        "deniedFallback": "Wir dürfen nicht auf Ihre Kamera zugreifen. Laden Sie die Aufnahmen stattdessen als Datei hoch.",
        "documentHint": "Alle vier Ecken im Bild, keine Spiegelungen.",
        "frameHint": "Legen Sie den Ausweis genau in den Rahmen.",
        "frontDefault": "Frontkamera (Standard)",
        "lowResolution": "Die Aufnahme ist klein ({{width}} × {{height}} px). Gehen Sie näher an den Ausweis oder wählen Sie eine bessere Kamera.",
        "numbered": "Kamera {{n}}",
        "previewAlt": "Vorschau der Aufnahme",
        "retake": "Wiederholen",
        "select": "Kamera",
        "selfieGuideHint": "Gesicht ins Oval, Hand in den Umriss.",
        "selfieHint": "Ihr Gesicht gut sichtbar, ohne Kopfbedeckung.",
        "shutter": "Aufnehmen",
        "starting": "Kamera wird gestartet …",
        "unavailable": "Wir finden keine Kamera auf diesem Gerät. Laden Sie stattdessen Fotos oder eine PDF-Kopie hoch.",
        "unavailableFallback": "Wir finden keine Kamera auf diesem Gerät. Laden Sie die Aufnahmen stattdessen als Datei hoch.",
        "use": "Verwenden"
      },
      "details": {
        "country": "Ausstellungsland",
        "countryHint": "Zwei Buchstaben, z. B. CH, DE oder FR.",
        "expiry": "Gültig bis",
        "lead": "Nur noch das Ausstellungsland — Nummer und Ablaufdatum sind freiwillig.",
        "number": "Ausweisnummer",
        "submit": "Zur Prüfung einreichen",
        "title": "Angaben zum Ausweis"
      },
      "documentTypes": {
        "ID_CARD": "Identitätskarte",
        "OTHER": "Anderer amtlicher Ausweis",
        "PASSPORT": "Pass",
        "RESIDENCE_PERMIT": "Ausländerausweis"
      },
      "errors": {
        "allSlotsFilled": "Alle Seiten sind bereits erfasst. Nutzen Sie «Ersetzen», um eine Aufnahme auszutauschen.",
        "alreadySubmitted": "Diese Identifikation wurde bereits eingereicht und wird geprüft.",
        "expired": "Dieser Ausweis ist abgelaufen. Bitte verwenden Sie einen gültigen Ausweis.",
        "incomplete": "Es fehlen noch Aufnahmen:",
        "submitFailed": "Das Einreichen hat nicht geklappt. Bitte versuchen Sie es erneut.",
        "tooLarge": "Die Datei ist zu gross. Erlaubt sind Dateien bis 15 MB.",
        "uploadFailed": "Die Datei konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
        "wrongType": "Dieses Format können wir nicht lesen. Erlaubt sind JPG, PNG, HEIC und PDF."
      },
      "face": {
        "loading": "Gesichtserkennung wird vorbereitet …",
        "multiple": "Nur eine Person im Bild.",
        "none": "Kein Gesicht erkannt.",
        "offCenter": "Halten Sie Ihr Gesicht in das Oval.",
        "showFingersNow_one": "Zeigen Sie jetzt {{count}} Finger",
        "showFingersNow_other": "Zeigen Sie jetzt {{count}} Finger",
        "steady": "Stillhalten …",
        "tooLarge": "Etwas weiter weg.",
        "tooSmall": "Etwas näher heran."
      },
      "liveness": {
        "LOOK_UP": "Nach oben schauen",
        "SHOW_FINGERS": "{{count}} Finger zeigen",
        "SHOW_TWO_FINGERS": "Zwei Finger zeigen",
        "TURN_HEAD_LEFT": "Kopf nach links drehen",
        "TURN_HEAD_RIGHT": "Kopf nach rechts drehen",
        "instructions": {
          "LOOK_UP": "Schauen Sie kurz nach oben",
          "SHOW_FINGERS_one": "Zeigen Sie {{count}} Finger neben dem Gesicht",
          "SHOW_FINGERS_other": "Zeigen Sie {{count}} Finger neben dem Gesicht",
          "SHOW_TWO_FINGERS": "Halten Sie zwei Finger neben Ihr Gesicht",
          "TURN_HEAD_LEFT": "Drehen Sie den Kopf leicht nach links",
          "TURN_HEAD_RIGHT": "Drehen Sie den Kopf leicht nach rechts"
        },
        "title": "Ihre Aufgabe für das Selfie"
      },
      "scanner": {
        "backgroundHint": "Tipp: Legen Sie den Ausweis auf eine dunkle, einfarbige Unterlage — oder lösen Sie mit «Aufnehmen» von Hand aus.",
        "closer": "Näher heran.",
        "loading": "Scanner wird geladen …",
        "searching": "Halten Sie den Ausweis in den Rahmen.",
        "steady": "Ruhig halten …",
        "straightened": "Ausweis automatisch gerade gerückt"
      },
      "setup": {
        "documentType": "Welchen Ausweis legen Sie vor?",
        "lead": "Wir brauchen ein Bild Ihres Ausweises und ein Selfie. Sie können beides direkt aufnehmen oder als Datei hochladen.",
        "live": "Mit Kamera aufnehmen",
        "liveDesc": "Handy-Kamera oder Webcam — Ausweis und Selfie in zwei Minuten.",
        "title": "Ausweis erfassen",
        "upload": "Dateien hochladen",
        "uploadDesc": "Fotos (JPG, PNG, HEIC) oder eine PDF-Kopie Ihres Ausweises."
      },
      "slots": {
        "back": "Rückseite des Ausweises",
        "front": "Vorderseite des Ausweises",
        "pdf": "PDF-Kopie des Ausweises",
        "selfie": "Selfie"
      },
      "summary": {
        "lead": "So haben wir Ihre Aufnahmen gespeichert. Ist etwas unscharf oder abgeschnitten, nehmen Sie es neu auf.",
        "pdfNote": "PDF-Kopie",
        "previewUnavailable": "Vorschau nicht verfügbar — die Datei ist gespeichert.",
        "retake": "Neu aufnehmen",
        "title": "Ihre Aufnahmen"
      },
      "upload": {
        "choose": "Dateien auswählen",
        "dropHint": "Dateien hierher ziehen oder auswählen",
        "formats": "JPG, PNG, HEIC oder PDF — bis 15 MB pro Datei.",
        "lead": "Fotos von Vorder- und Rückseite — oder eine PDF-Kopie des Ausweises. Ein Selfie hilft uns bei der Prüfung, ist hier aber freiwillig.",
        "nativeCamera": "Mit der Kamera aufnehmen",
        "pdfHint": "Sie haben eine PDF-Kopie Ihres Ausweises? Laden Sie einfach das PDF hoch — Vorder- und Rückseite entfallen dann.",
        "replace": "Ersetzen",
        "select": "Datei wählen",
        "title": "Dateien hochladen"
      }
    },
    "choice": {
      "autoIdent": "Ausweis + Selfie (2 Min.)",
      "autoIdentDesc": "Identitätskarte oder Pass vor die Kamera, danach ein Selfie.",
      "regulated": "Meine Firma ist beaufsichtigt oder kotiert",
      "regulatedDesc": "Bank, Versicherung, Fonds, Pensionskasse oder kotierte Gesellschaft — eine Bestätigung genügt.",
      "swissId": "Mit SwissID anmelden",
      "swissIdDesc": "Bereits identifiziert? Dann ist es mit SwissID sofort erledigt.",
      "title": "Wie möchten Sie sich identifizieren?"
    },
    "done": {
      "generic": "Ihre Identifikation ist erfasst und gilt unbefristet.",
      "regulatedConfirmed": "{{company}} ist als beaufsichtigte Gegenpartei erfasst.",
      "title": "Danke — das war es schon",
      "verifiedAt": "Identifiziert am {{date}}",
      "yourCompany": "Ihre Firma"
    },
    "errors": {
      "declareFailed": "Die Bestätigung konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.",
      "startFailed": "Die Identifikation konnte nicht gestartet werden. Bitte versuchen Sie es später erneut."
    },
    "handoff": {
      "continueHere": "Hier am Computer weitermachen",
      "expired": "Dieser Code ist abgelaufen. Erzeugen Sie einen neuen Code.",
      "failed": "Der Code konnte nicht erzeugt werden. Erzeugen Sie einen neuen oder machen Sie hier am Computer weiter.",
      "lead": "Scannen Sie den Code mit der Handy-Kamera. Der Code ist {{minutes}} Minuten gültig.",
      "phoneStarted": "Auf dem Handy geöffnet — bitte dort abschliessen. Dieses Fenster aktualisiert sich von selbst.",
      "qrAlt": "QR-Code für die Identifikation auf dem Handy",
      "regenerate": "Neuen Code erzeugen",
      "regenerateHint": "Ein neuer Code macht den bisherigen ungültig.",
      "remaining": "Code noch {{time}} gültig",
      "title": "Möchten Sie die Identifikation auf Ihrem Handy machen?"
    },
    "intro": {
      "bodyAfter": "Sie sind zum ersten Mal hier. Seit dem 1. Oktober 2026 verlangt das Schweizer Geldwäschereigesetz, dass wir unsere Vertragspartner einmal identifizieren — so wie Ihre Bank. Das dauert zwei Minuten und gilt dauerhaft.",
      "bodyBefore": "Sie sind zum ersten Mal hier. Ab dem 1. Oktober 2026 verlangt das Schweizer Geldwäschereigesetz, dass wir unsere Vertragspartner einmal identifizieren — so wie Ihre Bank. Das dauert zwei Minuten und gilt dauerhaft.",
      "pointDuration": "Zwei Minuten, kein Formular.",
      "pointOnce": "Einmal erledigt — unbefristet gültig.",
      "start": "Jetzt identifizieren",
      "title": "Willkommen bei Immotron — einmalig identifizieren"
    },
    "later": "Später",
    "methods": {
      "AUTO_IDENT": "Ausweis + Selfie",
      "CHECK_RUN": "Prüfvorgang",
      "MANUAL": "Manuell erfasst",
      "REGULATED_SELF_DECLARATION": "Selbstdeklaration als beaufsichtigte Gegenpartei",
      "SWISSID": "SwissID"
    },
    "mobile": {
      "done": {
        "body": "Danke — wir prüfen Ihre Angaben. Sie können zum Computer zurückkehren.",
        "title": "Eingereicht, wird geprüft"
      },
      "errors": {
        "alreadySubmitted": "Ihre Identifikation ist bereits eingereicht.",
        "expired": "Dieser Code ist abgelaufen.",
        "generic": "Die Seite konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
        "hint": "Öffnen Sie am Computer einen neuen QR-Code.",
        "sessionExpired": "Die Sitzung ist abgelaufen.",
        "unknown": "Ungültiger Code.",
        "used": "Dieser Code wurde bereits verwendet."
      },
      "greeting": "Hallo {{name}}",
      "greetingAnonymous": "Hallo",
      "lead": "Danach sind Sie fertig — der Computer aktualisiert sich von selbst.",
      "loading": "Einen Moment, wir öffnen Ihre Identifikation …",
      "title": "Identifikation auf dem Handy"
    },
    "pending": {
      "body": "Ihre Identifikation ist gestartet, aber noch nicht bestätigt. Sobald das Ergebnis vorliegt, sehen Sie es hier und in den Einstellungen.",
      "refresh": "Status aktualisieren",
      "resume": "Identifikation fortsetzen",
      "resumeBody": "Ihre Identifikation ist gestartet, aber noch nicht eingereicht. Sie können dort weitermachen, wo Sie aufgehört haben.",
      "resumeTitle": "Identifikation nicht abgeschlossen",
      "title": "Identifikation läuft"
    },
    "progress": {
      "cards": {
        "seco": "0 Treffer auf der Sanktionsliste des Bundes (SECO)",
        "signature": "Eintrag im Handelsregister",
        "uid": "UID"
      },
      "continue": "Weiter",
      "doneTitle": "Identifiziert",
      "failed": "Die Prüfung konnte nicht gestartet werden. Wir prüfen Ihre Angaben manuell und melden uns bei Ihnen.",
      "followUpBody": "Wir prüfen Ihre Angaben noch manuell und melden uns innert einem Arbeitstag bei Ihnen.",
      "followUpTitle": "Fast geschafft",
      "heading": "Einen Moment — wir prüfen Ihre Identität",
      "lead": "Sie sehen hier live, womit wir abgleichen. Das dauert nur wenige Sekunden.",
      "starting": "Einen Moment, wir prüfen Ihre Identität …",
      "state": {
        "error": "In Prüfung",
        "hit": "In Prüfung",
        "ok": "Geprüft",
        "pending": "In Prüfung",
        "running": "Läuft",
        "skipped": "Nicht nötig",
        "waiting": "Wartet"
      },
      "title": "Prüfschritte"
    },
    "regulated": {
      "authority": "Aufsichtsbehörde oder Quelle",
      "authorityPlaceholder": "z. B. FINMA, OAK BV, SIX",
      "categories": {
        "LISTED": "Kotierte Gesellschaft",
        "PUBLIC_LAW": "Öffentlich-rechtliche Körperschaft",
        "REGULATED": "FINMA- oder OAK-BV-beaufsichtigt (Bank, Versicherung, Fonds, Pensionskasse)"
      },
      "category": "Kategorie",
      "company": "Firma",
      "confirm": "Ich bestätige, dass die genannte Firma beaufsichtigt, kotiert oder öffentlich-rechtlich ist.",
      "description": "Ist Ihre Firma beaufsichtigt, kotiert oder öffentlich-rechtlich, genügt Ihre Bestätigung — eine persönliche Identifikation entfällt.",
      "noCompany": "Ihrem Konto ist keine Firma zugeordnet. Bitte identifizieren Sie sich als Person oder melden Sie sich bei uns.",
      "reference": "Bewilligungs- oder Registernummer",
      "submit": "Bestätigen",
      "title": "Beaufsichtigte Gegenpartei"
    },
    "review": {
      "title": "Identifikationen prüfen",
      "subtitle": "Eingereichte Selbst-Identifikationen prüfen und freigeben oder ablehnen. Eine Identifikation wird nie automatisch bestätigt.",
      "forbidden": "Nur für Admin / GwG-Verantwortliche.",
      "empty": "Keine offenen Identifikationen.",
      "emptyAll": "Keine Identifikationen vorhanden.",
      "selectHint": "Wählen Sie links einen Fall aus.",
      "submittedAt": "Eingereicht",
      "unknownPerson": "Unbekannte Person",
      "captureModeLabel": "Erfassungsart",
      "checkRunLabel": "Automatischer Prüflauf",
      "livenessLabel": "Lebendigkeits-Aufgabe",
      "fingerCountLabel": "Geforderte Fingerzahl",
      "fingerCountCheck": "Stimmt die Zahl der Finger auf dem Selfie?",
      "openInNewTab": "In neuem Tab öffnen",
      "zoom": "{{slot}} vergrössern",
      "uploadHint": "Hochgeladene Bilder wurden nicht live aufgenommen — besonders genau prüfen.",
      "correct": "Korrigieren",
      "correctHint": "Die Korrekturen werden zusammen mit Ihrem Entscheid gespeichert.",
      "nationalityHint": "Ländercode mit drei Buchstaben (ISO 3166), z. B. CHE für die Schweiz.",
      "nationalityInvalid": "Bitte genau drei Buchstaben eingeben, z. B. CHE.",
      "approve": "Freigeben",
      "reject": "Ablehnen",
      "reasonLabel": "Begründung",
      "reasonPlaceholder": "Warum wird die Identifikation abgelehnt?",
      "reasonHint": "Mindestens 5 Zeichen.",
      "rejectSubmit": "Ablehnung absenden",
      "approveSuccess": "Identifikation freigegeben.",
      "rejectSuccess": "Identifikation abgelehnt.",
      "filter": {
        "open": "Offen",
        "all": "Alle"
      },
      "captureMode": {
        "live": "Live aufgenommen",
        "upload": "Hochgeladen"
      },
      "fieldsSource": {
        "ai": "von KI",
        "reviewer": "von Prüfer korrigiert",
        "customer": "von Kunde erfasst"
      },
      "state": {
        "OPEN": "Offen",
        "FIRST_APPROVED": "1. Freigabe erteilt — zweite Person nötig",
        "APPROVED": "Freigegeben",
        "REJECTED": "Abgelehnt"
      },
      "checkRun": {
        "CLEAN": "Prüflauf ohne Befund",
        "HIT": "Listentreffer — genau prüfen",
        "INCOMPLETE": "Prüflauf unvollständig"
      },
      "files": {
        "title": "Ausweis und Selfie",
        "none": "Keine Dateien vorhanden."
      },
      "slot": {
        "front": "Ausweis Vorderseite",
        "back": "Ausweis Rückseite",
        "selfie": "Selfie",
        "pdf": "Ausweis (PDF)"
      },
      "document": {
        "title": "Ausweisdaten",
        "type": "Ausweisart",
        "country": "Ausstellungsland",
        "number": "Ausweisnummer",
        "expiry": "Gültig bis",
        "nationality": "Staatsangehörigkeit",
        "expired": "abgelaufen"
      },
      "documentType": {
        "ID_CARD": "Identitätskarte",
        "PASSPORT": "Pass",
        "RESIDENCE_PERMIT": "Aufenthaltsbewilligung",
        "OTHER": "Anderer Ausweis"
      },
      "contact": {
        "title": "Kontakt",
        "name": "Name",
        "email": "E-Mail",
        "birthday": "Geburtsdatum",
        "company": "Firma",
        "open": "Kontakt öffnen"
      },
      "decisions": {
        "title": "Bisherige Entscheide",
        "first": "Erste Prüfung",
        "second": "Zweite Prüfung",
        "reason": "Begründung",
        "none": "Noch kein Entscheid."
      },
      "decision": {
        "APPROVE": "Freigegeben",
        "REJECT": "Abgelehnt"
      },
      "errors": {
        "fourEyes": "Die zweite Freigabe muss eine andere Person erteilen.",
        "ownIdentification": "Eigene Identifikation kann nicht freigegeben werden.",
        "alreadyDecided": "Dieser Fall wurde bereits entschieden.",
        "reasonRequired": "Eine Begründung ist erforderlich (mindestens 5 Zeichen).",
        "decisionFailed": "Der Entscheid konnte nicht gespeichert werden."
      },
      "ai": {
        "title": "KI-Prüfung",
        "hintOnly": "Vorschlag der KI — die Freigabe bleibt eine menschliche Entscheidung",
        "pending": "KI-Prüfung läuft …",
        "approve": "Freigeben (KI empfiehlt)",
        "recommendation": {
          "approve": "Freigabe empfohlen",
          "review": "Bitte prüfen",
          "reject": "Ablehnung empfohlen"
        },
        "checks": {
          "face_match": "Gesichtsvergleich",
          "finger_count": "Fingerzahl im Selfie",
          "mrz_checksum": "Maschinenlesbare Zone (MRZ)",
          "not_expired": "Gültigkeit des Ausweises",
          "identity_match": "Name und Geburtsdatum",
          "sanctions": "Sanktionslisten"
        },
        "result": {
          "ok": "in Ordnung",
          "failed": "nicht in Ordnung",
          "unknown": "nicht prüfbar"
        }
      },
      "extraction": {
        "title": "Vom Ausweis ausgelesen (KI, nur Hinweis)",
        "hintOnly": "Nur Hinweis — die Freigabe bleibt eine menschliche Entscheidung",
        "pending": "Ausweisdaten werden ausgelesen …",
        "failed": "Die Ausweisdaten konnten nicht ausgelesen werden.",
        "retry": "Erneut auslesen",
        "match": "Stimmt mit dem Kontakt überein",
        "mismatchCount": "{{count}} Abweichungen zum Kontakt",
        "mismatchCount_one": "Eine Abweichung zum Kontakt",
        "disabled": "Das automatische Auslesen ist ausgeschaltet.",
        "running": "Das Auslesen läuft bereits — bitte warten.",
        "fields": {
          "lastName": "Nachname",
          "firstNames": "Vorname(n)",
          "birthDate": "Geburtsdatum",
          "nationality": "Nationalität",
          "documentType": "Ausweisart",
          "documentNumber": "Ausweisnummer",
          "expiryDate": "Ablaufdatum",
          "mrz": "Maschinenlesbare Zone (MRZ)"
        },
        "flags": {
          "LAST_NAME_MISMATCH": "Nachname weicht vom Kontakt ab",
          "FIRST_NAME_MISMATCH": "Vorname weicht vom Kontakt ab",
          "BIRTH_DATE_MISMATCH": "Geburtsdatum weicht vom Kontakt ab",
          "DOCUMENT_EXPIRED": "Ausweis abgelaufen"
        }
      }
    },
    "settings": {
      "declareRegulated": "Firma als beaufsichtigt melden",
      "lastRun": "Letzte Prüfung",
      "lastRunAt": "Durchgeführt am {{date}}",
      "legalHintAfter": "Seit dem 1. Oktober 2026 verlangt das Schweizer Geldwäschereigesetz, dass wir unsere Vertragspartner einmal identifizieren. Die Identifikation gilt unbefristet.",
      "legalHintBefore": "Ab dem 1. Oktober 2026 verlangt das Schweizer Geldwäschereigesetz, dass wir unsere Vertragspartner einmal identifizieren. Die Identifikation gilt unbefristet.",
      "method": "Methode: {{method}}",
      "open": "Identifikation ausstehend",
      "openHint": "Sie haben sich noch nicht identifiziert. Das dauert rund zwei Minuten.",
      "pending": "Identifikation läuft",
      "pendingHint": "Das Ergebnis liegt noch nicht vor.",
      "regulated": "Beaufsichtigte Gegenpartei",
      "regulatedHint": "{{company}} ist als beaufsichtigt gemeldet — eine persönliche Identifikation entfällt.",
      "restart": "Erneut identifizieren",
      "runChecks": "Prüfung durchführen",
      "start": "Jetzt identifizieren",
      "title": "Identifikation",
      "verified": "Identifiziert",
      "verifiedAt": "Identifiziert am {{date}}",
      "verifiedHint": "Ihre Identifikation gilt unbefristet."
    },
    "stepper": {
      "identification": "1 Identifikation",
      "label": "Fortschritt der Compliance-Prüfung",
      "lexKoller": "2 Erwerbsberechtigung"
    },
    "steps": {
      "IDENT": {
        "error": "Die Identitätsprüfung war nicht erfolgreich. Bitte starten Sie sie erneut.",
        "ok": "Ausweis und Selfie bestätigt.",
        "pending": "Das Ergebnis des Ident-Anbieters steht noch aus.",
        "running": "Wir prüfen Ihre Identität.",
        "title": "Identität",
        "waiting": "Ausweis und Selfie über den Ident-Anbieter."
      },
      "REGULATED": {
        "ok": "{{COMPANY_NAME}} ist als beaufsichtigte Gegenpartei erfasst.",
        "running": "Wir prüfen, ob Ihre Firma beaufsichtigt ist.",
        "skipped": "Keine Beaufsichtigung gemeldet — es gilt die reguläre Prüfung.",
        "title": "Beaufsichtigte Gegenpartei",
        "waiting": "Prüfung, ob Ihre Firma beaufsichtigt oder kotiert ist."
      },
      "SECO": {
        "error": "Der Abgleich ist zurzeit nicht möglich. Wir prüfen das manuell nach.",
        "hit": "Wir prüfen Ihre Angaben noch manuell und melden uns bei Ihnen.",
        "ok": "Kein Eintrag auf der Sanktionsliste des Bundes.",
        "running": "Wir gleichen mit der Sanktionsliste des Bundes ab.",
        "title": "SECO-Sanktionsliste",
        "waiting": "Abgleich mit der Sanktionsliste des Bundes."
      },
      "SIGNATORY": {
        "error": "Wir klären die Zeichnungsberechtigung persönlich mit Ihnen ab.",
        "ok": "Sie sind für {{COMPANY_NAME}} zeichnungsberechtigt.",
        "running": "Wir prüfen die Zeichnungsberechtigung.",
        "skipped": "Keine Zeichnungsberechtigung nötig — Sie handeln als Privatperson.",
        "title": "Zeichnungsberechtigung",
        "waiting": "Prüfung, ob Sie für Ihre Firma unterschreiben dürfen."
      },
      "TRANSPARENCY_REGISTER": {
        "error": "Das Transparenzregister ist zurzeit nicht erreichbar. Wir prüfen das manuell nach.",
        "ok": "Keine Auffälligkeiten im Transparenzregister.",
        "running": "Wir prüfen das Transparenzregister.",
        "skipped": "Der Abgleich erfolgt ab dem 1. Oktober 2026.",
        "title": "Transparenzregister",
        "waiting": "Abgleich mit dem eidgenössischen Transparenzregister."
      },
      "ZEFIX": {
        "error": "Das Handelsregister ist zurzeit nicht erreichbar. Wir prüfen das manuell nach.",
        "ok": "{{COMPANY_NAME}} ist im Schweizer Handelsregister eingetragen.",
        "running": "Wir gleichen mit dem Handelsregister ab.",
        "skipped": "Kein Abgleich nötig — Sie handeln als Privatperson.",
        "title": "Handelsregister (Zefix)",
        "waiting": "Abgleich Ihrer Firma mit dem Schweizer Handelsregister."
      }
    },
    "stub": {
      "back": "Zurück zur App",
      "description": "Diese Seite ersetzt den Ident-Anbieter auf der Testumgebung. Ein Klick schliesst die Identifikation ab — in der Produktion ist das nicht möglich.",
      "failed": "Die Simulation konnte nicht abgeschlossen werden.",
      "reference": "Referenz",
      "simulate": "Identifikation simulieren",
      "success": "Identifikation abgeschlossen. Sie werden zurückgeleitet.",
      "title": "Identifikation simulieren",
      "unavailable": "Die Simulation ist in dieser Umgebung nicht verfügbar."
    },
    "submitted": {
      "body": "Wir prüfen Ihre Angaben und melden uns. Sie können die Plattform weiter nutzen.",
      "title": "Eingereicht, wird geprüft"
    },
    "title": "Einmalig identifizieren"
  },
  "layout": {
    "endImpersonation": "Zurück zum Admin",
    "footer": {
      "allRightsReserved": "Alle Rechte vorbehalten.",
      "build": "Build"
    },
    "impersonating": "Eingeloggt als {{name}}",
    "reloadNow": "Jetzt aktualisieren",
    "updateAvailable": "Eine neue Version ist verfügbar."
  },
  "compliance": {
    "hint": {
      "action": "Jetzt starten",
      "pendingText": "Wir melden uns, sobald die Prüfung abgeschlossen ist. Sie müssen nichts weiter tun.",
      "pendingTitle": "Ihre Identifikation wird geprüft",
      "retryAction": "Erneut starten",
      "retryText": "Die letzte Prüfung konnte nicht abgeschlossen werden. Bitte führen Sie die Identifikation noch einmal durch.",
      "retryTitle": "Bitte Identifikation erneut durchführen",
      "statusLink": "Status ansehen",
      "textIdent": "Einmalig und in rund zwei Minuten: Ausweis und kurze Einschätzung zum Erwerb von Grundstücken (Lex Koller). Danach sehen Sie alle Unterlagen.",
      "textLexKoller": "Es fehlt nur noch die kurze Einschätzung zum Erwerb von Grundstücken (Lex Koller).",
      "title": "Bitte schliessen Sie Ihre Identifikation ab"
    }
  },
  "lexKoller": {
    "company": {
      "domicile": "Firmensitz in der Schweiz?",
      "domicilePrefilled": "Der Firmensitz in der Schweiz ist über Zefix bestätigt.",
      "foreignOwnership": "Ausländische Beteiligung über 33%?",
      "foreignOwnershipDesc": "Kapitalanteil oder Stimmrechte durch Personen im Ausland.",
      "title": "Firmendaten"
    },
    "details": {
      "canton": "Kanton",
      "noPermit": "Keine",
      "permit": "Aufenthaltsbewilligung",
      "permitB": "B — Aufenthalt",
      "permitC": "C — Niederlassung",
      "permitG": "G — Grenzgänger",
      "permitL": "L — Kurzaufenthalt",
      "residence": "Wohnsitz in der Schweiz?",
      "selectCanton": "Kanton wählen...",
      "title": "Aufenthalt & Bewilligung"
    },
    "disclaimer": "Dies ist eine informative Einschätzung und keine Rechtsberatung. Für verbindliche Auskünfte wenden Sie sich an einen Notar oder Rechtsanwalt.",
    "entityType": {
      "company": "Firma / Gesellschaft",
      "companyDesc": "AG, GmbH oder andere juristische Person",
      "description": "Bitte wählen Sie, ob Sie als Privatperson oder als Firma kaufen möchten.",
      "person": "Privatperson",
      "personDesc": "Natürliche Person",
      "title": "Wer möchte erwerben?"
    },
    "errors": {
      "assessFailed": "Die Einschätzung konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut.",
      "declareFailed": "Die Bestätigung konnte nicht gespeichert werden. Bitte versuchen Sie es später erneut."
    },
    "institutional": {
      "confirm": "Die Gesellschaft ist nicht zu mehr als einem Drittel ausländisch beherrscht (Art. 5 BewG).",
      "description": "{{company}} ist als beaufsichtigte/registrierte Institution erfasst ({{source}}). Lex Koller ist damit nicht anwendbar.",
      "doneBody": "Ihre Bestätigung ist erfasst. Für {{company}} gelten keine Lex-Koller-Beschränkungen.",
      "submit": "Bestätigen",
      "title": "Lex Koller ist nicht anwendbar",
      "unknownSource": "öffentliches Register",
      "yourCompany": "Ihre Gesellschaft"
    },
    "later": "Später erledigen",
    "nationality": {
      "ch": "Schweiz",
      "chDesc": "Schweizer Staatsbürger (inkl. Doppelbürger)",
      "companyDesc": "Nationalität der wirtschaftlich Berechtigten.",
      "euEfta": "EU / EFTA",
      "euEftaDesc": "EU- oder EFTA-Staatsangehörige",
      "other": "Anderes Land",
      "otherDesc": "Drittstaatsangehörige",
      "personDesc": "Wählen Sie Ihre Staatsangehörigkeit.",
      "title": "Staatsangehörigkeit"
    },
    "prefill": {
      "fromIdent": "Ihre Staatsangehörigkeit haben wir aus Ihrer Identifikation übernommen — wir fragen nur noch, was uns fehlt.",
      "fromDocument": "Aus Ihrem Ausweis übernommen — bitte prüfen und bei Bedarf ändern."
    },
    "result": {
      "cantonalApproval": "Kantonale Bewilligung erforderlich",
      "commercial": "Geschäftsliegenschaft",
      "investmentProperty": "Anlageobjekt",
      "primaryResidence": "Hauptwohnung"
    },
    "settings": {
      "assessedInfo": "Bewertung abgeschlossen",
      "editAssessment": "Bewertung bearbeiten",
      "noAssessment": "Keine Bewertung vorhanden",
      "startAssessment": "Bewertung starten"
    },
    "status": {
      "conditional": "Bedingt zulässig",
      "notApplicableInstitutional": "Nicht anwendbar (institutionell)",
      "restricted": "Eingeschränkt",
      "unrestricted": "Uneingeschränkt"
    },
    "title": "Lex Koller Einschätzung",
    "auto": {
      "title": "Automatisch ermittelt: Schweizer Staatsbürger — keine Einschränkung",
      "description": "Ihre Staatsangehörigkeit stammt aus Ihrem Ausweis. Lex Koller schränkt Sie damit nicht ein — Sie müssen nichts ausfüllen.",
      "edit": "Angaben ändern"
    }
  },
  "linkedinImport": {
    "confirm": {
      "create": "erstellen",
      "execute": "Import ausführen",
      "merge": "zusammenführen",
      "skip": "überspringen",
      "summary": "{{total}} Kontakte werden verarbeitet:",
      "title": "Import bestätigen",
      "warningCreate": "Neue Kontakte und Firmen werden erstellt",
      "warningMerge": "Bestehende Einträge werden mit neuen Infos ergänzt",
      "warningSkip": "Übersprungene Einträge werden nicht verändert",
      "warningTitle": "Was passiert beim Import?"
    },
    "detail": {
      "error": "Fehler beim Laden der Details",
      "loading": "Lade Details...",
      "records": "Datensätze",
      "title": "Import-Details"
    },
    "history": {
      "clickHint": "Klick für Details",
      "colCreated": "Erstellt",
      "colDate": "Datum",
      "colMerged": "Zusammengeführt",
      "colName": "Name",
      "colRecords": "Datensätze",
      "colSkipped": "Übersprungen",
      "colStatus": "Status",
      "detailColAction": "Aktion",
      "detailColCompany": "Organisation",
      "detailColMatch": "Abgleich",
      "detailColName": "Kontakt",
      "detailJobChanges": "Jobwechsel",
      "detailMerged": "Zusammengeführt",
      "detailNew": "Neu erstellt",
      "detailSkipped": "Übersprungen",
      "detailUpdated": "Aktualisiert",
      "loading": "Details werden geladen...",
      "noDetails": "Keine Details verfügbar",
      "statusCompleted": "Abgeschlossen",
      "statusFailed": "Fehlgeschlagen",
      "statusPending": "Ausstehend",
      "title": "Import-Verlauf",
      "viewDetail": "Details anzeigen"
    },
    "preview": {
      "aiParsed": "KI-erkannt",
      "autoMerge": "Auto-Merge",
      "colAction": "Aktion",
      "colCompany": "Firma",
      "colCompanyJob": "Firma / Jobtitel",
      "colEmail": "E-Mail",
      "colMatch": "Match",
      "colName": "Name",
      "company": "Firma",
      "crmMatch": "CRM-Abgleich",
      "decideAll": "Bitte alle Review-Einträge entscheiden",
      "executeImport": "Import ausführen",
      "importData": "Import-Daten",
      "jobChangeDetected": "Firmenwechsel erkannt",
      "jobChanges": "Jobwechsel",
      "matchMethod": "Methode",
      "matchScore": "Score",
      "matchedCompany": "Firma (CRM)",
      "matchedContact": "Kontakt",
      "needsReview": "Review nötig",
      "newContacts": "Neue Kontakte",
      "noMatch": "Neu",
      "noMatchFound": "Kein bestehender Kontakt gefunden",
      "parsedFromHeadline": "Aus Headline erkannt",
      "position": "Jobtitel"
    },
    "result": {
      "backToOverview": "Zurück zur Übersicht",
      "colAction": "Aktion",
      "colName": "Name",
      "colStatus": "Status",
      "created": "Erstellt",
      "errors": "Fehler",
      "merged": "Zusammengeführt",
      "skipped": "Übersprungen",
      "title": "Import abgeschlossen"
    },
    "scraper": {
      "batchSize": "Batch-Grösse: 5-100 Kontakte pro Durchlauf",
      "directSync": "Direkt-Sync: Extension kann Kontakte auch direkt an Immotron senden",
      "step1Desc": "Chrome Extension aus dem Immotron-Repo laden und in Chrome aktivieren",
      "step1Title": "Extension installieren",
      "step2Desc": "LinkedIn öffnen, Extension starten und Kontakte automatisch erfassen lassen",
      "step2Title": "Kontakte scrapen",
      "step3Desc": "Export als JSON-Datei herunterladen und unten hochladen oder direkt zu Immotron syncen",
      "step3Title": "JSON exportieren & hier importieren",
      "subtitle": "Kontakte direkt aus LinkedIn exportieren",
      "title": "LinkedIn Scraper Chrome Extension"
    },
    "steps": {
      "confirm": "Bestätigen",
      "preview": "Vorschau",
      "result": "Ergebnis",
      "upload": "Upload"
    },
    "subtitle": "LinkedIn-Kontakte importieren und mit bestehenden Adressen abgleichen",
    "title": "LinkedIn Import",
    "toast": {
      "importFailed": "Import fehlgeschlagen"
    },
    "upload": {
      "contactsFound": "{{count}} Kontakte erkannt",
      "emptyArray": "Leeres Array — keine Kontakte gefunden",
      "fileButton": "JSON-Datei laden",
      "fileHint": "Akzeptiert .json-Dateien",
      "fileReadError": "Datei konnte nicht gelesen werden",
      "importName": "Import-Name (optional)",
      "invalidJson": "Ungültiges JSON-Format",
      "namePlaceholder": "z.B. LinkedIn Export März 2026",
      "pasteLabel": "JSON einfügen",
      "placeholder": "[\n  {\n    \"linkedinUrl\": \"https://linkedin.com/in/...\",\n    \"firstName\": \"Max\",\n    \"lastName\": \"Muster\",\n    \"email\": \"max@example.com\",\n    \"currentCompany\": \"Firma AG\",\n    \"headline\": \"CEO bei Firma AG\"\n  }\n]",
      "previewFailed": "Vorschau fehlgeschlagen",
      "startPreview": "Vorschau starten",
      "validationError": "Validierungsfehler",
      "wrongFormat": "Falsches JSON-Format. Erwartet: [{linkedinUrl, firstName, lastName, ...}]"
    }
  },
  "listings": {
    "addListing": "Neuer Teaser",
    "addProperty": "Immobilie hinzufügen",
    "assignedBuyers": {
      "activeBadge": "Zugriff aktiv",
      "companyGroup": "Firma {{name}}",
      "conditionDeviates": "weicht vom Rahmenvertrag ab",
      "conditionOwnForProperty": "eigene Kondition für dieses Objekt",
      "conditionUnknown": "Keine Kondition hinterlegt",
      "emailLabelFor": "E-Mail-Adresse von {{name}}",
      "emailMissing": "E-Mail fehlt",
      "emailPlaceholder": "name@firma.ch",
      "emailSave": "Speichern",
      "emailSaveFailed": "E-Mail-Adresse konnte nicht gespeichert werden.",
      "emailSaveFor": "E-Mail-Adresse von {{name}} speichern",
      "emailSaved": "E-Mail-Adresse gespeichert.",
      "empty": "Noch keine Käufer zugeordnet",
      "inviteCount": "({{count}} Einladungen)",
      "inviteNever": "noch nicht angeschrieben",
      "inviteSent": "eingeladen am {{date}}",
      "inviteUsed": "Link geöffnet am {{date}}",
      "mixedBadge": "Gemischt",
      "pendingBadge": "Onboarding ausstehend",
      "pendingHint": "Bei der Freigabe übersprungen: kein aktiver Käufer-Vertrag. Der Zugriff wird nach Vertragsabschluss automatisch erteilt.",
      "personCount": "{{count}} Person(en)",
      "plannedCondition": "geplant: {{model}}",
      "remove": "Entfernen",
      "removeConfirm": "Zuordnung entfernen?",
      "removeConfirmGroup": "Alle {{count}} Personen von «{{name}}» verlieren den Zugriff auf dieses Objekt.",
      "removeConfirmPerson": "«{{name}}» verliert den Zugriff auf dieses Objekt. Die Zuordnung kann jederzeit neu erstellt werden.",
      "removeDone": "Zuordnung entfernt.",
      "removeFailed": "Entfernen fehlgeschlagen.",
      "removeFor": "Zuordnung von {{name}} entfernen",
      "removeGroup": "Alle Zuordnungen von {{name}} entfernen",
      "resend": "E-Mail erneut senden",
      "resendConfirm": "Erneut anschreiben?",
      "resendConfirmText": "{{count}} Empfänger wurden bereits eingeladen. Ein erneuter Versand macht die zuvor verschickten Links ungültig.",
      "resendDone": "Einladung erneut gesendet.",
      "resendFailed": "Versand fehlgeschlagen.",
      "resendFor": "E-Mail erneut an {{name}} senden",
      "resendGroupCount": "Alle offenen Personen von {{name}} anschreiben ({{count}})",
      "resendNoPending": "Niemand in dieser Gruppe wartet auf das Onboarding",
      "resendSkipped": "Keine Einladung versendet: {{reason}}",
      "resendSkippedUnknown": "Kein Grund angegeben",
      "sendAfterApproval": "Versand nach der Freigabe",
      "singlePersons": "Einzelpersonen",
      "skipReason": {
        "no_active_contract": "Kein aktiver Käufer-Vertrag",
        "no_contact": "Keine Ansprechperson hinterlegt",
        "no_email": "Keine E-Mail hinterlegt"
      },
      "statusOnApproval": "Zugriff bei Freigabe",
      "title": "Zugeordnete Käufer",
      "viaGroup": "über Gruppe {{name}}"
    },
    "bundle": "Bundle",
    "bundleCreated": "Bündel wurde erstellt.",
    "confirmDelete": "Möchten Sie diesen Teaser wirklich löschen? Die enthaltenen Immobilien bleiben erhalten.",
    "confirmDeleteDescription": "Sind Sie sicher, dass Sie dieses Listing löschen möchten?",
    "confirmRemoveProperty": "Möchten Sie diese Immobilie aus dem Teaser entfernen? Sie wird einem neuen Einzel-Teaser zugeordnet.",
    "confirmRemovePropertyDescription": "Sind Sie sicher, dass Sie diese Immobilie entfernen möchten?",
    "createBundle": "Bundle erstellen",
    "deleteSuccess": "Listing wurde gelöscht.",
    "errors": {
      "addPropertyFailed": "Immobilie konnte nicht hinzugefügt werden",
      "deleteFailed": "Teaser konnte nicht gelöscht werden",
      "loadFailed": "Teaser konnten nicht geladen werden",
      "notFound": "Teaser nicht gefunden",
      "removePropertyFailed": "Immobilie konnte nicht entfernt werden",
      "saveFailed": "Teaser konnte nicht gespeichert werden"
    },
    "fields": {
      "location": "Standort",
      "price": "Preis",
      "private": "Privat",
      "properties": "Enthaltene Immobilien",
      "public": "Öffentlich",
      "status": "Status",
      "title": "Titel",
      "totalPrice": "Gesamtpreis",
      "type": "Typ",
      "timeline": "Timeline",
      "interested": "Interessenten"
    },
    "list": {
      "empty": {
        "description": "Teaser werden automatisch erstellt, wenn Sie eine Immobilie anlegen.",
        "title": "Keine Teaser vorhanden"
      }
    },
    "noAvailableProperties": "Keine weiteren Immobilien verfügbar",
    "propertyRemoved": "Immobilie wurde entfernt.",
    "removeProperty": "Immobilie entfernen",
    "resultsLabel": "Listings",
    "selection": {
      "createBundle": "Gemeinsam vermarkten",
      "selectMode": "Auswahl",
      "selected": "{{count}} ausgewählt"
    },
    "single": "Einzel",
    "statuses": {
      "ACTIVE": "Aktiv",
      "ARCHIVED": "Archiviert",
      "DRAFT": "Entwurf",
      "SOLD": "Verkauft"
    },
    "subtitle": "Teaser und Bundles verwalten",
    "title": "Teaser",
    "saleMode": {
      "offerCollection": "Bieterverfahren",
      "fixedPrice": "Fixpreis"
    },
    "preview": {
      "title": "Teaser-Vorschau",
      "hint": "So sieht der Investor das Objekt",
      "propertyPickerLabel": "Objekt für die Vorschau wählen",
      "loadFailed": "Vorschau konnte nicht geladen werden."
    },
    "management": {
      "title": "Käufer-Verwaltung",
      "hint": "Käufer nachträglich ergänzen — über Investorengruppen, KI-Vorschläge oder die manuelle Suche.",
      "groupsTitle": "Investorengruppen",
      "groupsLoadFailed": "Investorengruppen konnten nicht geladen werden.",
      "groupsEmpty": "Keine Investorengruppen vorhanden.",
      "assignGroups": "{{count}} Gruppe(n) zuordnen",
      "groupsAssigned": "Investorengruppen zugeordnet — Mitglieder erhalten Zugriff.",
      "suggestionsTitle": "KI-Käufervorschläge",
      "load": "Käufervorschläge laden",
      "reload": "Neu berechnen",
      "loading": "Vorschläge werden berechnet …",
      "loadFailed": "Käufervorschläge konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "empty": "Keine passenden Käufer gefunden.",
      "assignSelected": "{{count}} Käufer zuordnen",
      "buyersAssigned": "{{count}} Käufer zugeordnet.",
      "manualTitle": "Personen-Suche",
      "manualHint": "CRM-Kontakte oder Firmen manuell als Käufer ergänzen.",
      "assignFailed": "Zuordnung fehlgeschlagen.",
      "conditionsPreview": "Konditionen dieses Objekts: {{model}}"
    },
    "masterData": {
      "title": "Stammdaten",
      "hint": "Titel, Status, Sichtbarkeit und Gesamtpreis des Teasers. Verkaufsmodus, Preis und NBO-/BO-Termine werden im Quality Gate festgelegt.",
      "saved": "Stammdaten gespeichert"
    },
    "stats": {
      "title": "Statistiken",
      "hint": "Öffnungen und Downloads des Teasers pro Investor",
      "loadFailed": "Statistiken konnten nicht geladen werden.",
      "retry": "Erneut versuchen",
      "empty": "Noch keine Aktivitäten erfasst.",
      "totalOpens": "Total Öffnungen",
      "uniqueVisitors": "Eindeutige Besucher",
      "documentViews": "Datei-Ansichten",
      "downloads": "Downloads",
      "investor": "Investor",
      "opens": "Öffnungen",
      "lastOpened": "Letzte Öffnung",
      "viewedDocuments": "Angesehene Dateien",
      "downloadedDocuments": "Heruntergeladene Dateien",
      "never": "—"
    }
  },
  "mandanten": {
    "accentColor": "Akzentfarbe",
    "active": "Aktiv",
    "addUser": "Benutzer hinzufügen",
    "address": "Adresse",
    "allRoles": "Alle Rollen",
    "allUsers": "Alle Benutzer",
    "brandColors": "Markenfarben",
    "brandColorsHint": "Diese Farben werden in der E-Mail-Signatur verwendet. Primärfarbe für Text und Trennlinie, Akzentfarbe für Links.",
    "canton": "Kanton",
    "city": "Ort",
    "confirmDeleteMandant": "Möchten Sie «{{name}}» wirklich unwiderruflich löschen? Alle zugehörigen Daten werden entfernt.",
    "confirmDeleteUser": "Möchten Sie diesen Benutzer wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
    "confirmRemove": "Möchten Sie diesen Benutzer wirklich entfernen?",
    "createAndAssign": "Erstellen & Zuweisen",
    "createMandant": "Mandant erstellen",
    "createMandantSuccess": "Mandant erstellt",
    "createUser": "Benutzer erstellen",
    "createUserSuccess": "Benutzer erstellt und zugewiesen",
    "customTemplate": "Benutzerdefiniertes Template",
    "deleteConfirmBtn": "Endgültig löschen",
    "deleteConfirmInput": "Geben Sie «{{name}}» ein zur Bestätigung:",
    "deleteKeys": {
      "campaign_recipients": "Kampagnen-Empfänger",
      "campaigns": "Kampagnen",
      "company_contacts": "Firmenkontakte",
      "contract_bundles": "Vertrags-Bundles",
      "contracts": "Verträge",
      "email_templates": "E-Mail-Vorlagen",
      "offers": "Angebote",
      "user_companies": "Benutzerzuweisungen"
    },
    "deleteMandant": "Mandant löschen",
    "deleteNoRelated": "Keine zugehörigen Daten vorhanden",
    "deletePreviewTitle": "Folgende Daten werden gelöscht:",
    "deleteSuccess": "Mandant «{{name}}» und alle zugehörigen Daten gelöscht",
    "deleteUser": "Benutzer löschen",
    "deleteUserSuccess": "Benutzer gelöscht",
    "directPhone": "Direktwahl",
    "directPhonePlaceholder": "z.B. +41 44 123 45 67",
    "editMandant": "Mandant bearbeiten",
    "editMandantSuccess": "Mandant aktualisiert",
    "editUser": "Benutzer bearbeiten",
    "email": "E-Mail",
    "empty": "Keine internen Firmen vorhanden",
    "errors": {
      "loadFailed": "Mandanten konnten nicht geladen werden",
      "loadUsersFailed": "Benutzer konnten nicht geladen werden"
    },
    "filterByRole": "Nach Rolle filtern",
    "function": "Funktion",
    "functionPlaceholder": "z.B. COO, VR-Präsident",
    "houseNumber": "Nr.",
    "impersonate": "Als Benutzer einloggen",
    "impersonateAction": "Einloggen",
    "impersonateHint": "Öffnet eine Session als dieser Benutzer",
    "impersonateSuccess": "Eingeloggt als {{name}}",
    "inactive": "Inaktiv",
    "legalForm": "Rechtsform",
    "linkCompany": "Firma verknüpfen",
    "linkCompanySuccess": "Firma als Mandant verknüpft",
    "logo": "Logo",
    "logoDragOrClick": "Logo hierher ziehen oder klicken zum Auswählen",
    "logoFormatError": "Nur PNG, JPG und WebP erlaubt",
    "logoRemove": "Logo entfernen",
    "logoSizeError": "Datei darf maximal 5 MB gross sein",
    "logoUploadError": "Logo-Upload fehlgeschlagen",
    "logoUploadSuccess": "Logo erfolgreich hochgeladen",
    "logoUploading": "Logo wird hochgeladen...",
    "mandantAssignment": "Mandant-Zuweisung",
    "noCompaniesAvailable": "Keine Firmen verfügbar",
    "noMandant": "–",
    "noPreference": "Keine Präferenz",
    "noUsers": "Keine Benutzer zugewiesen",
    "pageSubtitle": "Mandanten, Benutzer und Berechtigungen verwalten",
    "pageTitle": "Mandantenverwaltung",
    "passwordReset": "Passwort-Reset",
    "passwordResetHint": "Sendet einen Reset-Link per E-Mail",
    "phone": "Telefon",
    "preferredLanguage": "Bevorzugte Sprache",
    "primaryColor": "Primärfarbe",
    "removeFromMandant": "Zuweisung entfernen",
    "removeSuccess": "Benutzer aus Mandant entfernt",
    "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
    "resetSent": "Reset-Link wurde per E-Mail gesendet",
    "searchCompany": "Firma suchen...",
    "searchUsers": "Benutzer suchen...",
    "sectionAddress": "Adresse",
    "sectionCompany": "Firmendaten",
    "sectionContact": "Kontakt",
    "sectionSignature": "E-Mail-Signatur",
    "selectUser": "Benutzer auswählen",
    "sendReset": "Link senden",
    "signatories": "Zeichnungsberechtigte",
    "signaturePreview": "Signatur-Vorschau",
    "signaturePreviewError": "Vorschau konnte nicht geladen werden",
    "signaturePreviewHint": "Klicken Sie auf «Vorschau», um die aktuelle E-Mail-Signatur zu sehen.",
    "signatureText": "Zeichnungstext",
    "signatureType": "Zeichnungsberechtigung",
    "signatureTypes": {
      "COLLECTIVE_MORE": "Kollektivzeichnung zu mehreren",
      "COLLECTIVE_TWO": "Kollektivzeichnung zu zweit",
      "NONE": "Keine",
      "SINGLE": "Einzelzeichnung"
    },
    "status": "Status",
    "street": "Strasse",
    "subtitle": "Interne Firmen und Benutzerzuweisungen verwalten",
    "tabCreate": "Neu erstellen",
    "tabExisting": "Bestehend",
    "tabMandanten": "Mandanten",
    "tabManual": "Manuell",
    "tabUsers": "Benutzer",
    "tabZefix": "Zefix-Suche",
    "templateActive": "(aktiv)",
    "templateDefault": "(Standard)",
    "templateHint": "Variablen: {{ user_name }}, {{ user_function }}, {{ company_name }}, {{ company_logo_url }}, {{ disclaimer }}, {{ primary_color }}, {{ accent_color }} etc.",
    "templatePlaceholder": "Jinja2 HTML-Template (leer = Standard-Template)",
    "title": "Mandanten",
    "updateUserSuccess": "Änderungen gespeichert",
    "userDetails": "Benutzerdaten",
    "userEmail": "E-Mail",
    "userIsActive": "Benutzer aktiv",
    "userMandanten": "Mandant(en)",
    "userName": "Name",
    "userRole": "Rolle",
    "users": "Benutzer",
    "verbindlichkeitsklausel": "Verbindlichkeitsklausel",
    "verbindlichkeitsklauselHint": "Klausel in E-Mail-Signatur anzeigen",
    "website": "Website",
    "zipCode": "PLZ",
    "actions": "Aktionen"
  },
  "mapView": {
    "approximateLocation": "Ungefährer Standort",
    "cluster": "Cluster",
    "exactLocation": "Exakter Standort",
    "gridView": "Raster",
    "kmRadius": "ca. {{km}} km Radius",
    "mapView": "Karte",
    "showOnMap": "Details anzeigen"
  },
  "media": {
    "confirmDelete": "Möchten Sie dieses Bild wirklich löschen?",
    "copyUrl": "URL kopieren",
    "delete": "Löschen",
    "deleteFailed": "Datei konnte nicht gelöscht werden.",
    "deleteSuccess": "Bild gelöscht",
    "empty": "Noch keine Medien hochgeladen",
    "subtitle": "Bilder und Medien-Dateien verwalten",
    "title": "Medien",
    "upload": "Bild hochladen",
    "uploadFailed": "Upload fehlgeschlagen.",
    "uploadSuccess": "Upload erfolgreich.",
    "uploadedAt": "Hochgeladen am",
    "uploading": "Wird hochgeladen...",
    "urlCopied": "URL in Zwischenablage kopiert"
  },
  "missingConditions": {
    "title": "Keine Kondition vereinbart",
    "assignDescription": "Für die folgenden Personen ist an diesem Objekt keine Kondition vereinbart. Ohne vereinbarte Kondition wird nicht zugeordnet.",
    "approveDescription": "Für den Auftraggeber dieses Objekts ist keine Verkäuferkondition vereinbart. Ohne vereinbarte Kondition wird nicht freigegeben.",
    "blockedDescription": "Die Freigabe ist erst möglich, wenn für jeden Käufer eine Kondition hinterlegt ist. Am schnellsten: eine Objektkondition für alle festlegen.",
    "roles": {
      "buyer": "Käufer",
      "seller": "Verkäufer"
    },
    "entityCompany": "Firma",
    "entityContact": "Person",
    "checkedSources": "Geprüft wurde:",
    "sources": {
      "appendix_b": "Anhang B (Objektfreigabe)",
      "appendix_b_buyer": "Anhang B für diesen Käufer",
      "property": "Objektkondition",
      "framework": "Rahmenvertragssatz",
      "default_model": "Standardmodell des Mandanten"
    },
    "setConditions": "Kondition hinterlegen",
    "setBuyerConditions": "Kondition für diesen Käufer festlegen",
    "buyerContractPending": "Käufervertrag von {{name}} ist noch nicht gegengezeichnet — Kondition kann erst danach festgelegt werden.",
    "variableHint": "Rahmenvertrag ‹variabel›: Konditionen werden je Objekt vereinbart — das Standardmodell gilt hier nicht. Objektkondition hinterlegen oder für diesen Käufer festlegen.",
    "reasonLabel": "Begründung (Pflicht)",
    "reasonPlaceholder": "Warum soll der Vorgang ohne vereinbarte Kondition weitergehen?",
    "reasonHint": "Ohne Begründung lässt sich der Vorgang nicht bestätigen. Die bewusste Bestätigung wird mit Benutzer und Zeitpunkt im Aktivitätslog vermerkt.",
    "assignAnyway": "Trotzdem zuordnen",
    "approveAnyway": "Trotzdem freigeben",
    "confirmed": "Vorgang trotz fehlender Kondition bestätigt.",
    "retryFailed": "Der Vorgang ist fehlgeschlagen. Bitte erneut versuchen.",
    "conditionsSetRetry": "Kondition festgelegt — der Vorgang wurde ausgeführt."
  },
  "myOffers": {
    "activeOffers": "Aktive Angebote",
    "columns": {
      "actions": "Aktionen",
      "amount": "Betrag",
      "date": "Datum",
      "proof": "Nachweis",
      "property": "Objekt",
      "status": "Status",
      "type": "Typ"
    },
    "confirmWithdraw": "Möchten Sie dieses NBO wirklich zurückziehen?",
    "confirmWithdrawDescription": "Sind Sie sicher, dass Sie dieses Angebot zurückziehen möchten?",
    "detail": {
      "amount": "Betrag",
      "expired": "Abgelaufen",
      "financingProof": "Finanzierungsnachweis",
      "loiSigned": "LOI unterzeichnet",
      "no": "Nein",
      "notUploaded": "Ausstehend",
      "offerType": "Angebotstyp",
      "reservationExpires": "Reservierung läuft ab",
      "submittedAt": "Eingereicht am",
      "title": "Angebotsdetails",
      "uploaded": "Hochgeladen",
      "yes": "Ja",
      "conditions": "Bedingungen"
    },
    "empty": "Keine Angebote vorhanden",
    "emptyHint": "Ihre abgegebenen Angebote erscheinen hier",
    "filters": {
      "allStatuses": "Alle Status",
      "allTypes": "Alle Typen",
      "status": "Status",
      "title": "Filter",
      "type": "Angebotstyp"
    },
    "loadFailed": "Angebote konnten nicht geladen werden",
    "statuses": {
      "CANCELLED": "Storniert",
      "COMPLETED": "Abgeschlossen",
      "EXPIRED": "Abgelaufen",
      "LOST": "Nicht berücksichtigt",
      "PROOF_PENDING": "Nachweis ausstehend",
      "REJECTED": "Abgelehnt",
      "RESERVED": "Reserviert",
      "SUBMITTED": "Eingereicht",
      "UNDER_REVIEW": "In Prüfung",
      "WITHDRAWN": "Zurückgezogen",
      "WON": "Zuschlag"
    },
    "title": "Meine Angebote",
    "types": {
      "BO": "BO",
      "FIXED_PRICE": "Fixpreis",
      "NBO": "NBO"
    },
    "withdraw": "Zurückziehen",
    "withdrawFailed": "NBO konnte nicht zurückgezogen werden",
    "withdrawSuccess": "NBO erfolgreich zurückgezogen"
  },
  "navigation": {
    "activities": "Aktivitäten",
    "addresses": "Adressen",
    "admin": "Administration",
    "aiJobs": "KI-Jobs",
    "aiLearning": "Lern-Modus",
    "aiUpload": "KI-Upload",
    "bids": "Gebote",
    "campaigns": "Kampagnen",
    "ceoAgent": "Pendenzen-Assistent",
    "companies": "Organisationen",
    "contactDedup": "Deduplizierung",
    "contacts": "Kontakte",
    "contractExpiredTooltip": "Vertrag ausgelaufen — kontaktieren Sie uns für eine Verlängerung",
    "contracts": "Verträge",
    "createProperty": "Immobilie erstellen",
    "dashboard": "Dashboard",
    "deals": "Deals",
    "emailTemplates": "E-Mail-Vorlagen",
    "emails": "Emails",
    "favorites": "Merkliste",
    "fundRadar": "Fondsradar",
    "investorSettings": "Einstellungen",
    "investors": "Investoren",
    "linkedinImport": "LinkedIn Import",
    "listings": "Teaser",
    "myContracts": "Meine Verträge",
    "myOffers": "Meine Angebote",
    "myProperties": "Meine Immobilien",
    "portfolio": "Portfolio",
    "properties": "Immobilien",
    "qualityGate": "Quality Gate",
    "researchLeads": "Recherche-Leads",
    "schema": "DB Schema",
    "search": "Suche",
    "sectionAI": "Künstliche Intelligenz",
    "sectionAdmin": "Administration",
    "sectionBroker": "Makler",
    "sectionCRM": "CRM",
    "sectionImmobilien": "Immobilien",
    "sectionInvestor": "Investor",
    "sectionSales": "Vertrieb",
    "sectionSeller": "Verkäufer",
    "sectionSystem": "System",
    "sectionTransactions": "Transaktionen",
    "settings": "Einstellungen",
    "users": "Benutzer",
    "e2eReports": "E2E Reports",
    "menu": "Menü"
  },
  "nbobo": {
    "bo": {
      "amount": "Kaufangebot",
      "amountPlaceholder": "Betrag in CHF",
      "bindingNotice": "Dieses Angebot ist rechtlich verbindlich. Mit der Abgabe verpflichten Sie sich zum Kauf.",
      "conditions": "Bedingungen (optional)",
      "conditionsPlaceholder": "z.B. Übernahmedatum, Sonderwünsche",
      "description": "Geben Sie ein verbindliches Kaufangebot ab. Dieses Angebot ist rechtlich bindend.",
      "step1": "Angebot",
      "step2": "LOI-Signatur",
      "step3": "Finanzierungsnachweis",
      "step4": "Bestätigung",
      "submit": "Verbindlich absenden",
      "submitted": "Ihr BO wurde eingereicht.",
      "title": "Verbindliches Angebot (BO)",
      "waitingDecision": "Warten auf Verkäufer-Entscheid",
      "withdraw": "BO zurückziehen",
      "withdrawn": "Ihr BO wurde zurückgezogen.",
      "stepAmount": "Angebot",
      "stepLoi": "LOI",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Bestaetigung"
    },
    "boPhase": "Verbindliche Angebotsphase (BO)",
    "boStatus": {
      "lost": "Nicht berücksichtigt",
      "rejected": "Abgelehnt",
      "submitted": "Eingereicht",
      "withdrawn": "Zurückgezogen",
      "won": "Zugeschlagen"
    },
    "countdown": {
      "ended": "Phase beendet",
      "endsIn": "Endet in {{time}}"
    },
    "guidePrice": "Richtpreis",
    "minimumPrice": "Mindestpreis",
    "nbo": {
      "amount": "Ihr Angebot",
      "amountPlaceholder": "Betrag in CHF",
      "conditions": "Bedingungen (optional)",
      "conditionsPlaceholder": "z.B. Vorbehalt Finanzierung, Due Diligence",
      "description": "Geben Sie ein unverbindliches Preisangebot ab. Dies dient der Marktsondierung.",
      "evaluation": "NBO-Auswertung",
      "evaluationPending": "Die Auswertung der Angebote läuft.",
      "median": "Median",
      "nonBindingNotice": "Dieses Angebot ist unverbindlich und stellt keine Kaufverpflichtung dar.",
      "offers": "Angebote",
      "range": "Bandbreite",
      "submit": "NBO abgeben",
      "submitted": "Ihr NBO wurde eingereicht.",
      "title": "Indikatives Angebot (NBO)",
      "withdraw": "NBO zurückziehen",
      "withdrawConfirm": "Möchten Sie Ihr NBO wirklich zurückziehen?",
      "withdrawn": "Ihr NBO wurde zurückgezogen.",
      "stepAmount": "Angebot",
      "stepConditions": "Bedingungen",
      "stepFinancing": "Nachweis",
      "stepConfirm": "Unterschrift",
      "submittedDetail": "Ihr indikatives Angebot wurde erfolgreich eingereicht. Sie werden über den weiteren Verlauf informiert."
    },
    "nboPhase": "Indikative Angebotsphase (NBO)",
    "nboStatus": {
      "lost": "Nicht qualifiziert",
      "outbid": "Überboten",
      "rejected": "Abgelehnt",
      "shortlisted": "Shortlist",
      "submitted": "Eingereicht",
      "withdrawn": "Zurückgezogen",
      "won": "Qualifiziert"
    },
    "phase": "Phase",
    "sales": {
      "amount": "Betrag",
      "award": "Zuschlag erteilen",
      "awardConfirm": "Möchten Sie diesem Investor den Zuschlag erteilen?",
      "awardSuccess": "Zuschlag wurde erteilt.",
      "awarded": "Zugeschlagen",
      "boTab": "BO-Phase",
      "date": "Datum",
      "financingProof": "Fin.-Nachweis",
      "investor": "Investor",
      "nboTab": "NBO-Phase",
      "noOffers": "Noch keine Angebote",
      "status": "Status",
      "title": "Angebote"
    },
    "status": {
      "closed": "Abgeschlossen",
      "evaluating": "In Auswertung",
      "open": "Offen",
      "upcoming": "Bevorstehend"
    },
    "title": "Angebotsverfahren",
    "report": {
      "viewReport": "Auswertung anzeigen",
      "title": "NBO-Auswertung"
    },
    "myOffer": {
      "titleNbo": "Ihr eingereichtes NBO",
      "titleBo": "Ihr eingereichtes BO",
      "amount": "Angebotsbetrag",
      "status": "Status",
      "submittedAt": "Eingereicht am",
      "updatedAt": "Zuletzt geändert",
      "deadline": "Frist der Runde",
      "loiSigned": "LOI unterzeichnet",
      "financingProof": "Finanzierungsnachweis",
      "notAvailable": "Nicht vorhanden",
      "conditions": "Bedingungen und Vorbehalte",
      "noConditions": "Keine Angaben",
      "readOnlyHint": "Diese Ansicht zeigt Ihr eingereichtes Angebot. Änderungen sind hier nicht möglich."
    }
  },
  "notifications": {
    "allRead": "Alle Benachrichtigungen gelesen",
    "empty": "Keine Benachrichtigungen",
    "filterAll": "Alle",
    "filterUnread": "Ungelesen",
    "markAllRead": "Alle als gelesen markieren",
    "pushBlocked": "Push blockiert",
    "pushDisable": "Push deaktivieren",
    "pushEnable": "Push aktivieren",
    "pushEnabled": "Push aktiv",
    "timeAgo": {
      "days": "vor {{count}} Tag(en)",
      "hours": "vor {{count}} Std.",
      "justNow": "Gerade eben",
      "minutes": "vor {{count}} Min."
    },
    "title": "Benachrichtigungen",
    "types": {
      "ACCESS_GRANTED": "Zugang gewährt",
      "AI_EXTRACTION": "KI-Extraktion abgeschlossen",
      "AI_EXTRACTION_COMPLETE": "KI-Extraktion abgeschlossen",
      "BIDDING_ROUND_CLOSED": "Bieterrunde geschlossen",
      "BIDDING_ROUND_CLOSING_SOON": "Bieterrunde endet bald",
      "BIDDING_ROUND_OPENED": "Bieterrunde eröffnet",
      "BID_LOST": "Gebot nicht berücksichtigt",
      "BID_SUBMITTED": "Gebot abgegeben",
      "BID_SUBMITTED_SALES": "Neues Gebot eingegangen",
      "BID_WON": "Gebot akzeptiert",
      "CONTRACT_SIGNED_SALES": "Vertrag unterzeichnet",
      "CONTRACT_SIGNED_WELCOME": "Willkommen – Vertrag unterzeichnet",
      "COUNTERSIGN_READY": "Gegenzeichnung bereit",
      "COUNTERSIGN_REMINDER": "Erinnerung Gegenzeichnung",
      "DOSSIER_UPDATE": "Dossier aktualisiert",
      "INTEREST_EXPRESSED": "Interesse bekundet",
      "INTEREST_SALES_NOTIFY": "Neues Investoreninteresse",
      "NDA_CONFIRMED": "NDA bestätigt",
      "SIGNATURE_REQUIRED": "Unterschrift erforderlich"
    },
    "unreadCount": "ungelesen",
    "viewAll": "Alle anzeigen"
  },
  "offer": {
    "confirm": {
      "bindingWarning": "Mit dem Absenden geben Sie ein unverbindliches Kaufangebot ab. Dies ist noch kein Kaufvertrag.",
      "financingProof": "Finanzierungsnachweis",
      "loiSigned": "LOI unterzeichnet",
      "nonBindingInfo": "Mit dem Absenden geben Sie ein unverbindliches Kaufangebot ab. Dies ist noch kein Kaufvertrag.",
      "price": "Kaufpreis",
      "property": "Objekt",
      "submit": "Angebot absenden",
      "title": "Zusammenfassung",
      "uploadLater": "Wird nachgereicht"
    },
    "dialog": {
      "title": "Angebot abgeben",
      "yourPrice": "Ihr Angebot (CHF)",
      "stepsLabel": "Schritte der Angebotsabgabe",
      "steps": {
        "amount": "Ihr Angebot",
        "document": "Ihr Dokument",
        "review": "Prüfen & senden"
      },
      "amount": {
        "wholeFrancs": "Ganze Franken, ohne Rappen.",
        "fixedPrice": "Fixpreis: {{price}}",
        "guidePrice": "Richtpreis: {{price}}",
        "minimumPrice": "Mindestpreis: {{price}}"
      },
      "document": {
        "title": "Angebotsdokument",
        "description": "Verwenden Sie die Standard-Vorlage oder laden Sie Ihr eigenes Angebotsdokument hoch.",
        "standardOption": "Standard-Vorlage verwenden",
        "customOption": "Eigenes Dokument hochladen",
        "customDescription": "Laden Sie Ihr eigenes Angebotsdokument als PDF hoch. Es ersetzt die Standard-Vorlage.",
        "customHint": "Nur PDF, max. 50 MB",
        "dropHint": "Angebotsdokument hierher ziehen oder auswählen",
        "removeFile": "Datei entfernen",
        "chooseHint": "Bitte wählen Sie zuerst, wie Sie Ihr Angebot einreichen möchten."
      },
      "reservations": {
        "title": "Vorbehalte",
        "description": "Kreuzen Sie an, welche Vorbehalte für Ihr Angebot gelten. Nur die angekreuzten Punkte erscheinen im Dokument.",
        "templateTitle": "Ihr Angebot gilt unter folgenden Vorbehalten:",
        "none": "Keine Vorbehalte angekreuzt",
        "loadFailed": "Die Vorbehalte konnten nicht geladen werden. Sie können Ihr Angebot auch ohne Vorbehalte einreichen."
      },
      "remarks": {
        "title": "Bemerkungen",
        "description": "Halten Sie hier Hinweise zu Ihrem Angebot fest, die über die Vorbehalte hinausgehen — etwa eine gewünschte Übernahme ab einem bestimmten Datum. Der Text wird unverändert übermittelt.",
        "placeholder": "z.B. Übernahme frühestens per 1.1.2028"
      },
      "summary": {
        "document": "Angebotsdokument",
        "standardSigned": "Standard-Vorlage, digital unterzeichnet",
        "noRemarks": "Keine Bemerkungen"
      },
      "template": {
        "heading": "Absichtserklärung",
        "subtitleBinding": "Verbindliche Kaufabsichtserklärung",
        "subtitleNonBinding": "Unverbindliche Kaufabsichtserklärung",
        "date": "Datum",
        "object": "Objekt",
        "price": "Kaufpreis",
        "bodyBinding": "Hiermit erkläre ich mein verbindliches Kaufinteresse am oben genannten Objekt zum angegebenen Kaufpreis. Diese Erklärung bildet die Grundlage für die weiteren Verhandlungen und den Abschluss eines notariellen Kaufvertrags.",
        "bodyNonBinding": "Hiermit erkläre ich mein Kaufinteresse am oben genannten Objekt zum angegebenen Kaufpreis. Diese Erklärung ist unverbindlich und begründet keine Kaufpflicht.",
        "note": "Die Erklärung dient als Grundlage für den Kaufvertragsentwurf durch die Urkundsperson.",
        "signatureLine": "Ort, Datum / Unterschrift Käuferin oder Käufer"
      },
      "notice": {
        "binding": "Dies ist ein verbindliches Angebot. Mit dem Absenden verpflichten Sie sich zum Kauf zu den angegebenen Bedingungen.",
        "nonBinding": "Dies ist ein unverbindliches Angebot. Es entsteht noch kein Kaufvertrag."
      },
      "uploadFailed": "Ihr Angebot wurde eingereicht. Nicht übertragen werden konnte: {{files}}. Bitte erneut übertragen.",
      "retryUploads": "Dateien erneut übertragen",
      "success": {
        "title": "Angebot eingereicht",
        "message": "Ihr Angebot wurde erfolgreich eingereicht. Sie erhalten eine Bestätigung per E-Mail."
      }
    },
    "errors": {
      "alreadySubmitted": "Sie haben bereits ein Angebot für dieses Objekt abgegeben.",
      "noLongerAvailable": "Dieses Objekt ist nicht mehr verfügbar.",
      "submitFailed": "Angebot konnte nicht eingereicht werden. Bitte versuchen Sie es erneut."
    },
    "financing": {
      "browse": "Datei auswählen",
      "description": "Laden Sie einen Finanzierungsnachweis hoch (z.B. Bankbestätigung, Finanzierungszusage). Sie können diesen auch später nachreichen.",
      "dropHint": "Datei hierher ziehen oder klicken",
      "fileTooLarge": "Datei ist zu gross (max. 50 MB).",
      "hint": "PDF, PNG oder JPG, max. 50 MB",
      "required": "Bitte laden Sie einen Finanzierungsnachweis hoch.",
      "skipForNow": "Später nachreichen",
      "title": "Finanzierungsnachweis",
      "upload": "Nachweis hochladen",
      "uploadFailed": "Upload fehlgeschlagen. Bitte versuchen Sie es erneut.",
      "uploadSuccess": "Finanzierungsnachweis erfolgreich hochgeladen.",
      "uploaded": "Hochgeladen am {{date}}",
      "descriptionOptional": "Laden Sie einen Finanzierungsnachweis hoch (z.B. Bankbestätigung). Sie können diesen auch später nachreichen."
    },
    "loi": {
      "bindingNotice": "Mit Ihrer Unterschrift bestätigen Sie Ihr Kaufinteresse zum angegebenen Preis. Dies ist noch kein Kaufvertrag und unverbindlich.",
      "description": "Bitte unterzeichnen Sie den Letter of Intent (LOI), um Ihr Interesse am Kauf zu bestätigen.",
      "nonBindingNotice": "Mit Ihrer Unterschrift bestätigen Sie Ihr Kaufinteresse zum angegebenen Preis. Dies ist noch kein Kaufvertrag und unverbindlich.",
      "signatoryHint": "Bitte unterschreiben Sie hier",
      "signatureLabel": "Ihre Unterschrift",
      "title": "Letter of Intent unterzeichnen"
    },
    "status": {
      "awarded": "Zugeschlagen",
      "cancelled": "Storniert",
      "completed": "Abgeschlossen",
      "expired": "Abgelaufen",
      "outbid": "Überboten",
      "proofPending": "Nachweis ausstehend",
      "rejected": "Abgelehnt",
      "reserved": "Reserviert",
      "submitted": "Eingereicht",
      "withdrawn": "Zurückgezogen"
    },
    "statusCard": {
      "expired": "Reservierungsfrist abgelaufen",
      "expiresIn": "Frist läuft ab in {{time}}",
      "submittedAt": "Eingereicht am {{date}}",
      "title": "Ihr Angebot"
    },
    "submitButton": "Angebot abgeben",
    "success": {
      "message": "Ihr Angebot wurde erfolgreich eingereicht. Sie erhalten eine Bestätigung per E-Mail.",
      "proofReminder": "Bitte laden Sie den Finanzierungsnachweis innerhalb der Frist hoch.",
      "reservationInfo": "Ihre Reservierung läuft bis {{date}}. Bitte reichen Sie den Finanzierungsnachweis rechtzeitig ein.",
      "title": "Angebot erfolgreich eingereicht"
    }
  },
  "organizations": {
    "accentColor": "Akzentfarbe",
    "addAddress": "Adresse hinzufügen",
    "addContactToOrg": "Kontakt zuordnen",
    "addEmail": "E-Mail hinzufügen",
    "addInfoOwner": "+ Info-Owner hinzufügen",
    "addOrganization": "Organisation hinzufügen",
    "addPhone": "Telefonnummer hinzufügen",
    "addressAdded": "Adresse hinzugefügt",
    "addressDeleted": "Adresse gelöscht",
    "addressUpdated": "Adresse aktualisiert",
    "addresses": "Adressen",
    "allTypes": "Alle Typen",
    "bindingClauseEnabled": "Verbindlichkeitsklausel aktiviert",
    "cancelResearch": "Abbrechen",
    "cannotDelete": "Löschen nicht möglich",
    "cannotDeleteSigned": "Kontakt kann nicht gelöscht werden: Vertragsunterschriften vorhanden",
    "canton": "Kanton",
    "city": "Ort",
    "companyTab": "Firma",
    "confirmDelete": "Möchten Sie diese Organisation wirklich löschen? Alle Zuordnungen werden ebenfalls entfernt.",
    "contactCreateFailed": "Kontakt konnte nicht erstellt werden",
    "contacts": "Kontakte",
    "contactsTab": "Kontakte",
    "createSuccess": "Organisation erfolgreich erstellt",
    "createUser": "User erstellen",
    "dataQuality": {
      "title": "Datenqualität",
      "scoreOutOf": "{{score}} von 100 Punkten",
      "openTitle": "Offene Punkte ({{count}})",
      "fulfilledSummary": "{{count}} erfüllt",
      "passedOfTotal": "{{passed}} von {{total}} erfüllt",
      "filterIncomplete": "unvollständig (< {{min}})",
      "assignedToMe": "Organisation Ihnen zugewiesen",
      "duplicateRow": "Dublette: {{name}} ({{reason}})",
      "status": {
        "ok": "Vollständig",
        "warn": "Prüfen",
        "missing": "Fehlt",
        "alert": "Konflikt"
      },
      "actions": {
        "upload_logo": "Logo hochladen",
        "apply_research": "Vorschlag übernehmen",
        "run_research": "Recherche starten",
        "sync_zefix": "Zefix aktualisieren",
        "merge_contacts": "Kontakte zusammenführen",
        "merge_companies": "Organisationen zusammenführen",
        "assign_owner": "Mir zuweisen",
        "choose_owner": "Wählen",
        "add_email": "E-Mail erfassen",
        "add_address": "Adresse erfassen",
        "edit_search_profile": "Suchprofil erfassen"
      },
      "checks": {
        "logo": "Logo",
        "generic_email": "Firmen-Mail",
        "address": "Adresse",
        "phone": "Telefon",
        "zefix_age": "Handelsregister",
        "research": "Recherche",
        "research_pending": "Recherche-Vorschlag",
        "contact_duplicates": "Kontakt-Dubletten",
        "company_duplicates": "Dublette",
        "owner": "Zuständigkeit",
        "search_profile": "Suchprofil",
        "holdings": "Eigenbestand"
      }
    },
    "dedupBannerTitle": "Mögliche Duplikate erkannt:",
    "dedupReasonName": "ähnlicher Name",
    "dedupReasonUid": "gleiche UID",
    "dedupWarning": "Duplikat?",
    "deleteOrganization": "Organisation löschen",
    "deleteSuccess": "Organisation erfolgreich gelöscht",
    "description": "Beschreibung",
    "discardResearch": "Verwerfen",
    "discardResearchConfirm": "Die Recherche-Ergebnisse werden aus der Ansicht entfernt. Bei der nächsten Aktualisierung werden sie erneut geladen.",
    "discardResearchTitle": "Recherche verwerfen?",
    "duplicateUid": "Eine Organisation mit dieser UID existiert bereits",
    "editOrganization": "Organisation bearbeiten",
    "editRole": "Rolle bearbeiten",
    "email": "E-Mail",
    "emailAdded": "E-Mail hinzugefügt",
    "emailAddresses": "E-Mail-Adressen",
    "emailDeleted": "E-Mail gelöscht",
    "emailSignatureTemplate": "E-Mail-Signatur Template (HTML)",
    "emailUpdated": "E-Mail aktualisiert",
    "filterContacts": "Kontakte filtern...",
    "hasBlockers": "kann nicht gelöscht werden, da noch Abhängigkeiten bestehen:",
    "hasProfile": "Firmenprofil vorhanden",
    "hideContacts": "Kontakte ausblenden",
    "houseNumber": "Hausnummer",
    "infoOwner": "Info-Owner (mehrere möglich)",
    "infoOwnerRole": "Info",
    "isTenant": "Mandant (intern)",
    "keyPersonsFromResearch": "Schlüsselpersonen (aus Recherche)",
    "legalForm": "Rechtsform",
    "logoAlt": "Logo von {{name}}",
    "logoDragOrClick": "Logo hierhin ziehen oder klicken",
    "logoFormatError": "Nur PNG, JPG oder WebP erlaubt",
    "logoSizeError": "Datei zu gross (max. 5 MB)",
    "logoUploadFailed": "Logo-Upload fehlgeschlagen",
    "logoUploaded": "Logo hochgeladen",
    "logoUploading": "Wird hochgeladen...",
    "logoUrlPlaceholder": "Oder URL direkt eingeben: https://...",
    "mergeFailed": "Zusammenführung fehlgeschlagen",
    "mergeLinkMissing": "Verknüpfung zu dieser Organisation nicht gefunden",
    "mergeSuccess": "Organisationen erfolgreich zusammengeführt",
    "name": "Name",
    "noContactsForOrg": "Keine Kontakte zugeordnet",
    "noFilterResults": "Keine Kontakte gefunden",
    "noOrganizations": "Keine Organisationen gefunden",
    "noOwner": "-- Niemand zugewiesen --",
    "noUidDescription": "Diese Organisation hat keine UID. Sie können sie mit einem Zefix-Eintrag verknüpfen.",
    "notesAutoSaveHint": "Änderungen werden automatisch gespeichert.",
    "notesPlaceholder": "Notizen zur Organisation...",
    "openZefix": "In Zefix öffnen",
    "owner": "Verantwortlich",
    "ownerRole": "Verantwortlich",
    "phone": "Telefon",
    "phoneAdded": "Telefonnummer hinzugefügt",
    "phoneDeleted": "Telefonnummer gelöscht",
    "phoneNumbers": "Telefonnummern",
    "phoneUpdated": "Telefonnummer aktualisiert",
    "pin": "Anpinnen",
    "pinToggled": "Pin-Status geändert",
    "pinned": "Gepinnt",
    "possibleDuplicate": "Mögliches Duplikat",
    "possibleMatches": "Mögliche Zuordnungen:",
    "primaryAddress": "Hauptadresse",
    "primaryColor": "Primärfarbe",
    "primaryContact": "Ansprechpartner",
    "primaryEmail": "Haupt-E-Mail",
    "primaryPhone": "Hauptnummer",
    "profile": "Profil",
    "removeBlockersHint": "Bitte entfernen oder übertragen Sie die oben aufgeführten Abhängigkeiten, bevor Sie diese Organisation löschen.",
    "removeInfoOwner": "Info-Owner entfernen",
    "removeInvestorGroup": "Investorengruppe entfernen",
    "removePrimaryContact": "Ansprechpartner entfernen",
    "researchCancelled": "Recherche abgebrochen",
    "researchDiscarded": "Recherche-Ergebnisse verworfen",
    "resultsLabel": "Organisationen",
    "revenue": "Umsatz",
    "sameUid": "gleiche UID",
    "searchNameOrUid": "Name oder UID suchen...",
    "searchPlaceholder": "Suchen nach Name, UID oder Ort...",
    "selectMergeTarget": "Organisation zum Zusammenführen auswählen",
    "setPrimaryContact": "Als Ansprechpartner setzen",
    "showContacts": "Kontakte anzeigen",
    "signatureAuth": "Zeichnung",
    "similarName": "ähnlicher Name",
    "sourceManual": "Manuell",
    "street": "Strasse",
    "subtitle": "Alle erfassten Firmen aus dem Handelsregister",
    "syncAdded": "{{count}} hinzugefügt",
    "syncDeactivated": "{{count}} deaktiviert",
    "syncNoPersons": "Keine Zeichnungsberechtigten im Handelsregister gefunden",
    "syncNotFound": "Firma nicht im Handelsregister gefunden — UID existiert nicht bei Zefix",
    "syncReactivated": "{{count}} reaktiviert",
    "syncSkippedPinned": "{{count}} gepinnt (übersprungen)",
    "syncSuccess": "Kontakte von Zefix aktualisiert",
    "syncUnchanged": "{{count}} unverändert",
    "syncUpdated": "{{count}} aktualisiert",
    "syncingContacts": "Lade Kontakte von Zefix...",
    "tabAddressContact": "Adresse & Kontakt",
    "tabCommercialRegister": "Handelsregister",
    "tabMasterData": "Stammdaten",
    "tabNotes": "Notizen",
    "tabResearch": "Recherche",
    "tabResponsibility": "Zuständigkeit",
    "tabSignature": "Signatur",
    "title": "Organisationen",
    "type": "Typ",
    "typeNameOrUid": "Tippen Sie einen Namen oder eine UID...",
    "types": {
      "broker": "Vermittler",
      "buyer": "Käufer",
      "other": "Andere",
      "partner": "Partner",
      "seller": "Verkäufer"
    },
    "uid": "UID",
    "unpin": "Pin entfernen",
    "updateSuccess": "Organisation erfolgreich aktualisiert",
    "viaZefixCreate": "Via Zefix erfassen",
    "website": "Website",
    "zefixAssign": "Zefix zuordnen",
    "zefixAssigned": "Zefix zugeordnet",
    "zefixAssignFailed": "Zefix-Zuordnung fehlgeschlagen",
    "zefixAutoMerged": "{{count}} Kontakte automatisch aktualisiert (Funktion/Zeichnung)",
    "zefixContactCreated": "{{name}} neu erstellt",
    "zefixContactMerged": "{{name}} zusammengeführt",
    "zefixCreated": "Organisation via Zefix erfasst",
    "zefixRefresh": "Zefix aktualisieren",
    "zefixReviewDescription": "Die folgenden Kontakte aus dem Handelsregister konnten nicht eindeutig zugeordnet werden. Bitte prüfen Sie die Zuordnung manuell.",
    "zefixReviewTitle": "Zefix-Kontakte prüfen",
    "zefixSearchPlaceholder": "Firma im Handelsregister suchen...",
    "zefixSync": "Zefix aktualisieren",
    "zefixSyncFailed": "Zefix-Sync fehlgeschlagen",
    "zefixSynced": "Zefix-Daten aktualisiert",
    "zipCode": "PLZ",
    "capital": "Kapital",
    "quickProfile": "Kurzprofil",
    "industry": "Branche",
    "employees": "Mitarbeiter",
    "parentCompany": "Muttergesellschaft",
    "revenueEstimate": "Umsatz",
    "keyPersons": "Schlüsselpersonen",
    "contactImportFailed": "Import fehlgeschlagen",
    "contactAcknowledged": "Kontakt bestätigt",
    "acknowledgeFailed": "Bestätigung fehlgeschlagen",
    "extractedContacts": "Gefundene Kontakte",
    "alreadyExists": "Bereits vorhanden",
    "acknowledge": "Bestätigen",
    "imported": "Übernommen",
    "importContact": "Übernehmen",
    "researchComplete": "Recherche abgeschlossen",
    "researchFailed": "Recherche fehlgeschlagen",
    "researchStarting": "Recherche wird gestartet...",
    "discardFailed": "Verwerfen fehlgeschlagen",
    "purpose": "Zweck",
    "research": "KI-Recherche",
    "discard": "Verwerfen",
    "researching": "Recherchiere...",
    "updateResearch": "Aktualisieren",
    "startResearch": "Recherche starten",
    "discardConfirmTitle": "Recherche-Ergebnisse verwerfen?",
    "discardConfirmText": "Alle gespeicherten Recherche-Daten (Profil, Schlüsselpersonen, Branche etc.) werden unwiderruflich gelöscht.",
    "confirmDiscard": "Ja, verwerfen",
    "researchBackground": "Läuft im Hintergrund — du kannst die Seite verlassen.",
    "noResearch": "Noch keine Recherche vorhanden",
    "editSection": "{{section}} bearbeiten",
    "editMore": "Weitere Angaben bearbeiten",
    "addressLabel": "Bezeichnung",
    "phoneLabel": "Bezeichnung",
    "emailLabel": "Bezeichnung",
    "removeAddress": "Adresse entfernen",
    "removePhone": "Telefonnummer entfernen",
    "removeEmail": "E-Mail entfernen",
    "contactData": {
      "title": "Kontaktdaten der Organisation",
      "webLinks": "Web",
      "badgePrimary": "Haupt",
      "badgeCentral": "Zentrale",
      "badgeRank": "Rang {{rank}}",
      "genericHint": "Generische Adressen (investments@, info@) gehören der Organisation, persönliche Adressen dem jeweiligen Kontakt.",
      "updated": "Kontaktdaten aktualisiert"
    },
    "contactImported": "Kontakt übernommen: {{name}}",
    "dedupInfo": "{{count}} der gefundenen Personen sind bereits als Kontakte dieser Organisation erfasst.",
    "revenuePlaceholder": "1-5 Mio. CHF",
    "keyFigures": {
      "title": "Kennzahlen",
      "empty": "—",
      "add": "Ergänzen",
      "rows": {
        "capital": "Kapital",
        "founded": "Gründung",
        "employees": "Mitarbeitende",
        "revenue": "Umsatz",
        "dealSize": "Dealgrösse",
        "relevance": "Relevanz-Score"
      },
      "relevanceValue": "{{score}} von 100",
      "dealSizeFrom": "ab {{min}}",
      "dealSizeUpTo": "bis {{max}}",
      "sources": {
        "zefix": {
          "badge": "Z",
          "label": "Quelle: Handelsregister (Zefix)"
        },
        "research": {
          "badge": "KI",
          "label": "Quelle: KI-Recherche"
        },
        "searchProfile": {
          "badge": "SP",
          "label": "Quelle: Suchprofil"
        }
      },
      "pendingHint": "AUM, Portfolio und Transaktionen folgen mit Investor Research."
    },
    "searchProfile": {
      "title": "Suchprofil",
      "empty": "—",
      "add": "Ergänzen",
      "today": "heute",
      "hardMin": "unter Minimum ausgeschlossen",
      "dealSizeRange": "{{min}} – {{max}} Mio. CHF",
      "dealSizeFrom": "ab {{min}} Mio. CHF",
      "dealSizeUpTo": "bis {{max}} Mio. CHF",
      "yieldGross": "brutto ab {{value}}%",
      "columns": {
        "criterion": "Kriterium",
        "sought": "Gesucht",
        "excluded": "Ausgeschlossen",
        "source": "Quelle",
        "action": "Aktion"
      },
      "rows": {
        "usage": "Nutzung",
        "region": "Region / Kantone",
        "dealSize": "Dealgrösse",
        "yield": "Rendite",
        "investmentForm": "Investmentform",
        "conditionYear": "Zustand / Baujahr",
        "ownershipForm": "Eigentumsform",
        "minSize": "Mindestgrösse",
        "noGos": "No-Gos"
      },
      "sources": {
        "pitchdeck": {
          "badge": "PD",
          "label": "Quelle: Pitchdeck-Übernahme"
        },
        "ai": {
          "badge": "KI",
          "label": "Quelle: KI-Recherche"
        },
        "manual": {
          "badge": "✎",
          "label": "Quelle: manuell erfasst"
        },
        "archive": {
          "badge": "Archiv",
          "label": "Quelle: Altdaten-Übernahme"
        },
        "contract": {
          "badge": "SM",
          "label": "Quelle: Suchmandat"
        }
      }
    },
    "registerChecks": {
      "title": "Register & Prüfungen",
      "empty": "—",
      "asOf": "Stand {{date}}",
      "checkedAt": "geprüft {{date}}",
      "checks": {
        "zefix": "Handelsregister",
        "seco": "SECO-Sanktionsliste",
        "finma": "FINMA",
        "oak_bv": "OAK BV",
        "six": "SIX Swiss Exchange",
        "sro": "SRO (GwG)",
        "ubo": "Wirtschaftlich Berechtigte",
        "kyc": "Identifikation (GwG)",
        "memberships": "Verbände / Mitgliedschaften"
      },
      "status": {
        "ok": "Geprüft und bestätigt",
        "unknown": "Nicht gelistet / unbekannt",
        "warn": "Offen oder älter als 180 Tage",
        "alert": "Treffer, der handeln verlangt"
      },
      "actions": {
        "zefix_sync": "Zefix aktualisieren",
        "zefix_search": "Zefix zuordnen"
      }
    },
    "researchPortrait": {
      "portfolioTitle": "Portfolio",
      "transactionsTitle": "Transaktionen",
      "portfolioObjects_one": "{{count}} Objekt",
      "portfolioObjects_other": "{{count}} Objekte",
      "portfolioFocus": "Fokus",
      "amountMillions": "{{value}} Mio CHF",
      "amountBillions": "{{value}} Mrd CHF",
      "source": "Quelle",
      "empty": "Keine verwertbaren Angaben"
    },
    "researchApply": {
      "openCta": "Recherche prüfen & übernehmen ({{count}})",
      "title": "Rechercheergebnis übernehmen",
      "fieldsTitle": "Felder",
      "personsTitle": "Personen",
      "colMark": "Markiert",
      "colField": "Feld",
      "colCurrent": "Aktuell",
      "colProposal": "Vorschlag",
      "colConfidence": "Sicherheit",
      "colAction": "Aktion",
      "markRow": "{{field}} markieren",
      "actionFor": "Aktion für {{field}}",
      "actions": {
        "keep": "behalten",
        "accept": "übernehmen",
        "both": "beide"
      },
      "personActions": {
        "link": "verknüpfen",
        "create": "neu anlegen",
        "link_auditor": "als Revisionsstelle verknüpfen",
        "discard": "verwerfen"
      },
      "personMatch": "Treffer: {{name}}",
      "empty": "—",
      "lowConfidence": "Unsichere Angabe — bitte vor dem Übernehmen prüfen",
      "applyAll": "Alle übernehmen",
      "applyMarked": "Nur markierte",
      "applied": "{{fields}} Felder und {{persons}} Personen übernommen",
      "failed": "Übernahme fehlgeschlagen",
      "nothingMarked": "Keine Zeile markiert",
      "noProposals": "Keine offenen Vorschläge",
      "pendingTitle": "{{count}} Vorschläge aus der Recherche offen",
      "pendingHint": "Entschieden wird im Dialog «Rechercheergebnis übernehmen» — der Knopf steht oben auf dieser Seite.",
      "personsHint": "Personen verknüpfen, neu anlegen oder verwerfen Sie im Dialog «Rechercheergebnis übernehmen» oben auf dieser Seite.",
      "nothingToApply": "Alle Zeilen stehen auf «behalten» — es gibt nichts zu übernehmen."
    },
    "sourceBadge": {
      "ai": {
        "badge": "KI",
        "label": "Quelle: KI-Recherche"
      },
      "zefix": {
        "badge": "Z",
        "label": "Quelle: Handelsregister (Zefix)"
      },
      "manual": {
        "badge": "✎",
        "label": "Quelle: manuelle Erfassung"
      },
      "public_data": {
        "badge": "PD",
        "label": "Quelle: öffentliche Daten"
      },
      "import": {
        "badge": "IMP",
        "label": "Quelle: Datenimport"
      },
      "research": {
        "badge": "KI",
        "label": "Quelle: KI-Recherche"
      },
      "amtsblatt": {
        "badge": "AB",
        "label": "Quelle: Amtsblatt (SHAB)"
      },
      "dateLabel": "Stand {{date}}"
    },
    "hero": {
      "aiBadge": "KI",
      "aiSourceHint": "Aus der KI-Recherche übernommen",
      "applyResearch": "Recherche prüfen & übernehmen",
      "applyResearchCount": "Recherche prüfen & übernehmen ({{count}})",
      "cantons": "Kantone",
      "dataQuality": "Datenqualität {{value}}",
      "dataQualityComplete": "Daten vollständig",
      "dataQualityHint": "Zu den offenen Punkten",
      "dataQualityOpen": "Daten: {{open}} offen",
      "dealFrom": "Deal ab CHF {{min}} Mio",
      "dealRange": "Deal CHF {{min}}–{{max}} Mio",
      "dealTo": "Deal bis CHF {{max}} Mio",
      "holdings": "Bestand: {{objects}} · CHF {{value}}",
      "holdingsObjects": "Bestand: {{objects}}",
      "holdingsHint": "Zum Reiter Immobilien",
      "more": "+{{n}}",
      "owner": "Zuständig: {{name}}",
      "ownerMissing": "Zuständig: —",
      "relevance": "Relevanz {{score}}",
      "relevanceMissing": "Relevanz — nicht profiliert",
      "usages": "Nutzungen"
    },
    "holdings": {
      "title": "Eigenbestand",
      "objects": "{{count}} Objekte",
      "objectsOne": "1 Objekt",
      "objectFallback": "Objekt #{{id}}",
      "value": "CHF {{value}}",
      "valueMillions": "{{value}} Mio",
      "valueBillions": "{{value}} Mrd",
      "asOf": "Stand {{date}}",
      "groupBy": "Ansicht",
      "byFund": "Nach Vehikel/Cluster",
      "byUsage": "Nutzung",
      "byCanton": "Kanton",
      "unassignedFund": "Ohne Vehikel",
      "fundFilter": "Nur Vehikel «{{name}}»",
      "fundFilterClear": "Filter aufheben",
      "focusReason": "Kandidaten: {{reason}} ({{count}})",
      "focusReasonAny": "Kandidaten ({{count}})",
      "focusUsage": "Nutzung: {{usage}} ({{count}})",
      "focusCanton": "Kanton: {{canton}} ({{count}})",
      "focusClear": "Filter aufheben",
      "candidate": "Handelskandidat",
      "area": "{{value}} m²",
      "units": "{{count}} Einheiten",
      "unitsOne": "1 Einheit",
      "since": "seit {{year}}",
      "transactions": "Transaktionen",
      "columnDate": "Datum",
      "columnObject": "Objekt",
      "columnPrice": "Preis",
      "columns": {
        "object": "Objekt",
        "place": "Ort/Adresse",
        "usage": "Nutzung",
        "size": "Einheiten/Fläche",
        "value": "Wert",
        "acquired": "Erwerb",
        "fund": "Vehikel",
        "flag": "Kandidat",
        "source": "Quelle",
        "select": "Auswahl"
      },
      "source": "Quelle",
      "sourceRef": "Quelle: {{ref}}",
      "empty": "Kein Bestand bekannt",
      "fundKpis": {
        "value": "Marktwert",
        "objects": "Objekte",
        "objectsSource": "{{count}} laut Quelle",
        "objectsRecorded": "{{count}} erfasst",
        "vacancy": "Leerstand",
        "yield": "Rendite",
        "status": "Status",
        "asOf": "Stand",
        "empty": "{{name}} · keine Objekte erfasst"
      },
      "transactionKinds": {
        "buy": "Kauf",
        "sell": "Verkauf",
        "stake": "Beteiligung"
      },
      "edit": {
        "start": "Eigenbestand bearbeiten",
        "saved": "Eigenbestand aktualisiert",
        "addFund": "Vehikel",
        "addCluster": "Cluster",
        "addObject": "Objekt erfassen",
        "fundName": "Name des Vehikels",
        "clusterName": "Name des Clusters",
        "clusterKind": "Art der Gliederung",
        "clusterKinds": {
          "region": "Region",
          "usage": "Nutzung",
          "strategy": "Strategie",
          "size": "Grösse",
          "custom": "Eigene"
        },
        "renameFund": "Vehikel umbenennen",
        "renameCluster": "Cluster umbenennen",
        "deleteFund": "Vehikel löschen",
        "deleteCluster": "Cluster löschen",
        "deleteFundTitle": "Vehikel löschen?",
        "deleteClusterTitle": "Cluster löschen?",
        "deleteGroupHint": "«{{name}}» wird gelöscht. Die Objekte bleiben, verlieren die Zuordnung.",
        "deleteObject": "Objekt löschen",
        "deleteObjectTitle": "Objekt löschen?",
        "deleteObjectHint": "«{{name}}» wird aus dem Bestand entfernt.",
        "editObject": "Objekt bearbeiten",
        "selectObject": "{{name}} auswählen",
        "selectedCount": "{{count}} ausgewählt",
        "clearSelection": "Auswahl aufheben",
        "moveTo": "Verschieben nach",
        "moveToFund": "Verschieben nach Vehikel",
        "moveToCluster": "Verschieben nach Cluster",
        "objectTitleNew": "Objekt erfassen",
        "objectTitleEdit": "Objekt bearbeiten",
        "objectCreated": "Objekt erfasst",
        "objectUpdated": "Objekt gespeichert",
        "sourceManual": "Quelle: von Hand erfasst",
        "usage": "Nutzung",
        "usageDetail": "Nutzung, genauer",
        "usageOther": "Andere Nutzung",
        "usageNone": "Keine Angabe",
        "area": "Fläche (m²)",
        "units": "Einheiten",
        "buildYear": "Baujahr",
        "acquiredYear": "Erwerbsjahr",
        "value": "Wert (CHF)",
        "fund": "Vehikel",
        "cluster": "Cluster",
        "noCluster": "Ohne Cluster",
        "notes": "Notiz",
        "cantonInvalid": "Kanton als Kürzel mit 2 Zeichen, z. B. ZH",
        "yearInvalid": "Jahr mit 4 Stellen, z. B. 1998",
        "numberInvalid": "Bitte eine Zahl eingeben"
      }
    },
    "portfolioReview": {
      "title": "Portfoliobereinigung",
      "headerCount": "{{candidates}} von {{objects}} Objekten",
      "reasonCount": "{{label}} {{count}}",
      "reasons": {
        "non_core": "Non-Core",
        "small": "kleinteilig",
        "old": "alt",
        "manual": "manuell"
      },
      "reasonHints": {
        "non_core": "passt nicht zum Suchprofil (Nutzung oder Kanton)",
        "small": "Wert unter 10 % des Durchschnittsobjekts gleicher Nutzung",
        "old": "Baujahr über 25 Jahre älter als der Bestand",
        "manual": "von Hand markiert"
      },
      "noProfileHint": "Kein Suchprofil — nur Grösse/Alter bewertet",
      "shareOfObjects": "{{label}}: {{count}} von {{objects}} Objekten",
      "openProperties": "{{candidates}} Kandidaten im Reiter Immobilien ansehen",
      "empty": "Keine Kandidaten gefunden",
      "pdf": "PDF",
      "pdfAria": "Portfoliobereinigung als PDF herunterladen",
      "pdfFailed": "PDF konnte nicht geladen werden",
      "flagSet": "Als Handelskandidat markieren",
      "flagRemove": "Markierung entfernen",
      "flagSaved": "Markierung gespeichert",
      "noteTitle": "Als Handelskandidat markieren",
      "noteHint": "«{{name}}» wird als Handelskandidat markiert.",
      "noteLabel": "Notiz (optional)",
      "notePlaceholder": "Warum kann dieses Objekt raus?",
      "taskCreated": "Pendenz erstellt",
      "taskCreatedFor": "Pendenz für {{name}} erstellt"
    },
    "fundMonitor": {
      "title": "Anlagevehikel",
      "kpiAum": "AUM gesamt",
      "kpiProperties": "Liegenschaften",
      "kpiLtv": "LTV Ø / Limite",
      "kpiVacancy": "Leerstand Ø",
      "kpiSell": "Verkaufsanlässe",
      "kpiBuy": "Kaufanlässe",
      "colAum": "AUM",
      "colProperties": "Objekte",
      "colLtv": "LTV / Limite",
      "colVacancy": "Leerstand",
      "colTerm": "Laufzeit",
      "expand": "«{{name}}» aufklappen",
      "collapse": "«{{name}}» zuklappen",
      "sellSignal": "Verkaufsanlass",
      "buySignal": "Kaufanlass",
      "moreSignals": "+{{count}} weitere",
      "structureOpenEnd": "offene Struktur",
      "structureClosedEnd": "geschlossene Struktur",
      "termEnd": "bis {{date}}",
      "inception": "seit {{year}}",
      "subscription": "Zeichnung",
      "subscriptionOpen": "offen",
      "subscriptionClosed": "geschlossen",
      "redemption": "Rücknahme",
      "redemptionAnnounced": "angekündigt {{value}}",
      "capitalIncrease": "Kapitalerhöhung",
      "performance": "Performance",
      "perfYtd": "YTD",
      "perf1y": "1 J",
      "perf3y": "3 J",
      "perf5y": "5 J",
      "valuation": "Bewertung",
      "nav": "NAV",
      "gav": "GAV",
      "propertyValue": "Liegenschaften",
      "agio": "Agio",
      "fiscalYearEnd": "Geschäftsjahr",
      "source": "Quelle",
      "sourceLink": "Bericht",
      "openObjects": "Objekte",
      "openObjectsAria": "Objekte von «{{name}}» im Reiter Immobilien",
      "noObjectList": "Objektliste fehlt – Quelle: Bericht"
    },
    "qualification": {
      "action": "Qualifizieren",
      "blockedHint": "Branche und Ansprechperson sind erforderlich",
      "chipHint": "Aus dem Adress-Trichter importiert — noch nicht qualifiziert",
      "contactExisting": "Bestehende Person wählen",
      "contactNew": "Neue Person erfassen",
      "dialogTitle": "Organisation qualifizieren",
      "failed": "Qualifizierung fehlgeschlagen",
      "filterAll": "Qualifizierung: alle",
      "filterLabel": "Qualifizierung",
      "finish": "Abschliessen",
      "industryHint": "Mindestens eine Branche ist erforderlich.",
      "nameMismatch": "Der Name im Handelsregister lautet «{{register}}», erfasst ist «{{stored}}». Bitte zuerst abgleichen.",
      "noUid": "Zuerst UID zuordnen",
      "noUidHint": "Ohne UID lässt sich das Handelsregister nicht abgleichen. Ordnen Sie die Organisation einem Zefix-Eintrag zu.",
      "position": "Position",
      "qualified": "Qualifiziert",
      "stepContact": "Ansprechperson erfassen",
      "stepIndustry": "Branche wählen",
      "stepRegister": "Handelsregister bestätigen",
      "success": "Organisation qualifiziert",
      "unqualified": "Unqualifiziert"
    },
    "glossary": {
      "objects": {
        "title": "Objekte",
        "what": "Erfasste Liegenschaften dieser Firma (Eigenbestand), über alle Vehikel.",
        "how": "Zählung der Objekte im Reiter Immobilien."
      },
      "units": {
        "title": "Einheiten",
        "what": "Wohnungen und Gewerbeeinheiten aller erfassten Objekte.",
        "how": "Summe der Einheiten; «—» wenn bei keinem Objekt erfasst."
      },
      "value": {
        "title": "Wert",
        "what": "Summe der Marktwerte der bei uns erfassten Objekte — nicht das verwaltete Vermögen (AUM).",
        "how": "Addiert die Schätzwerte je Objekt."
      },
      "candidates": {
        "title": "Kandidaten",
        "what": "Objekte, die bei einer Portfoliobereinigung zum Verkauf anstehen könnten.",
        "how": "Non-Core, kleinteilig und alt werden berechnet; ⚑ manuell wird gespeichert."
      },
      "funds": {
        "title": "Vehikel",
        "what": "Fonds, Anlagegruppen und Anlagestiftungen dieser Firma.",
        "how": "Alle erfassten Vehikel, auch ohne zugeordnete Objekte."
      },
      "non_core": {
        "title": "Non-Core",
        "what": "Passt nicht zur Strategie der Firma.",
        "how": "Nutzung oder Kanton nicht im Suchprofil, oder Objekt im Cluster «Non-Core». Ohne Suchprofil entfällt der Grund."
      },
      "small": {
        "title": "kleinteilig",
        "what": "Zu klein für das Portfolio.",
        "how": "Wert unter 10 % des Durchschnittsobjekts gleicher Nutzung."
      },
      "old": {
        "title": "alt",
        "what": "Deutlich älter als der übrige Bestand.",
        "how": "Baujahr über 25 Jahre älter als der Bestand, keine Sanierung in den Notizen."
      },
      "manual": {
        "title": "manuell",
        "what": "Von Hand als Kandidat markiert (⚑).",
        "how": "Markierung im Reiter Immobilien, mit Notiz."
      },
      "sourceReport": "Bericht/Portrait",
      "aum_chf": {
        "title": "AUM",
        "what": "Verwaltetes Vermögen des Vehikels.",
        "how": "Laut Quelle: Liegenschaften, Flüssige Mittel und übrige Aktiven."
      },
      "properties_count": {
        "title": "Objekte",
        "what": "Liegenschaften dieses Vehikels, laut Quelle.",
        "how": "Zahl aus Bericht oder Portrait; fehlt sie, zählt die Zeile die bei uns erfassten Objekte."
      },
      "ltv_pct": {
        "title": "LTV",
        "what": "Anteil Hypotheken am Immobilienwert. Hoch = wenig Spielraum für Zukäufe.",
        "how": "Loan-to-Value = Hypotheken ÷ Marktwert der Liegenschaften, laut Quelle."
      },
      "ltv_limit_pct": {
        "title": "Limite",
        "what": "Obergrenze der Fremdfinanzierung dieses Vehikels.",
        "how": "Laut Reglement oder Prospekt. Je näher der LTV an der Limite, desto weniger Zukäufe möglich."
      },
      "vacancy_pct": {
        "title": "Leerstand",
        "what": "Mietausfall in Prozent. Tief = gesundes Portfolio.",
        "how": "Laut Quelle (Definition der Quelle: Ertrag oder Fläche)."
      },
      "agio_pct": {
        "title": "Agio / Disagio",
        "what": "Börsenkurs im Vergleich zum Nettoinventarwert (NAV), nur bei gehandelten Vehikeln.",
        "how": "Disagio (negativ) = Kurs unter NAV → Kapitalerhöhung unattraktiv → kauft kaum zu, verkauft eher."
      },
      "nav": {
        "title": "NAV",
        "what": "Vermögen des Vehikels nach Abzug der Schulden.",
        "how": "Nettoinventarwert laut Bericht."
      },
      "gav": {
        "title": "GAV",
        "what": "Vermögen des Vehikels vor Abzug der Schulden.",
        "how": "Bruttoinventarwert laut Bericht."
      },
      "signals_sell": {
        "title": "Verkaufsanlass",
        "what": "Aussage der Quelle, die auf Verkäufe deutet.",
        "how": "Wörtlich aus Bericht oder Medienmitteilung übernommen."
      },
      "signals_buy": {
        "title": "Kaufanlass",
        "what": "Aussage der Quelle, die auf Zukäufe deutet.",
        "how": "Z.B. Zeichnung offen, Kapitalerhöhung geplant."
      },
      "subscription": {
        "title": "Zeichnung",
        "what": "Ob neue Anteile gezeichnet werden können.",
        "how": "offen = Geld fliesst zu, Zukäufe wahrscheinlich; geschlossen = kein neues Kapital."
      },
      "redemption": {
        "title": "Rücknahme",
        "what": "Frist, zu der Anleger Anteile zurückgeben können.",
        "how": "Angekündigte Rücknahmen in CHF = Geld, das abfliesst → Verkaufsdruck."
      },
      "structure": {
        "title": "Laufzeit",
        "what": "Ob das Vehikel befristet ist.",
        "how": "offene Struktur = unbefristet; geschlossen = Laufzeit bis Datum, danach Verkauf des Bestands."
      },
      "capital_increase": {
        "title": "Kapitalerhöhung",
        "what": "Ob das Vehikel neues Kapital aufnimmt.",
        "how": "Letzte und geplante Erhöhung laut Quelle; geplant = Zukäufe wahrscheinlich."
      },
      "sourceLine": "Quelle: {{source}} · Stand {{date}}"
    },
    "holdingsCard": {
      "title": "Immobilien · Eigenbestand",
      "kpiObjects": "Objekte",
      "kpiUnits": "Einheiten",
      "kpiUnitsKnown": "{{known}} von {{total}} mit Angabe",
      "kpiValue": "Wert",
      "kpiCandidates": "Kandidaten",
      "kpiFunds": "Vehikel",
      "byUsage": "Nach Nutzung",
      "byReason": "Portfoliobereinigung",
      "byCanton": "Nach Kanton",
      "segment": "{{usage}}: {{count}}",
      "noCandidates": "Portfoliobereinigung: 0 Kandidaten — alle Objekte passen zum Suchprofil",
      "noValue": "Keine Angabe",
      "openProperties": "Reiter Immobilien",
      "barLink": "{{label}}: {{count}} Objekte im Reiter Immobilien anzeigen"
    },
    "uidSource": {
      "zefix": "UID: Handelsregister",
      "uid_register": "UID: UID-Register",
      "manual": "UID: manuell",
      "fetchedAt": "{{label}} — abgerufen am {{date}}"
    }
  },
  "pagination": {
    "next": "Nächste",
    "page": "Seite {{current}} von {{total}}",
    "previous": "Vorherige",
    "rowsPerPage": "Einträge pro Seite",
    "showing": "Zeige {{from}}-{{to}} von {{total}}"
  },
  "preferences": {
    "notifications": {
      "categories": {
        "contract_updates": "Vertrags-Updates",
        "favorites_updates": "Favoriten-Updates",
        "new_matches": "Neue Treffer",
        "offer_updates": "Angebots-Updates",
        "platform_news": "Plattform-News"
      },
      "descriptions": {
        "contract_updates": "Statusänderungen bei Verträgen, z.B. Signatur oder Ablauf.",
        "favorites_updates": "Änderungen an Ihren favorisierten Immobilien.",
        "new_matches": "Neue Immobilien, die zu Ihrem Suchprofil passen.",
        "offer_updates": "Wichtige Rückmeldungen zu Ihren Angeboten.",
        "platform_news": "Neuigkeiten und Funktionen auf Immotron."
      },
      "devices": {
        "empty": "Es ist noch kein Gerät für Push-Benachrichtigungen registriert. Registrieren Sie dieses Gerät, um Push-Nachrichten zu erhalten.",
        "namePlaceholder": "Gerätename (z.B. iPhone Privat)",
        "permissionBlocked": "Sie haben Push-Benachrichtigungen für diese Seite blockiert. Bitte aktivieren Sie diese in den Browser-Einstellungen.",
        "permissionDenied": "Berechtigung verweigert. Aktivieren Sie Benachrichtigungen in den Browser-Einstellungen.",
        "registerAnother": "Weiteres Gerät registrieren",
        "registerError": "Gerät konnte nicht registriert werden",
        "registerSuccess": "Gerät wurde registriert",
        "registerThis": "Dieses Gerät registrieren",
        "registeredOn": "Registriert am {{date}}",
        "removeAria": "Gerät entfernen",
        "removeError": "Gerät konnte nicht entfernt werden",
        "removeSuccess": "Gerät wurde entfernt",
        "renameAria": "Gerät umbenennen",
        "renameError": "Name konnte nicht gespeichert werden",
        "renameSuccess": "Name wurde aktualisiert",
        "serverNotConfigured": "Push-Benachrichtigungen sind serverseitig aktuell nicht konfiguriert. Die Einstellungen werden gespeichert und sobald Push verfügbar ist, erhalten Sie Nachrichten.",
        "subtitle": "Verwalten Sie die Geräte, auf denen Sie Push-Benachrichtigungen erhalten möchten.",
        "testButton": "Push testen",
        "testError": "Test konnte nicht gesendet werden",
        "testNone": "Keine Geräte erreichbar",
        "testSending": "Sende …",
        "testSent": "Test-Push an {{count}} Gerät(e) gesendet",
        "title": "Geräte für Push-Benachrichtigungen",
        "unnamedDevice": "Unbenanntes Gerät",
        "unregisterError": "Gerät konnte nicht abgemeldet werden",
        "unregisterSuccess": "Dieses Gerät wurde abgemeldet",
        "unregisterThis": "Dieses Gerät abmelden",
        "unsupported": "Dieser Browser unterstützt keine Push-Benachrichtigungen."
      },
      "emailColumn": "E-Mail",
      "loadFailed": "Benachrichtigungseinstellungen konnten nicht geladen werden",
      "locked": "Nicht deaktivierbar",
      "pushColumn": "Push",
      "pushRequiresDevice": "Bitte registrieren Sie zuerst ein Gerät, um Push-Benachrichtigungen zu aktivieren.",
      "saveFailed": "Einstellung konnte nicht gespeichert werden",
      "subtitle": "Wählen Sie pro Ereignis, wie Sie benachrichtigt werden möchten.",
      "title": "Benachrichtigungen"
    },
    "privacy": {
      "activityTracking": {
        "description": "Erlaubt uns, Ihre Nutzung der Plattform anonym auszuwerten, um die Benutzerfreundlichkeit zu verbessern.",
        "title": "Aktivitäts-Tracking"
      },
      "anonymizeActivity": "Aktivitäten anonymisieren",
      "anonymizeDescription": "Ihre Aktivitäten werden für andere Nutzer anonymisiert dargestellt",
      "anonymous": "Anonym",
      "anonymousDescription": "Ihr Profil ist für andere Nutzer nicht sichtbar",
      "dataManagement": "Datenverwaltung",
      "deleteAccount": {
        "button": "Konto löschen",
        "description": "Ihr Konto und alle zugehörigen Daten werden unwiderruflich gelöscht.",
        "title": "Konto löschen"
      },
      "exportData": {
        "button": "Exportieren",
        "description": "Laden Sie eine Kopie Ihrer persönlichen Daten herunter.",
        "error": "Datenexport fehlgeschlagen",
        "success": "Datenexport erfolgreich heruntergeladen",
        "title": "Daten exportieren"
      },
      "legal": "Rechtliche Hinweise",
      "loadFailed": "Privatsphäre-Einstellungen konnten nicht geladen werden",
      "marketingEmails": {
        "description": "Erhalten Sie gelegentlich Neuigkeiten, Tipps und Angebote per E-Mail.",
        "title": "Marketing-E-Mails"
      },
      "privacyPolicyLink": "Datenschutzerklärung",
      "profileVisibility": "Profilsichtbarkeit",
      "profileVisible": {
        "description": "Ihr Profil ist für andere Nutzer der Plattform sichtbar.",
        "title": "Profil sichtbar"
      },
      "public": "Öffentlich",
      "publicDescription": "Ihr Profil ist für andere Nutzer sichtbar",
      "saveFailed": "Einstellung konnte nicht gespeichert werden",
      "settings": "Datenschutzeinstellungen",
      "termsLink": "Nutzungsbedingungen",
      "title": "Privatsphäre"
    }
  },
  "profile": {
    "active": "Aktiv",
    "admin": {
      "backToUsers": "Zurück zur Benutzerliste",
      "impersonate": "Als Benutzer einloggen",
      "impersonateDescription": "Öffnet eine Session als dieser Benutzer",
      "loginAs": "Einloggen",
      "resetEmailSent": "Reset-E-Mail gesendet",
      "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
      "resetPassword": "Passwort zurücksetzen",
      "sendResetLink": "Reset-Link senden"
    },
    "companyAssignments": "Firmenzugehörigkeiten",
    "directPhone": "Direktnummer",
    "functionPlaceholder": "z.B. Geschäftsführer, Sales Manager",
    "functionTitle": "Funktion",
    "languageAuto": "Automatisch (Systemsprache)",
    "preferredLanguage": "Hauptsprache",
    "role": "Rolle",
    "sections": {
      "compliance": "Compliance",
      "emailAccounts": "E-Mail-Konten",
      "passkeys": "Passkeys",
      "password": "Passwort",
      "profile": "Profil",
      "security": "Sicherheit"
    },
    "subtitle": "Profil, Sicherheit und Einstellungen verwalten",
    "title": "Einstellungen"
  },
  "properties": {
    "activate": "Aktivieren",
    "activated": "Immobilie wurde aktiviert.",
    "activeHighlights": "Aktive Highlights",
    "addProperty": "Immobilie hinzufügen",
    "addRow": "Zeile hinzufügen",
    "address": "Adresse",
    "agentAnalysis": {
      "alreadyRunning": "Für dieses Objekt läuft bereits eine Analyse.",
      "openPoints": "Offene Punkte",
      "report": "Prüfbericht öffnen",
      "start": "Vollanalyse starten",
      "started": "Analyse angefordert — der Objekt-Agent arbeitet.",
      "status": {
        "completed": "Abgeschlossen",
        "failed": "Abgebrochen",
        "pending": "Wartet auf den Agenten",
        "processing": "In Arbeit"
      },
      "title": "Objekt-Analyse"
    },
    "aiBanner": {
      "confidence": "Konfidenz",
      "hideHints": "Hinweise ausblenden",
      "hintsCount": "{{count}} Hinweise",
      "showHints": "Hinweise anzeigen",
      "title": "KI-Extraktion"
    },
    "aiConfidence": "KI-Datenqualität",
    "approve": "Genehmigen",
    "approved": "Immobilie wurde genehmigt.",
    "area": "Fläche",
    "availableData": "Verfügbare Daten",
    "backToList": "Zurück zur Übersicht",
    "bulk": {
      "affectedCount": "{{count}} Immobilien betroffen",
      "confirmDelete": "Immobilien löschen?",
      "confirmStatus": "Status ändern?",
      "error": "Massenoperation fehlgeschlagen",
      "newStatus": "Neuer Status",
      "success": "Massenoperation erfolgreich."
    },
    "city": "Stadt",
    "compactMode": "Kompakt",
    "condition": {
      "EXCELLENT": "Ausgezeichnet",
      "FAIR": "Befriedigend",
      "GOOD": "Gut",
      "GUTTED": "Kernsaniert",
      "NEW": "Neubau",
      "RENOVATION_NEEDED": "Renovationsbedürftig"
    },
    "conditions": {
      "EXCELLENT": "Ausgezeichnet",
      "FAIR": "Befriedigend",
      "GOOD": "Gut",
      "GUTTED": "Kernsaniert",
      "NEW": "Neubau",
      "RENOVATION_NEEDED": "Renovationsbedürftig"
    },
    "confirmDelete": "Möchten Sie diese Immobilie wirklich löschen? Dieser Vorgang ist unwiderruflich.",
    "country": "Land",
    "createSuccess": "Immobilie erfolgreich erstellt",
    "deleteFinal": "Endgültig löschen",
    "deleteProperty": "Immobilie löschen",
    "deleteSuccess": "Immobilie erfolgreich gelöscht",
    "description": "Beschreibung",
    "detail": {
      "activate": "Aktivieren",
      "archive": "Archivieren",
      "changeStatus": "Status ändern",
      "gallery": "Bildergalerie",
      "investorAccess": "Investoren-Zugang",
      "keyFacts": "Kennzahlen",
      "noAccess": "Noch keine Investoren mit Zugang"
    },
    "diff": {
      "city": "Ort",
      "condition": "Zustand",
      "constructionYear": "Baujahr",
      "empty": "(leer)",
      "grossYield": "Bruttorendite",
      "heating": "Heizung",
      "lotSize": "Grundstücksflaeche",
      "marketValue": "Marktwert",
      "price": "Preis",
      "propertyType": "Immobilientyp",
      "rentalIncome": "Mieteinnahmen",
      "residentialUnits": "Wohneinheiten",
      "status": "Status",
      "street": "Strasse",
      "usableArea": "Nutzfläche",
      "zipCode": "PLZ"
    },
    "documents": "Dokumente",
    "draft": {
      "discard": "Verwerfen",
      "found": "Es wurde ein ungespeicherter Entwurf gefunden",
      "restore": "Wiederherstellen",
      "restored": "Entwurf wiederhergestellt"
    },
    "duplicate": "Duplizieren",
    "duplicateSuccess": "Immobilie als Kopie vorbereitet",
    "editProperty": "Immobilie bearbeiten",
    "errors": {
      "deleteFailed": "Immobilie konnte nicht gelöscht werden",
      "imageDeleteFailed": "Bild konnte nicht gelöscht werden",
      "imageRotateFailed": "Bild konnte nicht gedreht werden",
      "imageTooLarge": "Bild «{{name}}» ist zu gross (max. 10 MB)",
      "imageUnsupportedType": "Bildformat von «{{name}}» nicht unterstützt",
      "imageUploadFailed": "Bild konnte nicht hochgeladen werden",
      "loadFailed": "Immobilien konnten nicht geladen werden",
      "saveFailed": "Immobilie konnte nicht gespeichert werden",
      "submitFailed": "Fehler beim Einreichen",
      "unrealisticYield": "Unrealistischer Wert — bitte Eingabedaten prüfen",
      "updateFailed": "Aktualisierung fehlgeschlagen."
    },
    "externalLinks": "Externe Links",
    "favorites": {
      "empty": "Keine Favoriten vorhanden",
      "impersonate": "Als Investor einloggen",
      "loginAs": "Einloggen",
      "showDetails": "Details anzeigen",
      "title": "Investoren-Favoriten"
    },
    "fields": {
      "canton": "Kanton",
      "createdBy": "Erstellt von",
      "favorites": "Favoriten",
      "location": "Standort",
      "name": "Bezeichnung",
      "price": "Mindestpreis",
      "status": "Status",
      "type": "Typ"
    },
    "filters": {
      "clearAll": "Alle Filter zurücksetzen",
      "max": "Max",
      "min": "Min",
      "priceRange": "Preisbereich (CHF)",
      "results": "Ergebnisse",
      "sortBy": "Sortierung",
      "sortNewest": "Neueste zuerst",
      "sortOldest": "Älteste zuerst",
      "sortPriceAsc": "Preis aufsteigend",
      "sortPriceDesc": "Preis absteigend",
      "title": "Filter"
    },
    "floor": "Etage",
    "form": {
      "addressPlaceholder": "Adresse eingeben (z.B. Bahnhofstrasse 1, Zürich)",
      "annualRentalIncome": "Jährliche Mieteinnahmen (CHF)",
      "anzahl_etagen": "Etagen",
      "assignedTo": "Zugewiesen an",
      "bruttorendite_pct": "Bruttorendite",
      "buildingCount": "Anzahl Gebäude",
      "cadastralNumber": "Kataster-Nr.",
      "cadastreNumber": "Kataster-Nr.",
      "cadastre_number": "Kataster-Nr.",
      "calcAutoHint": "Wird automatisch berechnet",
      "canton": "Kanton",
      "city": "Ort",
      "commercialArea": "Gewerbefläche",
      "commercialAreaSqm": "Gewerbefläche (m²)",
      "commercialUnits": "Gewerbeeinheiten",
      "commercial_area_sqm": "Gewerbefläche",
      "commissionRate": "Honorar (%)",
      "condition": "Zustand",
      "conditionField": "Zustand",
      "constructionYear": "Baujahr",
      "country": "Land",
      "description": "Beschreibung",
      "desiredPrice": "Wunschpreis (CHF)",
      "desiredPricePlaceholder": "z.B. 1800000",
      "desiredTimeline": "Gewünschte Timeline",
      "desiredTimelinePlaceholder": "z.B. Verkauf bis Q3 2026",
      "detailedDescription": "Beschreibung",
      "dragToReorder": "Ziehen zum Sortieren",
      "egridNumber": "E-GRID Nr.",
      "energieklasse": "Energieklasse",
      "energyClassEnvelope": "Energieklasse Huelle",
      "energyClassTotal": "Energieklasse Gesamt",
      "equityYield": "Eigenkapitalrendite",
      "floorAreaRatio": "Ausnützungsziffer",
      "floorCount": "Anzahl Etagen",
      "garageParking": "Garagenplätze",
      "garageParkingCount": "Garagenparkplätze",
      "grossYield": "Bruttorendite",
      "groundLeaseExpiration": "Baurecht Ablaufdatum",
      "hasBuildingPermit": "Baubewilligung vorhanden",
      "hasBuildingRight": "Baurecht",
      "hasGroundLease": "Baurecht vorhanden",
      "hasLift": "Lift vorhanden",
      "has_building_permit": "Baubewilligung",
      "has_ground_lease": "Baurecht",
      "has_lift": "Lift",
      "heatingSystem": "Heizanlage",
      "heating_system": "Heizung",
      "highlightOrder": "Reihenfolge",
      "highlights": "Investment-Highlights",
      "houseNumber": "Hausnummer",
      "imageDragDrop": "Bilder hierher ziehen oder klicken",
      "imageHint": "JPG, PNG, WEBP. Max. 10 MB.",
      "imageUploading": "Bild wird hochgeladen...",
      "investmentHighlights": "Investment-Highlights",
      "isPrivateListing": "Privatangebot",
      "isPrivateListingHint": "Nur für ausgewählte Investoren sichtbar",
      "latitude": "Breitengrad",
      "leerstand_pct": "Leerstand",
      "listingExpirationDate": "Ablaufdatum",
      "longitude": "Längengrad",
      "lotSizeSqm": "Grundstücksfläche (m²)",
      "macroLocation": "Makrolage",
      "marketValueChf": "Marktwert (CHF)",
      "marketValueDate": "Marktwert Datum",
      "marketValueSource": "Marktwert Quelle",
      "marketValueSourcePlaceholder": "IAZI, Wüest Partner",
      "marktwert_chf": "Marktwert",
      "max_building_height": "Max. Gebäudehöhe",
      "microLocation": "Mikrolage",
      "minimumPrice": "Mindestpreis (CHF)",
      "multipleSelectionAllowed": "Mehrfachauswahl möglich",
      "name": "Bezeichnung",
      "netYield": "Nettorendite",
      "noImages": "Noch keine Bilder hochgeladen",
      "orderLost": "Auftrag verloren",
      "outdoorParking": "Aussenparkplätze",
      "outdoorParkingCount": "Aussenparkplätze",
      "ownershipType": "Eigentumsart",
      "ownership_type": "Eigentum",
      "parking": "Parkplätze",
      "postalCode": "PLZ",
      "price": "Preis",
      "pricePerSqm": "Preis pro m²",
      "price_per_sqm": "Preis/m²",
      "primaryImage": "Primärbild",
      "propertySubtype": "Subtyp",
      "propertyType": "Immobilientyp",
      "renovation": "Sanierung",
      "renovationPlaceholder": "z.B. Letzte Sanierung 2018, Dach 2020",
      "residentialArea": "Wohnfläche",
      "residentialAreaSqm": "Wohnfläche (m²)",
      "residentialUnits": "Wohneinheiten",
      "residential_area_sqm": "Wohnfläche",
      "rotateImage": "Um 90° drehen",
      "saleEndDate": "Verkaufsende",
      "saleStartDate": "Verkaufsstart",
      "salesUserId": "Sales-Verantwortlicher",
      "salesUserIdPlaceholder": "Keine Zuweisung",
      "sellerNotes": "Verkäufer-Anmerkungen",
      "sendExpirationReminder": "Erinnerung vor Ablauf senden",
      "setPrimary": "Als Primärbild setzen",
      "status": "Status",
      "street": "Strasse",
      "subheader": "Subheader",
      "teaserHighlights": "Teaser-Highlights",
      "teaserHighlightsHint": "Wählen Sie die Highlights, die auf der Investor-Teaserseite angezeigt werden sollen. Reihenfolge per Nummer festlegen.",
      "uploadImages": "Bilder hochladen",
      "usableAreaSqm": "Nutzfläche (m²)",
      "utilization_factor": "Ausnützungsziffer",
      "vacancyRate": "Leerstand (%)",
      "volume": "Volumen",
      "volumeM3": "Volumen (m³)",
      "volume_m3": "Volumen",
      "vrTourUrl": "VR-Tour URL",
      "yearBuilt": "Baujahr"
    },
    "heating": {
      "DISTRICT": "Fernwärme",
      "ELECTRIC": "Elektroheizung",
      "GAS": "Gasheizung",
      "HEAT_PUMP": "Wärmepumpe",
      "OIL": "Ölheizung",
      "OTHER": "Andere",
      "PELLETS": "Pelletheizung",
      "SOLAR": "Solarheizung"
    },
    "highlights": {
      "annual_income": "Mieteinnahmen p.a.",
      "building_count": "Gebäude",
      "building_permit": "Baubewilligung",
      "commercial_area": "Gewerbefläche",
      "commercial_units": "Gewerbeeinheiten",
      "condition": "Zustand",
      "construction_year": "Baujahr",
      "energieklasse": "Energieklasse",
      "etagen": "Etagen",
      "gross_yield": "Bruttorendite",
      "heating_system": "Heizung",
      "location": "Standort",
      "lot_size": "Grundstücksfläche",
      "marktwert": "Marktwert",
      "net_yield": "Nettorendite",
      "ownership": "Eigentumsart",
      "parking": "Parkplätze",
      "price": "Preisvorstellung",
      "property_type": "Objekttyp",
      "residential_area": "Wohnfläche",
      "residential_units": "Wohneinheiten",
      "usable_area": "Nutzfläche",
      "vacancy": "Leerstand",
      "volume": "Volumen"
    },
    "highlightsAddHint": "Highlights aus der Liste unten hinzufügen...",
    "images": "Bilder",
    "list": {
      "companyLabel": "Mandant",
      "empty": {
        "description": "Fügen Sie Ihre erste Immobilie hinzu, um loszulegen.",
        "title": "Keine Immobilien vorhanden"
      },
      "emptyFiltered": "Keine Objekte mit den aktiven Filtern: {{filters}}",
      "emptyFilteredTitle": "Keine Treffer",
      "resetFilters": "Filter zurücksetzen",
      "switchCompany": "Mandant wechseln"
    },
    "listingPreview": "Teaser-Vorschau",
    "listingPreviewBanner": "Vorschau — So sehen Investoren diesen Teaser",
    "teaserViewToggle": {
      "ariaLabel": "Vorschau-Ansicht wählen",
      "web": "Web-Ansicht",
      "newsletter": "E-Mail-Newsletter",
      "delivery": "Versand & Auswertung"
    },
    "teaserDelivery": {
      "title": "Versand & Auswertung",
      "summary": {
        "sent": "Versendet",
        "delivered": "Zugestellt",
        "opened": "Geöffnet",
        "clicked": "Geklickt"
      },
      "columns": {
        "recipient": "Empfänger",
        "mail": "Mail",
        "sent": "Versendet",
        "delivered": "Zugestellt",
        "opened": "Geöffnet",
        "clicked": "Geklickt"
      },
      "types": {
        "ACCESS_GRANTED": "Zugangs-Mail",
        "BUYER_ONBOARDING_INVITE": "Einladung",
        "ONBOARDING_CORRECTION": "Korrektur-Einladung"
      },
      "bounced": "Nicht zustellbar",
      "empty": "Zu diesem Angebot wurde noch keine Mail versendet.",
      "loadError": "Auswertung konnte nicht geladen werden."
    },
    "sendAsCampaign": {
      "button": "Als Kampagne versenden",
      "gateLocked": "Erst nach Quality Gate verfügbar",
      "title": "Teaser als Kampagne versenden",
      "intro": "Aus dem Teaser wird eine E-Mail-Kampagne erstellt — mit demselben Inhalt, den ein Investor ohne NDA sieht. Danach kannst du Inhalt und Empfänger prüfen, einen Test-Versand machen und versenden.",
      "gateChecking": "NDA-Gate wird geprüft …",
      "gateOk": "NDA-Gate frei — {{count}} Teaser-Bild(er) freigegeben",
      "gateBlocked": "NDA-Gate blockiert den Versand",
      "gateLoadFailed": "Teaser-Vorschau konnte nicht geladen werden.",
      "locationConfirm": "Standortkritische Bilder bewusst freigeben",
      "includeRecipients": "{{count}} Empfänger aus Investorengruppen übernehmen",
      "includeRecipientsHint": "Mitglieder der dem Objekt zugewiesenen Investorengruppen.",
      "noRecipients": "Keine Empfänger aus Investorengruppen gefunden — im nächsten Schritt kannst du Empfänger per CSV hochladen.",
      "create": "Kampagne erstellen",
      "created": "Kampagne erstellt — bitte Inhalt prüfen und Test-Versand durchführen.",
      "createFailed": "Kampagne konnte nicht erstellt werden.",
      "recipientsFailed": "Empfänger konnten nicht übernommen werden — bitte im Kampagnen-Flow hinzufügen."
    },
    "loading": "Wird geladen...",
    "map": {
      "noCoordinates": "{{count}} Immobilien ohne Koordinaten (nicht auf Karte sichtbar)"
    },
    "media": {
      "showArchive": "Auch gelöschte Bilder anzeigen",
      "archiveTitle": "Archiv ({{count}})",
      "archiveEmpty": "Keine gelöschten Bilder vorhanden.",
      "deletedOn": "Gelöscht am {{date}}",
      "restore": "Wiederherstellen",
      "restored": "Bild wiederhergestellt",
      "restoreError": "Wiederherstellung fehlgeschlagen",
      "teaserText": {
        "label": "Teaser-Kurztext",
        "placeholder": "z.B. Voll vermietete Liegenschaft mit stabilem Ertrag und Entwicklungsreserve ...",
        "hint": "Vor NDA sichtbar — keine Orte, keine Immo-Nr."
      }
    },
    "ownershipTypes": {
      "CORPORATE": "Firmeneigentum",
      "MULTIPLE": "Miteigentum",
      "SINGLE": "Alleineigentum",
      "TRUST": "Trust"
    },
    "price": "Preis",
    "propertyDetails": "Immobiliendetails",
    "quarantine": {
      "badge": "Standort fehlt",
      "banner": {
        "action": "Bitte Adressfelder manuell prüfen und ergänzen, dann speichern.",
        "description": "Der Standort konnte nicht automatisch ermittelt werden. Adressdaten (PLZ, Koordinaten, EGRID/EGID) fehlen.",
        "title": "KI-Extraktion unvollständig"
      }
    },
    "reject": "Ablehnen",
    "rejectReason": "Ablehnungsgrund",
    "rejected": "Immobilie wurde abgelehnt.",
    "removeRow": "Zeile entfernen",
    "rentRoll": {
      "ancillaryCostsChf": "Nebenkosten CHF",
      "areaSqm": "Fläche m²",
      "floor": "Etage",
      "netRentChf": "Nettomiete CHF",
      "nutzungsart": "Nutzungsart",
      "nutzungsartUnset": "Nicht gesetzt",
      "nutzungsartOptions": {
        "wohnung": "Wohnung",
        "gewerbe": "Gewerbe",
        "parkplatz": "Parkplatz",
        "werbeflaeche": "Werbefläche",
        "antenne": "Antenne",
        "sonstige": "Sonstige"
      },
      "rooms": "Zimmer",
      "status": "Status"
    },
    "rentalYield": "Mietrendite",
    "rooms": "Zimmer",
    "saveSuccess": "Immobilie erfolgreich gespeichert",
    "search": {
      "placeholder": "Suche nach Name, Stadt, Adresse..."
    },
    "sections": {
      "address": "Adresse",
      "buildingRight": "Baurecht",
      "calculations": "Kennzahlen",
      "classification": "Klassifizierung",
      "dealState": "Status & Deal-State",
      "dossierDocuments": "Dossier-Dokumente",
      "images": "Objektbilder",
      "land": "Grundstück",
      "objectDetails": "Objektdaten / Kennzahlen",
      "ownershipAndCadastre": "Eigentumsart & Kataster",
      "pricingTerms": "Preise & Konditionen",
      "salesTimeline": "Verkauf & Timeline",
      "sellerDesiredTerms": "Verkäufer-Wünsche",
      "statusLegal": "Status & Recht",
      "teaserHighlights": "Teaser-Highlights"
    },
    "states": {
      "CLOSED": "Abgeschlossen",
      "CLOSING": "Abschluss",
      "DUE_DILIGENCE": "Due Diligence",
      "IDENTIFIED": "Identifiziert",
      "NEGOTIATION": "In Verhandlung",
      "UNDER_CONTRACT": "Unter Vertrag"
    },
    "status": "Status",
    "statusChanged": "Status wurde geändert.",
    "statusDescriptions": {
      "ACTIVE": "Aktiv: Die Immobilie ist veröffentlicht und für Investoren sichtbar. Angebote können eingereicht werden.",
      "ARCHIVED": "Archiviert: Die Immobilie wurde deaktiviert und ist nicht mehr für Investoren sichtbar.",
      "DRAFT": "Entwurf: Die Immobilie wurde erfasst, aber noch nicht veröffentlicht. Sie ist nur für interne Mitarbeiter sichtbar und kann noch bearbeitet werden.",
      "PENDING": "Ausstehend: Die Immobilie wartet auf die Freigabe durch den Quality Gate. Alle Pflichtfelder und Dokumente müssen vollständig sein.",
      "SOLD": "Verkauft: Die Immobilie wurde erfolgreich vermittelt. Keine weiteren Angebote möglich."
    },
    "statuses": {
      "ACTIVE": "Aktiv",
      "ANALYSIS_DONE": "Analyse fertig — prüfen",
      "ANALYSIS_REQUESTED": "Analyse läuft",
      "ARCHIVED": "Archiviert",
      "DRAFT": "Entwurf",
      "PENDING": "Ausstehend",
      "SOLD": "Verkauft",
      "active": "Aktiv",
      "archived": "Archiviert",
      "draft": "Entwurf",
      "reserved": "Reserviert",
      "sold": "Verkauft",
      "IN_REVIEW": "In Prüfung"
    },
    "submitForReview": "Zur Prüfung einreichen",
    "submittedForReview": "Zur Prüfung eingereicht.",
    "subtitle": "Verwalten Sie Ihre Immobilien",
    "subtypes": {
      "AGRICULTURAL": "Landwirtschaftsland",
      "APARTMENT": "Wohnung / Stockwerkeigentum",
      "AUTO_REPAIR": "KFZ-Werkstatt",
      "CONDOMINIUM": "Eigentumswohnung",
      "DATA_CENTER": "Rechenzentrum",
      "DEVELOPMENT": "Bauland / Entwicklungsgrundstück",
      "FACTORY": "Fabrik / Produktionsstätte",
      "FITNESS_CENTER": "Fitnesscenter / Wellness",
      "GAS_STATION": "Tankstelle",
      "HOTEL": "Hotel",
      "LOGISTICS": "Logistikimmobilie",
      "MEDICAL_PRACTICE": "Arztpraxis / Gesundheitszentrum",
      "MIXED_COMMERCIAL": "Gemischte Gewerbefläche",
      "MULTI_FAMILY": "Mehrfamilienhaus",
      "OFFICE": "Büro",
      "PARKING": "Parkhaus / Parkplatz",
      "PRODUCTION": "Produktionsfläche",
      "RESTAURANT": "Restaurant / Gastronomie",
      "RETAIL": "Verkaufsfläche",
      "SHOWROOM": "Ausstellungsfläche / Showroom",
      "SINGLE_FAMILY": "Einfamilienhaus",
      "VILLA": "Villa",
      "WAREHOUSE": "Lager / Lagerhalle",
      "WORKSHOP": "Werkstatt / Handwerksbetrieb"
    },
    "tabs": {
      "basicData": "Basisdaten",
      "details": "Objektmerkmale",
      "legal": "Rechtliches",
      "media": "Medien & Marketing",
      "pricing": "Preis & Finanzen",
      "translations": "Übersetzungen"
    },
    "templates": {
      "deleted": "Vorlage gelöscht",
      "empty": "Keine Vorlagen gespeichert",
      "loaded": "Vorlage geladen",
      "namePrompt": "Name der Vorlage:",
      "saveAs": "Als Vorlage speichern...",
      "saved": "Vorlage gespeichert",
      "title": "Vorlagen"
    },
    "regenerateTexts": {
      "button": "Texte neu generieren",
      "error": "Textgenerierung fehlgeschlagen",
      "field": {
        "ariaLabel": "{{field}} neu generieren",
        "button": "Neu generieren",
        "description": "Optional eine Bemerkung angeben — es wird nur dieses Feld neu generiert (Sprache Deutsch).",
        "instructionLabel": "Bemerkung / Anweisung (optional)",
        "instructionPlaceholder": "z.B. kürzer halten, mehr auf Rendite fokussieren",
        "loading": "Wird generiert...",
        "submit": "Neu generieren",
        "success": "Feld wurde neu generiert",
        "title": "{{field}} neu generieren"
      },
      "hint": "Generiert Subheader, Highlights, Beschreibung sowie Makro- und Mikrolage per KI neu (Sprache Deutsch). Bestehende Texte werden überschrieben.",
      "loading": "Texte werden generiert...",
      "success": "Texte wurden neu generiert"
    },
    "title": "Immobilien",
    "translations": {
      "autoTranslate": "Auto-Übersetzen",
      "autoTranslateFailed": "Automatische Übersetzung fehlgeschlagen",
      "autoTranslateSuccess": "Übersetzungen wurden automatisch erstellt",
      "autoTranslating": "Übersetzungen werden erstellt...",
      "compareTo": "Vergleichen mit",
      "contentSection": "Inhalte",
      "hint": "Texte werden pro Sprache separat gespeichert. Füllen Sie eine Sprache aus und nutzen Sie die automatische Übersetzung für die weiteren Sprachen.",
      "locationSection": "Standortbeschreibung",
      "namePlaceholder": "z.B. Bürogebäude Zürich City",
      "noSourceContent": "Bitte füllen Sie zuerst mindestens den Titel oder die Beschreibung aus",
      "notFilled": "Nicht ausgefüllt",
      "outOfSync": "Die Master-Sprache ({{lang}}) wurde geändert. Die Übersetzungen sind möglicherweise nicht mehr aktuell.",
      "sideBySide": "Sprachen nebeneinander vergleichen",
      "sideBySideShort": "Vergleich",
      "subheaderPlaceholder": "z.B. Erstklassige Lage im Geschäftsviertel"
    },
    "type": "Typ",
    "types": {
      "COMMERCIAL": "Gewerbeimmobilie",
      "INDUSTRIAL": "Industrieimmobilie",
      "LAND": "Grundstück",
      "MIXED_USE": "Wohn / Gewerbe",
      "RESIDENTIAL": "Wohnimmobilie",
      "apartment": "Wohnung",
      "commercial": "Gewerbe",
      "house": "Haus",
      "land": "Grundstück",
      "office": "Büro",
      "retail": "Einzelhandel"
    },
    "unitMix": {
      "addRange": "Spanne",
      "area": "Fläche m²",
      "areaFrom": "Fläche m² von",
      "areaTo": "Fläche m² bis",
      "removeRange": "Spanne entfernen",
      "rentedCount": "Anzahl Vermietet",
      "rooms": "Zimmer",
      "totalCount": "Anzahl Total"
    },
    "validation": {
      "fixErrors": "Bitte füllen Sie alle Pflichtfelder aus",
      "required": "Pflichtfeld"
    },
    "unifiedWizard": {
      "advancedFields": "Erweiterte Angaben",
      "annualRentalIncome": "Jährliche Mieteinnahmen (CHF)",
      "anzahlEtagen": "Anzahl Etagen",
      "areas": "Flächen",
      "buildingCount": "Anzahl Gebäude",
      "cadastreNumber": "Grundbuch-Nummer",
      "commercialAreaSqm": "Gewerbefläche (m²)",
      "commercialUnits": "Gewerbeeinheiten",
      "create": "Immobilie erstellen",
      "createFailed": "Erstellung fehlgeschlagen",
      "createSuccess": "Immobilie erfolgreich erstellt",
      "detailedDescription": "Detailbeschreibung",
      "energyEnvelope": "Energieklasse Hülle",
      "energyTotal": "Energieklasse Gesamt",
      "garageParking": "Garagen-Parkplätze",
      "groundLeaseExpiration": "Baurecht Ablaufdatum",
      "hasBuildingPermit": "Baubewilligung vorhanden",
      "hasGroundLease": "Baurecht",
      "hasLift": "Aufzug vorhanden",
      "imageUploadFailed": "{{count}} von {{total}} Bildern konnten nicht hochgeladen werden",
      "internalFields": "Interne Angaben",
      "investmentHighlights": "Investment Highlights",
      "offerPrice": "Angebotspreis",
      "offerPriceHint": "Der Angebotspreis wird Investoren angezeigt.",
      "outdoorParking": "Aussen-Parkplätze",
      "ownershipType": "Eigentumsform",
      "principal": {
        "blockedHint": "Auftraggeber und Vermarktungsauftrag sind Pflicht, bevor Sie weitere Schritte bearbeiten können.",
        "contactCreateFailed": "Kontakt konnte nicht erstellt werden.",
        "contactCreated": "Kontakt erfolgreich erstellt",
        "contactHint": "Wählen Sie den bestehenden CRM-Kontakt aus oder erfassen Sie einen neuen Auftraggeber.",
        "contactLabel": "Auftraggeber (CRM-Kontakt)",
        "createNew": "Neuen Kontakt erfassen",
        "email": "E-Mail",
        "firstName": "Vorname",
        "lastName": "Nachname",
        "lastNameRequired": "Bitte Nachname erfassen",
        "optionalHint": "Auftraggeber ist optional. Sie können den Eintrag jederzeit über den Sticky Header der Bearbeitungsseite nachpflegen.",
        "ready": "Auftraggeber erfasst — Sie können fortfahren.",
        "saveContact": "Kontakt erstellen",
        "searchPlaceholder": "Kontakt suchen...",
        "subtitle": "Wer ist der Auftraggeber für die Vermarktung dieser Immobilie?"
      },
      "principalRequired": "Bitte zuerst Auftraggeber und Vermarktungsauftrag-Typ erfassen.",
      "renovation": "Renovation",
      "residentialAreaSqm": "Wohnfläche (m²)",
      "residentialUnits": "Wohneinheiten",
      "status": {
        "complete": "Vollständig",
        "incomplete": "Unvollständig",
        "neutral": "Optional"
      },
      "steps": {
        "aiUpload": "KI-Upload",
        "basicData": "Basisdaten",
        "details": "Objektmerkmale",
        "legal": "Rechtliches",
        "media": "Medien & Marketing",
        "pricing": "Preis & Vermarktung",
        "principal": "Auftraggeber",
        "summary": "Zusammenfassung"
      },
      "subtitle": "Erfassen Sie Ihre Immobilie in 8 Schritten",
      "summaryHint": "Prüfen Sie die Angaben und erstellen Sie die Immobilie.",
      "title": "Immobilie erfassen",
      "virtualTourUrl": "VR-Tour URL (optional)",
      "volumeM3": "Volumen (m³)"
    },
    "wizard": {
      "button": "Assistent",
      "create": "Immobilie erstellen",
      "descriptionPlaceholder": "Ausführliche Beschreibung der Immobilie...",
      "imagesCount": "Bilder",
      "investmentHighlightsPlaceholder": "z.B. Stabile Rendite von 4.5%, langfristige Mietverträge...",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB pro Bild",
      "photosHint": "Gute Bilder sind das wichtigste Verkaufsargument. Laden Sie aussagekräftige Fotos hoch.",
      "photosUpload": "Bilder hierher ziehen oder klicken zum Hochladen",
      "primaryImage": "Hauptbild",
      "steps": {
        "address": "Adresse",
        "classification": "Klassifizierung",
        "details": "Objektdaten",
        "land": "Grundstück",
        "photos": "Fotos",
        "pricing": "Preise",
        "summary": "Zusammenfassung",
        "teaser": "Teaser",
        "titleAddress": "Titel & Adresse",
        "type": "Typ"
      },
      "subtitle": "Schritt-für-Schritt-Assistent",
      "summaryHint": "Nach dem Erstellen können Sie die Immobilie im Detail bearbeiten, Dokumente hochladen und Übersetzungen ergänzen.",
      "teaserHighlightsPlaceholder": "z.B. Toplage in Zürich, frisch saniert, voll vermietet...",
      "teaserHint": "Beschreiben Sie die Immobilie für potenzielle Investoren. Diese Texte erscheinen auf dem Teaser.",
      "title": "Neue Immobilie erfassen",
      "virtualTourUrl": "VR-Tour URL (optional)"
    },
    "yearBuilt": "Baujahr",
    "yield": "Rendite",
    "activateProperty": "Immobilie aktivieren",
    "activateDescription": "Die Immobilie wird für Investoren sichtbar und kann in Angebotslisten (Listings) aufgenommen werden.",
    "activateChecklist": "Bitte stelle sicher, dass folgende Punkte erfüllt sind:",
    "activateCheck1": "Übersetzungen (Name, Beschreibung) vorhanden",
    "activateCheck2": "Mindestens ein Bild hochgeladen",
    "activateCheck3": "Mindestpreis gesetzt",
    "activateCheck4": "Adresse und Standort korrekt",
    "reviewSubmitted": "Immobilie zur Prüfung eingereicht",
    "ownerDraftHint": "Diese Immobilie ist noch nicht sichtbar für Investoren.",
    "ownerReviewHint": "Wird gerade vom Immotron-Team geprüft.",
    "ownerActiveHint": "Sichtbar für Investoren.",
    "saleMode": {
      "fixedPrice": "Fixpreis",
      "offerCollection": "Bieterverfahren"
    },
    "commissionConditions": {
      "title": "Konditionen",
      "hint": "Gilt für alle Käufer dieses Objekts, sofern kein individueller Anhang B besteht.",
      "currentModel": "Geltendes Honorarmodell",
      "noModel": "Kein Honorarmodell hinterlegt",
      "noModelOption": "Kein Honorarmodell — keine Objektkondition",
      "specialConditions": "Sonderkonditionen",
      "specialConditionsPlaceholder": "Abweichende Regelungen zu diesem Objekt, z. B. Provisionsteilung oder Mindesthonorar",
      "save": "Konditionen speichern",
      "saved": "Konditionen gespeichert",
      "saveFailed": "Konditionen konnten nicht gespeichert werden",
      "loading": "Konditionen werden geladen …",
      "loadFailed": "Konditionen konnten nicht geladen werden",
      "noneHint": "Keine Objektkondition. Es gilt pro Käufer: Satz aus seinem Rahmenvertrag, sonst Standard «{{model}}» — bei Käufervertrag «variabel» ist ohne Objektkondition nichts vereinbart.",
      "noneHintNoDefault": "Keine Objektkondition. Es gilt pro Käufer der Satz aus seinem Rahmenvertrag — bei Käufervertrag «variabel» ist ohne Objektkondition nichts vereinbart.",
      "blocked": {
        "no_contract": {
          "title": "Kein Rahmenvertrag verknüpft",
          "hint": "Objektkonditionen hängen am Rahmenvertrag des Auftraggebers. Zuerst den Vertrag erstellen oder verknüpfen, danach lassen sich die Konditionen setzen.",
          "cta": "Rahmenvertrag erstellen"
        },
        "unsupported_contract": {
          "title": "Objektkonditionen an diesem Vertrag nicht möglich",
          "hint": "Anhang B (Objektfreigabe) ist nur an einem Verkäufer-Rahmenvertrag vorgesehen. Bis dahin gilt die angezeigte Kondition."
        }
      }
    }
  },
  "propertyChat": {
    "askButton": "Frage stellen",
    "disclaimer": "KI-generiert — keine Rechtsberatung",
    "error": "Entschuldigung, ich konnte die Frage nicht beantworten. Bitte versuchen Sie es erneut.",
    "placeholder": "Frage eingeben...",
    "suggestion1": "Wie hoch ist die Rendite?",
    "suggestion2": "Beschreibe die Lage",
    "suggestion3": "Wann wurde es gebaut?",
    "title": "Fragen zum Objekt",
    "welcome": "Stellen Sie eine Frage zu diesem Objekt — z.B. zur Lage, Rendite oder Ausstattung."
  },
  "propertyDetail": {
    "approvalError": "Fehler bei der Genehmigung",
    "available": "Vorhanden",
    "buildingArea": "Gebäudefläche",
    "buyNow": "Jetzt kaufen",
    "description": "Beschreibung",
    "documents": "Dokumente",
    "documentsLocked": "Dokumente nach NDA-Freigabe verfügbar",
    "download": "Download",
    "downloadFailed": "Download fehlgeschlagen",
    "energyEnvelope": "Hülle",
    "energyTotal": "Gesamt",
    "financialMetrics": "Finanzielle Kennzahlen",
    "floors": "Stockwerke",
    "grossIncome": "Bruttomieteinnahmen",
    "imageCounter": "{{current}} / {{total}}",
    "investmentHighlights": "Investment Highlights",
    "investorActivity": {
      "interested": "{{count}} Investoren interessiert",
      "ndaConfirmed": "{{count}} NDA bestätigt"
    },
    "keyFigures": "Kennzahlen",
    "location": "Standort",
    "lotSize": "Grundstück",
    "ndaRequired": "NDA-Bestätigung erforderlich für Dokumentenzugriff",
    "noDocuments": "Keine Dokumente verfügbar",
    "noImages": "Keine Bilder verfügbar",
    "overview": "Übersicht",
    "parkingGarage": "Garage",
    "parkingOutdoor": "Aussen",
    "placeBid": "Gebot abgeben",
    "preview": "Vorschau",
    "priceLocked": "Preis nach NDA",
    "pricePerSqm": "Preis/m²",
    "rejectionError": "Fehler bei der Ablehnung",
    "rentalYield": "Rendite",
    "sections": {
      "details": "Details",
      "documents": "Dokumente",
      "financials": "Finanzen",
      "overview": "Übersicht",
      "timeline": "Timeline",
      "offers": "Angebot"
    },
    "submitError": "Fehler beim Einreichen",
    "submitOffer": "Angebot abgeben",
    "technicalDetails": "Technische Details",
    "title": "Objektdetails",
    "totalPrice": "Gesamtpreis",
    "units": "Einheiten",
    "uploadFailed": "Upload fehlgeschlagen",
    "yearBuilt": "Baujahr",
    "building": {
      "floors": "Stockwerke",
      "lift": "Aufzug",
      "heating": "Heizung",
      "energyTotal": "Energieklasse",
      "energyEnvelope": "Gebäudehülle",
      "condition": "Zustand",
      "renovation": "Renovierung",
      "residentialArea": "Wohnfläche",
      "commercialArea": "Gewerbefläche",
      "parking": "Parkplätze",
      "groundLease": "Baurecht",
      "title": "Gebäudedetails"
    },
    "investmentMetrics": "Investitionskennzahlen",
    "metrics": {
      "grossYield": "Bruttorendite",
      "vacancyRate": "Leerstand",
      "marketValue": "Marktwert"
    },
    "auftraggeber": {
      "title": "Auftraggeber",
      "subtitle": "Mit wem darf ich sprechen?",
      "openDrawer": "Auftraggeber-Details anzeigen",
      "statusActive": "Aktiver Vermarktungsauftrag",
      "statusExpired": "Vermarktungsauftrag abgelaufen",
      "statusNone": "Kein Vermarktungsauftrag",
      "ownMandate": "Eigenes Mandat (ausserhalb Immotron)",
      "ownMandateShort": "Eigenes Mandat",
      "ownMandateHint": "Der Verkaufsauftrag liegt ausserhalb der Plattform vor.",
      "company": "Firma",
      "companyMissing": "Firma noch nicht erfasst",
      "uid": "UID",
      "primaryContact": "Hauptansprechpartner",
      "contact": "Kontaktdaten",
      "noContact": "Keine Kontaktdaten hinterlegt. Bitte über \"Bearbeiten\" ergänzen.",
      "phoneMissing": "Telefon noch nicht erfasst",
      "emailMissing": "E-Mail noch nicht erfasst",
      "mandate": "Vermarktungsauftrag",
      "startDate": "Start",
      "endDate": "Ende",
      "minimumPrice": "Mindestpreis",
      "noMandate": "Noch keine Auftragsdaten hinterlegt.",
      "contract": "Vertragsdetails",
      "contractNumber": "Vertragsnummer",
      "contractType": "Typ",
      "signedAt": "Unterzeichnet",
      "expiresAt": "Läuft ab",
      "duration": "Laufzeit",
      "durationMonths": "{{count}} Monate",
      "openContract": "Vertrag öffnen",
      "commission": "Honorar",
      "commissionModel": "Modell",
      "commissionFlatRate": "Pauschale",
      "commissionBrackets": "Staffelung",
      "commissionBracketsCount": "{{count}} Stufen",
      "wishes": "Verkäufer-Wünsche & Notizen",
      "desiredPrice": "Wunschpreis",
      "desiredTimeline": "Wunsch-Zeitrahmen",
      "notes": "Anmerkungen",
      "noWishes": "Keine Wünsche oder Notizen erfasst.",
      "quickActions": "Quick-Actions",
      "actionCall": "Anrufen",
      "actionEmail": "E-Mail",
      "actionMeeting": "Termin",
      "actionEdit": "Bearbeiten",
      "comingSoon": "Bald verfügbar",
      "search": {
        "title": "Auftraggeber suchen",
        "subtitle": "Nur Firmen und Kontakte mit aktivem Plattformvertrag werden angezeigt.",
        "placeholder": "Firma, UID, Name oder E-Mail...",
        "hint": "Geben Sie mindestens 2 Zeichen ein, um zu suchen.",
        "empty": "Keine Treffer mit aktivem Plattformvertrag. Bitte zuerst einen Vermarktungsauftrag unterzeichnen.",
        "error": "Suche fehlgeschlagen. Bitte erneut versuchen.",
        "saveSuccess": "Auftraggeber gespeichert",
        "saveFailed": "Speichern fehlgeschlagen. Bitte erneut versuchen.",
        "clearSuccess": "Verknüpfung entfernt",
        "current": "Aktuelle Verknüpfung",
        "currentCompany": "Firma verknüpft",
        "currentContact": "Kontakt verknüpft",
        "unlink": "Entfernen",
        "typeCompany": "Firma",
        "typeContact": "Kontakt",
        "linked": "Aktiv",
        "noDetails": "Keine weiteren Details",
        "contractActive": "Vertrag aktiv",
        "contractActiveHint": "Plattformvertrag (SELLER_FRAMEWORK) ist unterzeichnet."
      }
    }
  },
  "publicHelp": {
    "badge": "Hilfe & Anleitung",
    "cta": {
      "button": "Jetzt anmelden",
      "subtitle": "Erstellen Sie Ihr Konto und entdecken Sie exklusive Immobilienangebote.",
      "title": "Bereit loszulegen?"
    },
    "faq": {
      "items": [
        {
          "a": "Für Investoren ist die Plattform kostenlos. Verkäufer und Vermittler zahlen ein erfolgsabhängiges Honorar beim Abschluss.",
          "q": "Ist die Nutzung von Immotron kostenlos?"
        },
        {
          "a": "Alle sensiblen Daten sind durch NDA-Vereinbarungen und rollenbasierte Zugriffskontrollen geschützt. Dokumente werden verschlüsselt gespeichert.",
          "q": "Wie werden meine Daten geschützt?"
        },
        {
          "a": "Nach der NDA erhalten Sie sofort Zugang zum vollständigen Dossier mit allen Details, der exakten Adresse und sämtlichen Finanzkennzahlen.",
          "q": "Was passiert nach der NDA-Bestätigung?"
        },
        {
          "a": "Ja, Immotron ist vollständig responsive und funktioniert auf allen Geräten — Desktop, Tablet und Smartphone.",
          "q": "Kann ich Immotron auf dem Handy nutzen?"
        },
        {
          "a": "Laden Sie ein PDF hoch und unsere KI erkennt automatisch Flächen, Mieteinnahmen, Baujahr und weitere Kennzahlen. Sie prüfen und bestätigen die Ergebnisse.",
          "q": "Wie funktioniert die KI-Datenextraktion?"
        },
        {
          "a": "Bei einer Bietrunde können mehrere Investoren innerhalb eines festgelegten Zeitraums Angebote abgeben. Der Verkäufer entscheidet anschliessend über den Zuschlag.",
          "q": "Was ist eine Bietrunde?"
        }
      ],
      "title": "Häufig gestellte Fragen"
    },
    "features": {
      "automated": {
        "desc": "KI-gestützte Datenextraktion, automatische E-Mails und intelligente Klausel-Vorschläge.",
        "title": "Automatisierte Workflows"
      },
      "digital": {
        "desc": "Vom ersten Kontakt bis zur Unterschrift — alles online, papierlos und nachvollziehbar.",
        "title": "100% digital"
      },
      "realtime": {
        "desc": "Push-Benachrichtigungen und E-Mail-Updates zu jedem wichtigen Schritt im Prozess.",
        "title": "Echtzeit-Benachrichtigungen"
      },
      "roles": {
        "desc": "Massgeschneiderte Ansichten für Investoren, Verkäufer, Sales-Teams und Administratoren.",
        "title": "Rollen für jeden Bedarf"
      },
      "secure": {
        "desc": "NDA-geschützte Dossiers, verschlüsselte Dokumente und rollenbasierte Zugriffskontrollen.",
        "title": "Sicher & vertraulich"
      },
      "title": "Warum Immotron?",
      "transparent": {
        "desc": "Exposé und Mieterspiegel mit allen relevanten Finanzdaten auf einen Blick.",
        "title": "Transparente Kennzahlen"
      }
    },
    "footer": "Alle Rechte vorbehalten",
    "hero": {
      "subtitle": "Immotron verbindet Immobilien-Investoren und -Verkäufer auf einer sicheren, digitalen Plattform. Hier erfahren Sie Schritt für Schritt, wie der Prozess abläuft.",
      "title": "So funktioniert Immotron"
    },
    "investor": {
      "steps": {
        "deal": {
          "desc": "Bei Zuschlag erhalten Sie den Vertragsentwurf zur digitalen Unterschrift. Der gesamte Prozess wird transparent auf der Timeline dokumentiert.",
          "title": "Vertragsabschluss"
        },
        "dossier": {
          "desc": "Das Dossier enthält Mieterspiegel, Exposé, Grundrisse, Fotos und alle relevanten Finanzkennzahlen — als Download oder Inline-Vorschau.",
          "title": "Vollständiges Dossier prüfen"
        },
        "nda": {
          "desc": "Interessiert? Bestätigen Sie die NDA digital, um Zugang zum vollständigen Dossier mit allen Details und der exakten Adresse zu erhalten.",
          "title": "Vertraulichkeitsvereinbarung (NDA)"
        },
        "offer": {
          "desc": "Geben Sie ein unverbindliches Angebot (NBO) oder ein bindendes Angebot (BO) ab. Bei Bietrunden sehen Sie den Zeitrahmen und können Ihr Angebot anpassen.",
          "title": "Angebot abgeben"
        },
        "search": {
          "desc": "Durchstöbern Sie verfügbare Anlageimmobilien mit Filtern nach Standort, Rendite, Objekttyp und Preisklasse. Die Kartenansicht zeigt Ihnen den ungefähren Standort.",
          "title": "Immobilien durchsuchen"
        },
        "teaser": {
          "desc": "Zu jedem Objekt gibt es ein anonymisiertes Teaser-Dossier mit Eckdaten, Fotos und Kennzahlen — ohne die genaue Adresse zu verraten.",
          "title": "Teaser-Dossier ansehen"
        }
      },
      "title": "Der Investoren-Prozess"
    },
    "login": "Anmelden",
    "seller": {
      "steps": {
        "contract": {
          "desc": "Erstellen Sie Kaufverträge direkt auf der Plattform mit unserem Vertrags-Wizard. Klauseln werden KI-unterstützt vorgeschlagen.",
          "title": "Vertragserstellung"
        },
        "matching": {
          "desc": "Immotron vermittelt Ihr Objekt gezielt an qualifizierte Investoren. Sie sehen in Echtzeit, wer Interesse zeigt und die NDA unterschrieben hat.",
          "title": "Investoren-Matching"
        },
        "review": {
          "desc": "Überprüfen Sie die KI-extrahierten Daten und ergänzen Sie fehlende Informationen. Ein Quality-Gate stellt sicher, dass alle Pflichtfelder ausgefüllt sind.",
          "title": "Daten prüfen & ergänzen"
        },
        "updates": {
          "desc": "Verfolgen Sie den gesamten Deal-Fortschritt auf der Timeline. Push-Benachrichtigungen halten Sie über jeden Schritt auf dem Laufenden.",
          "title": "Echtzeit-Updates"
        },
        "upload": {
          "desc": "Laden Sie Fotos und Dokumente hoch — unsere KI extrahiert automatisch die wichtigsten Daten wie Flächen, Mieteinnahmen und Baujahr.",
          "title": "Immobilie erfassen"
        }
      },
      "title": "Der Verkäufer-Prozess"
    },
    "tabs": {
      "investor": "Für Investoren",
      "seller": "Für Verkäufer"
    }
  },
  "onboarding": {
    "title": "Konto eröffnen",
    "intro": "Bitte prüfen Sie die uns vorliegenden Angaben. Stimmen sie, bestätigen Sie diese und gelangen direkt zur Vertragsunterzeichnung.",
    "footer": "Alle Rechte vorbehalten.",
    "loading": "Angaben werden geladen...",
    "validUntil": "Link gültig bis",
    "confirmHint": "Wenn alle Angaben korrekt sind, bestätigen Sie diese, um mit der Vertragsunterzeichnung fortzufahren.",
    "confirm": "Konto eröffnen →",
    "confirming": "Konto wird eröffnet …",
    "reportCorrection": "Korrektur melden",
    "legalNotice": "Mit der Bestätigung erklären Sie, dass die angezeigten Angaben korrekt sind.",
    "coSigner": {
      "title": "Zweite Unterschrift",
      "description": "Ihre Firma zeichnet kollektiv. Der Vertrag benötigt darum neben Ihrer Unterschrift eine zweite unterschriftsberechtigte Person.",
      "selectLabel": "Zweite unterschriftsberechtigte Person",
      "otherPerson": "Andere Person angeben",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "email": "E-Mail der zweiten Person",
      "emailPlaceholder": "name@firma.ch",
      "emailHint": "An diese Adresse senden wir den persönlichen Link zur Unterschrift.",
      "bothSignHint": "Beide Personen erhalten einen Link zur Unterschrift.",
      "required": "Bitte geben Sie die zweite unterschriftsberechtigte Person mit gültiger E-Mail-Adresse an.",
      "confirmedTitle": "Angaben bestätigt",
      "confirmedDescription": "Beide Personen erhalten einen Link zur Unterschrift. Sie können gleich jetzt unterschreiben.",
      "signatories": "Unterzeichnende",
      "signNow": "Jetzt unterschreiben"
    },
    "company": {
      "title": "Firmendaten",
      "name": "Firma",
      "uid": "UID",
      "address": "Adresse"
    },
    "person": {
      "title": "Ansprechperson",
      "name": "Name",
      "function": "Funktion"
    },
    "conditions": {
      "title": "Ihre Konditionen",
      "propertyHint": "Es geht um {{hint}}.",
      "contractGroup": "Vertrag",
      "feeGroup": "Honorar",
      "costLabel": "Kosten",
      "buyerCommission": "Käuferprovision (zahlen Sie)",
      "sellerCommission": "Verkäuferprovision (zahlt der Verkäufer)",
      "transparencyHint": "Immotron legt beide Provisionen offen — keine versteckten Kommissionen.",
      "matchHint": "Diese Konditionen stehen wortgleich im Vertrag, den Sie nach der Bestätigung zur Unterschrift erhalten.",
      "CONTRACT_TYPE_TEXT": "Vertrag",
      "COMMISSION_TEXT": "Provision"
    },
    "correction": {
      "title": "Korrektur melden",
      "description": "Bitte beschreiben Sie, welche Angaben nicht stimmen. Unser Team prüft Ihre Meldung und meldet sich bei Ihnen.",
      "label": "Ihre Korrektur",
      "placeholder": "Was muss korrigiert werden?",
      "submit": "Korrektur senden",
      "submitting": "Wird gesendet...",
      "cancel": "Abbrechen"
    },
    "correctionSent": {
      "title": "Meldung erhalten",
      "description": "Vielen Dank — wir prüfen die Angaben und senden Ihnen einen neuen Link.",
      "descriptionWithAdvisor": "Vielen Dank — Ihr Berater {{advisor}} prüft die Angaben und sendet Ihnen einen neuen Link.",
      "yourMessage": "Ihre Meldung",
      "quotedMessage": "„{{message}}“",
      "advisorContact": "Ihr Ansprechpartner"
    },
    "actions": {
      "home": "Zur Startseite",
      "close": "Fenster schliessen",
      "closeHint": "Ihr Browser lässt das automatische Schliessen nicht zu. Bitte schliessen Sie den Tab manuell."
    },
    "alreadyActive": {
      "title": "Bereits aktiv",
      "description": "Für Sie besteht bereits ein aktiver Vertrag. Sie können Ihre Verträge jederzeit in den Einstellungen einsehen."
    },
    "alreadyUsed": {
      "title": "Link bereits verwendet",
      "description": "Dieser Bestätigungslink wurde bereits verwendet. Bei Fragen wenden Sie sich bitte an Ihren Ansprechpartner."
    },
    "verificationFailed": {
      "title": "Bestätigung nicht möglich",
      "description": "Ihre Zeichnungsberechtigung konnte nicht automatisch bestätigt werden. Unser Team wurde informiert und meldet sich bei Ihnen."
    },
    "expired": {
      "title": "Link abgelaufen",
      "description": "Dieser Bestätigungslink ist leider abgelaufen. Bitte kontaktieren Sie Ihren Ansprechpartner für einen neuen Link."
    },
    "error": {
      "title": "Fehler",
      "generic": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      "invalidToken": "Ungültiger oder unbekannter Bestätigungslink.",
      "loadFailed": "Die Angaben konnten nicht geladen werden.",
      "confirmFailed": "Die Bestätigung konnte nicht verarbeitet werden. Bitte versuchen Sie es erneut.",
      "correctionFailed": "Die Korrektur konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
    },
    "welcome": "Willkommen, {{name}}",
    "invitedBy": "{{mandant}} lädt Sie ein, Immobilien auf Immotron anzuschauen.",
    "invitedGeneric": "Sie sind eingeladen, Immobilien auf Immotron anzuschauen.",
    "nextStep": "danach: kurz unterschreiben",
    "fullContract": "Vollständigen Vertrag anzeigen",
    "termsLink": "Nutzungsbedingungen lesen",
    "benefits": {
      "title": "Das bekommen Sie:",
      "account": "ein kostenloses Konto",
      "view": "Objekte ansehen und Unterlagen einsehen",
      "offer": "Angebote abgeben"
    },
    "cost": {
      "title": "Was kostet es?",
      "text": "Nichts. Nur wenn Sie ein Objekt kaufen, zahlen Sie eine Provision. Die Höhe sehen Sie bei jedem Objekt, bevor Sie Unterlagen öffnen."
    },
    "details": {
      "title": "Stimmen Ihre Angaben?",
      "change": "ändern"
    }
  },
  "publicProvider": {
    "offeredBy": "Angebot von",
    "contact": "Ihr Kontakt"
  },
  "publicTeaser": {
    "title": "Exklusive Investitionsmöglichkeit",
    "subtitle": "Eine erste Übersicht. Adresse, Dossier und alle Unterlagen sehen Sie, sobald Sie Ihr kostenloses Konto eröffnet haben.",
    "footer": "Alle Rechte vorbehalten.",
    "loading": "Teaser wird geladen...",
    "cta": {
      "loginTitle": "Sie haben bereits Zugang",
      "loginHint": "Melden Sie sich an, um das vollständige Dossier mit Adresse, Lage und allen Unterlagen einzusehen.",
      "loginButton": "Anmelden",
      "startTitle": "Konto eröffnen",
      "startHint": "Geben Sie Ihre E-Mail-Adresse ein — wir führen Sie direkt zur Kontoeröffnung und schalten danach Adresse, Lage und das komplette Objekt-Dossier frei.",
      "createAccountTitle": "Konto erstellen",
      "createAccountHint": "Um Adresse, Lage und das vollständige Dossier zu sehen, eröffnen Sie jetzt Ihr kostenloses Konto. Danach prüfen Sie Ihre Angaben und unterschreiben kurz online.",
      "createAccountButton": "Konto erstellen",
      "emailLabel": "E-Mail-Adresse",
      "emailHint": "Bitte geben Sie die E-Mail-Adresse ein, an die dieser Teaser gesendet wurde.",
      "emailInvalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
      "newHereToggle": "Ich bin neu hier",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "companyName": "Firma",
      "companyUid": "UID-Nummer",
      "continueButton": "Weiter zur Kontoeröffnung",
      "submitError": "Die Kontoeröffnung konnte nicht gestartet werden. Bitte versuchen Sie es später erneut.",
      "rateLimitError": "Zu viele Versuche. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
      "sentTitle": "Wir haben Ihnen den Link gesendet",
      "sentHint": "Wir haben Ihnen den Link zur Kontoeröffnung per E-Mail gesendet. Bitte prüfen Sie Ihren Posteingang.",
      "hasContractTitle": "Sie haben bereits ein Konto",
      "hasContractHint": "Für diese E-Mail-Adresse besteht bereits ein Konto. Melden Sie sich an, um das vollständige Dossier einzusehen."
    },
    "expired": {
      "title": "Link abgelaufen",
      "description": "Dieser Teaser-Link ist leider abgelaufen. Bitte kontaktieren Sie Ihren Ansprechpartner für einen neuen Link."
    },
    "error": {
      "title": "Teaser nicht gefunden",
      "description": "Dieser Link ist ungültig oder nicht mehr verfügbar. Bitte prüfen Sie den Link aus Ihrer E-Mail oder kontaktieren Sie Ihren Ansprechpartner."
    }
  },
  "publicSigning": {
    "accountLead": "Sie erhalten ein Konto, um Objekte anzusehen und Angebote abzugeben. Kosten nur beim Kauf.",
    "accountTitle": "Konto eröffnen: Unterschrift",
    "agb": {
      "accept": "Ich habe die Plattform-AGB der {{owner}} gelesen und akzeptiere sie.",
      "acceptWithMandant": "Ich habe die Plattform-AGB der {{owner}} und die ergänzenden Bedingungen der {{mandant}} gelesen und akzeptiere sie.",
      "description": "Die Plattform «Immotron» wird von der {{owner}} betrieben. Ihre Nutzungsbedingungen gelten ergänzend zu diesem Vertrag mit {{counterparty}}. Für Honorar und Konditionen geht der Vertrag vor.",
      "descriptionNoCounterparty": "Die Plattform «Immotron» wird von der {{owner}} betrieben. Ihre Nutzungsbedingungen gelten ergänzend zu diesem Vertrag. Für Honorar und Konditionen geht der Vertrag vor.",
      "mandantTerms": "Ergänzende Bedingungen der {{mandant}} ansehen",
      "modalTitle": "Plattform-Nutzungsbedingungen (AGB)",
      "requiredHint": "Bitte akzeptieren Sie die AGB, um den Vertrag unterschreiben zu können.",
      "title": "Plattform-Nutzungsbedingungen (AGB)",
      "viewAgb": "AGB der {{owner}} ansehen"
    },
    "authority": {
      "manual": "manuell verifiziert",
      "register": "Handelsregister-verifiziert",
      "signatureType": {
        "COLLECTIVE_MORE": "Kollektivunterschrift zu mehreren",
        "COLLECTIVE_TWO": "Kollektivunterschrift zu zweien",
        "NONE": "keine Zeichnungsberechtigung",
        "SINGLE": "Einzelunterschrift"
      },
      "unverified": "nicht verifiziert",
      "unverifiedHint": "Die Zeichnungsberechtigung wurde noch nicht gegen das Handelsregister geprüft. Mit Ihrer Unterschrift bestätigen Sie, dass Sie für {{company}} zeichnungsberechtigt sind.",
      "unverifiedHintGeneric": "Die Zeichnungsberechtigung wurde noch nicht gegen das Handelsregister geprüft. Mit Ihrer Unterschrift bestätigen Sie, dass Sie zur Unterzeichnung dieses Vertrags berechtigt sind."
    },
    "alreadySigned": {
      "countersignHint": "Ihre Unterschrift wurde erfasst. Der Vertrag wird derzeit von Immotron gegengezeichnet. Sobald dies erfolgt ist, werden Sie per E-Mail benachrichtigt und Ihr Konto wird aktiviert.",
      "countersignPending": "Gegenzeichnung ausstehend",
      "description": "Dieser Vertrag wurde von Ihnen bereits unterzeichnet.",
      "downloadPdf": "Vertrag als PDF herunterladen",
      "fullySigned": "Vertrag vollständig unterzeichnet",
      "fullySignedHint": "Alle Parteien haben unterzeichnet. Sie erhalten Ihre Kontozugangsdaten und können Ihre Verträge jederzeit unter Einstellungen einsehen.",
      "noActionNeeded": "Ihre Unterschrift ist gespeichert. Es ist keine weitere Handlung nötig.",
      "othersPending": "Weitere Unterschriften ausstehend",
      "othersPendingHint": "Ihre Unterschrift wurde erfasst. Sobald alle Parteien unterzeichnet haben, werden Sie per E-Mail über die nächsten Schritte informiert.",
      "signedAt": "Unterzeichnet am",
      "signedAtValue": "{{date}} um {{time}}",
      "title": "Sie haben bereits unterschrieben"
    },
    "backToSigning": "Zurück zur Unterzeichnung",
    "cancelled": {
      "description": "Eine Unterschrift ist nicht mehr möglich. Bei Fragen wenden Sie sich an Ihren Kontakt.",
      "title": "Dieser Vertrag wurde storniert"
    },
    "contractDetails": "Vertragsdetails",
    "contractNumber": "Vertragsnummer",
    "contractType": "Vertragsart",
    "downloadPdf": "PDF herunterladen",
    "error": {
      "generic": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
      "invalidToken": "Ungültiger oder unbekannter Unterzeichnungslink.",
      "kycRequired": "Bitte schliessen Sie zuerst Ihre Identifikation ab.",
      "loadFailed": "Der Vertrag konnte nicht geladen werden.",
      "submitFailed": "Die Unterschrift konnte nicht übermittelt werden. Bitte versuchen Sie es erneut.",
      "title": "Fehler"
    },
    "expired": {
      "description": "Dieser Unterzeichnungslink ist leider abgelaufen. Bitte kontaktieren Sie Ihren Ansprechpartner für einen neuen Link.",
      "title": "Link abgelaufen"
    },
    "footer": "Alle Rechte vorbehalten.",
    "geo": {
      "allow": "Standort freigeben",
      "description": "Für die rechtliche Dokumentation kann Ihr Standort erfasst werden. Dies ist optional.",
      "title": "Standortfreigabe"
    },
    "legalNotice": "Mit Ihrer Unterschrift bestätigen Sie, dass Sie den Vertrag gelesen und verstanden haben.",
    "loading": "Vertrag wird geladen...",
    "newTabHint": "Öffnet in neuem Tab",
    "otp": {
      "description": "Für diese Unterschrift ist zusätzlich ein Bestätigungscode nötig (fortgeschrittene elektronische Signatur).",
      "error": {
        "channelUnavailable": "Der Code konnte nicht zugestellt werden. Bitte kontaktieren Sie Ihren Ansprechpartner.",
        "cooldown": "Bitte kurz warten, bevor Sie einen neuen Code anfordern.",
        "expired": "Der Code ist abgelaufen — bitte neuen Code anfordern.",
        "invalid": "Der Code ist falsch.",
        "locked": "Zu viele Fehlversuche — bitte neuen Code anfordern.",
        "notRequired": "Für diese Unterschrift ist kein Bestätigungscode nötig.",
        "required": "Bitte zuerst den Code anfordern und eingeben.",
        "sendFailed": "Der Code konnte nicht gesendet werden. Bitte versuchen Sie es erneut."
      },
      "label": "6-stelliger Code",
      "requiredHint": "Bitte geben Sie den 6-stelligen Bestätigungscode ein.",
      "resend": "Code erneut senden",
      "resendIn": "Code erneut senden ({{seconds}} s)",
      "send": "Code senden",
      "sending": "Code wird gesendet ...",
      "sentHint": "Wir haben einen 6-stelligen Code an {{hint}} gesendet (gültig 5 Minuten).",
      "sentHintGeneric": "Wir haben Ihnen einen 6-stelligen Code gesendet (gültig 5 Minuten).",
      "title": "Bestätigungscode"
    },
    "parties": "Vertragsparteien",
    "partiesCompact": "Wer unterschreibt",
    "partyStatus": {
      "pending": "Ausstehend",
      "signed": "Signiert"
    },
    "pdfTitle": "Vertragsvorschau",
    "role": {
      "agent": "Bevollmächtigter",
      "broker": "Vermittlerin",
      "buyer": "Käufer",
      "companyRep": "Unternehmensvertreter",
      "label": "Rolle",
      "operator": "Betreiberin",
      "partner": "Partner",
      "seller": "Verkäufer",
      "user": "Benutzer"
    },
    "signatory": "Unterzeichner",
    "signatureLabel": "Unterschrift",
    "signatureTitle": "Ihre Unterschrift",
    "signedFor": "Unterschrieben für",
    "signingFor": "Sie unterschreiben für",
    "steps": {
      "agb": "Nutzungsbedingungen akzeptieren",
      "contract": "Vertrag ansehen",
      "otp": "Code eingeben",
      "sign": "Unterschreiben"
    },
    "submit": "Jetzt unterschreiben",
    "submitting": "Wird unterschrieben...",
    "success": {
      "contractNumber": "Vertragsnummer",
      "description": "Ihre Unterschrift wurde erfolgreich übermittelt. Sie erhalten eine Bestätigung per E-Mail.",
      "title": "Erfolgreich unterzeichnet!"
    },
    "title": "Vertragsunterzeichnung",
    "validUntil": "Gültig bis",
    "viewPdf": "Vertrag anzeigen",
    "youPrefix": "Sie:"
  },
  "qualityGate": {
    "buyerSuggestions": {
      "title": "KI-Käufervorschläge",
      "hint": "Von der KI vorgeschlagene Käufer, sortiert nach Eignung. Ausgewählte erhalten bei Freigabe Zugriff auf den Teaser.",
      "load": "Käufervorschläge laden",
      "reload": "Neu berechnen",
      "loading": "Vorschläge werden berechnet …",
      "loadFailed": "Käufervorschläge konnten nicht geladen werden",
      "retry": "Erneut versuchen",
      "empty": "Keine passenden Käufer gefunden",
      "fitScore": "Eignung: {{score}}%",
      "showReasoning": "Begründung anzeigen",
      "hideReasoning": "Begründung ausblenden",
      "summary": "{{count}} Käufer erhalten bei Freigabe Zugriff",
      "assign": "{{count}} Käufer zuordnen"
    },
    "address": "Adresse",
    "approve": "Freigeben",
    "approveConfirm": "Möchten Sie diese Immobilie wirklich freigeben?",
    "approveSuccess": "Immobilie erfolgreich freigegeben",
    "approvedAt": "Freigegeben am",
    "approvedTitle": "Qualitätsprüfung bestanden",
    "releaseInvitations": {
      "title": "E-Mails werden versendet",
      "description": "Mit der Freigabe erhalten {{count}} Käufer jetzt eine E-Mail mit Teaser und Onboarding-Link:",
      "noEmail": "Keine E-Mail hinterlegt — dieser Empfänger wird übersprungen.",
      "hint": "Vorsicht: Eine versendete E-Mail lässt sich nicht zurückholen.",
      "inviteTitle": "Einladung an neue Käufer",
      "accessTitle": "Zugangs-Mail an Käufer mit aktivem Vertrag",
      "groupTitle": "Zugangs-Mail an Gruppenmitglieder",
      "accessHint": "Diese Empfänger erhalten die Zugangs-Mail bei jeder Freigabe.",
      "approveAndSend": "Freigeben und senden",
      "approveOnly": "Nur freigeben",
      "approveWithoutInvitations": "Freigeben ohne Einladungen",
      "sentToast": "{{count}} Einladungen versendet",
      "notSentToast": "Nicht versendet an {{count}} Empfänger: {{names}}",
      "groupNotifiedToast_one": "Zugangs-Mail an {{names}} versendet",
      "groupNotifiedToast_other": "Zugangs-Mail an {{count}} Gruppenmitglieder versendet: {{names}}",
      "groupAlreadyToast_one": "1 Gruppenmitglied hatte bereits Zugang — keine neue Mail",
      "groupAlreadyToast_other": "{{count}} Gruppenmitglieder hatten bereits Zugang — keine neue Mail",
      "groupInvitedToast_one": "Einladung an {{names}} versendet",
      "groupInvitedToast_other": "Einladung an {{count}} Gruppenmitglieder versendet: {{names}}",
      "groupInviteFailedToast": "Einladung nicht versendet an {{names}}"
    },
    "checkpoints": {
      "canton": "Kanton angegeben",
      "city": "Ort angegeben",
      "contractSigned": "Vertrag unterzeichnet",
      "description": "Beschreibung geprüft",
      "documents": "Dokumente vollständig",
      "images": "Mindestens 1 Bild hochgeladen",
      "minimumPrice": "Mindestpreis festgelegt",
      "minimumPricePositive": "Mindestpreis grösser als 0",
      "pricing": "Preis festgelegt",
      "propertyType": "Immobilientyp festgelegt",
      "requiredFields": "Pflichtfelder ausgefüllt",
      "translations": "Mindestens 1 Übersetzung vorhanden"
    },
    "autoCheckTitle": "Automatische Prüf-Checkliste",
    "autoCheckHint": "Diese Punkte werden automatisch aus den Immobilien-Daten geprüft.",
    "autoChecks": {
      "required_fields": "Pflichtfelder ausgefüllt",
      "images": "Mindestens 3 Bilder hochgeladen",
      "description": "Beschreibung vorhanden",
      "pricing": "Preis hinterlegt",
      "documents": "Dokumente hochgeladen",
      "highlights": "Investment-Highlights vorhanden",
      "location": "Lage-Beschreibung vorhanden",
      "contract_signed": "Vermarktungsvertrag unterzeichnet"
    },
    "cannotApproveYet": "Genehmigung erst möglich, wenn alle Pflichtpunkte grün sind.",
    "approveBlocked": {
      "title": "Freigabe noch nicht möglich — diese Pflichtpunkte sind offen:"
    },
    "optional": "Optional",
    "pendingReviews": "{{count}} zur Prüfung",
    "morePropertiesPending": "{{count}} weitere Immobilien zur Prüfung — auswählen, um zu wechseln.",
    "selectAnother": "Andere Immobilie auswählen",
    "selectProperty": "Immobilie auswählen",
    "selectPropertyHint": "Wählen Sie links eine Immobilie aus, um die Vorschau und Prüf-Checkliste anzuzeigen.",
    "teaserPreview": "Investor-Vorschau",
    "teaserPreviewHint": "So sieht die Immobilie aus Investorensicht aus",
    "discretion": {
      "title": "Diskretion vor NDA",
      "none": "Keine Identitätsmerkmale im Teaser",
      "edit": "Teaser-Texte bearbeiten"
    },
    "newsletterPreview": {
      "description": "So wird dieser Teaser als E-Mail/Newsletter versendet — die Vorschau entspricht exakt der versendeten E-Mail.",
      "teaserImages": "{{count}} Teaser-Bilder",
      "hiddenImages": "{{count}} erst nach NDA sichtbar",
      "locationConfirm": "Standortkritische Bilder bewusst für den Teaser freigeben",
      "blocked": "Versand gesperrt — bitte zuerst die folgenden Hinweise beheben:",
      "refresh": "Aktualisieren",
      "loadFailed": "Newsletter-Vorschau konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "iframeTitle": "Newsletter-Vorschau als E-Mail",
      "empty": "Keine Newsletter-Vorschau verfügbar."
    },
    "contractNotSigned": "Kein unterzeichneter Vertrag vorhanden",
    "decideFailed": "Entscheidung konnte nicht gespeichert werden",
    "empty": "Keine Immobilien zur Prüfung",
    "emptyHint": "Neue Einreichungen erscheinen hier automatisch",
    "images": "{{count}} Bilder",
    "imagesNone": "Keine Bilder",
    "investorGroups": {
      "createNew": "Neue Gruppe erstellen",
      "empty": "Noch keine Investorengruppen vorhanden",
      "hint": "Diese Gruppen erhalten bei Freigabe automatisch Zugriff auf den Teaser.",
      "loadFailed": "Investorengruppen konnten nicht geladen werden",
      "summary": "{{investors}} Investoren aus {{groups}} Gruppen erhalten Zugriff",
      "summaryPersons": "{{persons}} Personen aus {{groups}} Gruppen erhalten Zugriff",
      "title": "Investorengruppen",
      "showMembers": "Mitglieder von {{name}} anzeigen",
      "hideMembers": "Mitglieder von {{name}} ausblenden",
      "noMembers": "Keine Mitglieder vorhanden",
      "unknownMember": "Unbekanntes Mitglied",
      "assign": "{{count}} Gruppe(n) zuordnen",
      "coversGroups": "Gilt auch für die Mitglieder der angehakten Investorengruppen.",
      "missingHint": "Mitglieder gewählter Investorengruppen: Die Objektkondition über «Für alle festlegen» deckt jedes Mitglied ohne eigene Kondition ab."
    },
    "loadFailed": "Prüfliste konnte nicht geladen werden",
    "owner": "Eigentümer",
    "previewFailed": "Vorschau konnte nicht geladen werden",
    "previewListing": "Käufer-Vorschau",
    "price": "Preis",
    "progress": "{{checked}}/{{total}} Prüfpunkte",
    "propertyDetails": "Immobilien-Details",
    "readOnlyAfterApproval": "Diese Immobilie wurde freigegeben und kann nicht mehr bearbeitet werden.",
    "readOnlyHint": "Diese Immobilie wurde freigegeben und kann nur noch von einem Administrator bearbeitet werden.",
    "reject": "Ablehnen",
    "rejectReason": "Begründung (Pflichtfeld)",
    "rejectReasonPlaceholder": "Bitte geben Sie den Grund für die Ablehnung an...",
    "rejectSuccess": "Immobilie abgelehnt",
    "required": "Pflicht",
    "reviewChecklist": "Prüf-Checkliste",
    "sellerContract": {
      "active": "Vertrag aktiv",
      "activeSince": "Vertrag aktiv seit {{date}}",
      "changeContract": "Vertrag ändern",
      "commission": "Kondition",
      "contractNumber": "Vertragsnummer",
      "expiresAt": "Läuft ab am {{date}}",
      "hideDetails": "Details ausblenden",
      "noActive": "Kein aktiver Plattformvertrag",
      "noActiveHint": "Diese Immobilie kann nicht freigegeben werden, solange der Verkäufer keinen unterzeichneten Plattformvertrag hat.",
      "openContract": "Vertrag öffnen",
      "ownMandate": "Eigenes Mandat (ausserhalb Immotron)",
      "principal": "Auftraggeber",
      "searchContract": "Vertrag suchen",
      "showDetails": "Details anzeigen",
      "signatoryTypes": {
        "BUYER": "Käufer",
        "PLATFORM": "Plattform",
        "SELLER": "Verkäufer",
        "WITNESS": "Zeuge"
      },
      "signedBy": "Unterzeichnet von",
      "title": "Verkäufer-Vertrag"
    },
    "statuses": {
      "ACTIVE": "Aktiv",
      "APPROVED": "Freigegeben",
      "DRAFT": "Entwurf",
      "IN_REVIEW": "In Prüfung",
      "REJECTED": "Abgelehnt"
    },
    "submittedAt": "Eingereicht am {{date}}",
    "subtitle": "Immobilien-Freigabe",
    "timeline": {
      "boDays": "BO-Phase (Tage)",
      "boPhase": "BO-Phase",
      "boReviewDays": "BO-Review (Tage)",
      "boReviewPhase": "BO-Review",
      "days": "Tage",
      "excludeLowestNbo": "Tiefstes NBO von BO ausschliessen",
      "excludeLowestNboHint": "Wenn aktiviert, wird das tiefste NBO-Angebot bei der Auswahl der BO-Kandidaten nicht berücksichtigt.",
      "durationPresetDays_one": "{{count}} Tag",
      "durationPresetDays_other": "{{count}} Tage",
      "durationPresets": "Schnellauswahl Laufzeit",
      "endDate": "Enddatum",
      "fixedPrice": "Fixpreis",
      "fixedPriceInfo": "Angebotspreis",
      "fixedPriceLabel": "Verkaufspreis",
      "guidePrice": "Richtpreis",
      "nboDays": "NBO-Phase (Tage)",
      "nboPhase": "NBO-Phase",
      "nboReviewDays": "NBO-Review (Tage)",
      "nboReviewPhase": "NBO-Review",
      "offerCollection": "Bieterverfahren",
      "preview": "Timeline-Vorschau",
      "reservePrice": "Mindestpreis",
      "reservePriceHint": "Intern. Wird Investoren nicht angezeigt.",
      "saleMode": "Verkaufsmodus",
      "startDate": "Startdatum",
      "submissionDays": "Einreichfrist (Tage)",
      "submissionPhase": "Einreichfrist",
      "title": "Verkaufskonfiguration",
      "totalDuration": "Gesamtdauer"
    },
    "title": "Quality Gate",
    "translations": "{{count}} Sprachen",
    "translationsNone": "Keine Übersetzungen",
    "viewProperty": "Immobilie bearbeiten",
    "zefix": {
      "autoLookup": "Verkäufer-Daten werden geladen...",
      "contractActive": "Vertrag aktiv",
      "contractActiveSince": "Vertrag aktiv seit {{date}}",
      "contractNumber": "Vertragsnummer",
      "expiresAt": "Läuft ab am {{date}}",
      "importContacts": "{{count}} Personen ins CRM übernehmen",
      "importDone": "{{count}} Kontakte wurden ins CRM übernommen",
      "importFailed": "Kontakte konnten nicht importiert werden",
      "importSuccess": "{{count}} Kontakte erfolgreich ins CRM übernommen",
      "imported": "Importiert",
      "importing": "Wird importiert...",
      "legalForm": "Rechtsform",
      "lookupFailed": "Verkäufer-Daten konnten nicht geladen werden",
      "noActiveContract": "Kein aktiver Verkäufer-Vertrag",
      "noActiveContractHint": "Im Quality Gate werden hier nur Verkäufer mit aktivem Plattformvertrag angezeigt. Bitte zuerst einen Vertrag erfassen und unterzeichnen lassen.",
      "noPersons": "Keine Zeichnungsberechtigten gefunden",
      "noPersonsHint": "Die SHAB-Daten für diese Firma sind nicht verfügbar. Bitte Zeichnungsberechtigte manuell im CRM erfassen.",
      "noUidActive": "Die zugeordnete Firma «{{company}}» hat keine UID. Zeichnungsberechtigte können nicht aus dem Handelsregister geladen werden.",
      "openContract": "Vertrag öffnen",
      "registeredPersons": "Zeichnungsberechtigte Personen (ZEFIX)",
      "signedBy": "Unterzeichnet von",
      "title": "Verkäufer-Handelsregister",
      "unknownSeller": "Unbekannter Verkäufer"
    },
    "personSearch": {
      "title": "Personen-Suche",
      "hint": "CRM-Kontakte oder Firmen manuell als Käufer zuordnen. Die Klassifizierung erscheint sofort: aktiv oder Onboarding nötig."
    },
    "buyerConditions": {
      "setForAll": "Für alle festlegen",
      "setForBuyer": "Für diesen Käufer festlegen",
      "setForBuyerAria": "Kondition für {{name}} festlegen",
      "savedForBuyer": "Kondition für {{name}} festgelegt",
      "modelRequired": "Für eine käuferindividuelle Kondition ist ein Honorarmodell erforderlich.",
      "dialogTitle": "Konditionen für alle festlegen",
      "dialogHint": "Die festgelegte Kondition wird als Anhang B zum Objekt gespeichert und gilt für alle zugeordneten Käufer dieses Objekts, die keine eigene Kondition haben.",
      "dialogTitleBuyer": "Kondition für {{name}} festlegen",
      "dialogHintBuyer": "Dieser Käufer hat einen Rahmenvertrag (variabel). Die Kondition gilt nur für dieses Objekt und wird als Anhang B zu seinem Käufer-Rahmenvertrag festgehalten.",
      "buyerObjectCondition": "Objektkondition dieses Objekts: {{model}}.",
      "buyerNoObjectCondition": "Für dieses Objekt sind keine Objektkonditionen hinterlegt.",
      "setPlannedForBuyer": "Geplante Kondition festlegen",
      "setPlannedForBuyerAria": "Geplante Kondition für {{name}} festlegen",
      "plannedSpecialCondition": "Sonderkondition",
      "plannedNoModel": "Keine Angabe — es gilt die Objektkondition ({{model}})",
      "plannedNoModelMissing": "Keine Angabe — ACHTUNG: dieses Objekt hat keine Objektkondition",
      "plannedNoObjectCondition": "Für dieses Objekt ist keine Objektkondition hinterlegt: Ohne eigenes Honorarmodell gilt für diesen Käufer nach seiner Unterschrift gar keine Kondition.",
      "plannedSetObjectCondition": "Objektkondition hinterlegen",
      "dialogTitlePlanned": "Geplante Kondition für {{name}} festlegen",
      "dialogHintPlanned": "Dieser Käufer hat noch keinen Rahmenvertrag. Ohne eigenes Honorarmodell gilt für ihn die Objektkondition dieses Objekts. Mit Honorarmodell bekommt er für dieses Objekt eine eigene Kondition — sie wird an seiner Zuordnung vorgemerkt und nach seiner Unterschrift automatisch als Anhang B übernommen.",
      "emailLabel": "E-Mail des Käufers",
      "emailRequired": "Für diesen Käufer ist keine E-Mail-Adresse hinterlegt — ohne sie geht keine Einladung raus. Bitte jetzt nachtragen."
    },
    "conditionObjections": {
      "title": "Offene Einwände zu Konditionen",
      "hint": "Käufer, die die Objektkondition abgelehnt und einen anderen Satz vorgeschlagen haben.",
      "property": "Objekt",
      "unknownProperty": "Objekt #{{id}}",
      "unknownPerson": "Unbekannte Person",
      "proposedRate": "Gewünschter Satz",
      "noRate": "Kein Satz genannt",
      "reason": "Begründung",
      "date": "Eingegangen",
      "accept": "Annehmen",
      "acceptHint": "Der vereinbarte Satz wird als Anhang B zum Objekt festgehalten.",
      "agreedRateLabel": "Vereinbarter Satz (%)",
      "acceptConfirm": "Annehmen",
      "accepted": "Einwand angenommen — Anhang B mit dem vereinbarten Satz erstellt.",
      "acceptFailed": "Der Einwand konnte nicht angenommen werden.",
      "reject": "Ablehnen",
      "rejectHint": "Die Begründung wird dem Käufer zugestellt.",
      "rejectReasonLabel": "Begründung",
      "rejectReasonPlaceholder": "Warum wird der Gegenvorschlag abgelehnt?",
      "rejectConfirm": "Ablehnen",
      "rejected": "Einwand abgelehnt — der Käufer wurde informiert.",
      "rejectFailed": "Der Einwand konnte nicht abgelehnt werden."
    }
  },
  "researchLeads": {
    "actions": {
      "approve": "Freigeben",
      "autoMatch": "Auto-Match",
      "import": "Importieren",
      "reject": "Ablehnen",
      "website": "Website"
    },
    "allProjects": "Alle Projekte",
    "batchMatch": "Auto-Match alle",
    "deleteTitle": "Lead löschen",
    "detail": {
      "assessment": "Bewertung",
      "businessModel": "Geschäftsmodell",
      "company": "Firma",
      "companyMatch": "Firma-Match",
      "contact": "Kontakt",
      "contactMatch": "Kontakt-Match",
      "created": "Erstellt",
      "email": "E-Mail",
      "employees": "Mitarbeiter",
      "industry": "Branche",
      "linkedin": "LinkedIn",
      "location": "Standort",
      "matching": "Matching",
      "nextSteps": "Nächste Schritte",
      "phone": "Telefon",
      "position": "Position",
      "profile": "Profil",
      "revenue": "Umsatz",
      "source": "Quelle"
    },
    "empty": "Keine Leads gefunden",
    "reject": "Ablehnen",
    "rejectPlaceholder": "Grund für die Ablehnung...",
    "rejectTitle": "Lead ablehnen",
    "searchPlaceholder": "Firma oder Kontakt suchen...",
    "stats": {
      "approved": "Freigegeben",
      "imported": "Importiert",
      "matched": "Gematcht",
      "new": "Neu",
      "rejected": "Abgelehnt",
      "review": "Review",
      "total": "Gesamt"
    },
    "subtitle": "Staging-Bereich für recherchierte Leads",
    "table": {
      "companyContact": "Firma / Kontakt",
      "match": "Match",
      "project": "Projekt",
      "score": "Score",
      "status": "Status",
      "type": "Typ"
    },
    "title": "Recherche-Leads",
    "toast": {
      "approveError": "Fehler bei Freigabe",
      "approved": "Lead freigegeben",
      "batchError": "Batch-Matching fehlgeschlagen",
      "deleteError": "Fehler beim Löschen",
      "deleted": "Lead gelöscht",
      "importError": "Import fehlgeschlagen",
      "matchError": "Matching fehlgeschlagen",
      "noMatch": "Kein Match gefunden",
      "rejectError": "Fehler beim Ablehnen",
      "rejected": "Lead abgelehnt"
    }
  },
  "researchPanel": {
    "adoptContacts": "Kontakte übernehmen",
    "cardAddContact": "Als Kontakt anlegen",
    "cardAddContactHint": "Als Kontakt anlegen (bald verfügbar)",
    "cardAddOrg": "Als Organisation anlegen",
    "cardAddOrgHint": "Als Organisation anlegen (bald verfügbar)",
    "cardPin": "Pinnen",
    "cardPinHint": "Als relevant pinnen (bald verfügbar)",
    "cardShowLess": "Weniger anzeigen",
    "cardShowMore": "Mehr anzeigen",
    "connections": "Netzwerk & Verbindungen",
    "existingCrmCompanies": "Bestehende CRM-Firmen",
    "existingCrmContacts": "Bestehende CRM-Kontakte",
    "foundContacts": "Gefundene Kontakte",
    "merge": "Zusammenführen",
    "mergeButtonEnrich": "Zusammenführen & Ergänzen",
    "mergeButtonLink": "Bestehenden verwenden",
    "mergeCompanyTitle": "Firma zusammenführen",
    "mergeContactTitle": "Kontakt zusammenführen",
    "mergeDraft": "Recherche",
    "mergeError": "Fehler beim Zusammenführen",
    "mergeExisting": "Bestand (CRM)",
    "mergeField": "Feld",
    "mergeLoadError": "Fehler beim Laden des Datensatzes",
    "mergeLoading": "Lade Vergleichsdaten...",
    "mergeSubtitle": "Recherche-Daten mit bestehendem Eintrag abgleichen",
    "mergeWhatHappens": "Was passiert?",
    "internEmpty": "Keine internen CRM-Treffer. Die Recherche hat keine bestehenden Kontakte oder Organisationen gefunden.",
    "noContacts": "Keine Kontakte in der Recherche gefunden.",
    "overview": "Übersicht",
    "personProfile": "Profil",
    "pinnedSection": "Gepinnt ({{count}})",
    "resultsCount": "{{count}} Ergebnis(se)",
    "searchingCrm": "Suche bestehende CRM-Einträge...",
    "tabExtern": "Extern",
    "tabIntern": "Intern",
    "tabsLabel": "Recherche-Bereiche",
    "unnamed": "Unbenannt",
    "unnamedQuery": "Recherche",
    "unpin": "Pin entfernen"
  },
  "roles": {
    "admin": "Administrator",
    "developer": "Entwickler",
    "investor": "Investor",
    "sales": "Verkauf"
  },
  "schema": {
    "columns": "Spalten",
    "primaryKeys": "Primary Keys",
    "relationships": "Beziehungen",
    "subtitle": "Entity Relationship Diagram (ERD)",
    "tableList": "Tabellen-Übersicht",
    "tables": "Tabellen",
    "title": "Datenbank Schema"
  },
  "seller": {
    "counts": {
      "bo": "BO",
      "interested": "Interessenten",
      "nbo": "NBO",
      "nda": "NDA"
    },
    "detail": {
      "address": "Adresse",
      "aiHints": "KI-Hinweise",
      "allDetails": "Alle Objektdaten",
      "confidence": "KI-Konfidenz",
      "description": "Beschreibung",
      "downloadFailed": "Download fehlgeschlagen",
      "engagement": "Investoren-Engagement",
      "engagementHint": "Detaillierte Statistiken werden laufend aktualisiert.",
      "grossYield": "Bruttorendite",
      "investmentMetrics": "Investment-Kennzahlen",
      "loadFailed": "Immobilie konnte nicht geladen werden",
      "location": "Standort",
      "noDocuments": "Noch keine Dokumente. Laden Sie relevante Unterlagen hoch (Grundbuchauszug, Mieterspiegel, etc.).",
      "pricePerSqm": "Preis/m²",
      "pricePerSqmLand": "Preis/m² Grundstück",
      "reviewHint": "Sobald alle Angaben vollständig sind, reichen Sie Ihre Immobilie zur Prüfung ein. Unser Team prüft die Daten und schaltet das Inserat frei.",
      "submitFailed": "Einreichen fehlgeschlagen. Bitte erneut versuchen.",
      "submitReview": "Zur Prüfung einreichen",
      "submitTitle": "Bereit zur Prüfung?",
      "submitting": "Wird eingereicht…",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "myProperties": {
      "addProperty": "Immobilie erstellen",
      "clearFilter": "Filter zurücksetzen",
      "empty": "Keine Immobilien vorhanden",
      "emptyHint": "Sie haben noch keine Immobilien erstellt.",
      "filterActive": "Gefiltert nach: {{status}}",
      "loadFailed": "Immobilien konnten nicht geladen werden",
      "noResultsForFilter": "Keine Immobilien für diesen Filter",
      "noResultsForFilterHint": "Es gibt keine Immobilien mit diesem Status.",
      "subtitle": "Ihre Immobilien im Überblick",
      "title": "Meine Immobilien"
    },
    "wizard": {
      "aiAnalyze": "KI-Analyse starten",
      "aiComplete": "Analyse abgeschlossen",
      "aiCompleteHint": "Die erkannten Daten wurden in den Wizard übernommen. Prüfen und ergänzen Sie die Angaben.",
      "aiPrefillSuccess": "Daten von KI übernommen — bitte prüfen und ergänzen.",
      "aiPrefilled": "Von KI vorausgefüllt — bitte prüfen",
      "aiProcessing": "KI analysiert Ihre Dokumente...",
      "aiProcessingFailed": "KI-Verarbeitung fehlgeschlagen",
      "aiProcessingWait": "Dies kann 1-2 Minuten dauern.",
      "aiSkip": "Ohne KI-Analyse fortfahren",
      "aiUploadDrop": "PDF-Dokumente oder Bilder hierher ziehen",
      "aiUploadFailed": "KI-Upload fehlgeschlagen",
      "aiUploadFormats": "PDF, JPG, PNG, WebP — max. 50 MB pro Datei",
      "aiUploadHint": "Laden Sie die relevanten Dateien hoch: aktueller Mieterspiegel, Baubeschrieb, Grundbuchauszug, Gebäudeversicherungsnachweis, Marktwertschätzungen (Wüest Partner, Fahrländer etc.) — die KI füllt den Wizard automatisch aus.",
      "classificationHint": "Wählen Sie den Typ und ggf. Subtyp Ihrer Immobilie.",
      "contractDeadlineHint": "Bitte beachten Sie: Der Vertrag hat ein Ablaufdatum. Planen Sie genügend Zeit für die Transaktion ein.",
      "create": "Immobilie erstellen",
      "createFailed": "Erstellung fehlgeschlagen",
      "createSuccess": "Immobilie erfolgreich erstellt",
      "desiredPrice": "Wunschpreis / Richtpreis",
      "desiredPriceHint": "Ihr Wunschpreis — unverbindlich, wird nicht veröffentlicht",
      "desiredPricePlaceholder": "z.B. 1'800'000",
      "desiredTimeline": "Gewünschte Timeline",
      "desiredTimelineHint": "Wann möchten Sie idealerweise verkaufen?",
      "desiredTimelinePlaceholder": "z.B. Verkauf bis Q3 2026, flexibel ab sofort",
      "expectedPrice": "Preisvorstellung (CHF)",
      "highlights": "Highlights",
      "highlightsHint": "Diese Punkte erscheinen prominent auf dem Teaser für Investoren.",
      "highlightsPlaceholder": "z.B. Toplage in Zürich, frisch saniert, voll vermietet, stabile Rendite...",
      "imagesCount": "Bilder",
      "namePlaceholder": "z.B. Mehrfamilienhaus Zürich-Seefeld",
      "photosFormats": "JPG, PNG, WEBP — max. 20 MB pro Bild",
      "photosHint": "Gute Bilder verkaufen! Laden Sie aussagekräftige Fotos Ihrer Immobilie hoch.",
      "photosUpload": "Bilder hierher ziehen oder klicken",
      "primaryImage": "Hauptbild",
      "saleEndDate": "Gewünschtes Verkaufsende",
      "saleStartDate": "Gewünschter Verkaufsstart",
      "sellerNotes": "Anmerkungen",
      "sellerNotesPlaceholder": "z.B. Besondere Umstände, Vertragslaufzeit, gewünschte Bedingungen...",
      "steps": {
        "aiUpload": "KI-Analyse",
        "classification": "Objekttyp",
        "details": "Objektdaten",
        "photos": "Fotos",
        "pricing": "Eckdaten",
        "summary": "Zusammenfassung",
        "titleAddress": "Titel & Adresse"
      },
      "subtitle": "Erfassen Sie Ihre Immobilie in wenigen Schritten",
      "summaryHint": "Nach der Erstellung wird unser Vertriebsteam Ihre Immobilie prüfen und Sie kontaktieren.",
      "timeline": "Zeitraum",
      "title": "Immobilie erstellen"
    }
  },
  "settings": {
    "ai": "KI-Assistent",
    "aiConfig": {
      "configured": "Konfiguriert",
      "currentKey": "Aktueller Key",
      "enterKey": "Bitte API Key eingeben",
      "notConfigured": "Nicht konfiguriert",
      "replaceKey": "API Key ersetzen",
      "saveFailed": "Fehler beim Speichern",
      "saved": "API Key gespeichert",
      "setKey": "API Key setzen",
      "status": "Status",
      "testConnection": "Verbindung testen",
      "testFailed": "Verbindung fehlgeschlagen",
      "testSuccess": "Verbindung erfolgreich ({{model}}, {{duration}}s)",
      "testing": "Teste...",
      "title": "Claude AI"
    },
    "aiDescription": "Claude AI Testumgebung",
    "apiTokens": {
      "confirmRevoke": "Wirklich widerrufen?",
      "create": "Neuer Token",
      "createError": "Token konnte nicht erstellt werden.",
      "createdTitle": "Token erfolgreich erstellt",
      "createdWarning": "Kopieren Sie den Token jetzt — er wird nicht erneut angezeigt.",
      "description": "Erstellen Sie persistente API-Tokens für Machine-to-Machine-Authentifizierung und E2E-Tests.",
      "dismiss": "Verstanden, schliessen",
      "empty": "Noch keine API-Tokens erstellt.",
      "expiresAt": "Läuft ab am",
      "generate": "Generieren",
      "nameLabel": "Token-Name",
      "namePlaceholder": "z.B. CI/CD Pipeline, E2E-Tests",
      "revoke": "Widerrufen",
      "revokeError": "Token konnte nicht widerrufen werden.",
      "revoked": "Token widerrufen",
      "tabLabel": "API-Tokens",
      "title": "API-Tokens"
    },
    "commissions": "Honorarmodelle",
    "commissionsDescription": "Honorarmodelle erstellen und verwalten",
    "displayMode": "Modus",
    "e2e": {
      "autoGenerated": "Der Report wird automatisch nach jedem E2E-Testlauf generiert.",
      "duration": "Dauer",
      "environment": "Umgebung",
      "failed": "Fehlgeschlagen",
      "generated": "Generiert",
      "loadError": "E2E-Report konnte nicht geladen werden.",
      "noReport": "Kein E2E-Report verfügbar. Starte die Tests mit: npx playwright test",
      "passed": "Bestanden",
      "refresh": "Aktualisieren",
      "subtitle": "Ergebnisse der automatisierten Browser-Tests",
      "title": "E2E Test Reports"
    },
    "investorGroups": "Investorengruppen",
    "investorGroupsDescription": "Investoren gruppieren und Zugang verwalten",
    "kycReview": "Identifikationen prüfen",
    "mandanten": "Mandantenverwaltung",
    "mandantenDescription": "Benutzer- und Firmenzuweisungen verwalten",
    "media": "Medien",
    "mediaDescription": "Bilder und Medien-Dateien verwalten",
    "processVis": {
      "finale": {
        "duration": "Gesamtdauer: 6–12 Monate",
        "subtitle": "Transparenz, Effizienz und Professionalität — für Verkäufer und Investoren gleichermassen.",
        "title": "Deal abgeschlossen."
      },
      "hero": {
        "platform": "Immotron Plattform",
        "scrollHint": "Scroll für den Prozess",
        "subtitle": "Vom ersten Kontakt bis zum Closing — 14 Schritte, 3 Akteure, 1 Plattform.",
        "titleLine1": "Der Weg zum",
        "titleLine2": "erfolgreichen Deal"
      },
      "personas": {
        "employee": "Mitarbeiter",
        "investor": "Investor",
        "vendor": "Verkäufer"
      },
      "scrollMore": "Scroll weiter"
    },
    "processes": "Prozessübersicht",
    "processesDescription": "Interaktive Visualisierung der 3 Kernprozesse",
    "schema": "Datenbank Schema",
    "schemaDescription": "Entity Relationship Diagram anzeigen",
    "signatories": "Zeichnungsberechtigte",
    "signatoriesDescription": "Interne Zeichnungsberechtigte verwalten",
    "subtitle": "Systemkonfiguration und Verwaltung",
    "system": "System",
    "systemDescription": "Erscheinungsbild und Farbschema anpassen",
    "theme": {
      "preset": "Farbschema",
      "presets": {
        "default-blue": "Standard Blau",
        "immotron-red": "Immotron Rot"
      },
      "preview": "Vorschau",
      "saved": "Farbschema gespeichert",
      "title": "Erscheinungsbild"
    },
    "title": "Einstellungen",
    "users": "Benutzerverwaltung",
    "usersDescription": "Benutzer erstellen, bearbeiten und verwalten",
    "regulatedWhitelist": "Aufsichtslisten",
    "regulatedWhitelistDescription": "Listen beaufsichtigter Gegenparteien importieren und Treffer prüfen",
    "zefixSync": "Zefix Sync",
    "zefixSyncDescription": "Handelsregister-Synchronisation verwalten",
    "e2eReports": "E2E Tests",
    "e2eReportsDescription": "Automatisierte Browser-Tests und Ergebnisse",
    "aiBalances": {
      "title": "API-Kontostände",
      "monthCost": "Monat",
      "calls": "Aufrufe"
    },
    "profile": "Profil"
  },
  "signatories": {
    "addSignatory": "Zeichnungsberechtigten hinzufügen",
    "addSuccess": "Zeichnungsberechtigter erfolgreich hinzugefügt",
    "confirmRemove": "Möchten Sie diese Zuordnung wirklich entfernen?",
    "editSignatory": "Zeichnungsberechtigten bearbeiten",
    "function": "Funktion",
    "noInternalCompanies": "Keine internen Firmen verfügbar",
    "noSignatories": "Keine Zeichnungsberechtigten vorhanden",
    "removeSignatory": "Zeichnungsberechtigten entfernen",
    "removeSuccess": "Zeichnungsberechtigter erfolgreich entfernt",
    "selectContact": "Kontakt auswählen",
    "signatureText": "Unterschriftstext",
    "signatureType": "Zeichnungsberechtigung",
    "subtitle": "Zeichnungsberechtigte der internen Firmen verwalten",
    "title": "Interne Zeichnungsberechtigte",
    "updateSuccess": "Zeichnungsberechtigter erfolgreich aktualisiert"
  },
  "signature": {
    "collectiveMore": "Kollektiv zu mehreren",
    "collectiveTwo": "Kollektiv zu zweit",
    "none": "Keine",
    "single": "Einzelzeichnung"
  },
  "signaturePad": {
    "handoff": {
      "close": "Schliessen",
      "done": "Unterschrift übernommen ✓",
      "doneHint": "Die Unterschrift steht jetzt im Feld. Senden Sie hier am Computer ab.",
      "expired": "Der Code ist abgelaufen.",
      "failed": "Der Code konnte nicht erzeugt werden.",
      "lead": "Scannen Sie den Code mit der Handy-Kamera und unterschreiben Sie dort. Der Code ist {{minutes}} Minuten gültig.",
      "open": "Auf Handy oder Tablet unterschreiben",
      "qrAlt": "QR-Code für die Unterschrift auf dem Handy",
      "regenerate": "Neuen Code erzeugen",
      "remaining": "Code noch {{time}} gültig",
      "retry": "Erneut versuchen",
      "title": "Auf dem Handy unterschreiben",
      "waiting": "Warten auf die Unterschrift vom Handy …"
    },
    "mobile": {
      "doneText": "Sie können zum Computer zurückkehren.",
      "doneTitle": "Unterschrift übernommen ✓",
      "error": "Die Unterschrift konnte nicht übernommen werden. Bitte versuchen Sie es erneut.",
      "expired": "Der Code ist abgelaufen. Erzeugen Sie am Computer einen neuen.",
      "invalid": "Der Code ist ungültig.",
      "lead": "Unterschreiben Sie hier mit dem Finger. Danach geht es am Computer weiter.",
      "loading": "Einen Moment, wir öffnen das Unterschriftsfeld …",
      "padLabel": "Ihre Unterschrift",
      "submit": "Übernehmen",
      "title": "Unterschreiben",
      "used": "Hier wurde bereits unterschrieben."
    }
  },
  "subTaskTabs": {
    "ariaLabel": "Sub-Pendenzen Tabs",
    "create": "Neue Sub-Pendenz",
    "createAriaLabel": "Neue Sub-Pendenz erstellen",
    "defaultTitle": "Neue Sub-Pendenz",
    "discardAriaLabel": "Sub-Pendenz verwerfen",
    "discardConfirm": "Sub-Pendenz mit Inhalt verwerfen? Diese Aktion kann nicht rueckgaengig gemacht werden.",
    "discardError": "Sub-Pendenz konnte nicht verworfen werden",
    "discarded": "Sub-Pendenz verworfen",
    "loading": "Lade Sub-Pendenzen...",
    "mainFallback": "Hauptpendenz",
    "untitled": "Ohne Titel"
  },
  "tasks": {
    "actions": {
      "action": "Aktion",
      "apply": "Übernehmen",
      "backToOverview": "Zurück zur Übersicht...",
      "callNote": "Anruf-Notiz",
      "dashMeansEmpty": "— = bisher leer",
      "dataWillBeAdded": "Folgende Daten werden ergänzt:",
      "description": "Beschreibung",
      "dismiss": "Verwerfen",
      "executed": "Aktion ausgeführt!",
      "meetingNote": "Meeting-Notiz",
      "noteLabel": "Notiz",
      "noteWillBeCreated": "Folgende Notiz wird erstellt:",
      "phone": "Telefon",
      "subject": "Betreff",
      "subtaskWillBeCreated": "Folgende Sub-Pendenz wird erstellt:",
      "title": "Titel"
    },
    "addAttachment": "Hinzufügen",
    "addDescription": "Bemerkung",
    "aiApply": "Übernehmen",
    "aiSuggestion": "KI-Vorschlag",
    "attachments": "Anhänge",
    "clickToEdit": "Klick zum Bearbeiten",
    "completed": "erledigt",
    "context": "Kontext",
    "createSuccess": "Pendenz erstellt",
    "delete": "Löschen",
    "deleteConfirm": "Pendenz wirklich löschen?",
    "deleteSuccess": "Pendenz gelöscht",
    "descriptionPlaceholder": "Bemerkung hinzufügen...",
    "done": "Erledigt",
    "editTask": "Pendenz bearbeiten",
    "errors": {
      "deleteFailed": "Pendenz konnte nicht gelöscht werden",
      "downloadFailed": "Download fehlgeschlagen",
      "loadFailed": "Pendenzen konnten nicht geladen werden",
      "titleSaveFailed": "Titel konnte nicht gespeichert werden",
      "updateFailed": "Status konnte nicht geändert werden",
      "uploadFailed": "Upload fehlgeschlagen"
    },
    "fields": {
      "assignedTo": "Zugewiesen an",
      "attachments": "Anhänge",
      "company": "Firma",
      "completedAt": "Erledigt",
      "contact": "Kontakt",
      "createdAt": "Erstellt am",
      "createdBy": "Erstellt von",
      "description": "Beschreibung",
      "dueDate": "Fällig am",
      "listing": "Inserat",
      "priority": "Priorität",
      "property": "Immobilie",
      "status": "Status",
      "title": "Titel",
      "unassigned": "Nicht zugewiesen",
      "visibility": "Sichtbarkeit",
      "descriptionPlaceholder": "Beschreibung hinzufügen..."
    },
    "goal": {
      "label": "Ziel",
      "prompt": "Was ist dein Ziel mit dieser Pendenz?",
      "hint": "Das Ziel leitet den Agenten bei allen Aktionen.",
      "placeholder": "z.B. Kunde kontaktieren und Besichtigungstermin vereinbaren",
      "edit": "Ziel bearbeiten",
      "remove": "Ziel entfernen",
      "removed": "Ziel entfernt",
      "saved": "Ziel gespeichert",
      "saveFailed": "Ziel konnte nicht gespeichert werden",
      "shortcut": "Cmd/Ctrl + Enter zum Speichern",
      "setAriaLabel": "Ziel für diese Pendenz setzen",
      "chips": {
        "contact": "Kontakt",
        "company": "Firma",
        "property": "Immobilie",
        "listing": "Inserat",
        "campaign": "Kampagne",
        "teaser": "Teaser",
        "removeAriaLabel": "{{label}} entfernen"
      },
      "contextEmpty": "Kein Kontext verknüpft",
      "createTask": "Pendenz aus Ziel erstellen",
      "createTaskSuccess": "Pendenz aus Ziel erstellt",
      "createTaskFailed": "Pendenz konnte nicht erstellt werden",
      "editClick": "Klick zum Bearbeiten",
      "stats": {
        "chunks_one": "{{count}} Notiz",
        "chunks_other": "{{count}} Notizen",
        "chunksTooltip": "Notizen zu dieser Pendenz",
        "pins_one": "{{count}} Notiz",
        "pins_other": "{{count}} Notizen",
        "pinsTooltip": "Gepinnte Chat-Antworten als Notizen"
      }
    },
    "groups": {
      "completed": "Erledigt",
      "later": "Später",
      "overdue": "Überfällig",
      "thisWeek": "Diese Woche",
      "today": "Heute"
    },
    "linkedCompany": "Firma",
    "linkedContact": "Kontakt",
    "lock": {
      "inProgress": "In Arbeit",
      "inputDisabled": "Eingabe gesperrt — Pendenz wird von jemand anderem bearbeitet",
      "readOnlyBanner": "In Bearbeitung durch {{name}} — nur Leseansicht",
      "unknownUser": "einen anderen Benutzer"
    },
    "markDone": "Als erledigt markieren",
    "newTask": "Neue Pendenz",
    "noAttachments": "Keine Anhänge",
    "noTasks": "Keine Pendenzen vorhanden",
    "noTasksHint": "Erstellen Sie eine neue Pendenz mit dem Button oben.",
    "open": "Offen",
    "overview": {
      "email": "Email",
      "emails": "E-Mails",
      "emailNoSubject": "Ohne Betreff",
      "emailStatusDraft": "Entwurf",
      "emailStatusSent": "Gesendet",
      "enrich": "Anreichern",
      "note": "Notiz",
      "quickActions": "Quick Actions",
      "removePin": "Pin entfernen",
      "searchCommercialRegister": "Im Handelsregister suchen",
      "propertyResidential": "Wohnfl.",
      "propertyCommercial": "Gewerbefl.",
      "propertyLot": "Land",
      "propertyFloors": "Et.",
      "propertyYear": "Bj.",
      "propertyOpen": "Objekt öffnen",
      "propertyLoading": "Lade Immobilie...",
      "propertyDocuments": "Dokumente",
      "propertyDocsLoading": "Lade Dokumente...",
      "propertyImages": "Bilder",
      "propertyImagesShowAll": "Alle anzeigen ({{count}})",
      "propertyImagesShowLess": "Weniger anzeigen",
      "attachToEmail": "An E-Mail anhängen",
      "attachToEmailShort": "An E-Mail",
      "docAttached": "{{name}} an E-Mail angehängt",
      "docAttachedShort": "Angehängt",
      "emailDiscard": "Entwurf verwerfen",
      "emailArchive": "E-Mail archivieren",
      "emailUnarchive": "Wiederherstellen",
      "emailDiscarded": "Entwurf verworfen",
      "emailUndo": "Rückgängig",
      "emailArchivedToast": "E-Mail archiviert",
      "emailUnarchivedToast": "E-Mail wiederhergestellt",
      "emailArchivedSection": "Archiviert ({{count}})",
      "emailSentOn": "Gesendet am {{date}}",
      "emailsAllArchived": "Alle E-Mails archiviert"
    },
    "compactHeader": {
      "addContact": "+ Kontakt",
      "addCompany": "+ Firma",
      "addProperty": "+ Immobilie",
      "removeContact": "Kontakt entfernen",
      "removeCompany": "Firma entfernen",
      "removeProperty": "Immobilie entfernen",
      "removeContactFailed": "Kontakt konnte nicht entfernt werden",
      "removeCompanyFailed": "Firma konnte nicht entfernt werden",
      "removeFailed": "Verknüpfung konnte nicht entfernt werden",
      "attachContactFailed": "Kontakt konnte nicht verknüpft werden",
      "attachCompanyFailed": "Firma konnte nicht verknüpft werden",
      "attachFailed": "Immobilie konnte nicht verknüpft werden",
      "details": "Details / Bearbeiten"
    },
    "priority": {
      "HIGH": "Hoch",
      "LOW": "Tief",
      "MEDIUM": "Mittel",
      "URGENT": "Dringend"
    },
    "private": "Privat",
    "public": "Öffentlich",
    "quickAdd": "Schnell hinzufügen",
    "reopen": "Wieder öffnen",
    "resetChat": "Chat zurücksetzen",
    "search": {
      "placeholder": "Pendenzen durchsuchen — Name, E-Mail, Telefon, Firma, Immobilie...",
      "aria": "Volltextsuche über Pendenzen",
      "clear": "Suche zurücksetzen",
      "noResults": "Keine Treffer",
      "noResultsHint": "Keine Pendenzen für «{{query}}» gefunden."
    },
    "smartCreate": {
      "hint": "Was ist dein Ziel? Beschreibe die Aufgabe — Firmen, Kontakte und Liegenschaften werden automatisch erkannt.",
      "placeholder": "z.B. \"Verkaufsmail an den CEO von Mansory fuer die Industriestrasse 11 in Dielsdorf\"",
      "analyzing": "Analysiere...",
      "proposalTitle": "Vorschlag",
      "steps": "Schritte",
      "manual": "Manuell erstellen",
      "smartMode": "Smart-Modus",
      "adjust": "Anpassen",
      "create": "Erstellen",
      "error": "Analyse fehlgeschlagen",
      "goalPrefix": "Ziel"
    },
    "sort": {
      "createdAt": "Erstelldatum",
      "dueDate": "Fälligkeitsdatum",
      "priority": "Priorität",
      "title": "Titel"
    },
    "stats": {
      "done": "Erledigt",
      "inProgress": "In Bearbeitung",
      "open": "Offen",
      "overdue": "Überfällig",
      "total": "Total"
    },
    "status": {
      "CANCELLED": "Abgebrochen",
      "DONE": "Erledigt",
      "IN_PROGRESS": "In Bearbeitung",
      "OPEN": "Offen",
      "cancelled": "Abgebrochen",
      "done": "Erledigt",
      "inProgress": "In Bearbeitung",
      "open": "Offen"
    },
    "statuses": {
      "CANCELLED": "Abgebrochen",
      "DONE": "Erledigt",
      "IN_PROGRESS": "In Arbeit",
      "OPEN": "Offen"
    },
    "subtasks": {
      "create": "Sub-Pendenz erstellen",
      "done": "erledigt",
      "empty": "Keine Sub-Pendenzen",
      "progress": "Fortschritt",
      "short": "Sub",
      "title": "Sub-Pendenzen"
    },
    "subtitle": "Aufgaben und Pendenzen verwalten",
    "title": "Pendenzen",
    "updateSuccess": "Pendenz aktualisiert",
    "widget": {
      "empty": "Keine offenen Pendenzen",
      "showAll": "Alle anzeigen",
      "title": "Meine Pendenzen"
    },
    "workflow": {
      "customize": "Anpassen",
      "dismiss": "Ignorieren",
      "exit": "Workflow verlassen",
      "exitShort": "Verlassen",
      "start": "Workflow starten"
    },
    "saveError": "Speichern fehlgeschlagen",
    "deleteError": "Löschen fehlgeschlagen",
    "purge": "Endgültig löschen",
    "purging": "Endgültig löschen …",
    "purged": "Pendenz endgültig gelöscht",
    "purgeError": "Endgültiges Löschen fehlgeschlagen",
    "purgeForbidden": "Keine Berechtigung: Nur ein Admin oder der Ersteller darf diese Pendenz endgültig löschen.",
    "purgeNotFound": "Pendenz nicht gefunden — sie wurde möglicherweise bereits gelöscht.",
    "purgeConfirmTitle": "Pendenz endgültig löschen?",
    "purgeConfirmDescription": "Diese Aktion ist unwiderruflich. Chat, Verlauf, Wissens-Bausteine und ALLE Sub-Pendenzen werden vollständig und dauerhaft entfernt. Anders als beim normalen Löschen ist keine Wiederherstellung möglich.",
    "purgeConfirmButton": "Endgültig löschen",
    "purgeHint": "Unwiderruflich – ohne Papierkorb, nicht wiederherstellbar.",
    "uploadError": "Upload fehlgeschlagen",
    "deleteAttachmentError": "Anhang löschen fehlgeschlagen",
    "toggleError": "Status ändern fehlgeschlagen",
    "saved": "Pendenz gespeichert",
    "deleted": "Pendenz gelöscht",
    "deleting": "Löschen...",
    "searchProperty": "Immobilie suchen...",
    "noPropertiesFound": "Keine Immobilien gefunden"
  },
  "teaser": {
    "salesContact": "Verkaufskontakt"
  },
  "teaserCard": {
    "accessGranted": "Zugriff erteilt",
    "clubDeal": "Club Deal",
    "noAccess": "Kein Zugriff",
    "priceLocked": "Preis nach NDA",
    "yieldLocked": "Rendite nach NDA"
  },
  "timeline": {
    "activities": "Aktivitäten",
    "activityCreated": "Aktivität erstellt",
    "addCall": "Anruf loggen",
    "addMeeting": "Meeting loggen",
    "addNote": "Notiz hinzufügen",
    "all": "Alle",
    "createContact": "Kontakt anlegen",
    "createContactFor": "Kontakt anlegen für {{name}}",
    "descriptionPlaceholder": "Details (optional)...",
    "dueDate": "Fällig",
    "durationPlaceholder": "Dauer in Minuten",
    "emailFrom": "Von:",
    "emailHasAttachments": "Anhang",
    "emailInbound": "Empfangen",
    "emailOutbound": "Gesendet",
    "emailTo": "An:",
    "emails": "E-Mails",
    "empty": "Keine Einträge vorhanden",
    "entries": "Einträge",
    "handledBy": "bearbeitet von {{name}}",
    "mailbox": "Postfach {{label}}",
    "mailboxPersonal": "Persönliches Postfach",
    "mailboxShared": "Geteiltes Postfach",
    "newCall": "Anruf loggen",
    "newMeeting": "Meeting loggen",
    "newNote": "Neue Notiz",
    "subjectPlaceholder": "Betreff...",
    "tasks": "Aufgaben",
    "thread": {
      "label": "Konversation",
      "last": "letzte {{date}}",
      "mails": "{{n}} Mails",
      "moreContacts": "+{{n}}",
      "noSubject": "(Kein Betreff)",
      "participantsLabel": "Beteiligte:",
      "unknownParticipant": "Unbekannt"
    },
    "title": "Timeline",
    "unanswered": "unbeantwortet",
    "activity": "Aktivitäten",
    "activity_one": "{{count}} Aktivität",
    "activity_other": "{{count}} Aktivitäten",
    "daysLeft_one": "Noch 1 Tag",
    "daysLeft_other": "Noch {{count}} Tage",
    "endsToday": "Endet heute!",
    "today": "Heute",
    "lastHours": "Letzte {{count}} Stunden — {{phase}} endet bald!",
    "onlyDaysLeft": "Nur noch {{count}} Tage — {{phase}} endet bald!",
    "phases": {
      "marketing": "Exklusiv-Vermarktung",
      "nbo": "Angebots-Runde",
      "evaluation": "Auswertung",
      "bo": "Finale Runde",
      "closing": "Abschluss",
      "sale": "Verkauft"
    }
  },
  "users": {
    "addCompany": "Firma hinzufügen",
    "addUser": "Benutzer hinzufügen",
    "allRoles": "Alle Rollen",
    "allStatuses": "Alle Status",
    "companyAdded": "Firma erfolgreich zugeordnet",
    "companyRemoved": "Zuordnung entfernt",
    "companyRoles": "Firmen-Zuordnungen",
    "companyUpdated": "Zuordnung aktualisiert",
    "confirmDelete": "Möchten Sie diesen Benutzer wirklich löschen?",
    "confirmRemoveCompany": "Möchten Sie diese Zuordnung wirklich entfernen?",
    "contact": "Verknüpfter Kontakt",
    "createGroupDescLabel": "Beschreibung (optional)",
    "createGroupFromSelection": "Gruppe erstellen",
    "createGroupNameLabel": "Gruppenname",
    "createGroupSuccess": "Gruppe «{{name}}» mit {{count}} Investoren erstellt",
    "createGroupTitle": "Investorengruppe erstellen",
    "createSuccess": "Benutzer erfolgreich erstellt",
    "createdAt": "Erstellt am",
    "creatingFromContact": "User wird aus Kontakt «{{name}}» erstellt und automatisch verknüpft.",
    "deleteSuccess": "Benutzer erfolgreich gelöscht",
    "deleteUser": "Benutzer löschen",
    "editUser": "Benutzer bearbeiten",
    "email": "E-Mail",
    "emailExists": "E-Mail-Adresse bereits vergeben",
    "firstName": "Vorname",
    "function": "Funktion",
    "isActive": "Aktiv",
    "lastLogin": "Letzter Login",
    "lastName": "Nachname",
    "noContact": "Kein Kontakt verknüpft",
    "noInvestorsSelected": "Keine Investoren in der Auswahl",
    "password": "Passwort",
    "passwordReset": "Passwort-Reset",
    "passwordResetHint": "Sendet Reset-Link per E-Mail",
    "removeContact": "Verknüpfung entfernen",
    "resetLinkCopied": "Reset-Link in Zwischenablage kopiert",
    "resetSent": "Reset-Link per E-Mail gesendet",
    "resultsLabel": "Benutzer",
    "role": "Rolle",
    "saveSuccess": "Benutzer erfolgreich gespeichert",
    "searchContacts": "Kontakt suchen...",
    "selectContact": "Kontakt auswählen",
    "selectedCount": "{{count}} ausgewählt",
    "sendReset": "Reset senden",
    "signatureType": "Zeichnungsberechtigung",
    "status": "Status",
    "title": "Benutzerverwaltung",
    "updateSuccess": "Benutzer erfolgreich aktualisiert"
  },
  "validation": {
    "email": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    "maxLength": "Maximal {{max}} Zeichen erlaubt",
    "minLength": "Mindestens {{min}} Zeichen erforderlich",
    "passwordMismatch": "Passwörter stimmen nicht überein",
    "required": "Dieses Feld ist erforderlich"
  },
  "regulatedWhitelist": {
    "category": {
      "LISTED": "Kotiert",
      "PUBLIC_LAW": "Öffentlich-rechtlich",
      "REGULATED": "Beaufsichtigt"
    },
    "columnCategory": "Kategorie",
    "columnCompany": "Firma",
    "columnCount": "Einträge",
    "columnDate": "Datum",
    "columnEntry": "Listeneintrag",
    "columnLastImport": "Letzter Import",
    "columnList": "Liste",
    "columnMatch": "Treffer",
    "confirm": "Bestätigen",
    "confirmFailed": "Bestätigung fehlgeschlagen.",
    "confirmSuccess": "Firma als beaufsichtigte Gegenpartei bestätigt.",
    "forbidden": "Keine Berechtigung — diese Seite ist Administratoren vorbehalten.",
    "hint": "UID-Treffer werden beim monatlichen Lauf automatisch bestätigt. Namens-Treffer müssen hier geprüft werden. Firmeneigene Pensionskassen ohne Listeneintrag: Selbstdeklaration im Profil der Firma.",
    "importBtn": "Listen jetzt importieren",
    "importFailed": "Import fehlgeschlagen.",
    "importListError": "Liste {{list}}: {{error}}",
    "importSuccess": "Import abgeschlossen: {{created}} neu, {{updated}} aktualisiert, {{removed}} entfernt.",
    "listsEmpty": "Noch keine Listen importiert.",
    "listsTitle": "Importierte Listen",
    "matchRunBtn": "Abgleich starten",
    "matchRunFailed": "Abgleich fehlgeschlagen.",
    "matchRunSuccess": "Abgleich abgeschlossen: {{confirmed}} automatisch bestätigt, {{pending}} zu prüfen, {{stale}} veraltet.",
    "matchType": {
      "name_exact": "Name exakt",
      "name_fuzzy": "Name unscharf",
      "uid": "UID"
    },
    "never": "Nie",
    "noMatches": "Keine Einträge in dieser Ansicht.",
    "queueTitle": "Zu prüfende Treffer",
    "reject": "Ablehnen",
    "rejectFailed": "Ablehnen fehlgeschlagen.",
    "rejectSuccess": "Treffer abgelehnt.",
    "staleHint": "Listeneintrag nicht mehr vorhanden — Status der Firma manuell prüfen.",
    "subtitle": "Beaufsichtigte Gegenparteien (FINMA, SIX, OAK BV): Listen importieren und Treffer prüfen.",
    "tabs": {
      "CONFIRMED": "Bestätigt",
      "PENDING": "Offen",
      "REJECTED": "Abgelehnt",
      "STALE": "Veraltet"
    },
    "title": "Aufsichtslisten"
  },
  "zefixSync": {
    "companies": "Organisationen",
    "companiesProcessed": "Firmen verarbeitet",
    "configFailed": "Zefix-Konfiguration fehlgeschlagen.",
    "configSaved": "Konfiguration gespeichert",
    "configuration": "Konfiguration",
    "duration": "Dauer",
    "errors": "Fehler",
    "history": "Verlauf",
    "interval": "Intervall",
    "lastRun": "Letzter Lauf",
    "mockModeWarning": "Mock-Modus aktiv — es werden keine echten Zefix-Daten abgefragt",
    "noLogs": "Noch keine Sync-Läufe vorhanden",
    "rateLimit": "Rate Limit",
    "result": "Ergebnis",
    "running": "Sync läuft...",
    "startedAt": "Gestartet",
    "status": {
      "completed": "Abgeschlossen",
      "failed": "Fehlgeschlagen",
      "running": "Läuft"
    },
    "subtitle": "Automatische Synchronisation mit dem Handelsregister",
    "syncFailed": "Zefix-Synchronisation fehlgeschlagen.",
    "syncStarted": "Zefix-Synchronisation gestartet.",
    "title": "Zefix Sync",
    "trigger": "Auslöser",
    "triggerManual": "Manuell",
    "triggerScheduler": "Automatisch",
    "triggerSync": "Sync starten",
    "revert": "Rückgängig",
    "revertTitle": "Sync rückgängig machen",
    "revertConfirm": "{{added}} hinzugefügte und {{updated}} aktualisierte Kontakte werden zurückgesetzt. Fortfahren?",
    "revertFailed": "Revert fehlgeschlagen"
  },
  "research": {
    "applyFailed": "Übernahme fehlgeschlagen",
    "proposalTitle": "Recherche-Vorschlag",
    "new": "neu",
    "changed": "geändert",
    "selectAll": "Alle",
    "selectOnlyNew": "Nur neue",
    "field": "Feld",
    "currentValue": "Aktuell (CRM)",
    "proposedValue": "Vorschlag (Recherche)",
    "applyHtmlReport": "HTML-Report übernehmen",
    "applyKeyPersons": "Kontakte synchronisieren",
    "applySelected": "Übernehmen",
    "applied": "{{count}} Felder übernommen"
  },
  "researchCard": {
    "location": "Standort"
  },
  "emailTemplatePicker": {
    "uncategorized": "Allgemein",
    "loading": "Vorlagen laden...",
    "noTemplate": "Ohne Vorlage",
    "preview": "Vorschau"
  },
  "softDelete": {
    "showDeleted": "Gelöschte anzeigen",
    "archived": "Archiviert",
    "restore": "Wiederherstellen",
    "restoreSuccess": "Erfolgreich wiederhergestellt"
  },
  "unifiedProcess": {
    "heading": {
      "create": "Neue Immobilie erfassen",
      "edit": "Immobilie bearbeiten — {{name}}",
      "editStatic": "Immobilie bearbeiten",
      "untitled": "Unbenannte Immobilie"
    },
    "loadError": "Immobilie konnte nicht geladen werden",
    "tabsAriaLabel": "Bearbeitungs-Tabs",
    "skeletonNote": "Dieser Tab wird in einem Folge-Schritt mit Inhalt befüllt.",
    "tabs": {
      "ai": "KI-Erfassung",
      "object": "Objekt",
      "location": "Standort",
      "pricing": "Preise & Miete",
      "media": "Medien & Texte",
      "review": "Auftrag & Vermarktung",
      "protocol": "KI-Extraktionsprotokoll",
      "knowledge": "Wissen",
      "aiInsights": "KI-Hinweise"
    },
    "tabHints": {
      "ai": "Dokumente hochladen — die KI extrahiert die Felder automatisch.",
      "object": "Flächen, Räume, Zustand und Energieklassen.",
      "location": "Karte, GWR-Daten und Umwelt-Restriktionen.",
      "pricing": "Angebotspreis, Mandatstyp und Konditionen.",
      "media": "Bilder, VR-Tour, Highlights und Beschreibungen.",
      "review": "Auftraggeber, Sales-Konfiguration und Quality Gate.",
      "protocol": "Übersicht aller KI-Extraktions-Jobs für diese Immobilie.",
      "knowledge": "Aus Pendenzen angeheftete Notizen zu dieser Immobilie."
    },
    "protocol": {
      "title": "KI-Extraktionsprotokoll",
      "subtitle": "Übersicht aller KI-Jobs, die Daten zu dieser Immobilie geliefert haben.",
      "empty": "Noch keine KI-Erfassung für diese Immobilie.",
      "loadFailed": "Protokoll konnte nicht geladen werden.",
      "jobLabel": "Job #{{id}}",
      "confidenceLabel": "Konfidenz:",
      "kpi": {
        "confidence": "Konfidenz",
        "documents": "Dokumente",
        "images": "Bilder",
        "fields": "Felder",
        "tokens": "Tokens"
      },
      "documents": {
        "title": "Dokument-Klassifizierung"
      },
      "location": {
        "title": "Standort-Daten",
        "summary": "{{found}} von {{total}} erkannt",
        "fields": {
          "address": "Adresse",
          "zip": "Postleitzahl",
          "city": "Ort",
          "municipality": "Gemeinde",
          "canton": "Kanton",
          "country": "Land",
          "coordinates": "Koordinaten"
        }
      },
      "fields": {
        "title": "Erkannte Felder ({{count}})"
      },
      "images": {
        "title": "Bild-Klassifizierung",
        "summary": "{{kept}} von {{total}} Bildern behalten"
      },
      "coverage": {
        "title": "Datenabdeckung",
        "summary": "{{found}} von {{total}} Feldern erkannt ({{pct}}%)",
        "found": "Erkannt",
        "missing": "Fehlt",
        "none": "Keine Einträge"
      },
      "warnings": {
        "title": "{{count}} Hinweis(e)"
      },
      "technical": {
        "title": "Technische Details"
      }
    },
    "location": {
      "readOnlyHint": "Alle Daten werden automatisch befüllt — durch KI-Upload oder Adresseingabe. Direkte Bearbeitung ist hier nicht möglich.",
      "notAvailable": "nicht verfügbar",
      "sections": {
        "basics": "Standort-Eckdaten",
        "energy": "Energie & Umwelt",
        "gwr": "Gebäuderegister (GWR)",
        "taxLaw": "Steuern & Recht",
        "environment": "Umwelt & Restriktionen"
      },
      "fields": {
        "map": "Karte",
        "municipality": "Gemeinde",
        "inhabitants": "Einwohnerzahl",
        "coordinates": "Koordinaten (Lat / Lon)",
        "zoneType": "Bauzone",
        "zoneRegulations": "Zonen-Vorschriften",
        "egid": "EGID (Gebäudeidentifikator)",
        "egrid": "EGRID (Grundstücksidentifikator)",
        "constructionYear": "Baujahr (Register)",
        "noiseSensitivity": "Lärmempfindlichkeitsstufe (ES)",
        "groundwaterZone": "Grundwasserschutzzone",
        "naturalHazard": "Naturgefahren",
        "floodRisk": "Hochwasser-Risikozone",
        "earthquakeZone": "Erdbebenzone",
        "contaminatedSite": "Altlasten-Eintrag",
        "heritageProtection": "Denkmalschutz",
        "co2Emissions": "CO₂-Emissionen Gebäude",
        "minergie": "Minergie-Zertifikat",
        "solarPotential": "Solarpotenzial Dach",
        "taxRateMunicipality": "Steuerfuss Gemeinde",
        "taxRateCanton": "Steuerfuss Kanton",
        "taxRateMunicipalityLegal": "Steuerfuss Gemeinde (jur. Personen)",
        "taxRateCantonLegal": "Steuerfuss Kanton (jur. Personen)",
        "zoning": "Nutzungszone (kommunal + kantonal)",
        "bauzone": "Bauzone (Kategorie)",
        "oevQuality": "ÖV-Güteklasse",
        "noiseDb": "Strassenlärm Tag (dB)"
      },
      "taxRateValue": "Einkommen: {{income}} · Vermögen: {{wealth}}",
      "taxRateLegalValue": "Gewinn: {{profit}} · Kapital: {{capital}}",
      "tooltip": {
        "showDetails": "Details anzeigen",
        "rawValue": "Originalwert: {{raw}}"
      },
      "noiseClassify": {
        "es1": {
          "label": "Ruhezone (ES I)",
          "description": "Erholungsgebiet. Strengste Lärmgrenzwerte — ideal für lärmempfindliche Nutzungen wie Spitäler oder Schulen."
        },
        "es2": {
          "label": "Wohnzone (ES II)",
          "description": "Reine Wohngebiete. Guter Lärmschutz — übliche Wohnnutzung uneingeschränkt möglich."
        },
        "es3": {
          "label": "Mischzone (ES III)",
          "description": "Wohnen und mässig störendes Gewerbe gemischt. Etwas Gewerbelärm möglich — meist akzeptabel für Wohnen."
        },
        "es4": {
          "label": "Industriezone (ES IV)",
          "description": "Stark störendes Gewerbe / Industrie. Kaum Lärmschutz — nicht für reine Wohnnutzung geeignet."
        },
        "db_quiet": {
          "label": "Sehr ruhig (<45 dB)",
          "description": "Ländliche Lage, kein Verkehrslärm. Ideale Wohnumgebung."
        },
        "db_calm": {
          "label": "Ruhig (45–54 dB)",
          "description": "Normale Wohnlage, geringer Hintergrundlärm."
        },
        "db_moderate": {
          "label": "Mässig (55–64 dB)",
          "description": "Spürbar — Fenster nachts geschlossen halten empfohlen."
        },
        "db_loud": {
          "label": "Laut (65–74 dB)",
          "description": "Hauptstrasse oder Bahnnähe. Lärmschutzfenster empfohlen."
        },
        "db_very_loud": {
          "label": "Sehr laut (≥75 dB)",
          "description": "Autobahn oder Flughafen. Wohnen nur mit umfassenden Schallschutzmassnahmen."
        },
        "unknown": {
          "label": "Klassifizierung unbekannt",
          "description": "Der Lärmwert konnte nicht eindeutig zugeordnet werden."
        }
      },
      "hazardClassify": {
        "none": {
          "label": "Keine Gefahr",
          "description": "Kein Naturgefahren-Eintrag — keine bekannten Risiken."
        },
        "low": {
          "label": "Gering",
          "description": "Minimales Risiko. Keine besonderen Schutzmassnahmen erforderlich."
        },
        "medium": {
          "label": "Mittel",
          "description": "Erdrutsch, Steinschlag oder Überschwemmung möglich. Versicherungsdeckung prüfen."
        },
        "high": {
          "label": "Erheblich",
          "description": "Schutzmassnahmen oder behördliche Auflagen möglich. Wertminderung berücksichtigen."
        },
        "severe": {
          "label": "Gross",
          "description": "Bauverbot oder strenge Auflagen wahrscheinlich. Deutlicher Bewertungsabschlag zu erwarten."
        },
        "unknown": {
          "label": "Klassifizierung unbekannt",
          "description": "Der Naturgefahren-Wert konnte nicht eindeutig zugeordnet werden."
        }
      },
      "earthquakeClassify": {
        "z1": {
          "label": "Geringe Erdbebenzone (Z1)",
          "description": "Niedrigste Gefährdung in der Schweiz. Standardbauweise ausreichend."
        },
        "z2": {
          "label": "Mässige Erdbebenzone (Z2)",
          "description": "Erhöhte Anforderungen an die Bauweise gemäss SIA 261."
        },
        "z3a": {
          "label": "Hohe Erdbebenzone (Z3a)",
          "description": "Strengere Bemessung erforderlich — höhere Baukosten möglich."
        },
        "z3b": {
          "label": "Sehr hohe Erdbebenzone (Z3b)",
          "description": "Höchste Schweizer Gefährdung (Wallis, Basel). Erdbebensichere Bauweise zwingend."
        }
      },
      "groundwaterClassify": {
        "none": {
          "label": "Keine Schutzzone",
          "description": "Keine Grundwasserschutz-Einschränkungen für Bau- oder Sanierungsvorhaben."
        },
        "au": {
          "label": "Schutzbereich Au",
          "description": "Allgemeiner Schutzbereich für nutzbares Grundwasser. Leichte Auflagen bei Bauvorhaben."
        },
        "s3": {
          "label": "Schutzzone S3",
          "description": "Weitere Schutzzone — Einschränkungen bei Aushub, Versickerung und Lagerung wassergefährdender Stoffe."
        },
        "s2": {
          "label": "Schutzzone S2",
          "description": "Engere Schutzzone — deutliche Auflagen, viele Bauvorhaben bewilligungspflichtig."
        },
        "s1": {
          "label": "Fassungsbereich S1",
          "description": "Direkter Bereich um die Trinkwasserfassung. Praktisch Bauverbot."
        },
        "unknown": {
          "label": "Klassifizierung unbekannt",
          "description": "Die Grundwasserschutzzone konnte nicht eindeutig zugeordnet werden."
        }
      },
      "co2Classify": {
        "neutral": {
          "label": "Klimaneutral",
          "description": "Erneuerbare Energie (Wärmepumpe, Fernwärme, Holz). Kein CO₂-bedingter Sanierungsbedarf."
        },
        "low": {
          "label": "Geringe Emissionen",
          "description": "Unter dem Schweizer Durchschnitt — keine kurzfristige Sanierungspflicht zu erwarten."
        },
        "high": {
          "label": "Hohe Emissionen",
          "description": "Typisch für Öl- oder Gasheizung. CO₂-Gesetz: Sanierungspflicht in den nächsten Jahren absehbar."
        },
        "unknown": {
          "label": "Emissionen unbekannt",
          "description": "Der CO₂-Wert konnte nicht eindeutig zugeordnet werden."
        }
      },
      "co2Tone": {
        "green": "Niedrige CO₂-Emissionen (erneuerbar)",
        "yellow": "Mittlere CO₂-Emissionen",
        "red": "Hohe CO₂-Emissionen",
        "gray": "CO₂-Emissionen unbekannt"
      },
      "hazardTone": {
        "green": "Gering",
        "yellow": "Mittel",
        "red": "Erheblich / Gross",
        "gray": "Unbekannt"
      },
      "noiseTone": {
        "green": "Ruhig",
        "yellow": "Mässig",
        "red": "Laut",
        "gray": "Unbekannt"
      },
      "zoneRegulationsDocuments": "Vorschriften-Dokumente",
      "zoneRegulationsDocument": "Dokument",
      "minergie": {
        "none": "Kein Zertifikat"
      },
      "oevClassify": {
        "a": {
          "label": "ÖV A (sehr gut)",
          "description": "Sehr gute Erschliessung — hochfrequenter Tram-/Bahnhof in unmittelbarer Nähe (urbane Toplage)."
        },
        "b": {
          "label": "ÖV B (gut)",
          "description": "Gute Erschliessung — dichter Fahrplan mit kurzem Fussweg. Typisch für gut angeschlossene Stadtquartiere."
        },
        "c": {
          "label": "ÖV C (mittel)",
          "description": "Mittelmässige Erschliessung — Bus oder Bahn mit Stundentakt erreichbar."
        },
        "d": {
          "label": "ÖV D (gering)",
          "description": "Geringe Erschliessung — wenige Verbindungen pro Tag. Auto faktisch notwendig."
        },
        "e": {
          "label": "ÖV E (marginal)",
          "description": "Marginale Erschliessung — kaum öffentlicher Verkehr. Periphere oder ländliche Lage."
        },
        "none": {
          "label": "Keine ÖV-Erschliessung",
          "description": "Kein öffentlicher Verkehr in nützlicher Distanz."
        },
        "unknown": {
          "label": "ÖV-Klasse unbekannt",
          "description": "Die ÖV-Güteklasse konnte nicht eindeutig bestimmt werden."
        }
      },
      "bauzoneInfo": {
        "wohnen": "Wohnzonen — vorwiegend für Wohnnutzung bestimmt (ein- bis mehrgeschossig).",
        "arbeit": "Arbeitszonen — für Industrie, Gewerbe und Dienstleistungen. Wohnen meist nur eingeschränkt zulässig.",
        "misch": "Mischzonen — Wohnen und mässig störendes Gewerbe gleichberechtigt zugelassen.",
        "zentrum": "Zentrumszonen — Kern- und Altstadtzonen mit hoher Nutzungsdichte und urbanem Charakter.",
        "oeffentlich": "Zonen für öffentliche Nutzungen — Schulen, Verwaltung, Spitäler, Sportanlagen.",
        "tourismus": "Tourismus- und Freizeitzonen — Hotels, Resorts, Sport- und Erholungsanlagen.",
        "eingeschraenkt": "Eingeschränkte Bauzonen — z. B. Weiler oder spezielle Schutzobjekte mit begrenzter Bautätigkeit.",
        "generic": "Bauzonenkategorie gemäss Eidg. Bauzonenstatistik (ARE)."
      },
      "links": {
        "googleMaps": "Google Maps öffnen",
        "geoAdmin": "Quelle: map.geo.admin.ch",
        "geodienste": "Quelle: geodienste.ch",
        "housingStat": "Quelle: housing-stat.ch (GWR)",
        "cadastre": "Quelle: cadastre.ch",
        "oereb": "Quelle: ÖREB-Kataster",
        "bfs": "Quelle: BFS",
        "bafu": "Quelle: BAFU (CO₂-Kataster)",
        "minergie": "Quelle: minergie.ch",
        "sonnendach": "Quelle: sonnendach.ch",
        "estv": "Quelle: ESTV Steuerrechner",
        "bauzone": "Quelle: ARE Bauzonenstatistik",
        "oevQuality": "Quelle: ARE ÖV-Güteklassen"
      }
    },
    "ai": {
      "upload": {
        "title": "Dokumente für KI-Erfassung hochladen",
        "subtitle": "Laden Sie Verkaufsdokumentation, Grundbuchauszüge, Pläne oder Bilder hoch — die KI füllt anschliessend die Folge-Tabs automatisch aus.",
        "dragDrop": "Dateien hierher ziehen oder klicken",
        "hint": "PDF, Bilder oder Office-Dokumente (max. 250 MB pro Datei)",
        "chooseFiles": "Dateien wählen",
        "chooseDirectory": "Verzeichnis wählen",
        "noSupportedInDirectory": "Keine unterstützten Dateien im Verzeichnis gefunden (PDF, Bilder oder Office-Dokumente)",
        "selectedFiles": "{{count}} Datei(en) ausgewählt",
        "removeFile": "{{name}} entfernen",
        "fileTooLarge": "{{name}}: Datei zu gross (max. 250 MB)",
        "startButton": "KI-Erfassung starten",
        "starting": "Wird hochgeladen…",
        "started": "Analyse gestartet",
        "uploadFailed": "Upload fehlgeschlagen",
        "startHint": "Die Analyse läuft im Hintergrund — der Fortschritt wird hier angezeigt.",
        "attachImagesLabel": "Bilder aus Dokumenten in die Galerie übernehmen",
        "attachImagesHint": "Standardmässig aus — schneller, die KI wertet bei ausgeschalteten Bildern die Fotos nicht aus. Lade Objektbilder lieber separat hoch."
      },
      "processing": {
        "title": "KI verarbeitet die Dokumente",
        "hint": "Bitte warten — das Ergebnis wird automatisch angezeigt."
      },
      "result": {
        "title": "Erfassung abgeschlossen",
        "subtitle": "Bitte prüfen Sie die Zusammenfassung und übernehmen Sie die Daten.",
        "confidenceLabel": "Konfidenz",
        "documentsLabel": "Erkannte Dokumente",
        "imagesLabel": "Bilder",
        "warningsLabel": "{{count}} Hinweis(e)",
        "warningsMore": "+{{count}} weitere…",
        "confirmButton": "Daten übernehmen & weiter",
        "confirming": "Wird erstellt…",
        "confirmed": "Immobilie erstellt — {{count}} Felder befüllt.",
        "confirmedRecovered": "Objekt #{{id}} wurde erstellt (Verbindung war kurz unterbrochen).",
        "confirmFailed": "Übernahme fehlgeschlagen",
        "cancelButton": "Verwerfen & neu starten"
      },
      "failed": {
        "title": "KI-Erfassung fehlgeschlagen",
        "retryButton": "Neu starten"
      },
      "history": {
        "title": "KI-Erfassungs-Historie",
        "subtitle": "Die folgenden KI-Jobs haben Daten zu dieser Immobilie geliefert.",
        "empty": "Keine KI-Erfassung für diese Immobilie.",
        "loadFailed": "Historie konnte nicht geladen werden.",
        "editNoUploadHint": "Im Bearbeitungs-Modus ist kein neuer KI-Upload möglich. Verwenden Sie die Folge-Tabs, um Daten manuell zu ergänzen.",
        "openInJobs": "In KI-Jobs öffnen",
        "jobLabel": "Job #{{id}}",
        "summary": "{{docs}} Dokument(e) · {{date}}",
        "confidenceLabel": "Konfidenz:"
      }
    },
    "save": {
      "idle": "Synchronisiert",
      "pending": "Änderungen ausstehend",
      "saving": "Speichern…",
      "saved": "Gespeichert",
      "error": "Speichern fehlgeschlagen"
    },
    "aiHints": {
      "title": "KI-Hinweise",
      "toggleAria": "KI-Hinweise ein- oder ausklappen"
    },
    "pricing": {
      "groups": {
        "pricing": "Preise & Konditionen",
        "rentSituation": "Mietsituation",
        "rentSituationToggle": "Mietsituation ein- oder ausklappen"
      },
      "sections": {
        "financialKpis": "Finanzkennzahlen",
        "unitMix": "Wohnungsmix",
        "rentRoll": "Mietspiegel"
      },
      "tablesUnavailableInCreateMode": "Wohnungsmix und Mietspiegel können nach dem ersten Speichern erfasst werden.",
      "unitMixSellerHint": "Der Wohnungsmix wird durch den Vermarkter gepflegt und kann hier nur eingesehen werden.",
      "rentRollSellerHint": "Sie können den Mietspiegel selbst ergänzen oder anpassen — nach dem Bearbeiten bitte speichern.",
      "saveUnitMix": "Wohnungsmix speichern",
      "saveRentRoll": "Mietspiegel speichern",
      "noUnitMix": "Noch keine Einträge im Wohnungsmix.",
      "noRentRoll": "Noch keine Einträge im Mietspiegel."
    },
    "media": {
      "requiresProperty": "Bitte zuerst Grunddaten speichern, danach können Sie Medien hochladen.",
      "images": {
        "title": "Bilder",
        "hint": "Hauptbild markieren, weitere Bilder per Drag & Drop sortieren. Visualisierungen, Fotos, Pläne und Karten werden automatisch gruppiert.",
        "noFilterMatch": "Keine Bilder im gewählten Filter.",
        "filters": {
          "ariaLabel": "Bilder nach Medium filtern",
          "all": "Alle",
          "photo": "Fotos",
          "visualisierung": "Visualisierungen",
          "plan": "Pläne",
          "karte": "Karten",
          "other": "Weitere"
        },
        "teaser": {
          "teaserOption": "Teaser",
          "ndaOption": "Nur NDA",
          "toggleAria": "Teaser-Sichtbarkeit",
          "riskBadge": "Standort",
          "riskTitle": "Lässt Rückschlüsse auf die genaue Lage zu",
          "confirmUpgrade": "Dieses Bild lässt Rückschlüsse auf den Standort zu. Trotzdem im Teaser (vor NDA) zeigen?",
          "confirmYes": "Trotzdem zeigen",
          "captionEmpty": "Keine KI-Beschreibung",
          "showFull": "Volle Beschreibung anzeigen",
          "summaryTeaser": "{{count}} im Teaser",
          "summaryNda": "{{count}} nur NDA",
          "summaryRisk": "{{count}} mit Standort-Risiko",
          "previewToggle": "Teaser-Vorschau",
          "previewHint": "Nur Bilder zeigen, die Käufer ohne NDA sehen",
          "previewEmpty": "Kein Bild ist für den Teaser freigegeben."
        },
        "mediumLabels": {
          "photo": "Foto",
          "visualisierung": "3D",
          "plan": "Plan",
          "karte": "Karte",
          "scan": "Scan",
          "logo": "Logo"
        },
        "subjectLabels": {
          "fassade": "Fassade",
          "wohnraum": "Wohnraum",
          "kueche": "Küche",
          "bad": "Bad",
          "schlafzimmer": "Schlafzimmer",
          "buero": "Büro",
          "treppenhaus": "Treppenhaus",
          "keller": "Keller",
          "garten": "Garten",
          "umgebung": "Umgebung",
          "luftbild": "Luftbild",
          "grundriss": "Grundriss",
          "schnitt": "Schnitt",
          "ansicht": "Ansicht",
          "lageplan": "Lageplan"
        }
      },
      "dossier": {
        "title": "Dossier-Dokumente",
        "hint": "Verkaufsunterlagen kategorisiert hochladen (Grundbuch, Handänderung, etc.)."
      },
      "accessLog": {
        "title": "Zugriffsprotokoll",
        "hint": "Wer hat welches Dokument wann angesehen oder heruntergeladen — Beweismittel zur Vertraulichkeitsvereinbarung.",
        "count": "{{count}} Zugriffe protokolliert",
        "filterLabel": "Käufer",
        "filterAll": "Alle Käufer",
        "empty": "Noch keine Dokumentzugriffe protokolliert.",
        "loadError": "Zugriffsprotokoll konnte nicht geladen werden.",
        "pageOf": "Seite {{page}} von {{total}}",
        "typeDownload": "Download",
        "typePreview": "Vorschau",
        "typePreviewPage": "Vorschau Seite {{page}}",
        "mayanDocument": "Dokument {{id}}",
        "columns": {
          "time": "Zeit",
          "buyer": "Käufer",
          "document": "Dokument",
          "type": "Art",
          "ip": "IP"
        }
      },
      "identifyLeak": {
        "button": "Leck zuordnen",
        "title": "Leck zuordnen",
        "description": "Weitergegebene Datei hochladen — der unsichtbare Fingerabdruck verrät, welcher Käufer sie erhalten hat.",
        "fileLabel": "Geleakte Datei",
        "fileHint": "Bild oder PDF, maximal 30 MB. Funktioniert auch bei Ausschnitten oder komprimierten Kopien.",
        "submit": "Zuordnen",
        "tooLarge": "Datei ist zu gross (maximal 30 MB).",
        "error": "Zuordnung fehlgeschlagen. Bitte erneut versuchen.",
        "resultFound": "Gehört zu: {{buyer}}, {{document}}, {{time}}",
        "resultNotFound": "Kein Fingerabdruck gefunden.",
        "unknownDocument": "Unbekanntes Dokument"
      },
      "immotron": {
        "title": "Immotron-Dokumente",
        "hint": "Systemgenerierte Dokumente — nur intern sichtbar."
      },
      "highlights": {
        "title": "Highlights & Beschreibung",
        "hint": "Maximal 5 Highlights anzeigen — Reihenfolge per Drag & Drop anpassen."
      },
      "vrTour": {
        "title": "VR-Tour & Links",
        "hint": "Externe Rundgang-URL einfügen (Matterport, Kuula, …)."
      },
      "translations": {
        "title": "Übersetzungen",
        "hint": "Texte in DE/EN/FR/IT pflegen — leere Felder können automatisch übersetzt werden.",
        "cards": {
          "title": "Titel",
          "description": "Beschreibung",
          "location": "Lage"
        },
        "placeholders": {
          "name": "z.B. Wohn- und Geschäftshaus Zürich-Seefeld",
          "subheader": "z.B. Erstklassige Lage im Geschäftsviertel",
          "highlights": "z.B. • Vollvermietet • Sanierung 2021 • ÖV-Güteklasse A",
          "description": "Ausführliche Beschreibung des Objekts: Lage, Zustand, Ausstattung, Besonderheiten und Nutzungsmöglichkeiten ...",
          "macro": "z.B. Zentrale Lage in der Stadt Zürich, etablierter Wirtschaftsraum ...",
          "micro": "z.B. Ruhige Seitenstrasse, Geschäfte und ÖV in Gehdistanz ..."
        },
        "aiBadge": "KI-Vorschlag",
        "aiTitle": "Dieser Text wurde von der KI vorgeschlagen. Bearbeiten Sie ihn, um den Hinweis zu entfernen.",
        "translated": "Übersetzt",
        "notTranslated": "Nicht übersetzt",
        "copyFromMaster": "Aus DE übernehmen",
        "reference": "Deutsche Originalfassung",
        "charCount": "{{count}} Zeichen",
        "charCountMax": "{{count}}/{{max}} Zeichen"
      }
    },
    "object": {
      "sections": {
        "classification": "Klassifizierung & Status",
        "address": "Adresse & Lage",
        "land": "Grundstück",
        "building": "Gebäude",
        "energy": "Energie & Zustand"
      },
      "fields": {
        "dealState": "Deal-State",
        "dealStateNotSet": "Nicht festgelegt",
        "inhabitants": "Einwohner (Gemeinde)",
        "coordinates": "Koordinaten",
        "minGroundFloorHeight": "Min. Erdgeschosshöhe",
        "egidNumber": "EGID-Nummer (Gebäudeidentifikator)",
        "egidPlaceholder": "z.B. 100123456",
        "energyClassPlaceholder": "z.B. A, B, C..."
      },
      "noSubtypes": "Für diesen Typ sind keine Subtypen verfügbar."
    },
    "review": {
      "sections": {
        "auftraggeber": "Auftraggeber",
        "sales": "Sales-Konfiguration",
        "listing": "Listing-Konfiguration",
        "qualityGate": "Quality Gate",
        "timeline": "Deal-Timeline"
      },
      "timeline": {
        "subtitle": "Aktuelle Phase und Aktivitäten auf einen Blick."
      },
      "auftraggeber": {
        "subtitle": "Wer hat den Vermarktungsauftrag erteilt?",
        "contactLabel": "Auftraggeber",
        "contactPlaceholder": "Bestehenden Kontakt suchen...",
        "contactHint": "Wird im Vermarktungsauftrag und in Verträgen verwendet.",
        "sellerReadOnly": "Diese Angaben werden vom Vermarkter gepflegt.",
        "notSet": "Noch nicht festgelegt",
        "searchButton": "Vertrag suchen",
        "changeButton": "Vertrag ändern",
        "removeButton": "Entfernen",
        "removeConfirmTitle": "Auftraggeber entfernen?",
        "removeConfirmText": "«{{name}}» wird als Auftraggeber von diesem Objekt entfernt. Bestehende Verträge bleiben erhalten; Sie können jederzeit einen neuen Auftraggeber verknüpfen.",
        "removeConfirmTextNoName": "Der Auftraggeber wird von diesem Objekt entfernt. Bestehende Verträge bleiben erhalten; Sie können jederzeit einen neuen Auftraggeber verknüpfen.",
        "removeSuccess": "Auftraggeber entfernt",
        "removeFailed": "Auftraggeber konnte nicht entfernt werden",
        "saveFirstHint": "Bitte Immobilie zuerst speichern, um einen Auftraggeber zu verknüpfen."
      },
      "sales": {
        "subtitle": "Verantwortlicher Berater und Mandatslaufzeit.",
        "salesUserLabel": "Verantwortlicher Berater",
        "salesUserPlaceholder": "Berater auswählen...",
        "saleStartDate": "Auftragsstart",
        "saleEndDate": "Auftragsende",
        "assignedTo": "Aktuell zugeteilt: {{name}}"
      },
      "listing": {
        "subtitle": "Sichtbarkeit und Veröffentlichungs-Einstellungen.",
        "privateLabel": "Privates Listing",
        "privateHint": "Nur ausgewählte Investoren oder Gruppen sehen diese Immobilie.",
        "expirationLabel": "Veröffentlichung läuft ab am",
        "expirationHint": "Nach diesem Datum wird das Listing automatisch deaktiviert.",
        "investorGroupHint": "Investor- und Gruppen-Zugang verwalten Sie weiterhin auf der Detailseite der Immobilie.",
        "openDetailPage": "Detailseite öffnen"
      },
      "qualityGate": {
        "subtitle": "Status und Einreichung zur internen Prüfung.",
        "statusLabel": "Aktueller Status",
        "submitButton": "Zur Prüfung einreichen",
        "submitting": "Wird eingereicht…",
        "submitted": "Zur Prüfung eingereicht.",
        "submitFailed": "Einreichen fehlgeschlagen. Bitte erneut versuchen.",
        "submitHint": "Nach der Einreichung prüft ein interner Mitarbeiter die Immobilie.",
        "inReviewHint": "Die Immobilie wird aktuell geprüft. Sie können bis zur Entscheidung weiter Daten anpassen.",
        "sellerStateHint": "Der aktuelle Status wird vom Vermarkter verwaltet.",
        "submittedAt": "Eingereicht am {{date}}",
        "reviewedAt": "Geprüft am {{date}}",
        "rejectedTitle": "Ablehnungsgrund",
        "rejectedHint": "Bitte beheben Sie die genannten Punkte und reichen Sie erneut ein."
      }
    },
    "aiInsights": {
      "title": "KI-Hinweise",
      "description": "Alle KI-Informationen zu dieser Immobilie an einem Ort: Hinweise aus der Extraktion, das Extraktionsprotokoll und angeheftetes Wissen.",
      "sectionsAriaLabel": "KI-Hinweise: Bereiche",
      "warningIndicatorAria": "Enthält Warnungen",
      "sections": {
        "hints": {
          "label": "Hinweise",
          "description": "Hinweise aus der KI-Extraktion (Eigentümer, Dienstbarkeiten, Grundpfand, Konflikte). Einträge mit ⚠️ sind hervorgehoben.",
          "empty": "Keine KI-Hinweise zu dieser Immobilie vorhanden."
        },
        "protocol": {
          "label": "Extraktionsprotokoll"
        },
        "knowledge": {
          "label": "Wissen",
          "description": "Aus Pendenzen angeheftete Notizen zu dieser Immobilie."
        }
      }
    }
  },
  "knowledgeBoard": {
    "pageTitle": "Notizen arrangieren",
    "pageSubtitle": "Ziehe Notizen aus der Recherche in das Ziel und ordne sie an.",
    "instructions": "Per Drag & Drop verschieben — oder Leertaste/Pfeiltasten zum Bedienen mit der Tastatur.",
    "reset": "Zurücksetzen",
    "sourceTitle": "Recherche",
    "sourceHint": "Pool gesammelter Notizen.",
    "sourceEmpty": "Keine weiteren Notizen in der Recherche.",
    "targetTitle": "Ziel",
    "targetHint": "Arbeitsbereich — Notizen hier ablegen und sortieren.",
    "targetEmpty": "Notiz hierher ziehen, um sie dem Ziel zuzuordnen.",
    "dragHandle": "Notiz «{{title}}» ziehen",
    "a11y": {
      "start": "Notiz {{id}} aufgenommen.",
      "over": "Notiz {{id}} über {{target}}.",
      "outside": "Notiz {{id}} ausserhalb gültiger Bereiche.",
      "end": "Notiz {{id}} bei {{target}} abgelegt.",
      "cancel": "Bewegung von Notiz {{id}} abgebrochen."
    },
    "samples": {
      "market": {
        "title": "Marktanalyse Zürich West",
        "summary": "Durchschnittspreis pro m² stieg im letzten Quartal um 3.2 % auf CHF 11'400.",
        "source": "Recherche · Marktdaten"
      },
      "location": {
        "title": "Lagebewertung Industriequartier",
        "summary": "Sehr gute ÖV-Anbindung, geplante Aufwertung durch neuen Stadtteil-Park.",
        "source": "Recherche · Standort"
      },
      "zefix": {
        "title": "Firmenprofil Musterhaus AG",
        "summary": "Aktiv seit 1998, 24 Mitarbeitende, Branche Bau & Renovation.",
        "source": "Zefix"
      },
      "news": {
        "title": "News: Neue Tramlinie 17 ab 2027",
        "summary": "Direkte Anbindung an HB geplant — voraussichtlich Wertsteigerung Liegenschaften im Korridor.",
        "source": "Recherche · News"
      }
    }
  },
  "buyerSearch": {
    "placeholder": "Name, Firma oder E-Mail suchen …",
    "hint": "Mindestens 2 Zeichen eingeben, um CRM-Kontakte, Firmen und das Handelsregister zu durchsuchen.",
    "empty": "Keine Treffer im CRM und im Handelsregister gefunden.",
    "searchFailed": "Suche fehlgeschlagen. Bitte erneut versuchen.",
    "assign": "Zuordnen",
    "assignFailed": "Zuordnung fehlgeschlagen",
    "alreadyAssigned": "Zugeordnet",
    "typeContact": "Kontakt",
    "typeCompany": "Firma",
    "statusActive": "Aktiv",
    "statusPending": "Onboarding nötig",
    "zefixBadge": "Zefix",
    "createFromZefix": "Firma anlegen",
    "createdFromZefix": "{{name}} und {{count}} Personen angelegt",
    "createFromZefixFailed": "Firma konnte nicht angelegt werden",
    "noZefixHint": "Nicht im Handelsregister?",
    "noZefixHintLink": "Neue Organisation im CRM anlegen",
    "inactiveAt": "inaktiv bei {{company}}",
    "inactiveAssignBlocked": "Rolle bei {{company}} beendet",
    "noEmailAssignBlocked": "Keine E-Mail-Adresse — nicht zuordenbar"
  },
  "emailConflict": {
    "duplicateContactTitle": "E-Mail bereits bei einem Kontakt hinterlegt",
    "duplicateCompanyTitle": "E-Mail bereits bei einer Organisation hinterlegt",
    "existingEntry": "Bestehender Eintrag",
    "switchToContact": "Zu Kontakt wechseln",
    "switchToCompany": "Zu Organisation wechseln",
    "merge": "Zusammenführen",
    "mergeTitle": "Kontakte zusammenführen",
    "matchReasonEmail": "Gleiche E-Mail-Adresse",
    "genericTitle": "Generische Adresse — zur Organisation verschieben?",
    "genericDescription": "Diese Adresse gehört zu einer Organisation, nicht zu einer einzelnen Person.",
    "moveToCompany": "Zu {{name}} verschieben",
    "moveToCompanyHint": "Die Adresse wird bei der Organisation erfasst und beim Kontakt entfernt.",
    "saveAnyway": "Trotzdem speichern",
    "noCompany": "Dieser Kontakt ist keiner Organisation zugeordnet.",
    "movedToCompany": "E-Mail zur Organisation verschoben",
    "moveFailed": "Verschieben zur Organisation fehlgeschlagen"
  }
}
